//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, o) => (o = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region node_modules/preact/dist/preact.module.js
function f(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function p(e) {
	e && e.parentNode && e.parentNode.removeChild(e);
}
function m(e, t, n) {
	var r, i, a, o = {};
	for (a in t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : o[a] = t[a];
	if (arguments.length > 2 && (o.children = arguments.length > 3 ? ge.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (a in e.defaultProps) o[a] === void 0 && (o[a] = e.defaultProps[a]);
	return h(e, o, r, i, null);
}
function h(e, t, n, r, i) {
	var a = {
		type: e,
		props: t,
		key: n,
		ref: r,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: i ?? ++_e,
		__i: -1,
		__u: 0
	};
	return i == null && O.vnode != null && O.vnode(a), a;
}
function g() {
	return { current: null };
}
function _(e) {
	return e.children;
}
function v(e, t) {
	this.props = e, this.context = t;
}
function y(e, t) {
	if (t == null) return e.__ ? y(e.__, e.__i + 1) : null;
	for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
	return typeof e.type == "function" ? y(e) : null;
}
function b(e) {
	if (e.__P && e.__d) {
		var t = e.__v, n = t.__e, r = [], i = [], a = f({}, t);
		a.__v = t.__v + 1, O.vnode && O.vnode(a), ie(e.__P, a, t, e.__n, e.__P.namespaceURI, 32 & t.__u ? [n] : null, r, n ?? y(t), !!(32 & t.__u), i), a.__v = t.__v, a.__.__k[a.__i] = a, oe(r, a, i), t.__e = t.__ = null, a.__e != n && x(a);
	}
}
function x(e) {
	if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
		if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
	}), x(e);
}
function S(e) {
	(!e.__d && (e.__d = !0) && ve.push(e) && !C.__r++ || ye != O.debounceRendering) && ((ye = O.debounceRendering) || be)(C);
}
function C() {
	try {
		for (var e, t = 1; ve.length;) ve.length > t && ve.sort(xe), e = ve.shift(), t = ve.length, b(e);
	} finally {
		ve.length = C.__r = 0;
	}
}
function w(e, t, n, r, i, a, o, s, c, l, u) {
	var d, f, p, m, h, g, _ = r && r.__k || Ae, v = t.length;
	for (c = T(n, t, _, c, v), d = 0; d < v; d++) (p = n.__k[d]) != null && (f = p.__i != -1 && _[p.__i] || ke, p.__i = d, g = ie(e, p, f, i, a, o, s, c, l, u), m = p.__e, p.ref && f.ref != p.ref && (f.ref && le(f.ref, null, p), u.push(p.ref, p.__c || m, p)), h == null && m != null && (h = m), 4 & p.__u ? (c = E(p, c, e), f.__e && (f.__e = null)) : typeof p.type == "function" && g !== void 0 ? c = g : m && (c = m.nextSibling), p.__u &= -7);
	return n.__e = h, c;
}
function T(e, t, n, r, i) {
	var a, o, s, c, l, u = n.length, d = u, f = 0;
	for (e.__k = Array(i), a = 0; a < i; a++) (o = t[a]) != null && typeof o != "boolean" && typeof o != "function" ? (typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? o = e.__k[a] = h(null, o, null, null, null) : Me(o) ? o = e.__k[a] = h(_, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? o = e.__k[a] = h(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : e.__k[a] = o, c = a + f, o.__ = e, o.__b = e.__b + 1, s = null, (l = o.__i = ee(o, n, c, d)) != -1 && (d--, (s = n[l]) && (s.__u |= 2)), s == null || s.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof o.type != "function" && (o.__u |= 4)) : l != c && (l == c - 1 ? f-- : l == c + 1 ? f++ : (l > c ? f-- : f++, o.__u |= 4))) : e.__k[a] = null;
	if (d) for (a = 0; a < u; a++) (s = n[a]) != null && !(2 & s.__u) && (s.__e == r && (r = y(s)), ue(s, s));
	return r;
}
function E(e, t, n) {
	var r, i;
	if (typeof e.type == "function") {
		for (r = e.__k, i = 0; r && i < r.length; i++) r[i] && (r[i].__ = e, t = E(r[i], t, n));
		return t;
	}
	e.__e != t && (t && e.type && !t.parentNode && (t = y(e)), t = n.insertBefore(e.__e, t || null));
	do
		t &&= t.nextSibling;
	while (t != null && t.nodeType == 8);
	return t;
}
function D(e, t) {
	return t ||= [], e == null || typeof e == "boolean" || (Me(e) ? e.some(function(e) {
		D(e, t);
	}) : t.push(e)), t;
}
function ee(e, t, n, r) {
	var i, a, o, s = e.key, c = e.type, l = t[n], u = l != null && !(2 & l.__u);
	if (l === null && s == null || u && s == l.key && c == l.type) return n;
	if (r > +!!u) {
		for (i = n - 1, a = n + 1; i >= 0 || a < t.length;) if ((l = t[o = i >= 0 ? i-- : a++]) != null && !(2 & l.__u) && s == l.key && c == l.type) return o;
	}
	return -1;
}
function te(e, t, n) {
	t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || je.test(t) ? n : n + "px";
}
function ne(e, t, n, r, i) {
	var a, o;
	n: if (t == "style") {
		if (typeof n == "string") e.style.cssText = n;
		else {
			if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || te(e.style, t, "");
			if (n) for (t in n) r && n[t] == r[t] || te(e.style, t, n[t]);
		}
	} else if (t[0] == "o" && t[1] == "n") a = t != (t = t.replace(we, "$1")), o = t.toLowerCase(), t = o in e || t == "onFocusOut" || t == "onFocusIn" ? o.slice(2) : t.slice(2), e.l ||= {}, e.l[t + a] = n, n ? r ? n[Ce] = r[Ce] : (n[Ce] = Te, e.addEventListener(t, a ? De : Ee, a)) : e.removeEventListener(t, a ? De : Ee, a);
	else {
		if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
		else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
			e[t] = n ?? "";
			break n;
		} catch {}
		typeof n == "function" || (n == null || !1 === n && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
	}
}
function re(e) {
	return function(t) {
		if (this.l) {
			var n = this.l[t.type + e];
			if (t[Se] == null) t[Se] = Te++;
			else if (t[Se] < n[Ce]) return;
			return n(O.event ? O.event(t) : t);
		}
	};
}
function ie(e, t, n, r, i, a, o, s, c, l) {
	var u, d, m, h, g, b, x, S, C, T, E, D, ee, te, ne, re, ie = t.type;
	if (t.constructor !== void 0) return null;
	128 & n.__u && (c = !!(32 & n.__u), a = [s = t.__e = n.__e]), (u = O.__b) && u(t);
	n: if (typeof ie == "function") {
		d = o.length;
		try {
			if (C = t.props, T = ie.prototype && ie.prototype.render, E = (u = ie.contextType) && r[u.__c], D = u ? E ? E.props.value : u.__ : r, n.__c ? S = (m = t.__c = n.__c).__ = m.__E : (T ? t.__c = m = new ie(C, D) : (t.__c = m = new v(C, D), m.constructor = ie, m.render = de), E && E.sub(m), m.state || (m.state = {}), m.__n = r, h = m.__d = !0, m.__h = [], m._sb = []), T && m.__s == null && (m.__s = m.state), T && ie.getDerivedStateFromProps != null && (m.__s == m.state && (m.__s = f({}, m.__s)), f(m.__s, ie.getDerivedStateFromProps(C, m.__s))), g = m.props, b = m.state, m.__v = t, h) T && ie.getDerivedStateFromProps == null && m.componentWillMount != null && m.componentWillMount(), T && m.componentDidMount != null && m.__h.push(m.componentDidMount);
			else {
				if (T && ie.getDerivedStateFromProps == null && C !== g && m.componentWillReceiveProps != null && m.componentWillReceiveProps(C, D), t.__v == n.__v || !m.__e && m.shouldComponentUpdate != null && !1 === m.shouldComponentUpdate(C, m.__s, D)) {
					t.__v != n.__v && (m.props = C, m.state = m.__s, m.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.some(function(e) {
						e && (e.__ = t);
					}), Ae.push.apply(m.__h, m._sb), m._sb = [], m.__h.length && o.push(m), s = y(n);
					break n;
				}
				m.componentWillUpdate != null && m.componentWillUpdate(C, m.__s, D), T && m.componentDidUpdate != null && m.__h.push(function() {
					m.componentDidUpdate(g, b, x);
				});
			}
			if (m.context = D, m.props = C, m.__P = e, m.__e = !1, ee = O.__r, te = 0, T) m.state = m.__s, m.__d = !1, ee && ee(t), u = m.render(m.props, m.state, m.context), Ae.push.apply(m.__h, m._sb), m._sb = [];
			else do
				m.__d = !1, ee && ee(t), u = m.render(m.props, m.state, m.context), m.state = m.__s;
			while (m.__d && ++te < 25);
			m.state = m.__s, m.getChildContext != null && (r = f(f({}, r), m.getChildContext())), T && !h && m.getSnapshotBeforeUpdate != null && (x = m.getSnapshotBeforeUpdate(g, b)), ne = u != null && u.type === _ && u.key == null ? se(u.props.children) : u, s = w(e, Me(ne) ? ne : [ne], t, n, r, i, a, o, s, c, l), m.base = t.__e, t.__u &= -161, m.__h.length && o.push(m), S && (m.__E = m.__ = null);
		} catch (e) {
			if (o.length = d, t.__v = null, c || a != null) {
				if (e.then) {
					for (t.__u |= c ? 160 : 128; s && s.nodeType == 8 && s.nextSibling;) s = s.nextSibling;
					a != null && (a[a.indexOf(s)] = null), t.__e = s;
				} else if (a != null) for (re = a.length; re--;) p(a[re]);
			} else t.__e = n.__e;
			t.__k ??= n.__k || [], e.then || ae(t), O.__e(e, t, n);
		}
	} else a == null && t.__v == n.__v ? (t.__k = n.__k, t.__e = n.__e) : s = t.__e = ce(n.__e, t, n, r, i, a, o, c, l);
	return (u = O.diffed) && u(t), 128 & t.__u ? void 0 : s;
}
function ae(e) {
	e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(ae));
}
function oe(e, t, n) {
	for (var r = 0; r < n.length; r++) le(n[r], n[++r], n[++r]);
	O.__c && O.__c(t, e), e.some(function(t) {
		try {
			e = t.__h, t.__h = [], e.some(function(e) {
				e.call(t);
			});
		} catch (e) {
			O.__e(e, t.__v);
		}
	});
}
function se(e) {
	return typeof e != "object" || !e || e.__b > 0 ? e : Me(e) ? e.map(se) : e.constructor === void 0 ? f({}, e) : null;
}
function ce(e, t, n, r, i, a, o, s, c) {
	var l, u, d, f, m, h, g, _ = n.props || ke, v = t.props, b = t.type;
	if (b == "svg" ? i = "http://www.w3.org/2000/svg" : b == "math" ? i = "http://www.w3.org/1998/Math/MathML" : i ||= "http://www.w3.org/1999/xhtml", a != null) {
		for (l = 0; l < a.length; l++) if ((m = a[l]) && "setAttribute" in m == !!b && (b ? m.localName == b : m.nodeType == 3)) {
			e = m, a[l] = null;
			break;
		}
	}
	if (e == null) {
		if (b == null) return document.createTextNode(v);
		e = document.createElementNS(i, b, v.is && v), s &&= (O.__m && O.__m(t, a), !1), a = null;
	}
	if (b == null) _ === v || s && e.data == v || (e.data = v);
	else {
		if (a = b == "textarea" && v.defaultValue != null ? null : a && ge.call(e.childNodes), !s && a != null) for (_ = {}, l = 0; l < e.attributes.length; l++) _[(m = e.attributes[l]).name] = m.value;
		for (l in _) m = _[l], l == "dangerouslySetInnerHTML" ? d = m : l == "children" || l in v || l == "value" && "defaultValue" in v || l == "checked" && "defaultChecked" in v || ne(e, l, null, m, i);
		for (l in v) m = v[l], l == "children" ? f = m : l == "dangerouslySetInnerHTML" ? u = m : l == "value" ? h = m : l == "checked" ? g = m : s && typeof m != "function" || _[l] === m || ne(e, l, m, _[l], i);
		if (u) s || d && (u.__html == d.__html || u.__html == e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
		else if (d && (e.innerHTML = ""), w(t.type == "template" ? e.content : e, Me(f) ? f : [f], t, n, r, b == "foreignObject" ? "http://www.w3.org/1999/xhtml" : i, a, o, a ? a[0] : n.__k && y(n, 0), s, c), a != null) for (l = a.length; l--;) p(a[l]);
		s && b != "textarea" || (l = "value", b == "progress" && h == null ? e.removeAttribute("value") : h != null && (h !== e[l] || b == "progress" && !h || b == "option" && h != _[l]) && ne(e, l, h, _[l], i), l = "checked", g != null && g != e[l] && ne(e, l, g, _[l], i));
	}
	return e;
}
function le(e, t, n) {
	try {
		if (typeof e == "function") {
			var r = typeof e.__u == "function";
			r && e.__u(), r && t == null || (e.__u = e(t));
		} else e.current = t;
	} catch (e) {
		O.__e(e, n);
	}
}
function ue(e, t, n) {
	var r, i;
	if (O.unmount && O.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || le(r, null, t)), (r = e.__c) != null) {
		if (r.componentWillUnmount) try {
			r.componentWillUnmount();
		} catch (e) {
			O.__e(e, t);
		}
		r.base = r.__P = r.__n = null;
	}
	if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && ue(r[i], t, n || typeof e.type != "function");
	n || p(e.__e), e.__c = e.__ = e.__e = void 0;
}
function de(e, t, n) {
	return this.constructor(e, n);
}
function fe(e, t, n) {
	var r, i, a, o;
	t == document && (t = document.documentElement), O.__ && O.__(e, t), i = (r = typeof n == "function") ? null : n && n.__k || t.__k, a = [], o = [], ie(t, e = (!r && n || t).__k = m(_, null, [e]), i || ke, ke, t.namespaceURI, !r && n ? [n] : i ? null : t.firstChild ? ge.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r, o), oe(a, e, o), e.props.children = null;
}
function pe(e, t) {
	fe(e, t, pe);
}
function me(e, t, n) {
	var r, i, a, o, s = f({}, e.props);
	for (a in e.type && e.type.defaultProps && (o = e.type.defaultProps), t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : s[a] = t[a] === void 0 && o != null ? o[a] : t[a];
	return arguments.length > 2 && (s.children = arguments.length > 3 ? ge.call(arguments, 2) : n), h(e.type, s, r || e.key, i || e.ref, null);
}
function he(e) {
	function t(e) {
		var n, r;
		return this.getChildContext || (n = /* @__PURE__ */ new Set(), (r = {})[t.__c] = this, this.getChildContext = function() {
			return r;
		}, this.componentWillUnmount = function() {
			n = null;
		}, this.shouldComponentUpdate = function(e) {
			this.props.value != e.value && n.forEach(function(e) {
				e.__e = !0, S(e);
			});
		}, this.sub = function(e) {
			n.add(e);
			var t = e.componentWillUnmount;
			e.componentWillUnmount = function() {
				n && n.delete(e), t && t.call(e);
			};
		}), e.children;
	}
	return t.__c = "__cC" + Oe++, t.__ = e, t.Provider = t.__l = (t.Consumer = function(e, t) {
		return e.children(t);
	}).contextType = t, t;
}
var ge, O, _e, ve, ye, be, xe, k, Se, Ce, we, Te, Ee, De, Oe, ke, Ae, je, Me, Ne = o((() => {
	ke = {}, Ae = [], je = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Me = Array.isArray, ge = Ae.slice, O = { __e: function(e, t, n, r) {
		for (var i, a, o; t = t.__;) if ((i = t.__c) && !i.__) try {
			if ((a = i.constructor) && a.getDerivedStateFromError != null && (i.setState(a.getDerivedStateFromError(e)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), o = i.__d), o) return i.__E = i;
		} catch (t) {
			e = t;
		}
		throw e;
	} }, _e = 0, v.prototype.setState = function(e, t) {
		var n = this.__s != null && this.__s != this.state ? this.__s : this.__s = f({}, this.state);
		typeof e == "function" && (e = e(f({}, n), this.props)), e && f(n, e), e != null && this.__v && (t && this._sb.push(t), S(this));
	}, v.prototype.forceUpdate = function(e) {
		this.__v && (this.__e = !0, e && this.__h.push(e), S(this));
	}, v.prototype.render = _, ve = [], be = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, xe = function(e, t) {
		return e.__v.__b - t.__v.__b;
	}, C.__r = 0, k = Math.random().toString(8), Se = "__d" + k, Ce = "__a" + k, we = /(PointerCapture)$|Capture$/i, Te = 0, Ee = re(!1), De = re(!0), Oe = 0;
}));
//#endregion
//#region node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
function A(e, t, n, r, i, a) {
	t ||= {};
	var o, s, c = t;
	if ("ref" in c) for (s in c = {}, t) s == "ref" ? o = t[s] : c[s] = t[s];
	var l = {
		type: e,
		props: c,
		key: n,
		ref: o,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: --Pe,
		__i: -1,
		__u: 0,
		__source: i,
		__self: a
	};
	if (typeof e == "function" && (o = e.defaultProps)) for (s in o) c[s] === void 0 && (c[s] = o[s]);
	return O.vnode && O.vnode(l), l;
}
var Pe, Fe = o((() => {
	Ne(), Pe = 0, Array.isArray;
}));
//#endregion
//#region node_modules/preact/hooks/dist/hooks.module.js
function Ie(e, t) {
	M.__h && M.__h(j, e, it || t), it = 0;
	var n = j.__H || (j.__H = {
		__: [],
		__h: []
	});
	return e >= n.__.length && n.__.push({}), n.__[e];
}
function Le(e) {
	return it = 1, Re(et, e);
}
function Re(e, t, n) {
	var r = Ie(tt++, 2);
	if (r.t = e, !r.__c && (r.__ = [n ? n(t) : et(void 0, t), function(e) {
		var t = r.__N ? r.__N[0] : r.__[0], n = r.t(t, e);
		t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
	}], r.__c = j, !j.__f)) {
		var i = function(e, t, n) {
			if (!r.__c.__H) return !0;
			var i = !1, o = r.__c.props !== e;
			if (r.__c.__H.__.some(function(e) {
				if (e.__N) {
					i = !0;
					var t = e.__[0];
					e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
				}
			}), a) {
				var s = a.call(this, e, t, n);
				return i ? s || o : s;
			}
			return !i || o;
		};
		j.__f = !0;
		var a = j.shouldComponentUpdate, o = j.componentWillUpdate;
		j.componentWillUpdate = function(e, t, n) {
			if (this.__e) {
				var r = a;
				a = void 0, i(e, t, n), a = r;
			}
			o && o.call(this, e, t, n);
		}, j.shouldComponentUpdate = i;
	}
	return r.__N || r.__;
}
function ze(e, t) {
	var n = Ie(tt++, 3);
	!M.__s && $e(n.__H, t) && (n.__ = e, n.u = t, j.__H.__h.push(n));
}
function Be(e, t) {
	var n = Ie(tt++, 4);
	!M.__s && $e(n.__H, t) && (n.__ = e, n.u = t, j.__h.push(n));
}
function Ve(e) {
	return it = 5, Ue(function() {
		return { current: e };
	}, []);
}
function He(e, t, n) {
	it = 6, Be(function() {
		if (typeof e == "function") {
			var n = e(t());
			return function() {
				e(null), n && typeof n == "function" && n();
			};
		}
		if (e) return e.current = t(), function() {
			return e.current = null;
		};
	}, n == null ? n : n.concat(e));
}
function Ue(e, t) {
	var n = Ie(tt++, 7);
	return $e(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function We(e, t) {
	return it = 8, Ue(function() {
		return e;
	}, t);
}
function Ge(e) {
	var t = j.context[e.__c], n = Ie(tt++, 9);
	return n.c = e, t ? (n.__ ?? (n.__ = !0, t.sub(j)), t.props.value) : e.__;
}
function Ke(e, t) {
	M.useDebugValue && M.useDebugValue(t ? t(e) : e);
}
function qe(e) {
	var t = Ie(tt++, 10), n = Le();
	return t.__ = e, j.componentDidCatch || (j.componentDidCatch = function(e, r) {
		t.__ && t.__(e, r), n[1](e);
	}), [n[0], function() {
		n[1](void 0);
	}];
}
function Je() {
	var e = Ie(tt++, 11);
	if (!e.__) {
		for (var t = j.__v; t !== null && !t.__m && t.__ !== null;) t = t.__;
		var n = t.__m || (t.__m = [0, 0]);
		e.__ = "P" + n[0] + "-" + n[1]++;
	}
	return e.__;
}
function Ye() {
	for (var e; e = at.shift();) {
		var t = e.__H;
		if (e.__P && t) try {
			t.__h.some(Ze), t.__h.some(Qe), t.__h = [];
		} catch (n) {
			t.__h = [], M.__e(n, e.__v);
		}
	}
}
function Xe(e) {
	var t, n = function() {
		clearTimeout(r), ft && cancelAnimationFrame(t), setTimeout(e);
	}, r = setTimeout(n, 35);
	ft && (t = requestAnimationFrame(n));
}
function Ze(e) {
	var t = j, n = e.__c;
	typeof n == "function" && (e.__c = void 0, n()), j = t;
}
function Qe(e) {
	var t = j;
	e.__c = e.__(), j = t;
}
function $e(e, t) {
	return !e || e.length !== t.length || t.some(function(t, n) {
		return t !== e[n];
	});
}
function et(e, t) {
	return typeof t == "function" ? t(e) : t;
}
var tt, j, nt, rt, it, at, M, ot, st, ct, lt, ut, dt, ft, N = o((() => {
	Ne(), it = 0, at = [], M = O, ot = M.__b, st = M.__r, ct = M.diffed, lt = M.__c, ut = M.unmount, dt = M.__, M.__b = function(e) {
		j = null, ot && ot(e);
	}, M.__ = function(e, t) {
		e && t.__k && t.__k.__m && (e.__m = t.__k.__m), dt && dt(e, t);
	}, M.__r = function(e) {
		st && st(e), tt = 0;
		var t = (j = e.__c).__H;
		t && (nt === j ? (t.__h = [], j.__h = [], t.__.some(function(e) {
			e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
		})) : (t.__h.some(Ze), t.__h.some(Qe), t.__h = [], tt = 0)), nt = j;
	}, M.diffed = function(e) {
		ct && ct(e);
		var t = e.__c;
		t && t.__H && (t.__H.__h.length && (at.push(t) !== 1 && rt === M.requestAnimationFrame || ((rt = M.requestAnimationFrame) || Xe)(Ye)), t.__H.__.some(function(e) {
			e.u &&= (e.__H = e.u, void 0);
		})), nt = j = null;
	}, M.__c = function(e, t) {
		t.some(function(e) {
			try {
				e.__h.some(Ze), e.__h = e.__h.filter(function(e) {
					return !e.__ || Qe(e);
				});
			} catch (n) {
				t.some(function(e) {
					e.__h &&= [];
				}), t = [], M.__e(n, e.__v);
			}
		}), lt && lt(e, t);
	}, M.unmount = function(e) {
		ut && ut(e);
		var t, n = e.__c;
		n && n.__H && (n.__H.__.some(function(e) {
			try {
				Ze(e);
			} catch (e) {
				t = e;
			}
		}), n.__H = void 0, t && M.__e(t, n.__v));
	}, ft = typeof requestAnimationFrame == "function";
})), pt = /* @__PURE__ */ c({
	Children: () => Kt,
	Component: () => v,
	Fragment: () => _,
	PureComponent: () => xt,
	StrictMode: () => _,
	Suspense: () => Et,
	SuspenseList: () => kt,
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: () => ln,
	cloneElement: () => zt,
	createContext: () => he,
	createElement: () => m,
	createFactory: () => Ft,
	createPortal: () => Mt,
	createRef: () => g,
	default: () => P,
	findDOMNode: () => Vt,
	flushSync: () => fn,
	forwardRef: () => Ct,
	hydrate: () => Pt,
	isElement: () => pn,
	isFragment: () => Lt,
	isMemo: () => Rt,
	isValidElement: () => It,
	lazy: () => Ot,
	memo: () => St,
	render: () => Nt,
	startTransition: () => vt,
	unmountComponentAtNode: () => Bt,
	unstable_batchedUpdates: () => dn,
	useCallback: () => We,
	useContext: () => Ge,
	useDebugValue: () => Ke,
	useDeferredValue: () => yt,
	useEffect: () => ze,
	useErrorBoundary: () => qe,
	useId: () => Je,
	useImperativeHandle: () => He,
	useInsertionEffect: () => Ht,
	useLayoutEffect: () => Be,
	useMemo: () => Ue,
	useReducer: () => Re,
	useRef: () => Ve,
	useState: () => Le,
	useSyncExternalStore: () => gt,
	useTransition: () => bt,
	version: () => un
});
function mt(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function ht(e, t) {
	for (var n in e) if (n !== "__source" && !(n in t)) return !0;
	for (var r in t) if (r !== "__source" && e[r] !== t[r]) return !0;
	return !1;
}
function gt(e, t) {
	var n = t(), r = Le({ t: {
		__: n,
		u: t
	} }), i = r[0].t, a = r[1];
	return Be(function() {
		i.__ = n, i.u = t, _t(i) && a({ t: i });
	}, [
		e,
		n,
		t
	]), ze(function() {
		return _t(i) && a({ t: i }), e(function() {
			_t(i) && a({ t: i });
		});
	}, [e]), n;
}
function _t(e) {
	try {
		return !((t = e.__) === (n = e.u()) && (t !== 0 || 1 / t == 1 / n) || t != t && n != n);
	} catch {
		return !0;
	}
	var t, n;
}
function vt(e) {
	e();
}
function yt(e) {
	return e;
}
function bt() {
	return [!1, vt];
}
function xt(e, t) {
	this.props = e, this.context = t;
}
function St(e, t) {
	function n(e) {
		var n = this.props.ref;
		return n != e.ref && n && (typeof n == "function" ? n(null) : n.current = null), t ? !t(this.props, e) || n != e.ref : ht(this.props, e);
	}
	function r(t) {
		return this.shouldComponentUpdate = n, m(e, t);
	}
	return r.displayName = "Memo(" + (e.displayName || e.name) + ")", r.__f = r.prototype.isReactComponent = !0, r.type = e, r;
}
function Ct(e) {
	function t(t) {
		var n = mt({}, t);
		return delete n.ref, e(n, t.ref || null);
	}
	return t.$$typeof = Wt, t.render = e, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
}
function wt(e, t, n) {
	return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(e) {
		typeof e.__c == "function" && e.__c();
	}), e.__c.__H = null), (e = mt({}, e)).__c != null && (e.__c.__P === n && (e.__c.__P = t), e.__c.__e = !0, e.__c = null), e.__k = e.__k && e.__k.map(function(e) {
		return wt(e, t, n);
	})), e;
}
function Tt(e, t, n) {
	return e && n && (e.__v = null, e.__k = e.__k && e.__k.map(function(e) {
		return Tt(e, t, n);
	}), e.__c && e.__c.__P === t && (e.__e && n.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = n)), e;
}
function Et() {
	this.__u = 0, this.o = null, this.__b = null;
}
function Dt(e) {
	var t = e.__ && e.__.__c;
	return t && t.__a && t.__a(e);
}
function Ot(e) {
	var t, n, r, i = null;
	function a(a) {
		if (t || (t = e()).then(function(e) {
			e && (i = e.default || e), r = !0;
		}, function(e) {
			n = e, r = !0;
		}), n) throw n;
		if (!r) throw t;
		return i ? m(i, a) : null;
	}
	return a.displayName = "Lazy", a.__f = !0, a;
}
function kt() {
	this.i = null, this.l = null;
}
function At(e) {
	return this.getChildContext = function() {
		return e.context;
	}, e.children;
}
function jt(e) {
	var t = this, n = e.h;
	if (t.componentWillUnmount = function() {
		fe(null, t.v), t.v = null, t.h = null;
	}, t.h && t.h !== n && t.componentWillUnmount(), !t.v) {
		for (var r = t.__v; r !== null && !r.__m && r.__ !== null;) r = r.__;
		t.h = n, t.v = {
			nodeType: 1,
			parentNode: n,
			childNodes: [],
			__k: { __m: r.__m },
			contains: function() {
				return !0;
			},
			namespaceURI: n.namespaceURI,
			insertBefore: function(e, n) {
				this.childNodes.push(e), t.h.insertBefore(e, n);
			},
			removeChild: function(e) {
				this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.h.removeChild(e);
			}
		};
	}
	fe(m(At, { context: t.context }, e.__v), t.v);
}
function Mt(e, t) {
	var n = m(jt, {
		__v: e,
		h: t
	});
	return n.containerInfo = t, n;
}
function Nt(e, t, n) {
	return t.__k ?? (t.textContent = ""), fe(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function Pt(e, t, n) {
	return pe(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function Ft(e) {
	return m.bind(null, e);
}
function It(e) {
	return !!e && e.$$typeof === Xt;
}
function Lt(e) {
	return It(e) && e.type === _;
}
function Rt(e) {
	return !!e && typeof e.displayName == "string" && e.displayName.indexOf("Memo(") == 0;
}
function zt(e) {
	return It(e) ? me.apply(null, arguments) : e;
}
function Bt(e) {
	return !!e.__k && (fe(null, e), !0);
}
function Vt(e) {
	return e && (e.base || e.nodeType === 1 && e) || null;
}
var Ht, Ut, Wt, Gt, Kt, qt, Jt, Yt, Xt, Zt, Qt, $t, en, tn, nn, rn, an, on, sn, cn, ln, un, dn, fn, pn, P, mn = o((() => {
	Ne(), N(), N(), Ht = Be, (xt.prototype = new v()).isPureReactComponent = !0, xt.prototype.shouldComponentUpdate = function(e, t) {
		return ht(this.props, e) || ht(this.state, t);
	}, Ut = O.__b, O.__b = function(e) {
		e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Ut && Ut(e);
	}, Wt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911, Gt = function(e, t) {
		return e == null ? null : D(D(e).map(t));
	}, Kt = {
		map: Gt,
		forEach: Gt,
		count: function(e) {
			return e ? D(e).length : 0;
		},
		only: function(e) {
			var t = D(e);
			if (t.length !== 1) throw "Children.only";
			return t[0];
		},
		toArray: D
	}, qt = O.__e, O.__e = function(e, t, n, r) {
		if (e.then) {
			for (var i, a = t; a = a.__;) if ((i = a.__c) && i.__c) return t.__e ?? (t.__e = n.__e, t.__k = n.__k || []), i.__c(e, t);
		}
		qt(e, t, n, r);
	}, Jt = O.unmount, O.unmount = function(e) {
		var t = e.__c;
		t && (t.__z = !0), t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), Jt && Jt(e);
	}, (Et.prototype = new v()).__c = function(e, t) {
		var n = t.__c, r = this;
		r.o ??= [], r.o.push(n);
		var i = Dt(r.__v), a = !1, o = function() {
			a || r.__z || (a = !0, n.__R = null, i ? i(c) : c());
		};
		n.__R = o;
		var s = n.__P;
		n.__P = null;
		var c = function() {
			if (!--r.__u) {
				if (r.state.__a) {
					var e = r.state.__a;
					r.__v.__k[0] = Tt(e, e.__c.__P, e.__c.__O);
				}
				var t;
				for (r.setState({ __a: r.__b = null }); t = r.o.pop();) t.__P = s, t.forceUpdate();
			}
		};
		r.__u++ || 32 & t.__u || r.setState({ __a: r.__b = r.__v.__k[0] }), e.then(o, o);
	}, Et.prototype.componentWillUnmount = function() {
		this.o = [];
	}, Et.prototype.render = function(e, t) {
		if (this.__b) {
			if (this.__v.__k) {
				var n = document.createElement("div"), r = this.__v.__k[0].__c;
				this.__v.__k[0] = wt(this.__b, n, r.__O = r.__P);
			}
			this.__b = null;
		}
		var i = t.__a && m(_, null, e.fallback);
		return i && (i.__u &= -33), [m(_, null, t.__a ? null : e.children), i];
	}, Yt = function(e, t, n) {
		if (++n[1] === n[0] && e.l.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.l.size)) for (n = e.i; n;) {
			for (; n.length > 3;) n.pop()();
			if (n[1] < n[0]) break;
			e.i = n = n[2];
		}
	}, (kt.prototype = new v()).__a = function(e) {
		var t = this, n = Dt(t.__v), r = t.l.get(e);
		return r[0]++, function(i) {
			var a = function() {
				t.props.revealOrder ? (r.push(i), Yt(t, e, r)) : i();
			};
			n ? n(a) : a();
		};
	}, kt.prototype.render = function(e) {
		this.i = null, this.l = /* @__PURE__ */ new Map();
		var t = D(e.children);
		e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
		for (var n = t.length; n--;) this.l.set(t[n], this.i = [
			1,
			0,
			this.i
		]);
		return e.children;
	}, kt.prototype.componentDidUpdate = kt.prototype.componentDidMount = function() {
		var e = this;
		this.l.forEach(function(t, n) {
			Yt(e, n, t);
		});
	}, Xt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, Zt = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Qt = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $t = /[A-Z0-9]/g, en = typeof document < "u", tn = function(e) {
		return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(e);
	}, v.prototype.isReactComponent = !0, [
		"componentWillMount",
		"componentWillReceiveProps",
		"componentWillUpdate"
	].forEach(function(e) {
		Object.defineProperty(v.prototype, e, {
			configurable: !0,
			get: function() {
				return this["UNSAFE_" + e];
			},
			set: function(t) {
				Object.defineProperty(this, e, {
					configurable: !0,
					writable: !0,
					value: t
				});
			}
		});
	}), nn = O.event, O.event = function(e) {
		return nn && (e = nn(e)), e.persist = function() {}, e.isPropagationStopped = function() {
			return this.cancelBubble;
		}, e.isDefaultPrevented = function() {
			return this.defaultPrevented;
		}, e.nativeEvent = e;
	}, an = {
		configurable: !0,
		get: function() {
			return this.class;
		}
	}, on = O.vnode, O.vnode = function(e) {
		typeof e.type == "string" && function(e) {
			var t = e.props, n = e.type, r = {}, i = n.indexOf("-") == -1;
			for (var a in t) {
				var o = t[a];
				if (!(a === "value" && "defaultValue" in t && o == null || en && a === "children" && n === "noscript" || a === "class" || a === "className")) {
					var s = a.toLowerCase();
					a === "defaultValue" && "value" in t && t.value == null ? a = "value" : a === "download" && !0 === o ? o = "" : s === "translate" && o === "no" ? o = !1 : s[0] === "o" && s[1] === "n" ? s === "ondoubleclick" ? a = "ondblclick" : s !== "onchange" || n !== "input" && n !== "textarea" || tn(t.type) ? s === "onfocus" ? a = "onfocusin" : s === "onblur" ? a = "onfocusout" : Qt.test(a) && (a = s) : s = a = "oninput" : i && Zt.test(a) ? a = a.replace($t, "-$&").toLowerCase() : o === null && (o = void 0), s === "oninput" && r[a = s] && (a = "oninputCapture"), r[a] = o;
				}
			}
			n == "select" && (r.multiple && Array.isArray(r.value) && (r.value = D(t.children).forEach(function(e) {
				e.props.selected = r.value.indexOf(e.props.value) != -1;
			})), r.defaultValue != null && (r.value = D(t.children).forEach(function(e) {
				e.props.selected = r.multiple ? r.defaultValue.indexOf(e.props.value) != -1 : r.defaultValue == e.props.value;
			}))), t.class && !t.className ? (r.class = t.class, Object.defineProperty(r, "className", an)) : t.className && (r.class = r.className = t.className), e.props = r;
		}(e), e.$$typeof = Xt, on && on(e);
	}, sn = O.__r, O.__r = function(e) {
		sn && sn(e), rn = e.__c;
	}, cn = O.diffed, O.diffed = function(e) {
		cn && cn(e);
		var t = e.props, n = e.__e;
		n != null && e.type === "textarea" && "value" in t && t.value !== n.value && (n.value = t.value == null ? "" : t.value), rn = null;
	}, ln = { ReactCurrentDispatcher: { current: {
		readContext: function(e) {
			return rn.__n[e.__c].props.value;
		},
		useCallback: We,
		useContext: Ge,
		useDebugValue: Ke,
		useDeferredValue: yt,
		useEffect: ze,
		useId: Je,
		useImperativeHandle: He,
		useInsertionEffect: Ht,
		useLayoutEffect: Be,
		useMemo: Ue,
		useReducer: Re,
		useRef: Ve,
		useState: Le,
		useSyncExternalStore: gt,
		useTransition: bt
	} } }, un = "18.3.1", dn = function(e, t) {
		return e(t);
	}, fn = function(e, t) {
		var n, r = O.debounceRendering;
		O.debounceRendering = function(e) {
			n = e;
		};
		try {
			var i = e(t);
			return n && n(), i;
		} finally {
			O.debounceRendering = r;
		}
	}, pn = It, P = {
		useState: Le,
		useId: Je,
		useReducer: Re,
		useEffect: ze,
		useLayoutEffect: Be,
		useInsertionEffect: Ht,
		useTransition: bt,
		useDeferredValue: yt,
		useSyncExternalStore: gt,
		startTransition: vt,
		useRef: Ve,
		useImperativeHandle: He,
		useMemo: Ue,
		useCallback: We,
		useContext: Ge,
		useDebugValue: Ke,
		version: "18.3.1",
		Children: Kt,
		render: Nt,
		hydrate: Pt,
		unmountComponentAtNode: Bt,
		createPortal: Mt,
		createElement: m,
		createContext: he,
		createFactory: Ft,
		cloneElement: zt,
		createRef: g,
		Fragment: _,
		isValidElement: It,
		isElement: pn,
		isFragment: Lt,
		isMemo: Rt,
		findDOMNode: Vt,
		Component: v,
		PureComponent: xt,
		memo: St,
		forwardRef: Ct,
		flushSync: fn,
		unstable_batchedUpdates: dn,
		StrictMode: _,
		Suspense: Et,
		SuspenseList: kt,
		lazy: Ot,
		__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ln
	};
}));
//#endregion
//#region node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
function hn(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function gn(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var _n, vn = o((() => {
	_n = /*#__PURE__*/ function() {
		function e(e) {
			var t = this;
			this._insertTag = function(e) {
				var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
				t.container.insertBefore(e, n), t.tags.push(e);
			}, this.isSpeedy = e.speedy === void 0 || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
		}
		var t = e.prototype;
		return t.hydrate = function(e) {
			e.forEach(this._insertTag);
		}, t.insert = function(e) {
			this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(gn(this));
			var t = this.tags[this.tags.length - 1];
			if (this.isSpeedy) {
				var n = hn(t);
				try {
					n.insertRule(e, n.cssRules.length);
				} catch {}
			} else t.appendChild(document.createTextNode(e));
			this.ctr++;
		}, t.flush = function() {
			this.tags.forEach(function(e) {
				return e.parentNode?.removeChild(e);
			}), this.tags = [], this.ctr = 0;
		}, e;
	}();
})), yn, bn, F, xn, Sn, Cn, wn, Tn, En, Dn = o((() => {
	yn = "-ms-", bn = "-moz-", F = "-webkit-", xn = "comm", Sn = "rule", Cn = "decl", wn = "@import", Tn = "@keyframes", En = "@layer";
}));
//#endregion
//#region node_modules/stylis/src/Utility.js
function On(e, t) {
	return Mn(e, 0) ^ 45 ? (((t << 2 ^ Mn(e, 0)) << 2 ^ Mn(e, 1)) << 2 ^ Mn(e, 2)) << 2 ^ Mn(e, 3) : 0;
}
function kn(e) {
	return e.trim();
}
function An(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function I(e, t, n) {
	return e.replace(t, n);
}
function jn(e, t) {
	return e.indexOf(t);
}
function Mn(e, t) {
	return e.charCodeAt(t) | 0;
}
function Nn(e, t, n) {
	return e.slice(t, n);
}
function Pn(e) {
	return e.length;
}
function Fn(e) {
	return e.length;
}
function In(e, t) {
	return t.push(e), e;
}
function Ln(e, t) {
	return e.map(t).join("");
}
var Rn, zn, Bn, Vn = o((() => {
	Rn = Math.abs, zn = String.fromCharCode, Bn = Object.assign;
}));
//#endregion
//#region node_modules/stylis/src/Tokenizer.js
function Hn(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: ar,
		column: or,
		length: o,
		return: ""
	};
}
function Un(e, t) {
	return Bn(Hn("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Wn() {
	return lr;
}
function Gn() {
	return lr = cr > 0 ? Mn(ur, --cr) : 0, or--, lr === 10 && (or = 1, ar--), lr;
}
function Kn() {
	return lr = cr < sr ? Mn(ur, cr++) : 0, or++, lr === 10 && (or = 1, ar++), lr;
}
function qn() {
	return Mn(ur, cr);
}
function Jn() {
	return cr;
}
function Yn(e, t) {
	return Nn(ur, e, t);
}
function Xn(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function Zn(e) {
	return ar = or = 1, sr = Pn(ur = e), cr = 0, [];
}
function Qn(e) {
	return ur = "", e;
}
function $n(e) {
	return kn(Yn(cr - 1, nr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function er(e) {
	for (; (lr = qn()) && lr < 33;) Kn();
	return Xn(e) > 2 || Xn(lr) > 3 ? "" : " ";
}
function tr(e, t) {
	for (; --t && Kn() && !(lr < 48 || lr > 102 || lr > 57 && lr < 65 || lr > 70 && lr < 97););
	return Yn(e, Jn() + (t < 6 && qn() == 32 && Kn() == 32));
}
function nr(e) {
	for (; Kn();) switch (lr) {
		case e: return cr;
		case 34:
		case 39:
			e !== 34 && e !== 39 && nr(lr);
			break;
		case 40:
			e === 41 && nr(e);
			break;
		case 92: Kn();
	}
	return cr;
}
function rr(e, t) {
	for (; Kn() && e + lr !== 57 && (e + lr !== 84 || qn() !== 47););
	return "/*" + Yn(t, cr - 1) + "*" + zn(e === 47 ? e : Kn());
}
function ir(e) {
	for (; !Xn(qn());) Kn();
	return Yn(e, cr);
}
var ar, or, sr, cr, lr, ur, dr = o((() => {
	Vn(), ar = 1, or = 1, sr = 0, cr = 0, lr = 0, ur = "";
}));
//#endregion
//#region node_modules/stylis/src/Parser.js
function fr(e) {
	return Qn(pr("", null, null, null, [""], e = Zn(e), 0, [0], e));
}
function pr(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, x = a, S = r, C = y; g;) switch (m = v, v = Kn()) {
		case 40: if (m != 108 && Mn(C, d - 1) == 58) {
			jn(C += I($n(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			C += $n(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			C += er(m);
			break;
		case 92:
			C += tr(Jn() - 1, 7);
			continue;
		case 47:
			switch (qn()) {
				case 42:
				case 47:
					In(hr(rr(Kn(), Jn()), t, n), c);
					break;
				default: C += "/";
			}
			break;
		case 123 * h: s[l++] = Pn(C) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (C = I(C, /\f/g, "")), p > 0 && Pn(C) - d && In(p > 32 ? gr(C + ";", r, n, d - 1) : gr(I(C, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: C += ";";
				default: if (In(S = mr(C, t, n, l, u, i, s, y, b = [], x = [], d), a), v === 123) {
					if (u === 0) pr(C, t, S, S, b, a, d, s, x);
					else switch (f === 99 && Mn(C, 3) === 110 ? 100 : f) {
						case 100:
						case 108:
						case 109:
						case 115:
							pr(e, S, S, r && In(mr(e, S, S, 0, 0, i, s, y, i, b = [], d), x), i, x, d, s, r ? b : x);
							break;
						default: pr(C, S, S, S, [""], x, 0, s, x);
					}
				}
			}
			l = u = p = 0, h = _ = 1, y = C = "", d = o;
			break;
		case 58: d = 1 + Pn(C), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && Gn() == 125) continue;
			}
			switch (C += zn(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (C += "\f", -1);
					break;
				case 44:
					s[l++] = (Pn(C) - 1) * _, _ = 1;
					break;
				case 64:
					qn() === 45 && (C += $n(Kn())), f = qn(), u = d = Pn(y = C += ir(Jn())), v++;
					break;
				case 45: m === 45 && Pn(C) == 2 && (h = 0);
			}
	}
	return a;
}
function mr(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = Fn(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = Nn(e, d + 1, d = Rn(h = o[m])), y = e; _ < p; ++_) (y = kn(h > 0 ? f[_] + " " + v : I(v, /&\f/g, f[_]))) && (c[g++] = y);
	return Hn(e, t, n, i === 0 ? Sn : s, c, l, u);
}
function hr(e, t, n) {
	return Hn(e, t, n, xn, zn(Wn()), Nn(e, 2, -2), 0);
}
function gr(e, t, n, r) {
	return Hn(e, t, n, Cn, Nn(e, 0, r), Nn(e, r + 1, -1), r);
}
var _r = o((() => {
	Dn(), Vn(), dr();
})), vr = o((() => {}));
//#endregion
//#region node_modules/stylis/src/Serializer.js
function yr(e, t) {
	for (var n = "", r = Fn(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function br(e, t, n, r) {
	switch (e.type) {
		case En: if (e.children.length) break;
		case wn:
		case Cn: return e.return = e.return || e.value;
		case xn: return "";
		case Tn: return e.return = e.value + "{" + yr(e.children, r) + "}";
		case Sn: e.value = e.props.join(",");
	}
	return Pn(n = yr(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
var xr = o((() => {
	Dn(), Vn();
}));
//#endregion
//#region node_modules/stylis/src/Middleware.js
function Sr(e) {
	var t = Fn(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function Cr(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
var wr = o((() => {
	Vn();
})), Tr = o((() => {
	Dn(), Vn(), _r(), vr(), dr(), xr(), wr();
}));
//#endregion
//#region node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function Er(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
var Dr = o((() => {}));
//#endregion
//#region node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
function Or(e, t) {
	switch (On(e, t)) {
		case 5103: return F + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return F + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return F + e + bn + e + yn + e + e;
		case 6828:
		case 4268: return F + e + yn + e + e;
		case 6165: return F + e + yn + "flex-" + e + e;
		case 5187: return F + e + I(e, /(\w+).+(:[^]+)/, F + "box-$1$2" + yn + "flex-$1$2") + e;
		case 5443: return F + e + yn + "flex-item-" + I(e, /flex-|-self/, "") + e;
		case 4675: return F + e + yn + "flex-line-pack" + I(e, /align-content|flex-|-self/, "") + e;
		case 5548: return F + e + yn + I(e, "shrink", "negative") + e;
		case 5292: return F + e + yn + I(e, "basis", "preferred-size") + e;
		case 6060: return F + "box-" + I(e, "-grow", "") + F + e + yn + I(e, "grow", "positive") + e;
		case 4554: return F + I(e, /([^-])(transform)/g, "$1" + F + "$2") + e;
		case 6187: return I(I(I(e, /(zoom-|grab)/, F + "$1"), /(image-set)/, F + "$1"), e, "") + e;
		case 5495:
		case 3959: return I(e, /(image-set\([^]*)/, F + "$1$`$1");
		case 4968: return I(I(e, /(.+:)(flex-)?(.*)/, F + "box-pack:$3" + yn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + F + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return I(e, /(.+)-inline(.+)/, F + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (Pn(e) - 1 - t > 6) switch (Mn(e, t + 1)) {
				case 109: if (Mn(e, t + 4) !== 45) break;
				case 102: return I(e, /(.+:)(.+)-([^]+)/, "$1" + F + "$2-$3$1" + bn + (Mn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~jn(e, "stretch") ? Or(I(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (Mn(e, t + 1) !== 115) break;
		case 6444:
			switch (Mn(e, Pn(e) - 3 - (~jn(e, "!important") && 10))) {
				case 107: return I(e, ":", ":" + F) + e;
				case 101: return I(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + F + (Mn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + F + "$2$3$1" + yn + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (Mn(e, t + 11)) {
				case 114: return F + e + yn + I(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return F + e + yn + I(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return F + e + yn + I(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return F + e + yn + e + e;
	}
	return e;
}
var kr, Ar, jr, Mr, Nr, Pr, Fr, Ir, Lr = o((() => {
	vn(), Tr(), kr = function(e, t, n) {
		for (var r = 0, i = 0; r = i, i = qn(), r === 38 && i === 12 && (t[n] = 1), !Xn(i);) Kn();
		return Yn(e, cr);
	}, Ar = function(e, t) {
		var n = -1, r = 44;
		do
			switch (Xn(r)) {
				case 0:
					r === 38 && qn() === 12 && (t[n] = 1), e[n] += kr(cr - 1, t, n);
					break;
				case 2:
					e[n] += $n(r);
					break;
				case 4: if (r === 44) {
					e[++n] = qn() === 58 ? "&\f" : "", t[n] = e[n].length;
					break;
				}
				default: e[n] += zn(r);
			}
		while (r = Kn());
		return e;
	}, jr = function(e, t) {
		return Qn(Ar(Zn(e), t));
	}, Mr = /* #__PURE__ */ new WeakMap(), Nr = function(e) {
		if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
			for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
			if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !Mr.get(n)) && !r) {
				Mr.set(e, !0);
				for (var i = [], a = jr(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
			}
		}
	}, Pr = function(e) {
		if (e.type === "decl") {
			var t = e.value;
			t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
		}
	}, Fr = [function(e, t, n, r) {
		if (e.length > -1 && !e.return) switch (e.type) {
			case Cn:
				e.return = Or(e.value, e.length);
				break;
			case Tn: return yr([Un(e, { value: I(e.value, "@", "@" + F) })], r);
			case Sn: if (e.length) return Ln(e.props, function(t) {
				switch (An(t, /(::plac\w+|:read-\w+)/)) {
					case ":read-only":
					case ":read-write": return yr([Un(e, { props: [I(t, /:(read-\w+)/, ":" + bn + "$1")] })], r);
					case "::placeholder": return yr([
						Un(e, { props: [I(t, /:(plac\w+)/, ":" + F + "input-$1")] }),
						Un(e, { props: [I(t, /:(plac\w+)/, ":" + bn + "$1")] }),
						Un(e, { props: [I(t, /:(plac\w+)/, yn + "input-$1")] })
					], r);
				}
				return "";
			});
		}
	}], Ir = function(e) {
		var t = e.key;
		if (t === "css") {
			var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
			Array.prototype.forEach.call(n, function(e) {
				e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
			});
		}
		var r = e.stylisPlugins || Fr, i = {}, a, o = [];
		a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
			for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
			o.push(e);
		});
		var s, c = [Nr, Pr], l, u = [br, Cr(function(e) {
			l.insert(e);
		})], d = Sr(c.concat(r, u)), f = function(e) {
			return yr(fr(e), d);
		};
		s = function(e, t, n, r) {
			l = n, f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
		};
		var p = {
			key: t,
			sheet: new _n({
				key: t,
				container: a,
				nonce: e.nonce,
				speedy: e.speedy,
				prepend: e.prepend,
				insertionPoint: e.insertionPoint
			}),
			nonce: e.nonce,
			inserted: i,
			registered: {},
			insert: s
		};
		return p.sheet.hydrate(o), p;
	};
})), Rr = /* @__PURE__ */ s(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), zr = /* @__PURE__ */ s(((e, t) => {
	t.exports = Rr();
})), Br = /* @__PURE__ */ s(((e, t) => {
	var n = zr(), r = {
		childContextTypes: !0,
		contextType: !0,
		contextTypes: !0,
		defaultProps: !0,
		displayName: !0,
		getDefaultProps: !0,
		getDerivedStateFromError: !0,
		getDerivedStateFromProps: !0,
		mixins: !0,
		propTypes: !0,
		type: !0
	}, i = {
		name: !0,
		length: !0,
		prototype: !0,
		caller: !0,
		callee: !0,
		arguments: !0,
		arity: !0
	}, a = {
		$$typeof: !0,
		render: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0
	}, o = {
		$$typeof: !0,
		compare: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0,
		type: !0
	}, s = {};
	s[n.ForwardRef] = a, s[n.Memo] = o;
	function c(e) {
		return n.isMemo(e) ? o : s[e.$$typeof] || r;
	}
	var l = Object.defineProperty, u = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
	function h(e, t, n) {
		if (typeof t != "string") {
			if (m) {
				var r = p(t);
				r && r !== m && h(e, r, n);
			}
			var a = u(t);
			d && (a = a.concat(d(t)));
			for (var o = c(e), s = c(t), g = 0; g < a.length; ++g) {
				var _ = a[g];
				if (!i[_] && !(n && n[_]) && !(s && s[_]) && !(o && o[_])) {
					var v = f(t, _);
					try {
						l(e, _, v);
					} catch {}
				}
			}
		}
		return e;
	}
	t.exports = h;
}));
//#endregion
//#region node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
function Vr(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? n && (r += n + " ") : t.push(e[n] + ";");
	}), r;
}
var Hr, Ur, Wr = o((() => {
	Hr = function(e, t, n) {
		var r = e.key + "-" + t.name;
		n === !1 && e.registered[r] === void 0 && (e.registered[r] = t.styles);
	}, Ur = function(e, t, n) {
		Hr(e, t, n);
		var r = e.key + "-" + t.name;
		if (e.inserted[t.name] === void 0) {
			var i = t;
			do
				e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
			while (i !== void 0);
		}
	};
}));
//#endregion
//#region node_modules/@emotion/hash/dist/emotion-hash.esm.js
function Gr(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Kr = o((() => {})), qr, Jr = o((() => {
	qr = {
		animationIterationCount: 1,
		aspectRatio: 1,
		borderImageOutset: 1,
		borderImageSlice: 1,
		borderImageWidth: 1,
		boxFlex: 1,
		boxFlexGroup: 1,
		boxOrdinalGroup: 1,
		columnCount: 1,
		columns: 1,
		flex: 1,
		flexGrow: 1,
		flexPositive: 1,
		flexShrink: 1,
		flexNegative: 1,
		flexOrder: 1,
		gridRow: 1,
		gridRowEnd: 1,
		gridRowSpan: 1,
		gridRowStart: 1,
		gridColumn: 1,
		gridColumnEnd: 1,
		gridColumnSpan: 1,
		gridColumnStart: 1,
		msGridRow: 1,
		msGridRowSpan: 1,
		msGridColumn: 1,
		msGridColumnSpan: 1,
		fontWeight: 1,
		lineHeight: 1,
		opacity: 1,
		order: 1,
		orphans: 1,
		scale: 1,
		tabSize: 1,
		widows: 1,
		zIndex: 1,
		zoom: 1,
		WebkitLineClamp: 1,
		fillOpacity: 1,
		floodOpacity: 1,
		stopOpacity: 1,
		strokeDasharray: 1,
		strokeDashoffset: 1,
		strokeMiterlimit: 1,
		strokeOpacity: 1,
		strokeWidth: 1
	};
}));
//#endregion
//#region node_modules/@emotion/serialize/dist/emotion-serialize.esm.js
function Yr(e, t, n) {
	if (n == null) return "";
	var r = n;
	if (r.__emotion_styles !== void 0) return r;
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			var i = n;
			if (i.anim === 1) return si = {
				name: i.name,
				styles: i.styles,
				next: si
			}, i.name;
			var a = n;
			if (a.styles !== void 0) {
				var o = a.next;
				if (o !== void 0) for (; o !== void 0;) si = {
					name: o.name,
					styles: o.styles,
					next: si
				}, o = o.next;
				return a.styles + ";";
			}
			return Xr(e, t, n);
		case "function": if (e !== void 0) {
			var s = si, c = n(e);
			return si = s, Yr(e, t, c);
		}
	}
	var l = n;
	if (t == null) return l;
	var u = t[l];
	return u === void 0 ? l : u;
}
function Xr(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += Yr(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") {
			var s = o;
			t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : ni(s) && (r += ri(a) + ":" + ii(a, s) + ";");
		} else {
			if (a === "NO_COMPONENT_SELECTOR" && Qr) throw Error(ai);
			if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var c = 0; c < o.length; c++) ni(o[c]) && (r += ri(a) + ":" + ii(a, o[c]) + ";");
			else {
				var l = Yr(e, t, o);
				switch (a) {
					case "animation":
					case "animationName":
						r += ri(a) + ":" + l + ";";
						break;
					default: r += a + "{" + l + "}";
				}
			}
		}
	}
	return r;
}
function Zr(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	si = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += Yr(n, t, a)) : i += a[0];
	for (var o = 1; o < e.length; o++) i += Yr(n, t, e[o]), r && (i += a[o]);
	oi.lastIndex = 0;
	for (var s = "", c; (c = oi.exec(i)) !== null;) s += "-" + c[1];
	return {
		name: Gr(i) + s,
		styles: i,
		next: si
	};
}
var Qr, $r, ei, ti, ni, ri, ii, ai, oi, si, ci = o((() => {
	Kr(), Jr(), Dr(), Qr = !1, $r = /[A-Z]|^ms/g, ei = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ti = function(e) {
		return e.charCodeAt(1) === 45;
	}, ni = function(e) {
		return e != null && typeof e != "boolean";
	}, ri = /* #__PURE__ */ Er(function(e) {
		return ti(e) ? e : e.replace($r, "-$&").toLowerCase();
	}), ii = function(e, t) {
		switch (e) {
			case "animation":
			case "animationName": if (typeof t == "string") return t.replace(ei, function(e, t, n) {
				return si = {
					name: t,
					styles: n,
					next: si
				}, t;
			});
		}
		return qr[e] !== 1 && !ti(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
	}, ai = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.", oi = /label:\s*([^\s;{]+)\s*(;|$)/g;
})), li, ui, di, fi = o((() => {
	mn(), li = function(e) {
		return e();
	}, ui = Ht || !1, di = ui || li;
})), pi, mi, hi, gi, _i, vi, yi, bi, xi, Si, Ci = o((() => {
	mn(), Lr(), Wr(), ci(), fi(), pi = /* #__PURE__ */ he(typeof HTMLElement < "u" ? /* #__PURE__ */ Ir({ key: "css" }) : null), mi = pi.Provider, hi = function(e) {
		return /*#__PURE__*/ Ct(function(t, n) {
			return e(t, Ge(pi), n);
		});
	}, gi = /* #__PURE__ */ he({}), _i = function() {
		return Ge(gi);
	}, vi = {}.hasOwnProperty, yi = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", bi = function(e, t) {
		var n = {};
		for (var r in t) vi.call(t, r) && (n[r] = t[r]);
		return n[yi] = e, n;
	}, xi = function(e) {
		var t = e.cache, n = e.serialized, r = e.isStringTag;
		return Hr(t, n, r), di(function() {
			return Ur(t, n, r);
		}), null;
	}, Si = /* @__PURE__ */ hi(function(e, t, n) {
		var r = e.css;
		typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
		var i = e[yi], a = [r], o = "";
		typeof e.className == "string" ? o = Vr(t.registered, a, e.className) : e.className != null && (o = e.className + " ");
		var s = Zr(a, void 0, Ge(gi));
		o += t.key + "-" + s.name;
		var c = {};
		for (var l in e) vi.call(e, l) && l !== "css" && l !== yi && (c[l] = e[l]);
		return c.className = o, n && (c.ref = n), /*#__PURE__*/ m(_, null, /*#__PURE__*/ m(xi, {
			cache: t,
			serialized: s,
			isStringTag: typeof i == "string"
		}), /*#__PURE__*/ m(i, c));
	});
}));
//#endregion
//#region node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
function L(e, t, n) {
	return vi.call(t, "css") ? A(Si, bi(e, t), n) : A(e, t, n);
}
function wi(e, t, n) {
	return vi.call(t, "css") ? A(Si, bi(e, t), n) : A(e, t, n);
}
var Ti, Ei = o((() => {
	Fe(), Ci(), mn(), Br(), fi(), Ti = _;
})), R = /* @__PURE__ */ s(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return Object.propertyIsEnumerable.call(e, t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (r[i] = p(e, i) && n.isMergeableObject(t[i]) ? u(i, n)(e[i], t[i], n) : c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
}));
//#endregion
//#region node_modules/is-plain-object/dist/is-plain-object.mjs
function Di(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Oi(e) {
	var t, n;
	return Di(e) !== !1 && (t = e.constructor, t === void 0 || (n = t.prototype, Di(n) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1));
}
var ki = o((() => {}));
//#endregion
//#region node_modules/mobx/dist/mobx.esm.js
function z(e) {
	var t = [...arguments].slice(1);
	throw Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (t.length ? " " + t.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
function Ai() {
	return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : Rs;
}
function ji() {
	Gs || z("Proxy not available");
}
function Mi(e) {
	var t = !1;
	return function() {
		if (!t) return t = !0, e.apply(this, arguments);
	};
}
function Ni(e) {
	return typeof e == "function";
}
function Pi(e) {
	switch (typeof e) {
		case "string":
		case "symbol":
		case "number": return !0;
	}
	return !1;
}
function Fi(e) {
	return typeof e == "object" && !!e;
}
function Ii(e) {
	if (!Fi(e)) return !1;
	var t = Object.getPrototypeOf(e);
	if (t == null) return !0;
	var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n.toString() === Ks;
}
function Li(e) {
	var t = e?.constructor;
	return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ri(e, t, n) {
	Vs(e, t, {
		enumerable: !1,
		writable: !0,
		configurable: !0,
		value: n
	});
}
function zi(e, t, n) {
	Vs(e, t, {
		enumerable: !1,
		writable: !1,
		configurable: !0,
		value: n
	});
}
function Bi(e, t) {
	var n = "isMobX" + e;
	return t.prototype[n] = !0, function(e) {
		return Fi(e) && e[n] === !0;
	};
}
function Vi(e) {
	return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function Hi(e) {
	var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t);
	return Object.getPrototypeOf(n) === null;
}
function Ui(e) {
	return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
function Wi(e) {
	var t = Object.keys(e);
	if (!Js) return t;
	var n = Object.getOwnPropertySymbols(e);
	return n.length ? [].concat(t, n.filter(function(t) {
		return Hs.propertyIsEnumerable.call(e, t);
	})) : t;
}
function Gi(e) {
	return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Ki(e, t) {
	return Hs.hasOwnProperty.call(e, t);
}
function qi(e, t) {
	return !!(e & t);
}
function Ji(e, t, n) {
	return n ? e |= t : e &= ~t, e;
}
function Yi(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Xi(e, t, n) {
	if (ia()) return Reflect.construct.apply(null, arguments);
	var r = [null];
	r.push.apply(r, t);
	var i = new (e.bind.apply(e, r))();
	return n && aa(i, n.prototype), i;
}
function Zi(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, sa(r.key), r);
	}
}
function Qi(e, t, n) {
	return t && Zi(e.prototype, t), n && Zi(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function $i(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = ca(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ea() {
	return ea = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, ea.apply(null, arguments);
}
function ta(e) {
	return ta = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
		return e.__proto__ || Object.getPrototypeOf(e);
	}, ta(e);
}
function na(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, aa(e, t);
}
function ra(e) {
	try {
		return Function.toString.call(e).indexOf("[native code]") !== -1;
	} catch {
		return typeof e == "function";
	}
}
function ia() {
	try {
		var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch {}
	return (ia = function() {
		return !!e;
	})();
}
function aa(e, t) {
	return aa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, aa(e, t);
}
function oa(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function sa(e) {
	var t = oa(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function ca(e, t) {
	if (e) {
		if (typeof e == "string") return Yi(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Yi(e, t) : void 0;
	}
}
function la(e) {
	var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
	return la = function(e) {
		if (e === null || !ra(e)) return e;
		if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
		if (t !== void 0) {
			if (t.has(e)) return t.get(e);
			t.set(e, n);
		}
		function n() {
			return Xi(e, arguments, ta(this).constructor);
		}
		return n.prototype = Object.create(e.prototype, { constructor: {
			value: n,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }), aa(n, e);
	}, la(e);
}
function ua(e) {
	function t(t, n) {
		if (pa(n)) return e.decorate_20223_(t, n);
		da(t, n, e);
	}
	return Object.assign(t, e);
}
function da(e, t, n) {
	Ki(e, Zs) || Ri(e, Zs, ea({}, e[Zs])), Ca(n) || (e[Zs][t] = n);
}
function fa(e) {
	return Ki(e, Zs) || Ri(e, Zs, ea({}, e[Zs])), e[Zs];
}
function pa(e) {
	return typeof e == "object" && typeof e.kind == "string";
}
function ma(e, t, n) {
	t === void 0 && (t = qs), n === void 0 && (n = qs);
	var r = new Qs(e);
	return t !== qs && Vo(r, t), n !== qs && Ho(r, n), r;
}
function ha(e, t) {
	return e === t;
}
function ga(e, t) {
	return Ns(e, t);
}
function _a(e, t) {
	return Ns(e, t, 1);
}
function va(e, t) {
	return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function ya(e, t, n) {
	return Qo(e) ? e : Array.isArray(e) ? U.array(e, { name: n }) : Ii(e) ? U.object(e, void 0, { name: n }) : Vi(e) ? U.map(e, { name: n }) : Ui(e) ? U.set(e, { name: n }) : typeof e == "function" && !Io(e) && !Xo(e) ? Li(e) ? nl(e) : Gc(n, e) : e;
}
function ba(e, t, n) {
	if (e == null || Ss(e) || gs(e) || hl(e) || vl(e)) return e;
	if (Array.isArray(e)) return U.array(e, {
		name: n,
		deep: !1
	});
	if (Ii(e)) return U.object(e, void 0, {
		name: n,
		deep: !1
	});
	if (Vi(e)) return U.map(e, {
		name: n,
		deep: !1
	});
	if (Ui(e)) return U.set(e, {
		name: n,
		deep: !1
	});
}
function xa(e) {
	return e;
}
function Sa(e, t) {
	return Ns(e, t) ? t : e;
}
function Ca(e) {
	return e.annotationType_ === tc;
}
function wa(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Ta,
		extend_: Ea,
		decorate_20223_: Da
	};
}
function Ta(e, t, n, r) {
	var i;
	return (i = this.options_) != null && i.bound ? this.extend_(e, t, n, !1) === null ? 0 : 1 : r === e.target_ ? this.extend_(e, t, n, !1) === null ? 0 : 2 : Io(n.value) ? 1 : (Vs(r, t, ka(e, this, t, n, !1)), 2);
}
function Ea(e, t, n, r) {
	var i = ka(e, this, t, n);
	return e.defineProperty_(t, i, r);
}
function Da(e, t) {
	var n = t.kind, r = t.name, i = t.addInitializer, a = this, o = function(e) {
		return to(a.options_?.name ?? r.toString(), e, a.options_?.autoAction ?? !1);
	};
	if (n == "field") return function(e) {
		var t, n = e;
		return Io(n) || (n = o(n)), (t = a.options_) != null && t.bound && (n = n.bind(this), n.isMobxAction = !0), n;
	};
	if (n == "method") {
		var s;
		return Io(e) || (e = o(e)), (s = this.options_) != null && s.bound && i(function() {
			var e = this, t = e[r].bind(e);
			t.isMobxAction = !0, e[r] = t;
		}), e;
	}
	z("Cannot apply '" + a.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + ("\n'" + a.annotationType_ + "' can only be used on properties with a function value."));
}
function Oa(e, t, n, r) {
	t.annotationType_, r.value;
}
function ka(e, t, n, r, i) {
	var a, o;
	i === void 0 && (i = K.safeDescriptors), Oa(e, t, n, r);
	var s = r.value;
	return (a = t.options_) != null && a.bound && (s = s.bind(e.proxy_ ?? e.target_)), {
		value: to(t.options_?.name ?? n.toString(), s, t.options_?.autoAction ?? !1, (o = t.options_) != null && o.bound ? e.proxy_ ?? e.target_ : void 0),
		configurable: !i || e.isPlainObject_,
		enumerable: !1,
		writable: !i
	};
}
function Aa(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: ja,
		extend_: Ma,
		decorate_20223_: Na
	};
}
function ja(e, t, n, r) {
	var i;
	return r === e.target_ ? this.extend_(e, t, n, !1) === null ? 0 : 2 : (i = this.options_) != null && i.bound && (!Ki(e.target_, t) || !Xo(e.target_[t])) && this.extend_(e, t, n, !1) === null ? 0 : Xo(n.value) ? 1 : (Vs(r, t, Fa(e, this, t, n, !1, !1)), 2);
}
function Ma(e, t, n, r) {
	var i = Fa(e, this, t, n, this.options_?.bound);
	return e.defineProperty_(t, i, r);
}
function Na(e, t) {
	var n, r = t.name, i = t.addInitializer;
	return Xo(e) || (e = nl(e)), (n = this.options_) != null && n.bound && i(function() {
		var e = this, t = e[r].bind(e);
		t.isMobXFlow = !0, e[r] = t;
	}), e;
}
function Pa(e, t, n, r) {
	t.annotationType_, r.value;
}
function Fa(e, t, n, r, i, a) {
	a === void 0 && (a = K.safeDescriptors), Pa(e, t, n, r);
	var o = r.value;
	return Xo(o) || (o = nl(o)), i && (o = o.bind(e.proxy_ ?? e.target_), o.isMobXFlow = !0), {
		value: o,
		configurable: !a || e.isPlainObject_,
		enumerable: !1,
		writable: !a
	};
}
function Ia(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: La,
		extend_: Ra,
		decorate_20223_: za
	};
}
function La(e, t, n) {
	return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ra(e, t, n, r) {
	return Ba(e, this, t, n), e.defineComputedProperty_(t, ea({}, this.options_, {
		get: n.get,
		set: n.set
	}), r);
}
function za(e, t) {
	var n = this, r = t.name, i = t.addInitializer, a;
	function o(t, i) {
		var a = ea({}, n.options_, {
			get: e,
			context: t
		});
		return a.name ||= "ObservableObject." + r.toString(), new wc(a);
	}
	return i(function() {
		var t = bs(this)[H], n = this, i = t.values_.get(r);
		i instanceof wc && i.derivation !== e && t.values_.delete(r), (t.lazyComputedKeys_ ??= /* @__PURE__ */ new Map()).set(r, function() {
			return o(n, t);
		});
	}), function() {
		var t = this[H], n = t.values_.get(r);
		if (n instanceof wc && n.derivation !== e) {
			var i = a?.get(this);
			return i || (i = o(this, t), (a ??= /* @__PURE__ */ new WeakMap()).set(this, i)), i.get();
		}
		return t.getObservablePropValue_(r);
	};
}
function Ba(e, t, n, r) {
	t.annotationType_, r.get;
}
function Va(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Ha,
		extend_: Ua,
		decorate_20223_: Wa
	};
}
function Ha(e, t, n) {
	return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ua(e, t, n, r) {
	return Ga(e, this, t, n), e.defineObservableProperty_(t, n.value, this.options_?.enhancer ?? ya, r);
}
function Wa(e, t) {
	var n = this, r = t.kind, i = t.name;
	if (r !== "accessor") return;
	function a(e, t) {
		var r = bs(e)[H];
		return (r.lazyObservableKeys_ ??= /* @__PURE__ */ new Map()).set(i, function() {
			return new Sc(t, n.options_?.enhancer ?? ya, "ObservableObject." + i.toString(), !1);
		}), r;
	}
	return {
		get: function() {
			return (this[H] ?? a(this, e.get.call(this))).getObservablePropValue_(i);
		},
		set: function(e) {
			return (this[H] ?? a(this, e)).setObservablePropValue_(i, e);
		},
		init: function(e) {
			return a(this, e), e;
		}
	};
}
function Ga(e, t, n, r) {
	t.annotationType_;
}
function Ka(e) {
	return {
		annotationType_: nc,
		options_: e,
		make_: qa,
		extend_: Ja,
		decorate_20223_: Ya
	};
}
function qa(e, t, n, r) {
	var i;
	if (n.get) return W.make_(e, t, n, r);
	if (n.set) {
		var a = Io(n.set) ? n.set : to(t.toString(), n.set);
		return r === e.target_ ? e.defineProperty_(t, {
			configurable: !K.safeDescriptors || e.isPlainObject_,
			set: a
		}) === null ? 0 : 2 : (Vs(r, t, {
			configurable: !0,
			set: a
		}), 2);
	}
	if (r !== e.target_ && typeof n.value == "function") {
		var o;
		if (Li(n.value)) {
			var s;
			return ((s = this.options_) != null && s.autoBind ? nl.bound : nl).make_(e, t, n, r);
		}
		return ((o = this.options_) != null && o.autoBind ? Gc.bound : Gc).make_(e, t, n, r);
	}
	var c = this.options_?.deep === !1 ? U.ref : U;
	return typeof n.value == "function" && (i = this.options_) != null && i.autoBind && (n.value = n.value.bind(e.proxy_ ?? e.target_)), c.make_(e, t, n, r);
}
function Ja(e, t, n, r) {
	var i;
	return n.get ? W.extend_(e, t, n, r) : n.set ? e.defineProperty_(t, {
		configurable: !K.safeDescriptors || e.isPlainObject_,
		set: to(t.toString(), n.set)
	}, r) : (typeof n.value == "function" && (i = this.options_) != null && i.autoBind && (n.value = n.value.bind(e.proxy_ ?? e.target_)), (this.options_?.deep === !1 ? U.ref : U).extend_(e, t, n, r));
}
function Ya(e, t) {
	z("'" + this.annotationType_ + "' cannot be used as a decorator");
}
function Xa(e) {
	return e || cc;
}
function Za(e) {
	return e.deep === !0 ? ya : e.deep === !1 ? xa : $a(e.defaultDecorator);
}
function Qa(e) {
	return e ? e.defaultDecorator ?? Ka(e) : void 0;
}
function $a(e) {
	return e ? e.options_?.enhancer ?? ya : ya;
}
function eo(e, t, n) {
	if (pa(t)) return lc.decorate_20223_(e, t);
	if (Pi(t)) {
		da(e, t, lc);
		return;
	}
	return Qo(e) ? e : Ii(e) ? U.object(e, t, n) : Array.isArray(e) ? U.array(e, t) : Vi(e) ? U.map(e, t) : Ui(e) ? U.set(e, t) : typeof e == "object" && e ? e : U.box(e, t);
}
function to(e, t, n, r) {
	n === void 0 && (n = !1);
	function i() {
		return no(e, n, t, r || this, arguments);
	}
	return i.isMobxAction = !0, i.toString = function() {
		return t.toString();
	}, bc && (xc.value = e, Vs(i, "name", xc)), i;
}
function no(e, t, n, r, i) {
	var a = ro(e, t, r, i);
	try {
		return n.apply(r, i);
	} catch (e) {
		throw a.error_ = e, e;
	} finally {
		io(a);
	}
}
function ro(e, t, n, r) {
	var i = !1, a = 0, o = K.trackingDerivation, s = !t || !o;
	wo();
	var c = K.allowStateChanges;
	s && (ho(), c = oo(!0));
	var l = _o(!0), u = {
		runAsAction_: s,
		prevDerivation_: o,
		prevAllowStateChanges_: c,
		prevAllowStateReads_: l,
		notifySpy_: i,
		startTime_: a,
		actionId_: yc++,
		parentActionId_: vc
	};
	return vc = u.actionId_, u;
}
function io(e) {
	vc !== e.actionId_ && z(30), vc = e.parentActionId_, e.error_ !== void 0 && (K.suppressReactionErrors = !0), so(e.prevAllowStateChanges_), vo(e.prevAllowStateReads_), To(), e.runAsAction_ && go(e.prevDerivation_), K.suppressReactionErrors = !1;
}
function ao(e, t) {
	var n = oo(e);
	try {
		return t();
	} finally {
		so(n);
	}
}
function oo(e) {
	var t = K.allowStateChanges;
	return K.allowStateChanges = e, t;
}
function so(e) {
	K.allowStateChanges = e;
}
function co(e) {
	return e instanceof Dc;
}
function lo(e) {
	switch (e.dependenciesState_) {
		case G.UP_TO_DATE_: return !1;
		case G.NOT_TRACKING_:
		case G.STALE_: return !0;
		case G.POSSIBLY_STALE_:
			for (var t = _o(!0), n = ho(), r = e.observing_, i = r.length, a = 0; a < i; a++) {
				var o = r[a];
				if (Tc(o)) {
					if (K.disableErrorBoundaries) o.get();
					else try {
						o.get();
					} catch {
						return go(n), vo(t), !0;
					}
					if (e.dependenciesState_ === G.STALE_) return go(n), vo(t), !0;
				}
			}
			return yo(e), go(n), vo(t), !1;
	}
}
function uo(e, t, n) {
	var r = _o(!0);
	yo(e), e.newObserving_ = Array(e.runId_ === 0 ? 100 : e.observing_.length), e.unboundDepsCount_ = 0, e.runId_ = ++K.runId;
	var i = K.trackingDerivation;
	K.trackingDerivation = e, K.inBatch++;
	var a;
	if (K.disableErrorBoundaries === !0) a = t.call(n);
	else try {
		a = t.call(n);
	} catch (e) {
		a = new Dc(e);
	}
	return K.inBatch--, K.trackingDerivation = i, fo(e), vo(r), a;
}
function fo(e) {
	for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = G.UP_TO_DATE_, i = 0, a = e.unboundDepsCount_, o = 0; o < a; o++) {
		var s = n[o];
		s.diffValue === 0 && (s.diffValue = 1, i !== o && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
	}
	for (n.length = i, e.newObserving_ = null, a = t.length; a--;) {
		var c = t[a];
		c.diffValue === 0 && So(c, e), c.diffValue = 0;
	}
	for (; i--;) {
		var l = n[i];
		l.diffValue === 1 && (l.diffValue = 0, xo(l, e));
	}
	r !== G.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function po(e) {
	var t = e.observing_;
	e.observing_ = [];
	for (var n = t.length; n--;) So(t[n], e);
	e.dependenciesState_ = G.NOT_TRACKING_;
}
function mo(e) {
	var t = ho();
	try {
		return e();
	} finally {
		go(t);
	}
}
function ho() {
	var e = K.trackingDerivation;
	return K.trackingDerivation = null, e;
}
function go(e) {
	K.trackingDerivation = e;
}
function _o(e) {
	var t = K.allowStateReads;
	return K.allowStateReads = e, t;
}
function vo(e) {
	K.allowStateReads = e;
}
function yo(e) {
	if (e.dependenciesState_ !== G.UP_TO_DATE_) {
		e.dependenciesState_ = G.UP_TO_DATE_;
		for (var t = e.observing_, n = t.length; n--;) t[n].lowestObserverState_ = G.UP_TO_DATE_;
	}
}
function bo() {
	if ((K.pendingReactions.length || K.inBatch || K.isRunningReactions) && z(36), Ac = !0, kc) {
		var e = Ai();
		--e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), K = new Oc();
	}
}
function xo(e, t) {
	e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function So(e, t) {
	e.observers_.delete(t), e.observers_.size === 0 && Co(e);
}
function Co(e) {
	e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, K.pendingUnobservations.push(e));
}
function wo() {
	K.inBatch++;
}
function To() {
	if (--K.inBatch === 0) {
		Ao();
		for (var e = K.pendingUnobservations, t = 0; t < e.length; t++) {
			var n = e[t];
			n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof wc && n.suspend_());
		}
		K.pendingUnobservations = [];
	}
}
function Eo(e) {
	var t = K.trackingDerivation;
	return t === null ? (e.observers_.size === 0 && K.inBatch > 0 && Co(e), !1) : (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && K.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved);
}
function Do(e) {
	e.lowestObserverState_ !== G.STALE_ && (e.lowestObserverState_ = G.STALE_, e.observers_.forEach(function(e) {
		e.dependenciesState_ === G.UP_TO_DATE_ && e.onBecomeStale_(), e.dependenciesState_ = G.STALE_;
	}));
}
function Oo(e) {
	e.lowestObserverState_ !== G.STALE_ && (e.lowestObserverState_ = G.STALE_, e.observers_.forEach(function(t) {
		t.dependenciesState_ === G.POSSIBLY_STALE_ ? t.dependenciesState_ = G.STALE_ : t.dependenciesState_ === G.UP_TO_DATE_ && (e.lowestObserverState_ = G.UP_TO_DATE_);
	}));
}
function ko(e) {
	e.lowestObserverState_ === G.UP_TO_DATE_ && (e.lowestObserverState_ = G.POSSIBLY_STALE_, e.observers_.forEach(function(e) {
		e.dependenciesState_ === G.UP_TO_DATE_ && (e.dependenciesState_ = G.POSSIBLY_STALE_, e.onBecomeStale_());
	}));
}
function Ao() {
	K.inBatch > 0 || K.isRunningReactions || Nc(jo);
}
function jo() {
	K.isRunningReactions = !0;
	for (var e = K.pendingReactions, t = 0; e.length > 0;) {
		++t === Mc && (console.error("[mobx] cycle in reaction: " + e[0]), e.splice(0));
		for (var n = e.splice(0), r = 0, i = n.length; r < i; r++) n[r].runReaction_();
	}
	K.isRunningReactions = !1;
}
function Mo(e) {
	var t = Nc;
	Nc = function(n) {
		return e(function() {
			return t(n);
		});
	};
}
function No() {
	return !1;
}
function Po(e) {
	return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
}
function Fo(e) {
	return function(t, n) {
		if (Ni(t)) return to(t.name || zc, t, e);
		if (Ni(n)) return to(t, n, e);
		if (pa(n)) return (e ? Hc : Bc).decorate_20223_(t, n);
		if (Pi(n)) return da(t, n, e ? Hc : Bc);
		if (Pi(t)) return ua(wa(e ? Lc : Fc, {
			name: t,
			autoAction: e
		}));
	};
}
function Io(e) {
	return Ni(e) && e.isMobxAction === !0;
}
function Lo(e, t) {
	var n;
	t === void 0 && (t = Ws);
	var r = t?.name ?? "Autorun", i = !t.scheduler && !t.delay, a;
	if (i) a = new jc(r, function() {
		this.track(c);
	}, t.onError, t.requiresObservable);
	else {
		var o = Ro(t), s = !1;
		a = new jc(r, function() {
			s || (s = !0, o(function() {
				s = !1, a.isDisposed || a.track(c);
			}));
		}, t.onError, t.requiresObservable);
	}
	function c() {
		e(a);
	}
	return (n = t) != null && (n = n.signal) != null && n.aborted || a.schedule_(), a.getDisposer_(t?.signal);
}
function Ro(e) {
	return e.scheduler ? e.scheduler : e.delay ? function(t) {
		return setTimeout(t, e.delay);
	} : Kc;
}
function zo(e, t, n) {
	var r;
	n === void 0 && (n = Ws);
	var i = n.name ?? "Reaction", a = Wc(i, n.onError ? Bo(n.onError, t) : t), o = !n.scheduler && !n.delay, s = Ro(n), c = !0, l = !1, u, d = n.compareStructural ? ec.structural : n.equals || ec.default, f = new jc(i, function() {
		c || o ? p() : l || (l = !0, s(p));
	}, n.onError, n.requiresObservable);
	function p() {
		if (l = !1, !f.isDisposed) {
			var t = !1, r = u;
			f.track(function() {
				var n = ao(!1, function() {
					return e(f);
				});
				t = c || !d(u, n), u = n;
			}), (c && n.fireImmediately || !c && t) && a(u, r, f), c = !1;
		}
	}
	return (r = n) != null && (r = r.signal) != null && r.aborted || f.schedule_(), f.getDisposer_(n?.signal);
}
function Bo(e, t) {
	return function() {
		try {
			return t.apply(this, arguments);
		} catch (t) {
			e.call(this, t);
		}
	};
}
function Vo(e, t, n) {
	return Uo(qc, e, t, n);
}
function Ho(e, t, n) {
	return Uo(Jc, e, t, n);
}
function Uo(e, t, n, r) {
	var i = typeof r == "function" ? ks(t, n) : ks(t), a = Ni(r) ? r : n, o = e + "L";
	return i[o] ? i[o].add(a) : i[o] = /* @__PURE__ */ new Set([a]), function() {
		var e = i[o];
		e && (e.delete(a), e.size === 0 && delete i[o]);
	};
}
function Wo(e) {
	e.isolateGlobalState === !0 && bo();
	var t = e.useProxies, n = e.enforceActions;
	if (t !== void 0 && (K.useProxies = t === Xc || t !== Yc && typeof Proxy < "u"), t === "ifavailable" && (K.verifyProxies = !0), n !== void 0) {
		var r = n === Xc ? Xc : n === Zc;
		K.enforceActions = r, K.allowStateChanges = r !== !0 && r !== Xc;
	}
	[
		"computedRequiresReaction",
		"reactionRequiresObservable",
		"observableRequiresReaction",
		"disableErrorBoundaries",
		"safeDescriptors"
	].forEach(function(t) {
		t in e && (K[t] = !!e[t]);
	}), K.allowStateReads = !K.observableRequiresReaction, e.reactionScheduler && Mo(e.reactionScheduler);
}
function Go(e, t, n, r) {
	var i = Xs(t);
	return Ms(function() {
		var t = bs(e, r)[H];
		Ys(i).forEach(function(e) {
			t.extend_(e, i[e], n && e in n ? n[e] : !0);
		});
	}), e;
}
function Ko(e, t) {
	return qo(ks(e, t));
}
function qo(e) {
	var t = { name: e.name_ };
	return e.observing_ && e.observing_.length > 0 && (t.dependencies = Jo(e.observing_).map(qo)), t;
}
function Jo(e) {
	return Array.from(new Set(e));
}
function Yo(e) {
	Ni(e.cancel) && e.cancel();
}
function Xo(e) {
	return e?.isMobXFlow === !0;
}
function Zo(e, t) {
	if (!e) return !1;
	if (t !== void 0) {
		if (Ss(e)) {
			var n, r, i = e[H];
			return i.values_.has(t) || !!((n = i.lazyComputedKeys_) != null && n.has(t)) || !!((r = i.lazyObservableKeys_) != null && r.has(t));
		}
		return !1;
	}
	return Ss(e) || !!e[H] || $s(e) || Pc(e) || Tc(e);
}
function Qo(e) {
	return Zo(e);
}
function $o(e) {
	if (Ss(e)) return e[H].ownKeys_();
	z(38);
}
function es(e, t, n) {
	return e.set(t, n), n;
}
function ts(e, t) {
	if (typeof e != "object" || !e || e instanceof Date || !Qo(e)) return e;
	if (Cc(e) || Tc(e)) return ts(e.get(), t);
	if (t.has(e)) return t.get(e);
	if (gs(e)) {
		var n = es(t, e, Array(e.length));
		return e.forEach(function(e, r) {
			n[r] = ts(e, t);
		}), n;
	}
	if (vl(e)) {
		var r = es(t, e, /* @__PURE__ */ new Set());
		return e.forEach(function(e) {
			r.add(ts(e, t));
		}), r;
	}
	if (hl(e)) {
		var i = es(t, e, /* @__PURE__ */ new Map());
		return e.forEach(function(e, n) {
			i.set(n, ts(e, t));
		}), i;
	}
	var a = es(t, e, {});
	return $o(e).forEach(function(n) {
		Hs.propertyIsEnumerable.call(e, n) && (a[n] = ts(e[n], t));
	}), a;
}
function ns(e, t) {
	return ts(e, /* @__PURE__ */ new Map());
}
function rs(e, t) {
	t === void 0 && (t = void 0), wo();
	try {
		return e.apply(t);
	} finally {
		To();
	}
}
function is(e) {
	return e[H];
}
function as(e, t) {
	var n;
	return ji(), e = bs(e, t), (n = e[H]).proxy_ ?? (n.proxy_ = new Proxy(e, rl));
}
function os(e) {
	return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function ss(e, t) {
	var n = e.interceptors_ ||= [];
	return n.push(t), Mi(function() {
		var e = n.indexOf(t);
		e !== -1 && n.splice(e, 1);
	});
}
function cs(e, t) {
	var n = ho();
	try {
		for (var r = [].concat(e.interceptors_ || []), i = 0, a = r.length; i < a && (t = r[i](t), t && !t.type && z(14), t); i++);
		return t;
	} finally {
		go(n);
	}
}
function ls(e) {
	return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function us(e, t) {
	var n = e.changeListeners_ ||= [];
	return n.push(t), Mi(function() {
		var e = n.indexOf(t);
		e !== -1 && n.splice(e, 1);
	});
}
function ds(e, t) {
	var n = ho(), r = e.changeListeners_;
	if (r) {
		r = r.slice();
		for (var i = 0, a = r.length; i < a; i++) r[i](t);
		go(n);
	}
}
function B(e, t, n) {
	return Ms(function() {
		var r = bs(e, n)[H];
		t ??= fa(e), Ys(t).forEach(function(e) {
			return r.make_(e, t[e]);
		});
	}), e;
}
function fs(e, t, n, r) {
	return n === void 0 && (n = "ObservableArray"), r === void 0 && (r = !1), ji(), Ms(function() {
		var i = new cl(n, t, r, !1);
		zi(i.values_, H, i);
		var a = new Proxy(i.values_, sl);
		return i.proxy_ = a, e && e.length && i.spliceWithArray_(0, 0, e), a;
	});
}
function V(e, t) {
	typeof Array.prototype[e] == "function" && (ll[e] = t(e));
}
function ps(e) {
	return function() {
		var t = this[H];
		t.atom_.reportObserved();
		var n = t.dehanceValues_(t.values_);
		return n[e].apply(n, arguments);
	};
}
function ms(e) {
	return function(t, n) {
		var r = this, i = this[H];
		return i.atom_.reportObserved(), i.dehanceValues_(i.values_)[e](function(e, i) {
			return t.call(n, e, i, r);
		});
	};
}
function hs(e) {
	return function() {
		var t = this, n = this[H];
		n.atom_.reportObserved();
		var r = n.dehanceValues_(n.values_), i = arguments[0];
		return arguments[0] = function(e, n, r) {
			return i(e, n, r, t);
		}, r[e].apply(r, arguments);
	};
}
function gs(e) {
	return Fi(e) && ul(e[H]);
}
function _s(e) {
	return e[Symbol.toStringTag] = "MapIterator", Is(e);
}
function vs(e) {
	if (Vi(e) || hl(e)) return e;
	if (Array.isArray(e)) return new Map(e);
	if (Ii(e)) {
		var t = /* @__PURE__ */ new Map();
		for (var n in e) t.set(n, e[n]);
		return t;
	}
	return z(21, e);
}
function ys(e) {
	return e[Symbol.toStringTag] = "SetIterator", Is(e);
}
function bs(e, t) {
	if (Ki(e, H)) return e;
	var n = t?.name ?? "ObservableObject";
	return Ri(e, H, new xl(e, /* @__PURE__ */ new Map(), String(n), Qa(t))), e;
}
function xs(e) {
	return yl[e] || (yl[e] = {
		get: function() {
			return this[H].getObservablePropValue_(e);
		},
		set: function(t) {
			return this[H].setObservablePropValue_(e, t);
		}
	});
}
function Ss(e) {
	return Fi(e) ? Sl(e[H]) : !1;
}
function Cs(e, t, n) {
	var r;
	(r = e.target_[Zs]) == null || delete r[n];
}
function ws(e, t) {
	Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ === void 0 ? e.prototype = t : e.prototype.__proto__ = t;
}
function Ts(e) {
	return {
		enumerable: !1,
		configurable: !0,
		get: function() {
			return this[H].get_(e);
		},
		set: function(t) {
			this[H].set_(e, t);
		}
	};
}
function Es(e) {
	Vs(Dl.prototype, "" + e, Ts(e));
}
function Ds(e) {
	if (e > Tl) {
		for (var t = Tl; t < e + 100; t++) Es(t);
		Tl = e;
	}
}
function Os(e, t, n) {
	return new Dl(e, t, n);
}
function ks(e, t) {
	if (typeof e == "object" && e) {
		if (gs(e)) return t !== void 0 && z(23), e[H].atom_;
		if (vl(e)) return e.atom_;
		if (hl(e)) {
			if (t === void 0) return e.keysAtom_;
			var n = e.data_.get(t) || e.hasMap_.get(t);
			return n || z(25, t, js(e)), n;
		}
		if (Ss(e)) {
			if (!t) return z(26);
			var r = e[H], i = r.values_.get(t) ?? r.materializeLazyComputed_(t) ?? r.materializeLazyObservable_(t);
			return i || z(27, t, js(e)), i;
		}
		if ($s(e) || Tc(e) || Pc(e)) return e;
	} else if (Ni(e) && Pc(e[H])) return e[H];
	z(28);
}
function As(e, t) {
	if (e || z(29), t !== void 0) return As(ks(e, t));
	if ($s(e) || Tc(e) || Pc(e) || hl(e) || vl(e)) return e;
	if (e[H]) return e[H];
	z(24, e);
}
function js(e, t) {
	var n;
	if (t !== void 0) n = ks(e, t);
	else if (Io(e)) return e.name;
	else n = Ss(e) || hl(e) || vl(e) ? As(e) : ks(e);
	return n.name_;
}
function Ms(e) {
	var t = ho(), n = oo(!0);
	wo();
	try {
		return e();
	} finally {
		To(), so(n), go(t);
	}
}
function Ns(e, t, n) {
	return n === void 0 && (n = -1), Ps(e, t, n);
}
function Ps(e, t, n, r, i) {
	if (e === t) return e !== 0 || 1 / e == 1 / t;
	if (e == null || t == null) return !1;
	if (e !== e) return t !== t;
	var a = typeof e;
	if (a !== "function" && a !== "object" && typeof t != "object") return !1;
	var o = Ol.call(e);
	if (o !== Ol.call(t)) return !1;
	switch (o) {
		case "[object RegExp]":
		case "[object String]": return "" + e == "" + t;
		case "[object Number]": return +e == +e ? +e == 0 ? 1 / e == 1 / t : +e == +t : +t != +t;
		case "[object Date]":
		case "[object Boolean]": return +e == +t;
		case "[object Symbol]": return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
		case "[object Map]":
		case "[object Set]": n >= 0 && n++;
	}
	e = Fs(e), t = Fs(t);
	var s = o === "[object Array]";
	if (!s) {
		if (typeof e != "object" || typeof t != "object") return !1;
		var c = e.constructor, l = t.constructor;
		if (c !== l && !(Ni(c) && c instanceof c && Ni(l) && l instanceof l) && "constructor" in e && "constructor" in t) return !1;
	}
	if (n === 0) return !1;
	n < 0 && (n = -1), r ||= [], i ||= [];
	for (var u = r.length; u--;) if (r[u] === e) return i[u] === t;
	if (r.push(e), i.push(t), s) {
		if (u = e.length, u !== t.length) return !1;
		for (; u--;) if (!Ps(e[u], t[u], n - 1, r, i)) return !1;
	} else {
		var d = Object.keys(e), f = d.length;
		if (Object.keys(t).length !== f) return !1;
		for (var p = 0; p < f; p++) {
			var m = d[p];
			if (!(Ki(t, m) && Ps(e[m], t[m], n - 1, r, i))) return !1;
		}
	}
	return r.pop(), i.pop(), !0;
}
function Fs(e) {
	return gs(e) ? e.slice() : Vi(e) || hl(e) || Ui(e) || vl(e) ? Array.from(e.entries()) : e;
}
function Is(e) {
	return e[Symbol.iterator] = Ls, Object.assign(Object.create(kl), e);
}
function Ls() {
	return this;
}
var Rs, zs, Bs, Vs, Hs, Us, Ws, Gs, Ks, qs, Js, Ys, Xs, Zs, H, Qs, $s, ec, tc, nc, rc, ic, ac, oc, sc, cc, lc, uc, dc, fc, pc, U, mc, hc, gc, _c, W, vc, yc, bc, xc, Sc, Cc, wc, Tc, G, Ec, Dc, Oc, kc, Ac, K, jc, Mc, Nc, Pc, Fc, Ic, Lc, Rc, zc, Bc, Vc, Hc, Uc, Wc, Gc, Kc, qc, Jc, Yc, Xc, Zc, Qc, $c, el, tl, nl, rl, il, al, ol, sl, cl, ll, ul, dl, fl, pl, ml, hl, gl, _l, vl, yl, bl, xl, Sl, Cl, wl, Tl, El, Dl, Ol, kl, Al = o((() => {
	Rs = {}, zs = Object.assign, Bs = Object.getOwnPropertyDescriptor, Vs = Object.defineProperty, Hs = Object.prototype, Us = [], Object.freeze(Us), Ws = {}, Object.freeze(Ws), Gs = typeof Proxy < "u", Ks = /*#__PURE__*/ Object.toString(), qs = function() {}, Js = Object.getOwnPropertySymbols !== void 0, Ys = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Js ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : /* istanbul ignore next */ Object.getOwnPropertyNames, Xs = Object.getOwnPropertyDescriptors || function(e) {
		var t = {};
		return Ys(e).forEach(function(n) {
			t[n] = Bs(e, n);
		}), t;
	}, Zs = /*#__PURE__*/ Symbol("mobx-stored-annotations"), H = /*#__PURE__*/ Symbol("mobx administration"), Qs = /*#__PURE__*/ function() {
		function e(e) {
			e === void 0 && (e = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = G.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e;
		}
		var t = e.prototype;
		return t.onBO = function() {
			this.onBOL && this.onBOL.forEach(function(e) {
				return e();
			});
		}, t.onBUO = function() {
			this.onBUOL && this.onBUOL.forEach(function(e) {
				return e();
			});
		}, t.reportObserved = function() {
			return Eo(this);
		}, t.reportChanged = function() {
			wo(), Do(this), To();
		}, t.toString = function() {
			return this.name_;
		}, Qi(e, [
			{
				key: "isBeingObserved",
				get: function() {
					return qi(this.flags_, e.isBeingObservedMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isBeingObservedMask_, t);
				}
			},
			{
				key: "isPendingUnobservation",
				get: function() {
					return qi(this.flags_, e.isPendingUnobservationMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isPendingUnobservationMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!qi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), Qs.isBeingObservedMask_ = 1, Qs.isPendingUnobservationMask_ = 2, Qs.diffValueMask_ = 4, $s = /*#__PURE__*/ Bi("Atom", Qs), ec = {
		identity: ha,
		structural: ga,
		default: va,
		shallow: _a
	}, tc = "override", nc = "true", rc = /*#__PURE__*/ Ka(), ic = "observable", ac = "observable.ref", oc = "observable.shallow", sc = "observable.struct", cc = {
		deep: !0,
		name: void 0,
		defaultDecorator: void 0,
		proxy: !0
	}, Object.freeze(cc), lc = /*#__PURE__*/ Va(ic), uc = /*#__PURE__*/ Va(ac, { enhancer: xa }), dc = /*#__PURE__*/ Va(oc, { enhancer: ba }), fc = /*#__PURE__*/ Va(sc, { enhancer: Sa }), pc = /*#__PURE__*/ ua(lc), zs(eo, pc), U = /*#__PURE__*/ zs(eo, {
		box: function(e, t) {
			var n = Xa(t);
			return new Sc(e, Za(n), n.name, !0, n.equals);
		},
		array: function(e, t) {
			var n = Xa(t);
			return (K.useProxies === !1 || n.proxy === !1 ? Os : fs)(e, Za(n), n.name);
		},
		map: function(e, t) {
			var n = Xa(t);
			return new ml(e, Za(n), n.name);
		},
		set: function(e, t) {
			var n = Xa(t);
			return new _l(e, Za(n), n.name);
		},
		object: function(e, t, n) {
			return Ms(function() {
				return Go(K.useProxies === !1 || n?.proxy === !1 ? bs({}, n) : as({}, n), e, t);
			});
		},
		ref: /*#__PURE__*/ ua(uc),
		shallow: /*#__PURE__*/ ua(dc),
		deep: pc,
		struct: /*#__PURE__*/ ua(fc)
	}), mc = "computed", hc = "computed.struct", gc = /*#__PURE__*/ Ia(mc), _c = /*#__PURE__*/ Ia(hc, { equals: ec.structural }), W = function(e, t) {
		if (pa(t)) return gc.decorate_20223_(e, t);
		if (Pi(t)) return da(e, t, gc);
		if (Ii(e)) return ua(Ia(mc, e));
		var n = Ii(t) ? t : {};
		return n.get = e, n.name ||= e.name || "", new wc(n);
	}, Object.assign(W, gc), W.struct = /*#__PURE__*/ ua(_c), vc = 0, yc = 1, bc = (/*#__PURE__*/ Bs(function() {}, "name"))?.configurable ?? !1, xc = {
		value: "action",
		configurable: !0,
		writable: !1,
		enumerable: !1
	}, Sc = /*#__PURE__*/ function(e) {
		function t(t, n, r, i, a) {
			var o;
			return r === void 0 && (r = "ObservableValue"), i === void 0 && (i = !0), a === void 0 && (a = ec.default), o = e.call(this, r) || this, o.enhancer = void 0, o.name_ = void 0, o.equals = void 0, o.hasUnreportedChange_ = !1, o.interceptors_ = void 0, o.changeListeners_ = void 0, o.value_ = void 0, o.dehancer = void 0, o.enhancer = n, o.name_ = r, o.equals = a, o.value_ = n(t, void 0, r), o;
		}
		na(t, e);
		var n = t.prototype;
		return n.dehanceValue = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, n.set = function(e) {
			this.value_, e = this.prepareNewValue_(e), e !== K.UNCHANGED && this.setNewValue_(e);
		}, n.prepareNewValue_ = function(e) {
			if (os(this)) {
				var t = cs(this, {
					object: this,
					type: al,
					newValue: e
				});
				if (!t) return K.UNCHANGED;
				e = t.newValue;
			}
			return e = this.enhancer(e, this.value_, this.name_), this.equals(this.value_, e) ? K.UNCHANGED : e;
		}, n.setNewValue_ = function(e) {
			var t = this.value_;
			this.value_ = e, this.reportChanged(), ls(this) && ds(this, {
				type: al,
				object: this,
				newValue: e,
				oldValue: t
			});
		}, n.get = function() {
			return this.reportObserved(), this.dehanceValue(this.value_);
		}, n.intercept_ = function(e) {
			return ss(this, e);
		}, n.observe_ = function(e, t) {
			return t && e({
				observableKind: "value",
				debugObjectName: this.name_,
				object: this,
				type: al,
				newValue: this.value_,
				oldValue: void 0
			}), us(this, e);
		}, n.raw = function() {
			return this.value_;
		}, n.toJSON = function() {
			return this.get();
		}, n.toString = function() {
			return this.name_ + "[" + this.value_ + "]";
		}, n.valueOf = function() {
			return Gi(this.get());
		}, n[Symbol.toPrimitive] = function() {
			return this.valueOf();
		}, t;
	}(Qs), Cc = /*#__PURE__*/ Bi("ObservableValue", Sc), wc = /*#__PURE__*/ function() {
		function e(e) {
			this.dependenciesState_ = G.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = G.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Dc(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Ec.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e.get || z(31), this.derivation = e.get, this.name_ = e.name || "ComputedValue", e.set && (this.setter_ = to("ComputedValue-setter", e.set)), this.equals_ = e.equals || (e.compareStructural || e.struct ? ec.structural : ec.default), this.scope_ = e.context, this.requiresReaction_ = e.requiresReaction, this.keepAlive_ = !!e.keepAlive;
		}
		var t = e.prototype;
		return t.onBecomeStale_ = function() {
			ko(this);
		}, t.onBO = function() {
			this.onBOL && this.onBOL.forEach(function(e) {
				return e();
			});
		}, t.onBUO = function() {
			this.onBUOL && this.onBUOL.forEach(function(e) {
				return e();
			});
		}, t.get = function() {
			if (this.isComputing && z(32, this.name_, this.derivation), K.inBatch === 0 && this.observers_.size === 0 && !this.keepAlive_) lo(this) && (this.warnAboutUntrackedRead_(), wo(), this.value_ = this.computeValue_(!1), To());
			else if (Eo(this), lo(this)) {
				var e = K.trackingContext;
				this.keepAlive_ && !e && (K.trackingContext = this), this.trackAndCompute() && Oo(this), K.trackingContext = e;
			}
			var t = this.value_;
			if (co(t)) throw t.cause;
			return t;
		}, t.set = function(e) {
			if (this.setter_) {
				this.isRunningSetter && z(33, this.name_), this.isRunningSetter = !0;
				try {
					this.setter_.call(this.scope_, e);
				} finally {
					this.isRunningSetter = !1;
				}
			} else z(34, this.name_);
		}, t.trackAndCompute = function() {
			var e = this.value_, t = this.dependenciesState_ === G.NOT_TRACKING_, n = this.computeValue_(!0), r = t || co(e) || co(n) || !this.equals_(e, n);
			return r && (this.value_ = n), r;
		}, t.computeValue_ = function(e) {
			this.isComputing = !0;
			var t = oo(!1), n;
			if (e) n = uo(this, this.derivation, this.scope_);
			else if (K.disableErrorBoundaries === !0) n = this.derivation.call(this.scope_);
			else try {
				n = this.derivation.call(this.scope_);
			} catch (e) {
				n = new Dc(e);
			}
			return so(t), this.isComputing = !1, n;
		}, t.suspend_ = function() {
			this.keepAlive_ || (po(this), this.value_ = void 0);
		}, t.observe_ = function(e, t) {
			var n = this, r = !0, i = void 0;
			return Lo(function() {
				var a = n.get();
				if (!r || t) {
					var o = ho();
					e({
						observableKind: "computed",
						debugObjectName: n.name_,
						type: al,
						object: n,
						newValue: a,
						oldValue: i
					}), go(o);
				}
				r = !1, i = a;
			});
		}, t.warnAboutUntrackedRead_ = function() {}, t.toString = function() {
			return this.name_ + "[" + this.derivation.toString() + "]";
		}, t.valueOf = function() {
			return Gi(this.get());
		}, t[Symbol.toPrimitive] = function() {
			return this.valueOf();
		}, Qi(e, [
			{
				key: "isComputing",
				get: function() {
					return qi(this.flags_, e.isComputingMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isComputingMask_, t);
				}
			},
			{
				key: "isRunningSetter",
				get: function() {
					return qi(this.flags_, e.isRunningSetterMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isRunningSetterMask_, t);
				}
			},
			{
				key: "isBeingObserved",
				get: function() {
					return qi(this.flags_, e.isBeingObservedMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isBeingObservedMask_, t);
				}
			},
			{
				key: "isPendingUnobservation",
				get: function() {
					return qi(this.flags_, e.isPendingUnobservationMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isPendingUnobservationMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!qi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), wc.isComputingMask_ = 1, wc.isRunningSetterMask_ = 2, wc.isBeingObservedMask_ = 4, wc.isPendingUnobservationMask_ = 8, wc.diffValueMask_ = 16, Tc = /*#__PURE__*/ Bi("ComputedValue", wc), (function(e) {
		e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
	})(G ||= {}), (function(e) {
		e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
	})(Ec ||= {}), Dc = function(e) {
		this.cause = void 0, this.cause = e;
	}, Oc = function() {
		this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
	}, kc = !0, Ac = !1, K = /*#__PURE__*/ function() {
		var e = /*#__PURE__*/ Ai();
		return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (kc = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Oc().version && (kc = !1), kc ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /*#__PURE__*/ new Oc()) : (setTimeout(function() {
			Ac || z(35);
		}, 1), new Oc());
	}(), jc = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			e === void 0 && (e = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = G.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = Ec.NONE, this.name_ = e, this.onInvalidate_ = t, this.errorHandler_ = n, this.requiresObservable_ = r;
		}
		var t = e.prototype;
		return t.onBecomeStale_ = function() {
			this.schedule_();
		}, t.schedule_ = function() {
			this.isScheduled || (this.isScheduled = !0, K.pendingReactions.push(this), Ao());
		}, t.runReaction_ = function() {
			if (!this.isDisposed) {
				wo(), this.isScheduled = !1;
				var e = K.trackingContext;
				if (K.trackingContext = this, lo(this)) {
					this.isTrackPending = !0;
					try {
						this.onInvalidate_();
					} catch (e) {
						this.reportExceptionInDerivation_(e);
					}
				}
				K.trackingContext = e, To();
			}
		}, t.track = function(e) {
			if (!this.isDisposed) {
				wo(), this.isRunning = !0;
				var t = K.trackingContext;
				K.trackingContext = this;
				var n = uo(this, e, void 0);
				K.trackingContext = t, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && po(this), co(n) && this.reportExceptionInDerivation_(n.cause), To();
			}
		}, t.reportExceptionInDerivation_ = function(e) {
			var t = this;
			if (this.errorHandler_) {
				this.errorHandler_(e, this);
				return;
			}
			if (K.disableErrorBoundaries) throw e;
			var n = "[mobx] uncaught error in '" + this + "'";
			K.suppressReactionErrors || console.error(n, e), K.globalReactionErrorHandlers.forEach(function(n) {
				return n(e, t);
			});
		}, t.dispose = function() {
			this.isDisposed || (this.isDisposed = !0, this.isRunning || (wo(), po(this), To()));
		}, t.getDisposer_ = function(e) {
			var t = this, n = function n() {
				t.dispose(), e == null || e.removeEventListener == null || e.removeEventListener("abort", n);
			};
			return e == null || e.addEventListener == null || e.addEventListener("abort", n), n[H] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (n[Symbol.dispose] = n), n;
		}, t.toString = function() {
			return "Reaction[" + this.name_ + "]";
		}, t.trace = function(e) {
			e === void 0 && (e = !1);
		}, Qi(e, [
			{
				key: "isDisposed",
				get: function() {
					return qi(this.flags_, e.isDisposedMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isDisposedMask_, t);
				}
			},
			{
				key: "isScheduled",
				get: function() {
					return qi(this.flags_, e.isScheduledMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isScheduledMask_, t);
				}
			},
			{
				key: "isTrackPending",
				get: function() {
					return qi(this.flags_, e.isTrackPendingMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isTrackPendingMask_, t);
				}
			},
			{
				key: "isRunning",
				get: function() {
					return qi(this.flags_, e.isRunningMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.isRunningMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!qi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = Ji(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), jc.isDisposedMask_ = 1, jc.isScheduledMask_ = 2, jc.isTrackPendingMask_ = 4, jc.isRunningMask_ = 8, jc.diffValueMask_ = 16, Mc = 100, Nc = function(e) {
		return e();
	}, Pc = /*#__PURE__*/ Bi("Reaction", jc), Fc = "action", Ic = "action.bound", Lc = "autoAction", Rc = "autoAction.bound", zc = "<unnamed action>", Bc = /*#__PURE__*/ wa(Fc), Vc = /*#__PURE__*/ wa(Ic, { bound: !0 }), Hc = /*#__PURE__*/ wa(Lc, { autoAction: !0 }), Uc = /*#__PURE__*/ wa(Rc, {
		autoAction: !0,
		bound: !0
	}), Wc = /*#__PURE__*/ Fo(!1), Object.assign(Wc, Bc), Gc = /*#__PURE__*/ Fo(!0), Object.assign(Gc, Hc), Wc.bound = /*#__PURE__*/ ua(Vc), Gc.bound = /*#__PURE__*/ ua(Uc), Kc = function(e) {
		return e();
	}, qc = "onBO", Jc = "onBUO", Yc = "never", Xc = "always", Zc = "observed", Qc = 0, $c = /*#__PURE__*/ function(e) {
		function t() {
			var n = e.call(this, "FLOW_CANCELLED") || this;
			return Object.setPrototypeOf(n, (this instanceof t ? this.constructor : void 0).prototype), n.name = "FlowCancellationError", n;
		}
		na(t, e);
		var n = t.prototype;
		return n.toString = function() {
			return "Error: " + this.message;
		}, t;
	}(/*#__PURE__*/ la(Error)), el = /*#__PURE__*/ Aa("flow"), tl = /*#__PURE__*/ Aa("flow.bound", { bound: !0 }), nl = /*#__PURE__*/ Object.assign(function(e, t) {
		if (pa(t)) return el.decorate_20223_(e, t);
		if (Pi(t)) return da(e, t, el);
		var n = e, r = n.name || "<unnamed flow>", i = function() {
			var e = this, t = arguments, i = ++Qc, a = Wc(r + " - runid: " + i + " - init", n).apply(e, t), o, s = void 0, c = new Promise(function(e, t) {
				var n = 0;
				o = t;
				function c(e) {
					s = void 0;
					var o;
					try {
						o = Wc(r + " - runid: " + i + " - yield " + n++, a.next).call(a, e);
					} catch (e) {
						return t(e);
					}
					u(o);
				}
				function l(e) {
					s = void 0;
					var o;
					try {
						o = Wc(r + " - runid: " + i + " - yield " + n++, a.throw).call(a, e);
					} catch (e) {
						return t(e);
					}
					u(o);
				}
				function u(n) {
					if (Ni(n?.then)) {
						n.then(u, t);
						return;
					}
					return n.done ? e(n.value) : (s = Promise.resolve(n.value), s.then(c, l));
				}
				c(void 0);
			});
			return c.cancel = Wc(r + " - runid: " + i + " - cancel", function() {
				try {
					s && Yo(s);
					var e = a.return(void 0), t = Promise.resolve(e.value);
					t.then(qs, qs), Yo(t), o(new $c());
				} catch (e) {
					o(e);
				}
			}), c;
		};
		return i.isMobXFlow = !0, i;
	}, el), nl.bound = /*#__PURE__*/ ua(tl), rl = {
		has: function(e, t) {
			return is(e).has_(t);
		},
		get: function(e, t) {
			return is(e).get_(t);
		},
		set: function(e, t, n) {
			return Pi(t) ? is(e).set_(t, n, !0) ?? !0 : !1;
		},
		deleteProperty: function(e, t) {
			return Pi(t) ? is(e).delete_(t, !0) ?? !0 : !1;
		},
		defineProperty: function(e, t, n) {
			return is(e).defineProperty_(t, n) ?? !0;
		},
		ownKeys: function(e) {
			return is(e).ownKeys_();
		},
		preventExtensions: function(e) {
			z(13);
		}
	}, il = "splice", al = "update", ol = 1e4, sl = {
		get: function(e, t) {
			var n = e[H];
			return t === H ? n : t === "length" ? n.getArrayLength_() : typeof t == "string" && !isNaN(t) ? n.get_(parseInt(t)) : Ki(ll, t) ? ll[t] : e[t];
		},
		set: function(e, t, n) {
			var r = e[H];
			return t === "length" && r.setArrayLength_(n), typeof t == "symbol" || isNaN(t) ? e[t] = n : r.set_(parseInt(t), n), !0;
		},
		preventExtensions: function() {
			z(15);
		}
	}, cl = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			e === void 0 && (e = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = r, this.atom_ = new Qs(e), this.enhancer_ = function(e, n) {
				return t(e, n, "ObservableArray[..]");
			};
		}
		var t = e.prototype;
		return t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.dehanceValues_ = function(e) {
			return this.dehancer !== void 0 && e.length > 0 ? e.map(this.dehancer) : e;
		}, t.intercept_ = function(e) {
			return ss(this, e);
		}, t.observe_ = function(e, t) {
			return t === void 0 && (t = !1), t && e({
				observableKind: "array",
				object: this.proxy_,
				debugObjectName: this.atom_.name_,
				type: "splice",
				index: 0,
				added: this.values_.slice(),
				addedCount: this.values_.length,
				removed: [],
				removedCount: 0
			}), us(this, e);
		}, t.getArrayLength_ = function() {
			return this.atom_.reportObserved(), this.values_.length;
		}, t.setArrayLength_ = function(e) {
			(typeof e != "number" || isNaN(e) || e < 0) && z("Out of range: " + e);
			var t = this.values_.length;
			if (e !== t) {
				if (e > t) {
					for (var n = Array(e - t), r = 0; r < e - t; r++) n[r] = void 0;
					this.spliceWithArray_(t, 0, n);
				} else this.spliceWithArray_(e, t - e);
			}
		}, t.updateArrayLength_ = function(e, t) {
			e !== this.lastKnownLength_ && z(16), this.lastKnownLength_ += t, this.legacyMode_ && t > 0 && Ds(e + t + 1);
		}, t.spliceWithArray_ = function(e, t, n) {
			var r = this;
			this.atom_;
			var i = this.values_.length;
			if (e === void 0 ? e = 0 : e > i ? e = i : e < 0 && (e = Math.max(0, i + e)), t = arguments.length === 1 ? i - e : t == null ? 0 : Math.max(0, Math.min(t, i - e)), n === void 0 && (n = Us), os(this)) {
				var a = cs(this, {
					object: this.proxy_,
					type: il,
					index: e,
					removedCount: t,
					added: n
				});
				if (!a) return Us;
				t = a.removedCount, n = a.added;
			}
			if (n = n.length === 0 ? n : n.map(function(e) {
				return r.enhancer_(e, void 0);
			}), this.legacyMode_) {
				var o = n.length - t;
				this.updateArrayLength_(i, o);
			}
			var s = this.spliceItemsIntoValues_(e, t, n);
			return (t !== 0 || n.length !== 0) && this.notifyArraySplice_(e, n, s), this.dehanceValues_(s);
		}, t.spliceItemsIntoValues_ = function(e, t, n) {
			if (n.length < ol) {
				var r;
				return (r = this.values_).splice.apply(r, [e, t].concat(n));
			}
			var i = this.values_.slice(e, e + t), a = this.values_.slice(e + t);
			this.values_.length += n.length - t;
			for (var o = 0; o < n.length; o++) this.values_[e + o] = n[o];
			for (var s = 0; s < a.length; s++) this.values_[e + n.length + s] = a[s];
			return i;
		}, t.notifyArrayChildUpdate_ = function(e, t, n) {
			var r = !this.owned_ && No(), i = ls(this), a = i || r ? {
				observableKind: "array",
				object: this.proxy_,
				type: al,
				debugObjectName: this.atom_.name_,
				index: e,
				newValue: t,
				oldValue: n
			} : null;
			this.atom_.reportChanged(), i && ds(this, a);
		}, t.notifyArraySplice_ = function(e, t, n) {
			var r = !this.owned_ && No(), i = ls(this), a = i || r ? {
				observableKind: "array",
				object: this.proxy_,
				debugObjectName: this.atom_.name_,
				type: il,
				index: e,
				removed: n,
				added: t,
				removedCount: n.length,
				addedCount: t.length
			} : null;
			this.atom_.reportChanged(), i && ds(this, a);
		}, t.get_ = function(e) {
			if (this.legacyMode_ && e >= this.values_.length) {
				console.warn("[mobx] Out of bounds read: " + e);
				return;
			}
			return this.atom_.reportObserved(), this.dehanceValue_(this.values_[e]);
		}, t.set_ = function(e, t) {
			var n = this.values_;
			if (this.legacyMode_ && e > n.length && z(17, e, n.length), e < n.length) {
				this.atom_;
				var r = n[e];
				if (os(this)) {
					var i = cs(this, {
						type: al,
						object: this.proxy_,
						index: e,
						newValue: t
					});
					if (!i) return;
					t = i.newValue;
				}
				t = this.enhancer_(t, r), t !== r && (n[e] = t, this.notifyArrayChildUpdate_(e, t, r));
			} else {
				for (var a = Array(e + 1 - n.length), o = 0; o < a.length - 1; o++) a[o] = void 0;
				a[a.length - 1] = t, this.spliceWithArray_(n.length, 0, a);
			}
		}, e;
	}(), ll = {
		clear: function() {
			return this.splice(0);
		},
		replace: function(e) {
			var t = this[H];
			return t.spliceWithArray_(0, t.values_.length, e);
		},
		toJSON: function() {
			return this.slice();
		},
		splice: function(e, t) {
			var n = [...arguments].slice(2), r = this[H];
			switch (arguments.length) {
				case 0: return [];
				case 1: return r.spliceWithArray_(e);
				case 2: return r.spliceWithArray_(e, t);
			}
			return r.spliceWithArray_(e, t, n);
		},
		spliceWithArray: function(e, t, n) {
			return this[H].spliceWithArray_(e, t, n);
		},
		push: function() {
			var e = this[H], t = [...arguments];
			return e.spliceWithArray_(e.values_.length, 0, t), e.values_.length;
		},
		pop: function() {
			return this.splice(Math.max(this[H].values_.length - 1, 0), 1)[0];
		},
		shift: function() {
			return this.splice(0, 1)[0];
		},
		unshift: function() {
			var e = this[H], t = [...arguments];
			return e.spliceWithArray_(0, 0, t), e.values_.length;
		},
		reverse: function() {
			return K.trackingDerivation && z(37, "reverse"), this.replace(this.slice().reverse()), this;
		},
		sort: function() {
			K.trackingDerivation && z(37, "sort");
			var e = this.slice();
			return e.sort.apply(e, arguments), this.replace(e), this;
		},
		remove: function(e) {
			var t = this[H], n = t.dehanceValues_(t.values_).indexOf(e);
			return n > -1 && (this.splice(n, 1), !0);
		}
	}, V("at", ps), V("concat", ps), V("flat", ps), V("includes", ps), V("indexOf", ps), V("join", ps), V("lastIndexOf", ps), V("slice", ps), V("toString", ps), V("toLocaleString", ps), V("toSorted", ps), V("toSpliced", ps), V("with", ps), V("every", ms), V("filter", ms), V("find", ms), V("findIndex", ms), V("findLast", ms), V("findLastIndex", ms), V("flatMap", ms), V("forEach", ms), V("map", ms), V("some", ms), V("toReversed", ms), V("reduce", hs), V("reduceRight", hs), ul = /*#__PURE__*/ Bi("ObservableArrayAdministration", cl), dl = {}, fl = "add", pl = "delete", ml = /*#__PURE__*/ function() {
		function e(e, t, n) {
			var r = this;
			t === void 0 && (t = ya), n === void 0 && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[H] = dl, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = n, Ni(Map) || z(18), Ms(function() {
				r.keysAtom_ = ma("ObservableMap.keys()"), r.data_ = /* @__PURE__ */ new Map(), r.hasMap_ = /* @__PURE__ */ new Map(), e && r.merge(e);
			});
		}
		var t = e.prototype;
		return t.has_ = function(e) {
			return this.data_.has(e);
		}, t.has = function(e) {
			var t = this;
			if (!K.trackingDerivation) return this.has_(e);
			var n = this.hasMap_.get(e);
			if (!n) {
				var r = n = new Sc(this.has_(e), xa, "ObservableMap.key?", !1);
				this.hasMap_.set(e, r), Ho(r, function() {
					return t.hasMap_.delete(e);
				});
			}
			return n.get();
		}, t.set = function(e, t) {
			var n = this.has_(e);
			if (os(this)) {
				var r = cs(this, {
					type: n ? al : fl,
					object: this,
					newValue: t,
					name: e
				});
				if (!r) return this;
				t = r.newValue;
			}
			return n ? this.updateValue_(e, t) : this.addValue_(e, t), this;
		}, t.delete = function(e) {
			var t = this;
			if (this.keysAtom_, os(this) && !cs(this, {
				type: pl,
				object: this,
				name: e
			})) return !1;
			if (this.has_(e)) {
				var n = No(), r = ls(this), i = r || n ? {
					observableKind: "map",
					debugObjectName: this.name_,
					type: pl,
					object: this,
					oldValue: this.data_.get(e).value_,
					name: e
				} : null;
				return rs(function() {
					var n;
					t.keysAtom_.reportChanged(), (n = t.hasMap_.get(e)) == null || n.setNewValue_(!1), t.data_.get(e).setNewValue_(void 0), t.data_.delete(e);
				}), r && ds(this, i), !0;
			}
			return !1;
		}, t.updateValue_ = function(e, t) {
			var n = this.data_.get(e);
			if (t = n.prepareNewValue_(t), t !== K.UNCHANGED) {
				var r = No(), i = ls(this), a = i || r ? {
					observableKind: "map",
					debugObjectName: this.name_,
					type: al,
					object: this,
					oldValue: n.value_,
					name: e,
					newValue: t
				} : null;
				n.setNewValue_(t), i && ds(this, a);
			}
		}, t.addValue_ = function(e, t) {
			var n = this;
			this.keysAtom_, rs(function() {
				var r, i = new Sc(t, n.enhancer_, "ObservableMap.key", !1);
				n.data_.set(e, i), t = i.value_, (r = n.hasMap_.get(e)) == null || r.setNewValue_(!0), n.keysAtom_.reportChanged();
			});
			var r = No(), i = ls(this), a = i || r ? {
				observableKind: "map",
				debugObjectName: this.name_,
				type: fl,
				object: this,
				name: e,
				newValue: t
			} : null;
			i && ds(this, a);
		}, t.get = function(e) {
			return this.has(e) ? this.dehanceValue_(this.data_.get(e).get()) : this.dehanceValue_(void 0);
		}, t.getOrInsert = function(e, t) {
			return this.has(e) || this.set(e, t), this.get(e);
		}, t.getOrInsertComputed = function(e, t) {
			return this.has(e) || this.set(e, t(e)), this.get(e);
		}, t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.keys = function() {
			return this.keysAtom_.reportObserved(), this.data_.keys();
		}, t.values = function() {
			var e = this, t = this.keys();
			return _s({ next: function() {
				var n = t.next(), r = n.done, i = n.value;
				return {
					done: r,
					value: r ? void 0 : e.get(i)
				};
			} });
		}, t.entries = function() {
			var e = this, t = this.keys();
			return _s({ next: function() {
				var n = t.next(), r = n.done, i = n.value;
				return {
					done: r,
					value: r ? void 0 : [i, e.get(i)]
				};
			} });
		}, t[Symbol.iterator] = function() {
			return this.entries();
		}, t.forEach = function(e, t) {
			for (var n = $i(this), r; !(r = n()).done;) {
				var i = r.value, a = i[0], o = i[1];
				e.call(t, o, a, this);
			}
		}, t.merge = function(e) {
			var t = this;
			return hl(e) && (e = new Map(e)), rs(function() {
				Ii(e) ? Wi(e).forEach(function(n) {
					return t.set(n, e[n]);
				}) : Array.isArray(e) ? e.forEach(function(e) {
					var n = e[0], r = e[1];
					return t.set(n, r);
				}) : Vi(e) ? (Hi(e) || z(19, e), e.forEach(function(e, n) {
					return t.set(n, e);
				})) : e != null && z(20, e);
			}), this;
		}, t.clear = function() {
			var e = this;
			rs(function() {
				mo(function() {
					for (var t = $i(e.keys()), n; !(n = t()).done;) {
						var r = n.value;
						e.delete(r);
					}
				});
			});
		}, t.replace = function(e) {
			var t = this;
			return rs(function() {
				for (var n = vs(e), r = /* @__PURE__ */ new Map(), i = !1, a = $i(t.data_.keys()), o; !(o = a()).done;) {
					var s = o.value;
					if (!n.has(s)) {
						if (t.delete(s)) i = !0;
						else {
							var c = t.data_.get(s);
							r.set(s, c);
						}
					}
				}
				for (var l = $i(n.entries()), u; !(u = l()).done;) {
					var d = u.value, f = d[0], p = d[1], m = t.data_.has(f);
					if (t.set(f, p), t.data_.has(f)) {
						var h = t.data_.get(f);
						r.set(f, h), m || (i = !0);
					}
				}
				if (!i) {
					if (t.data_.size !== r.size) t.keysAtom_.reportChanged();
					else for (var g = t.data_.keys(), _ = r.keys(), v = g.next(), y = _.next(); !v.done;) {
						if (v.value !== y.value) {
							t.keysAtom_.reportChanged();
							break;
						}
						v = g.next(), y = _.next();
					}
				}
				t.data_ = r;
			}), this;
		}, t.toString = function() {
			return "[object ObservableMap]";
		}, t.toJSON = function() {
			return Array.from(this);
		}, t.observe_ = function(e, t) {
			return us(this, e);
		}, t.intercept_ = function(e) {
			return ss(this, e);
		}, Qi(e, [{
			key: "size",
			get: function() {
				return this.keysAtom_.reportObserved(), this.data_.size;
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Map";
			}
		}]);
	}(), hl = /*#__PURE__*/ Bi("ObservableMap", ml), gl = {}, _l = /*#__PURE__*/ function() {
		function e(e, t, n) {
			var r = this;
			t === void 0 && (t = ya), n === void 0 && (n = "ObservableSet"), this.name_ = void 0, this[H] = gl, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, Ni(Set) || z(22), this.enhancer_ = function(e, r) {
				return t(e, r, n);
			}, Ms(function() {
				r.atom_ = ma(r.name_), e && r.replace(e);
			});
		}
		var t = e.prototype;
		return t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.clear = function() {
			var e = this;
			rs(function() {
				mo(function() {
					for (var t = $i(e.data_.values()), n; !(n = t()).done;) {
						var r = n.value;
						e.delete(r);
					}
				});
			});
		}, t.forEach = function(e, t) {
			for (var n = $i(this), r; !(r = n()).done;) {
				var i = r.value;
				e.call(t, i, i, this);
			}
		}, t.add = function(e) {
			var t = this;
			if (this.atom_, os(this)) {
				var n = cs(this, {
					type: fl,
					object: this,
					newValue: e
				});
				if (!n) return this;
				e = n.newValue;
			}
			if (!this.has(e)) {
				rs(function() {
					t.data_.add(t.enhancer_(e, void 0)), t.atom_.reportChanged();
				});
				var r = ls(this), i = r ? {
					observableKind: "set",
					debugObjectName: this.name_,
					type: fl,
					object: this,
					newValue: e
				} : null;
				r && ds(this, i);
			}
			return this;
		}, t.delete = function(e) {
			var t = this;
			if (os(this) && !cs(this, {
				type: pl,
				object: this,
				oldValue: e
			})) return !1;
			if (this.has(e)) {
				var n = ls(this), r = n ? {
					observableKind: "set",
					debugObjectName: this.name_,
					type: pl,
					object: this,
					oldValue: e
				} : null;
				return rs(function() {
					t.atom_.reportChanged(), t.data_.delete(e);
				}), n && ds(this, r), !0;
			}
			return !1;
		}, t.has = function(e) {
			return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(e));
		}, t.entries = function() {
			var e = this.values();
			return ys({ next: function() {
				var t = e.next(), n = t.value, r = t.done;
				return r ? {
					value: void 0,
					done: r
				} : {
					value: [n, n],
					done: r
				};
			} });
		}, t.keys = function() {
			return this.values();
		}, t.values = function() {
			this.atom_.reportObserved();
			var e = this, t = this.data_.values();
			return ys({ next: function() {
				var n = t.next(), r = n.value, i = n.done;
				return i ? {
					value: void 0,
					done: i
				} : {
					value: e.dehanceValue_(r),
					done: i
				};
			} });
		}, t.intersection = function(e) {
			return Ui(e) && !vl(e) ? e.intersection(this) : new Set(this).intersection(e);
		}, t.union = function(e) {
			return Ui(e) && !vl(e) ? e.union(this) : new Set(this).union(e);
		}, t.difference = function(e) {
			return new Set(this).difference(e);
		}, t.symmetricDifference = function(e) {
			return Ui(e) && !vl(e) ? e.symmetricDifference(this) : new Set(this).symmetricDifference(e);
		}, t.isSubsetOf = function(e) {
			return new Set(this).isSubsetOf(e);
		}, t.isSupersetOf = function(e) {
			return new Set(this).isSupersetOf(e);
		}, t.isDisjointFrom = function(e) {
			return Ui(e) && !vl(e) ? e.isDisjointFrom(this) : new Set(this).isDisjointFrom(e);
		}, t.replace = function(e) {
			var t = this;
			return vl(e) && (e = new Set(e)), rs(function() {
				Array.isArray(e) || Ui(e) ? (t.clear(), e.forEach(function(e) {
					return t.add(e);
				})) : e != null && z("Cannot initialize set from " + e);
			}), this;
		}, t.observe_ = function(e, t) {
			return us(this, e);
		}, t.intercept_ = function(e) {
			return ss(this, e);
		}, t.toJSON = function() {
			return Array.from(this);
		}, t.toString = function() {
			return "[object ObservableSet]";
		}, t[Symbol.iterator] = function() {
			return this.values();
		}, Qi(e, [{
			key: "size",
			get: function() {
				return this.atom_.reportObserved(), this.data_.size;
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Set";
			}
		}]);
	}(), vl = /*#__PURE__*/ Bi("ObservableSet", _l), yl = /*#__PURE__*/ Object.create(null), bl = "remove", xl = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			t === void 0 && (t = /* @__PURE__ */ new Map()), r === void 0 && (r = rc), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.lazyComputedKeys_ = void 0, this.lazyObservableKeys_ = void 0, this.target_ = e, this.values_ = t, this.name_ = n, this.defaultAnnotation_ = r, this.keysAtom_ = new Qs("ObservableObject.keys"), this.isPlainObject_ = Ii(this.target_);
		}
		var t = e.prototype;
		return t.getObservablePropValue_ = function(e) {
			return (this.values_.get(e) ?? this.materializeLazyComputed_(e) ?? this.materializeLazyObservable_(e)).get();
		}, t.materializeLazyComputed_ = function(e) {
			var t = this.lazyComputedKeys_?.get(e);
			if (t) {
				this.lazyComputedKeys_.delete(e), this.lazyComputedKeys_.size === 0 && (this.lazyComputedKeys_ = void 0);
				var n = t();
				return this.values_.set(e, n), n;
			}
		}, t.materializeLazyObservable_ = function(e) {
			var t = this.lazyObservableKeys_?.get(e);
			if (t) {
				this.lazyObservableKeys_.delete(e), this.lazyObservableKeys_.size === 0 && (this.lazyObservableKeys_ = void 0);
				var n = t();
				return this.values_.set(e, n), n;
			}
		}, t.setObservablePropValue_ = function(e, t) {
			var n = this.values_.get(e) ?? this.materializeLazyComputed_(e) ?? this.materializeLazyObservable_(e);
			if (n instanceof wc) return n.set(t), !0;
			if (os(this)) {
				var r = cs(this, {
					type: al,
					object: this.proxy_ || this.target_,
					name: e,
					newValue: t
				});
				if (!r) return null;
				t = r.newValue;
			}
			if (t = n.prepareNewValue_(t), t !== K.UNCHANGED) {
				var i = ls(this), a = i ? {
					type: al,
					observableKind: "object",
					debugObjectName: this.name_,
					object: this.proxy_ || this.target_,
					oldValue: n.value_,
					name: e,
					newValue: t
				} : null;
				n.setNewValue_(t), i && ds(this, a);
			}
			return !0;
		}, t.get_ = function(e) {
			return K.trackingDerivation && !Ki(this.target_, e) && this.has_(e), this.target_[e];
		}, t.set_ = function(e, t, n) {
			return n === void 0 && (n = !1), Ki(this.target_, e) ? this.values_.has(e) ? this.setObservablePropValue_(e, t) : n ? Reflect.set(this.target_, e, t) : (this.target_[e] = t, !0) : this.extend_(e, {
				value: t,
				enumerable: !0,
				writable: !0,
				configurable: !0
			}, this.defaultAnnotation_, n);
		}, t.has_ = function(e) {
			if (!K.trackingDerivation) return e in this.target_;
			this.pendingKeys_ ||= /* @__PURE__ */ new Map();
			var t = this.pendingKeys_.get(e);
			return t || (t = new Sc(e in this.target_, xa, "ObservableObject.key?", !1), this.pendingKeys_.set(e, t)), t.get();
		}, t.make_ = function(e, t) {
			if (t === !0 && (t = this.defaultAnnotation_), t !== !1) {
				if (!(e in this.target_)) {
					var n;
					if ((n = this.target_[Zs]) != null && n[e]) return;
					z(1, t.annotationType_, this.name_ + "." + e.toString());
				}
				for (var r = this.target_; r && r !== Hs;) {
					var i = Bs(r, e);
					if (i) {
						var a = t.make_(this, e, i, r);
						if (a === 0) return;
						if (a === 1) break;
					}
					r = Object.getPrototypeOf(r);
				}
				Cs(this, t, e);
			}
		}, t.extend_ = function(e, t, n, r) {
			if (r === void 0 && (r = !1), n === !0 && (n = this.defaultAnnotation_), n === !1) return this.defineProperty_(e, t, r);
			var i = n.extend_(this, e, t, r);
			return i && Cs(this, n, e), i;
		}, t.defineProperty_ = function(e, t, n) {
			n === void 0 && (n = !1), this.keysAtom_;
			try {
				wo();
				var r = this.delete_(e);
				if (!r) return r;
				if (os(this)) {
					var i = cs(this, {
						object: this.proxy_ || this.target_,
						name: e,
						type: fl,
						newValue: t.value
					});
					if (!i) return null;
					var a = i.newValue;
					t.value !== a && (t = ea({}, t, { value: a }));
				}
				if (n) {
					if (!Reflect.defineProperty(this.target_, e, t)) return !1;
				} else Vs(this.target_, e, t);
				this.notifyPropertyAddition_(e, t.value);
			} finally {
				To();
			}
			return !0;
		}, t.defineObservableProperty_ = function(e, t, n, r) {
			r === void 0 && (r = !1), this.keysAtom_;
			try {
				wo();
				var i = this.delete_(e);
				if (!i) return i;
				if (os(this)) {
					var a = cs(this, {
						object: this.proxy_ || this.target_,
						name: e,
						type: fl,
						newValue: t
					});
					if (!a) return null;
					t = a.newValue;
				}
				var o = xs(e), s = {
					configurable: !K.safeDescriptors || this.isPlainObject_,
					enumerable: !0,
					get: o.get,
					set: o.set
				};
				if (r) {
					if (!Reflect.defineProperty(this.target_, e, s)) return !1;
				} else Vs(this.target_, e, s);
				var c = new Sc(t, n, "ObservableObject.key", !1);
				this.values_.set(e, c), this.notifyPropertyAddition_(e, c.value_);
			} finally {
				To();
			}
			return !0;
		}, t.defineComputedProperty_ = function(e, t, n) {
			n === void 0 && (n = !1), this.keysAtom_;
			try {
				wo();
				var r = this.delete_(e);
				if (!r) return r;
				if (os(this) && !cs(this, {
					object: this.proxy_ || this.target_,
					name: e,
					type: fl,
					newValue: void 0
				})) return null;
				t.name ||= "ObservableObject.key", t.context = this.proxy_ || this.target_;
				var i = xs(e), a = {
					configurable: !K.safeDescriptors || this.isPlainObject_,
					enumerable: !1,
					get: i.get,
					set: i.set
				};
				if (n) {
					if (!Reflect.defineProperty(this.target_, e, a)) return !1;
				} else Vs(this.target_, e, a);
				this.values_.set(e, new wc(t)), this.notifyPropertyAddition_(e, void 0);
			} finally {
				To();
			}
			return !0;
		}, t.delete_ = function(e, t) {
			if (t === void 0 && (t = !1), this.keysAtom_, !Ki(this.target_, e)) return !0;
			if (os(this) && !cs(this, {
				object: this.proxy_ || this.target_,
				name: e,
				type: bl
			})) return null;
			try {
				var n;
				wo();
				var r = ls(this), i = this.values_.get(e), a = void 0;
				if (!i && r && (a = Bs(this.target_, e)?.value), t) {
					if (!Reflect.deleteProperty(this.target_, e)) return !1;
				} else delete this.target_[e];
				if (i && (this.values_.delete(e), i instanceof Sc && (a = i.value_), Do(i)), this.keysAtom_.reportChanged(), (n = this.pendingKeys_) == null || (n = n.get(e)) == null || n.set(e in this.target_), r) {
					var o = {
						type: bl,
						observableKind: "object",
						object: this.proxy_ || this.target_,
						debugObjectName: this.name_,
						oldValue: a,
						name: e
					};
					r && ds(this, o);
				}
			} finally {
				To();
			}
			return !0;
		}, t.observe_ = function(e, t) {
			return us(this, e);
		}, t.intercept_ = function(e) {
			return ss(this, e);
		}, t.notifyPropertyAddition_ = function(e, t) {
			var n, r = ls(this);
			if (r) {
				var i = r ? {
					type: fl,
					observableKind: "object",
					debugObjectName: this.name_,
					object: this.proxy_ || this.target_,
					name: e,
					newValue: t
				} : null;
				r && ds(this, i);
			}
			(n = this.pendingKeys_) == null || (n = n.get(e)) == null || n.set(!0), this.keysAtom_.reportChanged();
		}, t.ownKeys_ = function() {
			return this.keysAtom_.reportObserved(), Ys(this.target_);
		}, t.keys_ = function() {
			return this.keysAtom_.reportObserved(), Object.keys(this.target_);
		}, e;
	}(), Sl = /*#__PURE__*/ Bi("ObservableObjectAdministration", xl), Cl = /*#__PURE__*/ Ts(0), wl = /*#__PURE__*/ function() {
		var e = !1, t = {};
		return Object.defineProperty(t, "0", { set: function() {
			e = !0;
		} }), (/*#__PURE__*/ Object.create(t))[0] = 1, e === !1;
	}(), Tl = 0, El = function() {}, ws(El, Array.prototype), Dl = /*#__PURE__*/ function(e) {
		function t(t, n, r, i) {
			var a;
			return r === void 0 && (r = "ObservableArray"), i === void 0 && (i = !1), a = e.call(this) || this, Ms(function() {
				var e = new cl(r, n, i, !0);
				e.proxy_ = a, zi(a, H, e), t && t.length && a.spliceWithArray(0, 0, t), wl && Object.defineProperty(a, "0", Cl);
			}), a;
		}
		na(t, e);
		var n = t.prototype;
		return n.concat = function() {
			this[H].atom_.reportObserved();
			var e = [...arguments];
			return Array.prototype.concat.apply(this.slice(), e.map(function(e) {
				return gs(e) ? e.slice() : e;
			}));
		}, n[Symbol.iterator] = function() {
			var e = this, t = 0;
			return Is({ next: function() {
				return t < e.length ? {
					value: e[t++],
					done: !1
				} : {
					done: !0,
					value: void 0
				};
			} });
		}, Qi(t, [{
			key: "length",
			get: function() {
				return this[H].getArrayLength_();
			},
			set: function(e) {
				this[H].setArrayLength_(e);
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Array";
			}
		}]);
	}(El), Object.entries(ll).forEach(function(e) {
		var t = e[0], n = e[1];
		t !== "concat" && Ri(Dl.prototype, t, n);
	}), Ds(1e3), Ol = Hs.toString, kl = (/* @__PURE__ */ Ai()).Iterator?.prototype || {}, [
		"Symbol",
		"Map",
		"Set"
	].forEach(function(e) {
		Ai()[e] === void 0 && z("MobX requires global '" + e + "' to be available or polyfilled");
	}), typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
		spy: Po,
		extras: { getDebugName: js },
		$mobx: H
	});
})), jl, Ml, Nl = o((() => {
	jl = [], Ml = class {
		constructor(e, t, n) {
			this.targets = [], this.styleBlockRefs = {}, this.targetedElems = [], this.unhideTarget = (e) => {
				if (this.styleBlockRefs[e]) try {
					this.document.head.removeChild(this.styleBlockRefs[e]), delete this.styleBlockRefs[e];
				} catch {}
			}, this.hideTarget = (e) => {
				if (this.styleBlockRefs[e]) return;
				let t = `${e} { visibility: hidden !important }`, n = this.document.createElement("style");
				n.setAttribute("type", "text/css"), n.appendChild(this.document.createTextNode(t)), this.document.head.appendChild(n), this.styleBlockRefs[e] = n;
			}, this.document = n || window.document;
			try {
				this.abortController = new (this.document.defaultView || window).AbortController();
			} catch {}
			this.targets = e, this.onTarget = t, this.retarget(), this.targets.forEach((e) => {
				let t = 100, n = () => {
					this.abortController?.signal.aborted || (t < 2e3 ? (t += 200, this.retarget(), setTimeout(n, t)) : e.hideTarget && this.unhideTarget(e.selector));
				};
				if (e.clickRetarget) {
					let r = [];
					typeof e.clickRetarget == "boolean" ? r.push(this.document) : r = Array.from(this.document.querySelectorAll(e.clickRetarget)), r.map((e) => {
						e.addEventListener("click", () => {
							t = 100, setTimeout(n);
						}, {
							capture: !0,
							signal: this.abortController?.signal
						});
					});
				}
				if (e.navigationRetarget) try {
					this.document.defaultView?.navigation?.addEventListener("navigate", () => {
						t = 100, n();
					}, { signal: this.abortController?.signal });
				} catch {}
				e.autoRetarget ? n() : /complete|interactive|loaded/.test(this.document.readyState) ? e.hideTarget && this.unhideTarget(e.selector) : this.document.addEventListener("DOMContentLoaded", () => {
					this.retarget(), e.hideTarget && this.unhideTarget(e.selector);
				}, { signal: this.abortController?.signal });
			});
		}
		getTargets() {
			return this.targets;
		}
		getTargetedElems() {
			return this.targetedElems = this.targetedElems.filter((e) => e.isConnected !== !1), [...this.targetedElems];
		}
		releaseTargets(e) {
			(e || this.targetedElems).forEach((e) => {
				let t = jl.indexOf(e);
				t !== -1 && jl.splice(t, 1);
			}), this.targetedElems = e ? this.targetedElems.filter((t) => !e.includes(t)) : [];
		}
		destroy() {
			this.abortController?.abort(), this.releaseTargets(), Object.keys(this.styleBlockRefs).forEach((e) => this.unhideTarget(e));
		}
		retarget() {
			jl = jl.filter((e) => e.isConnected !== !1), this.targetedElems = this.targetedElems.filter((e) => e.isConnected !== !1);
			let e = this.targets.flatMap((e) => {
				e.hideTarget && this.hideTarget(e.selector);
				let t = this.domQuery(e.selector).filter((t) => {
					if (!jl.find((e) => e == t) && !this.targetedElems.find((e) => e == t)) return !0;
					e.hideTarget && this.unhideTarget(e.selector);
				});
				return e.inject?.element || (jl = jl.concat(t)), t.map((t) => ({
					target: e,
					elem: t
				}));
			});
			for (let { target: t, elem: n } of e) try {
				if (this.targetedElems = this.targetedElems.concat(n), t.inject) {
					let e = this.inject(n, t), r = this.onTarget(t, e, n, this);
					r && typeof r.then == "function" && r.catch((e) => {
						console.error("DomTargeter onTarget async failure:", e);
					});
				} else {
					if (t.emptyTarget = t.emptyTarget ?? !0, t.emptyTarget) for (; n.firstChild && n.removeChild(n.firstChild););
					let e = this.onTarget(t, n, void 0, this);
					e && typeof e.then == "function" && e.catch((e) => {
						console.error("DomTargeter onTarget async failure:", e);
					});
				}
				t.hideTarget && this.unhideTarget(t.selector), t.unsetTargetMinHeight = t.unsetTargetMinHeight ?? !0, t.unsetTargetMinHeight && n.style.minHeight && (n.style.minHeight = "");
			} catch (e) {
				console.error("DomTargeter retarget failure:", e);
			}
		}
		domQuery(e) {
			return Array.from(this.document.querySelectorAll(e));
		}
		inject(e, t) {
			if (!t || !t.inject) throw Error("DomTargeter::inject: Injected element unspecified");
			let n = t.inject.element instanceof Function ? t.inject.element(t, e) : t.inject.element;
			if (!n) throw Error("DomTargeter::inject: Injected element unspecified");
			if (!e.parentNode) throw Error("DomTargeter::inject: Provided element has no parent element");
			switch (t?.inject?.action) {
				case "before":
					e.parentNode.insertBefore(n, e);
					break;
				case "after":
					e.nextSibling ? e.parentNode.insertBefore(n, e.nextSibling) : e.parentNode.appendChild(n);
					break;
				case "append":
					e.appendChild(n);
					break;
				case "prepend":
					e.firstChild ? e.insertBefore(n, e.firstChild) : e.appendChild(n);
					break;
				case "replace": e.parentNode.replaceChild(n, e);
			}
			return n;
		}
	};
})), Pl = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/featureFlags/featureFlags.js
function Fl(e = "") {
	e = (e || (typeof window > "u" ? {} : window?.navigator).userAgent || "").toLowerCase();
	let t = (function() {
		let t;
		return function() {
			if (t === void 0) {
				let n = (e.match(/(msie|trident\/7.0; rv:) ?([0-9]{1,2})\./) || [])[2];
				t = n ? Number(n) : !1;
			}
			return t;
		};
	})();
	return {
		cors: function() {
			return !t() || Number(t()) >= 10;
		},
		cookies: function() {
			return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
		},
		storage: function() {
			let e = "ss-test";
			try {
				return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
			} catch {
				return !1;
			}
		}
	};
}
var Il, Ll, Rl = o((() => {
	Il = Fl(), Ll = {
		cors: Il.cors(),
		cookies: Il.cookies(),
		storage: Il.storage()
	};
})), zl, Bl = o((() => {
	Rl(), zl = {
		set: (e, t, n, r, i) => {
			if (Fl().cookies()) {
				n ||= "Lax";
				let a = e + "=" + encodeURIComponent(t) + ";SameSite=" + n + ";path=/;";
				if (window.location.protocol == "https:" && (a += "Secure;"), r) {
					let e = /* @__PURE__ */ new Date();
					e.setTime(e.getTime() + r), a += "expires=" + e.toUTCString() + ";";
				}
				i && (a += "domain=" + i + ";"), window.document.cookie = a;
			}
		},
		get: (e) => {
			if (Fl().cookies()) {
				e += "=";
				let t = window.document.cookie.split(";");
				for (let n = 0; n < t.length; n++) {
					let r = t[n];
					for (; r.charAt(0) == " ";) r = r.substring(1);
					if (r.indexOf(e) == 0) return decodeURIComponent(r.substring(e.length, r.length));
				}
			}
			return "";
		},
		unset: (e, t) => {
			if (!Fl().cookies()) return;
			let n = e + "=; path=/; Max-Age=-99999999;";
			t && (n += "domain=" + t + ";"), window.document.cookie = n;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/escapeHTML/escapeHTML.js
function Vl(e) {
	if (typeof e != "string") throw Error("parameter must be a string");
	if (window?.document) {
		let t = window.document.createElement("textarea");
		return t.textContent = e, t.innerHTML;
	}
	return e.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/'/g, "&#039;").replace(/"/g, "&quot;");
}
var Hl = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/unescapeHTML/unescapeHTML.js
function Ul(e) {
	return e.replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&#0?39;/g, "'").replace(/&apos;/g, "'").replace(/&#0?34;/g, "\"").replace(/&quot;/g, "\"").replace(/&amp;/g, "&");
}
var Wl = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/getContext/getContext.js
function Gl(e = [], t) {
	let n;
	if (!t || typeof t == "string" ? n = Array.from(document.querySelectorAll(t || "script[id^=searchspring], script[id=athos-context], script[src*=\"snapui.searchspring.io\"], script[src*=\"snapui.athoscommerce.io\"]")).sort((e, t) => e.innerHTML.length - t.innerHTML.length).pop() : t && t.tagName === "SCRIPT" && (n = t), !n) throw Error("getContext: did not find a script tag");
	let r = n;
	if (!t && !r.getAttribute("type")?.match(/^searchspring/i) && !r.id?.match(/^searchspring/i) && !r.id?.match(/athos-context/) && !r.src?.match(/\/\/snapui.searchspring.io/i) && !r.src?.match(/\/\/snapui.athoscommerce.io/i)) throw Error("getContext: did not find a script from Snap CDN or with attribute (type, id) starting with \"athos-context\"");
	if (e && !Array.isArray(e) || e && !e.reduce((e, t) => e && typeof t == "string", !0)) throw Error("getContext: first parameter must be an array of strings");
	let i = "siteId", a = {};
	Object.values(n?.attributes).map((t) => {
		let r = t.nodeName;
		e.includes(r) && (a[r] = n?.getAttribute(r));
	});
	let o = {}, s = n?.innerHTML, c = s.replace(/`(?:\\[\s\S]|[^`\\])*`|'(?:\\[\s\S]|[^'\\])*'|"(?:\\[\s\S]|[^"\\])*"/g, "").match(/([a-zA-Z_$][a-zA-Z_$0-9]*)\s*=/g)?.map((e) => e.replace(/[\s=]/g, "")), l = e.concat(c || []), u = l.filter((e, t) => {
		let n = ql.has(e);
		return n && console.error(`getContext: JavaScript keyword found: '${e}'! Please use a different variable name.`), l.indexOf(e) === t && !n;
	});
	e?.forEach((e) => {
		try {
			let t = Function(`
				var ${u.join(", ")};
				${s}
				return ${e};
			`);
			o[e] = t();
		} catch (t) {
			ql.has(e) || (console.error(`getContext: error evaluating '${e}'`), console.error(t)), o[e] = void 0;
		}
	});
	let d = {
		...Kl(a),
		...Kl(o)
	};
	if (e.includes(i) && !d[i]) {
		let e = n.getAttribute("src")?.match(/.*snapui.(?:searchspring|athoscommerce).io\/([a-zA-Z0-9]{6})\//);
		e && e.length > 1 && (d.siteId = e[1]);
	}
	return d;
}
function Kl(e) {
	return Object.keys(e).forEach((t) => {
		e[t] === void 0 && delete e[t];
	}), e;
}
var ql, Jl = o((() => {
	ql = /* @__PURE__ */ new Set(/* @__PURE__ */ "break.case.catch.class.const.continue.debugger.default.delete.do.else.export.extends.finally.for.function.if.import.in.instanceof.new.return.super.switch.this.throw.try.typeof.var.void.while.with.yield.let.static.enum.await.implements.package.protected.interface.private.public".split("."));
})), Yl = o((() => {})), Xl, Zl = o((() => {
	Xl = (e) => {
		if (!e) return;
		let [t, n] = e.split("#"), [r, i] = t.split("?"), a = {
			query: {},
			hash: n
		};
		return i?.split("&").forEach((e) => {
			let [t, n] = e.split("=");
			a.query[t] = n;
		}), {
			base: r,
			params: a,
			url: () => {
				let e = Object.keys(a.query).map((e) => `${e}=${a.query[e]}`).join("&");
				return `${r}${e ? "?" + e : ""}${a.hash ? "#" + a.hash : ""}`;
			}
		};
	};
})), Ql, $l, eu, tu, nu, ru, iu, au, ou, su, cu, lu, uu, du = o((() => {
	Ql = "@athoscommerce/snap-toolbox", $l = "1.11.0", eu = "Snap Toolbox", tu = "dist/cjs/index.js", nu = "dist/esm/index.js", ru = "dist/esm/index.d.ts", iu = "AthosCommerce", au = {
		type: "git",
		url: "https://github.com/AthosCommerce/snap.git"
	}, ou = { access: "public" }, su = {
		build: "rm -rf ./dist && tsc",
		"build:prod": "rm -rf ./dist && (tsc & p1=$!; tsc -p tsconfig.cjs.json & p2=$!; wait $p1 && wait $p2)",
		"build:docs": "typedoc --out docs src/index.ts",
		dev: "tsc --watch",
		format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
		lint: "eslint 'src/**/*.{js,jsx,ts,tsx}'",
		test: "jest",
		"test:watch": "jest --watch"
	}, cu = ["dist/**/*"], lu = "827b9566f3a8282b3a78fd85b0b2a281fe963df4", uu = {
		name: Ql,
		version: $l,
		description: eu,
		main: tu,
		module: nu,
		types: ru,
		author: iu,
		license: "MIT",
		repository: au,
		publishConfig: ou,
		scripts: su,
		sideEffects: !1,
		files: cu,
		gitHead: lu
	};
})), fu, pu = o((() => {
	du(), {version: fu} = uu;
})), mu = o((() => {})), hu, gu, _u, vu = o((() => {
	wu(), hu = { cookies: zl }, gu = class {
		constructor(e) {
			if (this.type = null, this.expiration = 31536e6, this.sameSite = "Lax", this.key = "ss-storage", this.cookieDomain = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, this.state = {}, e) switch (e.key.trim() !== "" && (this.key = e.key.trim()), e?.cookie?.expiration && (this.expiration = e.cookie.expiration), e?.cookie?.sameSite && (this.sameSite = e.cookie.sameSite), e.type) {
				case _u.session:
					this.type = Ll.storage ? e.type : null, this.type && (this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}"), window.sessionStorage.setItem(this.key, JSON.stringify(this.state)));
					break;
				case _u.local:
					this.type = Ll.storage ? e.type : null, this.type && (this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}"), window.localStorage.setItem(this.key, JSON.stringify(this.state)));
					break;
				case _u.cookie:
					if (Ll.cookies) {
						this.type = e.type;
						let t = hu.cookies.get(this.key);
						t && (this.state = JSON.parse(t));
					}
					break;
				default: this.type = _u.memory;
			}
		}
		set(e, t) {
			switch (this.type) {
				case _u.session:
					this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}");
					break;
				case _u.local:
					this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}");
					break;
				case _u.cookie: {
					let e = hu.cookies.get(this.key);
					e && (this.state = JSON.parse(e));
					break;
				}
			}
			let n;
			n = typeof e == "string" ? e?.split(".") : e;
			let r = this.state;
			n?.forEach((e, i) => {
				i == n.length - 1 ? r[e] = t : r = r[e] = r[e] || {};
			});
			try {
				switch (this.type) {
					case _u.session:
						window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
						break;
					case _u.local:
						window.localStorage.setItem(this.key, JSON.stringify(this.state));
						break;
					case _u.cookie: hu.cookies.set(this.key, JSON.stringify(this.state), this.sameSite, this.expiration, this.cookieDomain);
				}
			} catch {
				console.warn(`something went wrong setting ${this.key} to ${this.type} storage`);
			}
		}
		get(e) {
			switch (this.type) {
				case _u.session:
					let e = window.sessionStorage.getItem(this.key);
					this.state = e ? JSON.parse(e) : {};
					break;
				case _u.local:
					let t = window.localStorage.getItem(this.key);
					this.state = t ? JSON.parse(t) : {};
					break;
				case _u.cookie:
					let n = hu.cookies.get(this.key);
					n && (this.state = JSON.parse(n) || {});
			}
			let t;
			if (t = typeof e == "string" ? e?.split(".") : e, !t?.length) return;
			let n = this.state;
			for (let e of t) if (n && n[e] !== void 0) n = n[e];
			else {
				n = {};
				return;
			}
			return n;
		}
		clear() {
			switch (this.type) {
				case _u.session:
					window.sessionStorage.removeItem(this.key);
					break;
				case _u.local:
					window.localStorage.removeItem(this.key);
					break;
				case _u.cookie: hu.cookies.unset(this.key, this.cookieDomain);
			}
			this.state = {};
		}
	}, (function(e) {
		e.session = "session", e.local = "local", e.cookie = "cookie", e.memory = "memory";
	})(_u ||= {});
})), q, yu = o((() => {
	(function(e) {
		e.production = "production", e.development = "development";
	})(q ||= {});
})), bu = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/sprintf/sprintf.js
function xu(e, t) {
	let n = [];
	for (; t > 0; n[--t] = e);
	return n.join("");
}
function Su(e, ...t) {
	let n = [e, ...t], r = 0, i, a = n[r++], o, s, c, l, u = [];
	for (; a;) {
		if (o = /^[^\x25]+/.exec(a)) u.push(o[0]);
		else if (o = /^\x25{2}/.exec(a)) u.push("%");
		else if (o = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(a)) {
			if ((i = n[parseInt(o[1]) || r++]) == null || i == null) throw "Too few arguments.";
			if (/[^s]/.test(o[7]) && typeof i != "number") throw "Expecting number but found " + typeof i;
			switch (o[7]) {
				case "b":
					i = i.toString(2);
					break;
				case "c":
					i = String.fromCharCode(i);
					break;
				case "d":
					i = parseInt(i);
					break;
				case "e":
					i = o[6] ? i.toExponential(parseInt(o[6])) : i.toExponential();
					break;
				case "f":
					i = o[6] ? parseFloat(i).toFixed(parseInt(o[6])) : parseFloat(i);
					break;
				case "o":
					i = i.toString(8);
					break;
				case "s":
					i = (i = String(i)) && o[6] ? i.substring(0, parseInt(o[6])) : i;
					break;
				case "u":
					i = Math.abs(i);
					break;
				case "x":
					i = i.toString(16);
					break;
				case "X": i = i.toString(16).toUpperCase();
			}
			i = /[def]/.test(o[7]) && o[2] && i > 0 ? "+" + i : i, c = o[3] ? o[3] == "0" ? "0" : o[3].charAt(1) : " ", l = (o[5] ? parseInt(o[5]) : 0) - String(i).length, s = o[5] ? xu(c, l) : "", u.push(o[4] ? i + s : s + i);
		} else throw Error("sprintf: Invalid format string encountered");
		a = a.substring(o[0].length);
	}
	return u.join("");
}
var Cu = o((() => {})), wu = o((() => {
	Nl(), Pl(), Rl(), Bl(), Hl(), Wl(), Jl(), Yl(), Zl(), pu(), mu(), vu(), yu(), bu(), Cu();
})), Tu, Eu = o((() => {
	Tu = (e) => {
		let t = 1, n = 0, r;
		for (; e >= 0;) r = t, t += n, n = r, e--;
		return n;
	};
})), Du, Ou, ku, Au, ju = o((() => {
	Du = /* @__PURE__ */ u(R()), Ou = "athos-networkcache", ku = {
		enabled: !0,
		type: "sessionStorage",
		ttl: 3e5,
		maxSize: 1e3,
		purgeable: !0
	}, Au = class {
		constructor(e) {
			this.memoryCache = {}, this.config = (0, Du.default)(ku, e || {}), this.load(), this.config?.entries && Object.keys(this.config.entries).map((e) => {
				this.config.entries && this.config.entries[e] && this.set(e, this.config.entries[e]);
			});
		}
		load() {
			if (typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage") {
				let e = window.sessionStorage.getItem(Ou), t = { ...e && JSON.parse(e) };
				this.memoryCache = t || {};
			}
			this.purgeExpired();
		}
		get(e) {
			if (this.config.enabled) {
				this.load();
				try {
					let t = [];
					if (typeof window < "u" && window.performance?.getEntriesByType("navigation")?.[0]?.type === "back_forward" && (t = ["lastViewed", "cart"]), Object.keys(this.memoryCache).length && e) {
						let n = e;
						if (t.length && e.startsWith("/v1/search")) try {
							let r = e.split("{")[0], i = "{" + e.split("{")[1], a = JSON.parse(i), o = Object.keys(this.memoryCache).find((e) => {
								try {
									if (e.split("{")[0] == r) {
										let n = "{" + e.split("{")[1], r = JSON.parse(n), i = Array.from(/* @__PURE__ */ new Set([...Object.keys(a), ...Object.keys(r)]));
										for (let e of i) if (!t.includes(e) && JSON.stringify(a[e]) !== JSON.stringify(r[e])) return !1;
										return !0;
									}
									return !1;
								} catch {
									return !1;
								}
							});
							o && (n = o);
						} catch {}
						if (this.memoryCache[n]) return this.memoryCache[n].value;
					}
				} catch (e) {
					console.warn("something went wrong getting from cache: ", e);
				}
			}
		}
		purgeExpired() {
			Object.keys(this.memoryCache).forEach((e) => {
				Date.now() >= this.memoryCache[e].expires && delete this.memoryCache[e];
			});
			try {
				if (typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage") {
					let e = JSON.stringify(this.memoryCache);
					window.sessionStorage.setItem(Ou, e);
				}
			} catch (e) {
				console.warn("failed to store network cache: ", e);
			}
		}
		set(e, t) {
			if (this.config.enabled) {
				this.load();
				try {
					let n = {
						value: t,
						expires: Date.now() + this.config.ttl,
						purgeable: this.config.purgeable
					}, r = new Blob([JSON.stringify({ [e]: n })], { endings: "native" }).size / 1024;
					if (r > this.config.maxSize) {
						console.warn(`Cache object size (${r.toFixed(2)}KB) exceeds maxSize (${this.config.maxSize}KB), skipping cache`);
						return;
					}
					let i = new Blob([JSON.stringify(this.memoryCache)], { endings: "native" }).size / 1024;
					for (; i + r > this.config.maxSize;) {
						let e = Object.keys(this.memoryCache).filter((e) => this.memoryCache[e].purgeable).sort((e, t) => this.memoryCache[e].expires - this.memoryCache[t].expires)[0];
						if (!e) break;
						delete this.memoryCache[e], i = new Blob([JSON.stringify(this.memoryCache)], { endings: "native" }).size / 1024;
					}
					if (i + r > this.config.maxSize) {
						console.warn(`Unable to cache entry for key "${e}" without exceeding maxSize (${this.config.maxSize}KB), skipping cache`);
						return;
					}
					this.memoryCache[e] = n, typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage" && window.sessionStorage.setItem(Ou, JSON.stringify(this.memoryCache));
				} catch (e) {
					console.warn("something went wrong setting to cache: ", e);
				}
			}
		}
		clear() {
			try {
				this.memoryCache = {}, typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage" && window.sessionStorage.setItem(Ou, "");
			} catch (e) {
				console.warn("something went wrong clearing cache: ", e);
			}
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/apis/Abstract.js
function Mu(e, t = "") {
	return Object.keys(e).map((n) => {
		let r = t + (t.length ? `[${n}]` : n), i = e[n];
		if (i instanceof Array) {
			let e = i.map((e) => encodeURIComponent(String(e))).join(`&${encodeURIComponent(r)}=`);
			return `${encodeURIComponent(r)}=${e}`;
		}
		return i instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(i.toISOString())}` : i instanceof Object ? Mu(i, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(i))}`;
	}).filter((e) => e.length > 0).join("&");
}
var Nu, Pu, Fu, Iu, Lu = o((() => {
	Nu = /* @__PURE__ */ u(R()), wu(), Eu(), ju(), Pu = (e) => typeof Blob < "u" && e instanceof Blob, Fu = class {
		constructor(e) {
			this.configuration = e, this.retryDelay = 1e3, this.retryCount = 0, this.cache = new Au(this.configuration.cache);
		}
		get mode() {
			return this.configuration.mode;
		}
		async request(e, t) {
			let { url: n, init: r } = this.createFetchParams(e);
			if (t) {
				let n = this.cache.get(`${e.path}/${t}`) || this.cache.get(`${e.path}/*`);
				if (n) return this.retryCount = 0, this.retryDelay = 1e3, n;
			}
			let i, a;
			try {
				if (i = await this.fetchApi(n, r), a = await i?.json(), i.status >= 200 && i.status < 300) return this.retryCount = 0, this.retryDelay = 1e3, t && this.cache.set(`${e.path}/${t}`, a), a;
				throw i.status == 429 ? this.retryCount < this.configuration.maxRetry ? (await new Promise((e) => setTimeout(e, this.retryDelay)), this.retryDelay = Tu(this.retryCount) * 1e3, this.retryCount++, Error("Rate limited.")) : Error("Retry rate limit exceeded.") : i.status == 404 && a?.message == "Profile is currently paused" ? Error(`${a.message}: ${e.query?.tag}`) : Error("Unexpected Response Status.");
			} catch (a) {
				if (a.message == "Rate limited.") return await this.request(e, t);
				throw {
					err: a,
					fetchDetails: {
						status: i?.status,
						message: i?.statusText || "FAILED",
						url: n,
						...r
					}
				};
			}
		}
		createFetchParams(e) {
			let t = e?.body?.siteId || e?.query?.siteId;
			if (!t) throw Error("Request failed. Missing \"siteId\" parameter.");
			let n = `https://${t}.a${e.subDomain ? `.${e.subDomain}` : ""}.athoscommerce.net`, r = `${(e.origin || this.configuration.origin || n).replace(/\/$/, "")}/${e.path.replace(/^\//, "")}`, i = (0, Nu.default)(e.query || {}, this.configuration.globals);
			Object.keys(i).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(i));
			let a = typeof FormData < "u" && e.body instanceof FormData || e.body instanceof URLSearchParams || Pu(e.body) ? e.body : JSON.stringify(e.body ? (0, Nu.default)(e.body, this.configuration.globals) : e.body), o = {
				...this.configuration.headers,
				...e.headers
			}, s = {
				method: e.method,
				headers: o,
				body: a
			};
			return {
				url: r,
				init: s
			};
		}
		async fetchApi(e, t) {
			return await this.configuration.fetchApi(e, t);
		}
	}, Iu = class {
		constructor(e = {}) {
			this.config = e, e.maxRetry || (this.config.maxRetry = 8), this.config.cache = this.config.cache || {}, this.config.mode = this.config.mode || q.production, this.config.mode == q.development && (this.config.cache.enabled = !1);
		}
		get cache() {
			return this.config?.cache || {};
		}
		get maxRetry() {
			return this.config.maxRetry || 8;
		}
		get origin() {
			return this.config.origin || "";
		}
		get initiator() {
			return this.config.initiator || `snap/client/${fu}`;
		}
		get fetchApi() {
			return this.config.fetchApi || (typeof window < "u" ? window.fetch?.bind(window) : fetch);
		}
		get queryParamsStringify() {
			return this.config.queryParamsStringify || Mu;
		}
		get headers() {
			return this.config.headers || {};
		}
		set headers(e) {
			this.config.headers = e;
		}
		get globals() {
			return this.config.globals || {};
		}
		set globals(e) {
			this.config.globals = e;
		}
		get mode() {
			return this.config.mode;
		}
		get paths() {
			return this.config.paths || {};
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/searchResponse.js
function Ru(e, t) {
	return {
		pagination: Ru.pagination(e),
		results: Ru.results(e),
		filters: Ru.filters(e),
		facets: Ru.facets(e, t),
		sorting: Ru.sorting(e),
		merchandising: Ru.merchandising(e),
		search: Ru.search(e, t),
		tracking: Ru.tracking(e)
	};
}
function zu(e) {
	return Array.isArray(e) ? e.map((e) => typeof e == "string" ? Ul(String(e)) : e) : Ul(typeof e == "string" ? e : JSON.stringify(e));
}
var Bu, Vu, Hu = o((() => {
	wu(), Bu = [
		"uid",
		"sku",
		"available",
		"name",
		"url",
		"addToCartUrl",
		"parentId",
		"parentImageUrl",
		"price",
		"msrp",
		"imageUrl",
		"secureImageUrl",
		"thumbnailImageUrl",
		"secureThumbnailImageUrl",
		"rating",
		"ratingCount",
		"description",
		"stockMessage",
		"brand",
		"popularity",
		"caption"
	], Vu = class {
		constructor(e) {
			Object.assign(this, e);
		}
	}, Ru.pagination = (e) => {
		let t = e?.pagination;
		return {
			totalResults: t?.totalResults,
			page: t?.currentPage,
			pageSize: t?.perPage,
			totalPages: t?.totalPages
		};
	}, Ru.results = (e) => (e?.results || []).map((t) => Ru.result(t, e)), Ru.result = (e, t) => {
		let n = Bu.reduce((t, n) => e[n] === void 0 ? t : {
			...t,
			[n]: zu(e[n] || "")
		}, {});
		n.price &&= +n.price, n.msrp &&= +n.msrp, n.available?.toString() === "true" ? n.available = !0 : n.available?.toString() === "false" && (n.available = !1);
		let r = Object.keys(e).filter((e) => Bu.indexOf(e) == -1).filter((t) => !(t == "badges" && Array.isArray(e[t]) && typeof e[t]?.[0] == "object")).filter((e) => e != "variants").reduce((t, n) => ({
			...t,
			[n]: zu(e[n] || "")
		}), {});
		return new Vu({
			id: e.uid,
			responseId: t.responseId,
			mappings: { core: n },
			attributes: r,
			badges: Array.isArray(e.badges) && typeof e.badges[0] == "object" ? e.badges : [],
			variants: e.variants
		});
	}, Ru.filters = (e) => (e?.filterSummary || []).map((e) => {
		let t = e.value, n = "value";
		return typeof e.value == "object" && e && e.value && e.value.rangeHigh != null && e.value.rangeLow != null && (n = "range", t = {
			low: +e.value.rangeLow,
			high: +e.value.rangeHigh
		}), {
			type: n,
			field: e.field,
			label: e.filterValue,
			value: t
		};
	}), Ru.facets = (e, t = {}) => {
		let n = t.filters || [], r = e?.facets || [], i = t?.facets?.limit, a = t?.facets?.valueLimit, o = r.map((e) => {
			let t = {
				field: e.field,
				type: "value",
				filtered: !!e.facet_active
			};
			if (e.step) e.range && (t = {
				...t,
				type: "range",
				step: e.step,
				range: {
					low: e.range[0] == "*" ? void 0 : +e.range[0],
					high: e.range[1] == "*" ? void 0 : +e.range[1]
				}
			}), e.active && typeof e.active != "boolean" && e.active.length > 1 && (t.active = {
				low: e.active[0] == "*" ? void 0 : +e.active[0],
				high: e.active[1] == "*" ? void 0 : +e.active[1]
			});
			else if (e.values instanceof Array) {
				if (e.type == "hierarchy") {
					t.type = "value", t.values = (e.values || []).map((e) => ({
						filtered: !!e.active,
						value: e.value,
						label: e.label,
						count: e.count
					}));
					let r = n.find((t) => t.field == e.field), i = [];
					if (r && !r.background) {
						let t = r.value?.split(e.hierarchyDelimiter || ">");
						if (t) for (let n = t.length - 1; n >= 0; n--) {
							let a = t.slice(0, n + 1), o = a.join(e.hierarchyDelimiter);
							i.unshift({
								value: o,
								filtered: o == r.value,
								label: a[a.length - 1]
							});
						}
						i.unshift({
							value: void 0,
							filtered: !1,
							label: "View All"
						});
					}
					t.values = i.concat(t.values);
				} else e.values[0].type == "value" ? (t.type = "value", t.values = e.values.map((e) => ({
					filtered: e.active,
					value: e.value,
					label: e.label,
					count: e.count
				}))) : e.values[0].type == "range" && (t.type = "range-buckets", t.values = e.values.map((e) => ({
					filtered: e.active,
					low: e.low == "*" || e.low == null ? null : +e.low,
					high: e.high == "*" || e.high == null ? null : +e.high,
					label: e.label,
					count: e.count
				})));
			}
			return t;
		});
		return i && (o = o.slice(0, i)), a && (o = o.map((e) => (e.values &&= e.values.slice(0, a), e))), o;
	}, Ru.sorting = (e) => (e?.sorting?.options || []).filter((e) => e.active).map((e) => ({
		field: e.field,
		direction: e.direction
	})), Ru.merchandising = (e) => {
		let t = e?.merchandising;
		return t?.content && Array.isArray(t.content) && !t.content.length && (t.content = {}), {
			redirect: t?.redirect || "",
			content: t?.content || {},
			campaigns: t?.triggeredCampaigns || [],
			personalized: t?.personalized,
			experiments: t?.experiments || []
		};
	}, Ru.search = (e, t) => {
		let n = {
			query: t?.search?.query?.string,
			didYouMean: e?.didYouMean?.query,
			matchType: e?.query?.matchType,
			subject: e?.query?.subject
		};
		return e?.query?.corrected && e?.query.original && (n.query = e?.query?.corrected, n.originalQuery = e?.query?.original), n;
	}, Ru.tracking = (e) => ({ responseId: e.responseId });
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/utils/mergeParams.js
function Uu(...e) {
	let t = {};
	return e.reverse().forEach((e) => {
		Object.keys(e).forEach((n) => {
			let r = e[n], i = t[n];
			if (r instanceof Array) {
				let e = i === void 0 ? [] : i instanceof Array ? i : [i];
				t[n] = e.concat(r.filter((t) => e.indexOf(t) === -1));
			} else i instanceof Array ? t[n] = i.indexOf(r) === -1 ? [r].concat(i) : i : t[n] = r;
		});
	}), t;
}
var Wu = o((() => {})), Gu = o((() => {
	Wu();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/searchRequest.js
function Ku(e) {
	return Uu(Ku.sorts(e), Ku.search(e), Ku.filters(e), Ku.merchandising(e), Ku.pagination(e), Ku.siteId(e), Ku.facets(e), Ku.tracking(e), Ku.personalization(e));
}
var qu = o((() => {
	Gu(), Ku.sorts = (e = {}) => (e.sorts || []).reduce((e, t) => !t.field || !t.direction || t.direction != "asc" && t.direction != "desc" ? e : {
		...e,
		["sort." + t.field]: (e[t.field] || []).concat([t.direction])
	}, {}), Ku.search = (e = {}) => {
		let t = e.search || {}, n = {};
		return t.query && t.query.string && (n.q = t.query.string), t.subQuery && (n.rq = t.subQuery.trim()), t.originalQuery && (n.originalQuery = t.originalQuery.trim()), t.fallbackQuery && (n.fallbackQuery = t.fallbackQuery.trim()), t.redirectResponse && (n.redirectResponse = t.redirectResponse), t.source && (n.source = t.source), t.input && (n.input = t.input), n;
	}, Ku.filters = (e = {}) => (e.filters || []).reduce((e, t) => {
		let n = t.background ? "bgfilter" : "filter";
		if (t.type == "value") {
			let r = n + "." + t.field;
			return {
				...e,
				[r]: (e[r] || []).concat([t.value])
			};
		}
		if (t.type == "range") {
			let r = n + "." + t.field + ".low", i = n + "." + t.field + ".high", a = t?.value?.low ?? "*", o = t?.value?.high ?? "*";
			return {
				...e,
				[r]: (e[r] || []).concat([a]),
				[i]: (e[i] || []).concat([o])
			};
		}
		return e;
	}, {}), Ku.merchandising = (e = {}) => {
		let t = e.merchandising || {}, n = t.disabled ? { disableMerchandising: !0 } : {};
		return t.landingPage && (n["landing-page"] = t.landingPage), t.segments instanceof Array && t.segments.length && (n.tag = t.segments.map((e) => `merch.segment/${e}`)), t.disableInlineBanners && (n.disableInlineBanners = t.disableInlineBanners), n;
	}, Ku.pagination = (e = {}) => {
		let t = e.pagination || {}, n = {};
		return t.page && (n.page = t.page), (t.pageSize || t.pageSize === 0) && (n.resultsPerPage = t.pageSize), n;
	}, Ku.siteId = (e = {}) => e.siteId ? { siteId: e.siteId } : {}, Ku.facets = (e = {}) => {
		let t = e.facets || {}, n = {};
		if (t.include && t.include.length && t.exclude && t.exclude.length) throw "cannot use facet include and exclude at the same time";
		return t.include?.length && (n.includedFacets = t.include), t.exclude?.length && (n.excludedFacets = t.exclude), t.autoDrillDown === !1 && (n.disableFacetDrillDown = !0), n;
	}, Ku.tracking = (e = {}) => {
		let t = e.tracking || {}, n = {};
		return t.userId && (n.userId = t.userId), t.domain && (n.domain = t.domain), t.sessionId && (n.sessionId = t.sessionId), t.pageLoadId && (n.pageLoadId = t.pageLoadId), n;
	}, Ku.personalization = (e = {}) => {
		let t = e.personalization || {}, n = {};
		return t.disabled && (n.skipPersonalization = t.disabled), t.cart && (n.cart = t.cart), t.lastViewed && (n.lastViewed = t.lastViewed), t.shopper && (n.shopper = t.shopper), n;
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/suggestResponse.js
function Ju(e) {
	return {
		query: e?.query,
		correctedQuery: e?.["corrected-query"],
		suggested: Ju.suggested(e),
		alternatives: Ju.alternatives(e)
	};
}
var Yu = o((() => {
	Ju.suggested = (e) => typeof e != "object" || !e.suggested || typeof e.suggested != "object" ? {} : {
		text: e.suggested?.text,
		type: e.suggested?.type,
		source: e.suggested?.source
	}, Ju.alternatives = (e) => (e?.alternatives || []).map((e) => ({ text: e.text }));
})), Xu, Zu = o((() => {
	Xu = (e) => {
		if (!e) return;
		let t = [];
		return e.map((e) => {
			if (e.type == "value") {
				let n = t.findIndex((t) => t.field == e.field);
				if (n > -1) t[n].values.push(e.value);
				else {
					let n = {
						field: e.field,
						type: "=",
						values: [e.value]
					};
					t.push(n);
				}
			} else if (e.type == "range") {
				if (typeof e.value.low == "number") {
					let n = {
						field: e.field,
						type: ">=",
						values: [e.value.low]
					}, r = t.findIndex((t) => t.field == e.field && t.type == ">=");
					r > -1 ? t[r] = n : t.push(n);
				}
				if (typeof e.value.high == "number") {
					let n = {
						field: e.field,
						type: "<=",
						values: [e.value.high]
					}, r = t.findIndex((t) => t.field == e.field && t.type == "<=");
					r > -1 ? t[r] = n : t.push(n);
				}
			}
		}), t;
	};
})), Qu = o((() => {
	qu(), Hu(), Yu(), Zu();
})), $u, ed, td = o((() => {
	fd(), wu(), Hu(), Qu(), $u = "test", ed = class extends Fu {
		async getEndpoint(e, t) {
			let n = Ku(e);
			n.ajaxCatalog = this.configuration.initiator, n.resultsFormat = "native", this.configuration.mode == q.development && (n[$u] = !0);
			let r = { ...n };
			return delete r.pageLoadId, delete r.domain, delete r.input, delete r.redirectResponse, Ru(await this.request({
				path: t,
				method: "GET",
				headers: {},
				query: n
			}, JSON.stringify(r)), e);
		}
		async getAutocomplete(e) {
			return this.getEndpoint(e, this.configuration.paths.autocomplete || "/v1/autocomplete");
		}
		async getSearch(e) {
			return this.getEndpoint(e, this.configuration.paths.search || "/v1/search");
		}
		async getCategory(e) {
			return this.getEndpoint(e, this.configuration.paths.category || "/v1/category");
		}
		async getFinder(e) {
			return this.getEndpoint(e, this.configuration.paths.finder || "/v1/finder");
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/apis/Recommend.js
function nd(e, t) {
	let n = e.request, r = t.request, i = n.order ?? n.profile?.order, a = r.order ?? r.profile?.order;
	return i == null && a == null ? 0 : i == null && a != null ? 1 : a == null && i != null || i < a ? -1 : +(i > a);
}
function rd(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var id, ad, od, sd = o((() => {
	Lu(), wu(), Qu(), td(), id = class {
		constructor() {
			this.promise = new Promise((e, t) => {
				this.reject = t, this.resolve = e;
			});
		}
	}, ad = 150, od = class extends Fu {
		constructor() {
			super(...arguments), this.batches = {};
		}
		async getProfile(e) {
			return await this.request({
				path: this.configuration.paths.profile || "/v1/profile",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async batchRecommendations(e) {
			let t = e.batchId || 1, n = e.batched ? `${e.profile?.siteId || e.siteId}:${t}` : `${Math.random()}:${t}`, r = this.batches[n] = this.batches[n] || {
				timeout: null,
				request: { profiles: [] },
				entries: []
			}, i = new id();
			r.entries.push({
				request: e,
				deferred: i
			});
			let a = typeof window < "u" ? window.clearTimeout : clearTimeout, o = typeof window < "u" ? window.setTimeout : setTimeout;
			return a && a(r.timeout), r.timeout = o(async () => {
				delete this.batches[n], r.entries.sort(nd), r.entries.map((e) => {
					if (e.request.product && (Array.isArray(e.request.products) && e.request.products.indexOf(e.request.product) == -1 ? e.request.products = e.request.products.concat(e.request.product) : e.request.products = [e.request.product]), e.request.profile) {
						let { tag: t, profile: { categories: n, brands: i, blockedItems: a, limit: o, query: s, filters: c, dedupe: l } } = e.request, u = {
							tag: t,
							...rd({
								categories: n,
								brands: i,
								blockedItems: a,
								limit: o,
								searchTerm: s,
								filters: Xu(c),
								dedupe: l
							})
						};
						r.request.profiles?.push(u);
					} else {
						let { tag: t, categories: n, brands: i, limit: a, query: o, dedupe: s } = e.request, c = {
							tag: t,
							...rd({
								categories: n,
								brands: i,
								limit: a,
								searchTerm: o,
								dedupe: s
							})
						};
						r.request.profiles?.push(c);
					}
					let { products: t, blockedItems: n, filters: i, test: a, cart: o, lastViewed: s, shopper: c, withRecInfo: l } = e.request, u = Array.from(new Set((r.request.products || []).concat(t || []))), d = Array.from(new Set((r.request.blockedItems || []).concat(n || []))), f = Array.from(new Set((r.request.filters || []).concat(Xu(i) || []).map((e) => JSON.stringify(e)))).map((e) => JSON.parse(e)), p = r.request.withRecInfo || l || void 0;
					r.request = {
						...r.request,
						...rd({
							siteId: e.request.profile?.siteId || e.request.siteId,
							products: u.length ? u : void 0,
							blockedItems: d.length ? d : void 0,
							filters: f.length ? f : void 0,
							test: a,
							cart: o,
							lastViewed: s,
							shopper: c,
							withRecInfo: p
						})
					}, this.configuration.mode == q.development && (r.request[$u] = !0);
				});
				try {
					this.configuration.mode == q.development && (r.request.test = !0);
					let e = await this.postRecommendations(r.request);
					r.entries?.forEach((t, n) => {
						t.deferred.resolve(e[n]);
					});
				} catch (e) {
					r.entries?.forEach((t) => {
						t.deferred.reject(e);
					});
				}
			}, ad), i.promise;
		}
		async postRecommendations(e) {
			let t = {};
			return t["Content-Type"] = "text/plain", await this.request({
				path: this.configuration.paths.recommend || "/v1/recommend",
				method: "POST",
				headers: t,
				body: e,
				subDomain: "p13n"
			}, JSON.stringify(e));
		}
	};
})), cd, ld = o((() => {
	Lu(), cd = class extends Fu {
		async getSuggest(e) {
			return await this.request({
				path: this.configuration.paths.suggest || "/v1/suggest",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async postSuggest(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.suggest || "/v1/suggest",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
		async getTrending(e) {
			return await this.request({
				path: this.configuration.paths.trending || "/v1/trending",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async postTrending(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.trending || "/v1/trending",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
	};
})), ud, dd = o((() => {
	fd(), ud = class extends Fu {
		async postMeta(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.meta || "/v1/meta",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
		async getMeta(e) {
			return await this.request({
				path: this.configuration.paths.meta || "/v1/meta",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
	};
})), fd = o((() => {
	Lu(), td(), sd(), ld(), dd();
})), pd, md, hd, gd = o((() => {
	wu(), fd(), pd = /* @__PURE__ */ u(R()), Qu(), md = {
		mode: q.production,
		meta: { cache: { purgeable: !1 } }
	}, hd = class {
		constructor(e, t = {}) {
			if (this.mode = q.production, !e?.siteId) throw "no siteId specified!";
			this.globals = e, this.config = (0, pd.default)(md, t), Object.values(q).includes(this.config.mode) && (this.mode = this.config.mode), this.requesters = {
				meta: new ud(new Iu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.meta?.origin,
					headers: this.config.meta?.headers,
					cache: this.config.meta?.cache,
					globals: this.config.meta?.globals,
					paths: this.config.meta?.paths
				})),
				recommend: new od(new Iu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.recommend?.origin,
					headers: this.config.recommend?.headers,
					cache: this.config.recommend?.cache,
					globals: this.config.recommend?.globals,
					paths: this.config.recommend?.paths
				})),
				search: new ed(new Iu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.search?.origin,
					headers: this.config.search?.headers,
					cache: this.config.search?.cache,
					globals: this.config.search?.globals,
					paths: this.config.search?.paths
				})),
				suggest: new cd(new Iu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.suggest?.origin,
					headers: this.config.suggest?.headers,
					cache: this.config.suggest?.cache,
					globals: this.config.suggest?.globals,
					paths: this.config.suggest?.paths
				}))
			};
		}
		async meta(e) {
			let t = { siteId: this.globals.siteId };
			return e = (0, pd.default)(t, e || {}), this.requesters.meta.getMeta(e);
		}
		async autocomplete(e = {}) {
			if (!e.search?.query?.string) throw "query string parameter is required";
			e = (0, pd.default)(this.globals, e);
			let t = this.meta({ siteId: e.siteId || "" }), n = {
				siteId: e.siteId || "",
				language: "en",
				query: e.search?.query?.string || "",
				suggestionCount: (e.suggestions || {}).count || 5
			};
			e.search?.query?.spellCorrection === !1 && (n.disableSpellCorrect = !0);
			let r = Ju(await this.requesters.suggest.getSuggest(n)), i = (r.suggested || {}).text || r.query || r.correctedQuery;
			e.search = e.search || {}, e.search.redirectResponse = "full", i && e.search?.query?.string && (e.search.query.string = i);
			let a = {
				...await this.requesters.search.getAutocomplete(e),
				autocomplete: r
			}, [o, s] = await Promise.all([t, a]);
			return {
				meta: o,
				search: s
			};
		}
		async search(e = {}) {
			e = (0, pd.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getSearch(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async category(e = {}) {
			e = (0, pd.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getCategory(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async finder(e = {}) {
			e = (0, pd.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getFinder(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async trending(e) {
			return e = (0, pd.default)({ siteId: this.globals.siteId }, e || {}), this.requesters.suggest.getTrending(e);
		}
		async recommend(e) {
			let { tag: t, ...n } = e;
			if (!t) throw "tag parameter is required";
			let r = {
				tag: t,
				siteId: e.siteId || this.globals.siteId
			};
			n.branch && (r.branch = n.branch, delete n.branch);
			let i = {
				tag: t,
				...n,
				siteId: e.siteId || this.globals.siteId
			}, [a, o, s] = await Promise.all([
				this.meta(e.siteId ? { siteId: e.siteId } : void 0),
				this.requesters.recommend.getProfile(r),
				this.requesters.recommend.batchRecommendations(i)
			]);
			return {
				...o,
				meta: a,
				results: s && s.results,
				responseId: s ? s.responseId : ""
			};
		}
	};
})), _d = o((() => {
	gd();
})), vd, yd = o((() => {
	vd = {
		blue: "#3379c1",
		bluelight: "#688BA3",
		bluedark: "#1B3141",
		bluegreen: "#318495",
		grey: "#61717B",
		green: "#507B43",
		greendark: "#63715F",
		greenblue: "#46927D",
		indigo: "#4c3ce2",
		orange: "#ecaa15",
		orangelight: "#ff6600",
		orangedark: "#c59600",
		red: "#cc1212",
		redlight: "#f30707",
		reddark: "#8E111C",
		yellow: "#d1d432"
	};
})), bd, xd = o((() => {
	bd = {
		bang: String.fromCodePoint(8252),
		bright: String.fromCodePoint(128262),
		check: String.fromCodePoint(10004),
		clock: String.fromCodePoint(128342),
		cloud: String.fromCodePoint(9729),
		dim: String.fromCodePoint(128261),
		gear: String.fromCodePoint(9881),
		interobang: String.fromCodePoint(8265),
		lightning: String.fromCodePoint(9889),
		magic: String.fromCodePoint(10024),
		rocket: String.fromCodePoint(128640),
		search: String.fromCodePoint(128269),
		snap: String.fromCodePoint(128165),
		ufo: String.fromCodePoint(128760),
		vortex: String.fromCodePoint(127744),
		warning: String.fromCodePoint(9888)
	};
})), Sd, Cd = o((() => {
	wu(), yd(), xd(), Sd = class {
		constructor(e) {
			this.mode = q.production, this.emoji = bd, this.colors = vd, this.prefix = "", this.prefix = e?.prefix || "", this.mode = e?.mode || q.production;
		}
		setNamespace(e) {
			this.prefix = ` [${e}] :: `;
		}
		error(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), console.log(`%c ${bd.bang} %c${this.prefix}${t}`, `color: ${vd.red}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${vd.red}; font-weight: bold;`, ...n);
		}
		warn(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), console.log(`%c ${bd.warning} %c${this.prefix}%c${t}`, `color: ${vd.yellow}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${vd.yellow}; font-weight: normal;`, `color: ${vd.yellow}; font-weight: bold;`, ...n);
		}
		image({ url: e, width: t, height: n }, ...r) {
			let i = {
				size: `font-size: 1px; padding: ${n || t} ${t || n};`,
				background: `background: url("${e}") no-repeat; background-size: contain;`
			};
			this.dev("%c...", `${i.size} ${i.background}`, ...r);
		}
		imageText({ url: e, text: t = "", style: n }, ...r) {
			let i = {
				background: `margin-left: 6px; background: url("${e}") no-repeat; background-size: contain;`,
				custom: n
			}, a = t, o = r;
			!a && r?.length && ([a, ...o] = r), this.dev(`%c ${"  " + this.prefix}${a}`, `${i.background} ${i.custom}`, ...o);
		}
		debug(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), this.dev(`%c ${bd.interobang} %c${this.prefix}${t}`, `color: ${vd.orangelight}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${vd.orangelight}; font-weight: bold;`, ...n);
		}
		profile(e, ...t) {
			this.dev(`%c ${bd.gear} %c${this.prefix}%c${e.type}  %c~  ${e.name}  ::  %c${e.status.toUpperCase()}${e.status == "finished" ? "  ::  %c" + e.time.run + "ms" : ""}`, `color: ${vd.orange}; font-size: 14px; line-height: 12px;`, `color: ${vd.orange};`, `color: ${vd.orange}; font-style: italic;`, `color: ${vd.orange};`, `color: ${vd.orange}; font-weight: bold;`, `color: ${vd.grey};`, ...t);
		}
		dev(...e) {
			this.mode === q.development && console.log(...e);
		}
	};
})), wd = o((() => {
	Cd(), yd(), xd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AttributionInner.js
function Td(e) {
	return Ed(e, !1);
}
function Ed(e, t = !1) {
	return e == null ? e : {
		type: e.type,
		id: e.id
	};
}
var Dd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Currency.js
function Od(e) {
	return kd(e, !1);
}
function kd(e, t = !1) {
	return e == null ? e : { code: e.code };
}
var Ad = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Context.js
function jd(e) {
	return Md(e, !1);
}
function Md(e, t = !1) {
	return e == null ? e : {
		initiator: e.initiator,
		pageLoadId: e.pageLoadId,
		pageUrl: e.pageUrl,
		sessionId: e.sessionId,
		timestamp: e.timestamp,
		userId: e.userId,
		attribution: e.attribution == null ? void 0 : e.attribution.map(Td),
		currency: Od(e.currency),
		dev: e.dev,
		IP: e.iP,
		shopperId: e.shopperId,
		userAgent: e.userAgent
	};
}
var Nd = o((() => {
	Dd(), Ad();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Product.js
function Pd(e) {
	return Fd(e, !1);
}
function Fd(e, t = !1) {
	return e == null ? e : {
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku,
		qty: e.qty,
		price: e.price
	};
}
var Id = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AddtocartSchemaData.js
function Ld(e) {
	return Rd(e, !1);
}
function Rd(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(Pd)
	};
}
var zd = o((() => {
	Id();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AddtocartSchema.js
function Bd(e) {
	return Vd(e, !1);
}
function Vd(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Ld(e.data)
	};
}
var Hd = o((() => {
	Nd(), zd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BannersInner.js
function Ud(e) {
	return Wd(e, !1);
}
function Wd(e, t = !1) {
	return e == null ? e : { uid: e.uid };
}
var Gd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesAddtocartSchemaData.js
function Kd(e) {
	return qd(e, !1);
}
function qd(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		tag: e.tag,
		results: e.results.map(Pd)
	};
}
var Jd = o((() => {
	Id();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesAddtocartSchema.js
function Yd(e) {
	return Xd(e, !1);
}
function Xd(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Kd(e.data)
	};
}
var Zd = o((() => {
	Nd(), Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersInner.js
function Qd(e) {
	return $d(e, !1);
}
function $d(e, t = !1) {
	return e == null ? e : { uid: e.uid };
}
var ef = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersSchema1.js
function tf(e) {
	return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function nf(e) {
	return rf(e, !1);
}
function rf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		banners: e.banners.map(Qd)
	};
}
var af = o((() => {
	ef();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultProductType.js
function of(e) {
	return e;
}
var sf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultProduct.js
function cf(e) {
	return !(!("type" in e) || e.type === void 0 || !("parentId" in e) || e.parentId === void 0 || !("uid" in e) || e.uid === void 0);
}
function lf(e) {
	return uf(e, !1);
}
function uf(e, t = !1) {
	return e == null ? e : {
		type: of(e.type),
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var df = o((() => {
	sf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultResultBanner.js
function ff(e) {
	return !(!("type" in e) || e.type === void 0 || !("uid" in e) || e.uid === void 0);
}
function pf(e) {
	return mf(e, !1);
}
function mf(e, t = !1) {
	return e == null ? e : {
		type: of(e.type),
		uid: e.uid
	};
}
var hf = o((() => {
	sf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsInner.js
function gf(e) {
	return _f(e, !1);
}
function _f(e, t = !1) {
	return typeof e != "object" || !e ? e : cf(e) ? lf(e) : ff(e) ? pf(e) : {};
}
var vf = o((() => {
	df(), hf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsSchema1.js
function yf(e) {
	return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function bf(e) {
	return xf(e, !1);
}
function xf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results.map(gf)
	};
}
var Sf = o((() => {
	vf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesClickthroughSchemaData.js
function Cf(e) {
	return wf(e, !1);
}
function wf(e, t = !1) {
	return typeof e != "object" || !e ? e : tf(e) ? nf(e) : yf(e) ? bf(e) : {};
}
var Tf = o((() => {
	af(), Sf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesClickthroughSchema.js
function Ef(e) {
	return Df(e, !1);
}
function Df(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Cf(e.data)
	};
}
var Of = o((() => {
	Nd(), Tf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultsInner.js
function kf(e) {
	return Af(e, !1);
}
function Af(e, t = !1) {
	return typeof e != "object" || !e ? e : cf(e) ? lf(e) : ff(e) ? pf(e) : {};
}
var jf = o((() => {
	df(), hf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesImpressionSchemaData.js
function Mf(e) {
	return Nf(e, !1);
}
function Nf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results == null ? void 0 : e.results.map(kf),
		banners: e.banners.map(Ud)
	};
}
var Pf = o((() => {
	Gd(), jf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesImpressionSchema.js
function Ff(e) {
	return If(e, !1);
}
function If(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Mf(e.data)
	};
}
var Lf = o((() => {
	Nd(), Pf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesRenderSchemaData.js
function Rf(e) {
	return zf(e, !1);
}
function zf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId
	};
}
var Bf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesRenderSchema.js
function Vf(e) {
	return Hf(e, !1);
}
function Hf(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Rf(e.data)
	};
}
var Uf = o((() => {
	Nd(), Bf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/CartSchemaData.js
function Wf(e) {
	return Gf(e, !1);
}
function Gf(e, t = !1) {
	return e == null ? e : {
		results: e.results.map(Pd),
		cart: e.cart.map(Pd)
	};
}
var Kf = o((() => {
	Id();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/CartSchema.js
function qf(e) {
	return Jf(e, !1);
}
function Jf(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Wf(e.data)
	};
}
var Yf = o((() => {
	Kf(), Nd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatAddtocartSchemaData.js
function Xf(e) {
	return Zf(e, !1);
}
function Zf(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(Pd)
	};
}
var Qf = o((() => {
	Id();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatAddtocartSchema.js
function $f(e) {
	return ep(e, !1);
}
function ep(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Xf(e.data)
	};
}
var tp = o((() => {
	Nd(), Qf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatResultProductType.js
function np(e) {
	return e;
}
var rp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatResultProduct.js
function ip(e) {
	return ap(e, !1);
}
function ap(e, t = !1) {
	return e == null ? e : {
		type: np(e.type),
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var op = o((() => {
	rp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatClickthroughSchemaData.js
function sp(e) {
	return cp(e, !1);
}
function cp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(ip)
	};
}
var lp = o((() => {
	op();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatClickthroughSchema.js
function up(e) {
	return dp(e, !1);
}
function dp(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: sp(e.data)
	};
}
var fp = o((() => {
	Nd(), lp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatFeedbackSchemaData.js
function pp(e) {
	return mp(e, !1);
}
function mp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		feedback: e.feedback
	};
}
var hp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatFeedbackSchema.js
function gp(e) {
	return _p(e, !1);
}
function _p(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: pp(e.data)
	};
}
var vp = o((() => {
	hp(), Nd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatImpressionSchemaData.js
function yp(e) {
	return bp(e, !1);
}
function bp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(ip)
	};
}
var xp = o((() => {
	op();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatImpressionSchema.js
function Sp(e) {
	return Cp(e, !1);
}
function Cp(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: yp(e.data)
	};
}
var wp = o((() => {
	Nd(), xp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersSchema.js
function Tp(e) {
	return !(!("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function Ep(e) {
	return Dp(e, !1);
}
function Dp(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		banners: e.banners.map(Qd)
	};
}
var Op = o((() => {
	ef();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsSchema.js
function kp(e) {
	return !(!("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function Ap(e) {
	return jp(e, !1);
}
function jp(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(gf)
	};
}
var Mp = o((() => {
	vf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughSchemaData.js
function Np(e) {
	return Pp(e, !1);
}
function Pp(e, t = !1) {
	return typeof e != "object" || !e ? e : Tp(e) ? Ep(e) : kp(e) ? Ap(e) : {};
}
var Fp = o((() => {
	Op(), Mp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughSchema.js
function Ip(e) {
	return Lp(e, !1);
}
function Lp(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Np(e.data)
	};
}
var Rp = o((() => {
	Nd(), Fp();
})), zp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ImpressionSchemaData.js
function Bp(e) {
	return Vp(e, !1);
}
function Vp(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(kf),
		banners: e.banners.map(Ud)
	};
}
var Hp = o((() => {
	Gd(), jf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ImpressionSchema.js
function Up(e) {
	return Wp(e, !1);
}
function Wp(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Bp(e.data)
	};
}
var Gp = o((() => {
	Nd(), Hp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/InlineObject.js
function J(e) {
	return Kp(e, !1);
}
function Kp(e, t) {
	return e == null ? e : { success: e.success == null ? void 0 : e.success };
}
var qp = o((() => {})), Jp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/LogSchemaData.js
function Yp(e) {
	return Xp(e, !1);
}
function Xp(e, t = !1) {
	return e == null ? e : {
		message: e.message,
		stack: e.stack,
		details: e.details
	};
}
var Zp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/LogSchema.js
function Qp(e) {
	return $p(e, !1);
}
function $p(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Yp(e.data)
	};
}
var em = o((() => {
	Nd(), Zp();
})), tm = o((() => {})), nm = o((() => {})), rm = o((() => {
	tm(), nm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/OrderTransactionSchemaData.js
function im(e) {
	return am(e, !1);
}
function am(e, t = !1) {
	return e == null ? e : {
		orderId: e.orderId,
		transactionTotal: e.transactionTotal,
		total: e.total,
		vat: e.vat,
		city: e.city,
		state: e.state,
		country: e.country,
		results: e.results.map(Pd)
	};
}
var om = o((() => {
	Id();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/OrderTransactionSchema.js
function sm(e) {
	return cm(e, !1);
}
function cm(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: im(e.data)
	};
}
var lm = o((() => {
	Nd(), om();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogContext.js
function um(e) {
	return dm(e, !1);
}
function dm(e, t = !1) {
	return e == null ? e : {
		timestamp: e.timestamp,
		dev: e.dev
	};
}
var fm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogSchemaData.js
function pm(e) {
	return mm(e, !1);
}
function mm(e, t = !1) {
	return e == null ? e : {
		message: e.message,
		stack: e.stack,
		details: e.details
	};
}
var hm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogSchema.js
function gm(e) {
	return _m(e, !1);
}
function _m(e, t = !1) {
	return e == null ? e : {
		context: um(e.context),
		data: pm(e.data)
	};
}
var vm = o((() => {
	hm(), fm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchemaDataResult.js
function ym(e) {
	return bm(e, !1);
}
function bm(e, t = !1) {
	return e == null ? e : {
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var xm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchemaData.js
function Sm(e) {
	return Cm(e, !1);
}
function Cm(e, t = !1) {
	return e == null ? e : { result: ym(e.result) };
}
var wm = o((() => {
	xm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchema.js
function Tm(e) {
	return Em(e, !1);
}
function Em(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Sm(e.data)
	};
}
var Dm = o((() => {
	Nd(), wm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsAddtocartSchemaData.js
function Om(e) {
	return km(e, !1);
}
function km(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		tag: e.tag,
		results: e.results.map(Pd)
	};
}
var Am = o((() => {
	Id();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsAddtocartSchema.js
function jm(e) {
	return Mm(e, !1);
}
function Mm(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Om(e.data)
	};
}
var Nm = o((() => {
	Nd(), Am();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsClickthroughSchemaData.js
function Pm(e) {
	return Fm(e, !1);
}
function Fm(e, t = !1) {
	return typeof e != "object" || !e ? e : tf(e) ? nf(e) : yf(e) ? bf(e) : {};
}
var Im = o((() => {
	af(), Sf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsClickthroughSchema.js
function Lm(e) {
	return Rm(e, !1);
}
function Rm(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Pm(e.data)
	};
}
var zm = o((() => {
	Nd(), Im();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsImpressionSchemaData.js
function Bm(e) {
	return Vm(e, !1);
}
function Vm(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results == null ? void 0 : e.results.map(kf),
		banners: e.banners.map(Ud)
	};
}
var Hm = o((() => {
	Gd(), jf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsImpressionSchema.js
function Um(e) {
	return Wm(e, !1);
}
function Wm(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Bm(e.data)
	};
}
var Gm = o((() => {
	Nd(), Hm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsRenderSchemaData.js
function Km(e) {
	return qm(e, !1);
}
function qm(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId
	};
}
var Jm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsRenderSchema.js
function Ym(e) {
	return Xm(e, !1);
}
function Xm(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Km(e.data)
	};
}
var Zm = o((() => {
	Nd(), Jm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RedirectSchemaData.js
function Qm(e) {
	return $m(e, !1);
}
function $m(e, t = !1) {
	return e == null ? e : {
		redirect: e.redirect,
		responseId: e.responseId
	};
}
var eh = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RedirectSchema.js
function th(e) {
	return nh(e, !1);
}
function nh(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: Qm(e.data)
	};
}
var rh = o((() => {
	Nd(), eh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RenderSchemaData.js
function ih(e) {
	return ah(e, !1);
}
function ah(e, t = !1) {
	return e == null ? e : { responseId: e.responseId };
}
var oh = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RenderSchema.js
function sh(e) {
	return ch(e, !1);
}
function ch(e, t = !1) {
	return e == null ? e : {
		context: jd(e.context),
		data: ih(e.data)
	};
}
var lh = o((() => {
	Nd(), oh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ShopperContext.js
function uh(e) {
	return dh(e, !1);
}
function dh(e, t = !1) {
	return e == null ? e : {
		initiator: e.initiator,
		pageLoadId: e.pageLoadId,
		pageUrl: e.pageUrl,
		sessionId: e.sessionId,
		shopperId: e.shopperId,
		timestamp: e.timestamp,
		userId: e.userId,
		attribution: e.attribution == null ? void 0 : e.attribution.map(Td),
		currency: Od(e.currency),
		dev: e.dev,
		IP: e.iP,
		userAgent: e.userAgent
	};
}
var fh = o((() => {
	Dd(), Ad();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ShopperLoginSchema.js
function ph(e) {
	return mh(e, !1);
}
function mh(e, t = !1) {
	return e == null ? e : { context: uh(e.context) };
}
var hh = o((() => {
	fh();
})), gh = o((() => {})), _h = o((() => {
	Hd(), zd(), Dd(), Gd(), Zd(), Jd(), Of(), Tf(), Lf(), Pf(), Uf(), Bf(), Yf(), Kf(), tp(), Qf(), fp(), lp(), vp(), hp(), wp(), xp(), op(), rp(), ef(), Op(), af(), vf(), Mp(), Sf(), Rp(), Fp(), Nd(), Ad(), zp(), Gp(), Hp(), qp(), Jp(), em(), Zp(), rm(), tm(), nm(), lm(), om(), fm(), vm(), hm(), Id(), Dm(), wm(), xm(), Nm(), Am(), zm(), Im(), Gm(), Hm(), Zm(), Jm(), rh(), eh(), lh(), oh(), df(), sf(), hf(), jf(), fh(), hh(), gh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/runtime.js
function vh(e) {
	return typeof Blob < "u" && e instanceof Blob;
}
function yh(e) {
	return typeof FormData < "u" && e instanceof FormData;
}
function bh(e, t = "") {
	return Object.keys(e).map((n) => xh(n, e[n], t)).filter((e) => e.length > 0).join("&");
}
function xh(e, t, n = "") {
	let r = n + (n.length ? `[${e}]` : e);
	if (t instanceof Array) {
		let e = t.map((e) => encodeURIComponent(String(e))).join(`&${encodeURIComponent(r)}=`);
		return `${encodeURIComponent(r)}=${e}`;
	}
	return t instanceof Set ? xh(e, Array.from(t), n) : t instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? bh(t, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(t))}`;
}
var Sh, Ch, wh, Th, Eh, Dh, Y, X, Oh = o((() => {
	Sh = "https://analytics.athoscommerce.net/beacon/v2".replace(/\/+$/, ""), Ch = class {
		constructor(e = {}) {
			this.configuration = e;
		}
		set config(e) {
			this.configuration = e;
		}
		get basePath() {
			return this.configuration.basePath == null ? Sh : this.configuration.basePath;
		}
		get fetchApi() {
			return this.configuration.fetchApi;
		}
		get middleware() {
			return this.configuration.middleware || [];
		}
		get queryParamsStringify() {
			return this.configuration.queryParamsStringify || bh;
		}
		get username() {
			return this.configuration.username;
		}
		get password() {
			return this.configuration.password;
		}
		get apiKey() {
			let e = this.configuration.apiKey;
			if (e) return typeof e == "function" ? e : () => e;
		}
		get accessToken() {
			let e = this.configuration.accessToken;
			if (e) return typeof e == "function" ? e : async () => e;
		}
		get headers() {
			return this.configuration.headers;
		}
		get credentials() {
			return this.configuration.credentials;
		}
	}, wh = new Ch(), Th = class e {
		constructor(e = wh) {
			this.configuration = e, this.fetchApi = async (e, t) => {
				let n = {
					url: e,
					init: t
				};
				for (let e of this.middleware) e.pre && (n = await e.pre({
					fetch: this.fetchApi,
					...n
				}) || n);
				let r;
				try {
					r = await (this.configuration.fetchApi || fetch)(n.url, n.init);
				} catch (e) {
					for (let t of this.middleware) t.onError && (r = await t.onError({
						fetch: this.fetchApi,
						url: n.url,
						init: n.init,
						error: e,
						response: r ? r.clone() : void 0
					}) || r);
					if (r === void 0) throw e instanceof Error ? new Dh(e, "The request failed and the interceptors did not return an alternative response") : e;
				}
				for (let e of this.middleware) e.post && (r = await e.post({
					fetch: this.fetchApi,
					url: n.url,
					init: n.init,
					response: r.clone()
				}) || r);
				return r;
			}, this.middleware = e.middleware;
		}
		withMiddleware(...e) {
			let t = this.clone();
			return t.middleware = t.middleware.concat(...e), t;
		}
		withPreMiddleware(...e) {
			let t = e.map((e) => ({ pre: e }));
			return this.withMiddleware(...t);
		}
		withPostMiddleware(...e) {
			let t = e.map((e) => ({ post: e }));
			return this.withMiddleware(...t);
		}
		isJsonMime(t) {
			return t ? e.jsonRegex.test(t) : !1;
		}
		async request(e, t) {
			let { url: n, init: r } = await this.createFetchParams(e, t), i = await this.fetchApi(n, r);
			if (i && i.status >= 200 && i.status < 300) return i;
			throw new Eh(i, "Response returned an error code");
		}
		async createFetchParams(e, t) {
			let n = this.configuration.basePath + e.path;
			e.query !== void 0 && Object.keys(e.query).length !== 0 && (n += "?" + this.configuration.queryParamsStringify(e.query));
			let r = Object.assign({}, this.configuration.headers, e.headers);
			Object.keys(r).forEach((e) => r[e] === void 0 ? delete r[e] : {});
			let i = typeof t == "function" ? t : async () => t, a = {
				method: e.method,
				headers: r,
				body: e.body,
				credentials: this.configuration.credentials
			}, o = {
				...a,
				...await i({
					init: a,
					context: e
				})
			}, s;
			s = yh(o.body) || o.body instanceof URLSearchParams || vh(o.body) ? o.body : this.isJsonMime(r["Content-Type"]) ? JSON.stringify(o.body) : o.body;
			let c = {
				...o,
				body: s
			};
			return {
				url: n,
				init: c
			};
		}
		clone() {
			let e = this.constructor, t = new e(this.configuration);
			return t.middleware = this.middleware.slice(), t;
		}
	}, Th.jsonRegex = /* @__PURE__ */ RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i"), Eh = class extends Error {
		constructor(e, t) {
			super(t), this.response = e, this.name = "ResponseError";
		}
	}, Dh = class extends Error {
		constructor(e, t) {
			super(t), this.cause = e, this.name = "FetchError";
		}
	}, Y = class extends Error {
		constructor(e, t) {
			super(t), this.field = e, this.name = "RequiredError";
		}
	}, X = class {
		constructor(e, t = (e) => e) {
			this.raw = e, this.transformer = t;
		}
		async value() {
			return this.transformer(await this.raw.json());
		}
	};
})), kh, Ah = o((() => {
	Oh(), _h(), kh = class extends Th {
		async autocompleteAddtocartRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteAddtocart().");
			if (e.addtocartSchema == null) throw new Y("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling autocompleteAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Bd(e.addtocartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async autocompleteAddtocart(e, t) {
			return await (await this.autocompleteAddtocartRaw(e, t)).value();
		}
		async autocompleteClickthroughRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteClickthrough().");
			if (e.clickthroughSchema == null) throw new Y("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling autocompleteClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Ip(e.clickthroughSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async autocompleteClickthrough(e, t) {
			return await (await this.autocompleteClickthroughRaw(e, t)).value();
		}
		async autocompleteImpressionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteImpression().");
			if (e.impressionSchema == null) throw new Y("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling autocompleteImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Up(e.impressionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async autocompleteImpression(e, t) {
			return await (await this.autocompleteImpressionRaw(e, t)).value();
		}
		async autocompleteRedirectRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteRedirect().");
			if (e.redirectSchema == null) throw new Y("redirectSchema", "Required parameter \"redirectSchema\" was null or undefined when calling autocompleteRedirect().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/redirect";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: th(e.redirectSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async autocompleteRedirect(e, t) {
			return await (await this.autocompleteRedirectRaw(e, t)).value();
		}
		async autocompleteRenderRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteRender().");
			if (e.renderSchema == null) throw new Y("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling autocompleteRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: sh(e.renderSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async autocompleteRender(e, t) {
			return await (await this.autocompleteRenderRaw(e, t)).value();
		}
	};
})), jh, Mh = o((() => {
	Oh(), _h(), jh = class extends Th {
		async bundlesAddtocartRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesAddtocart().");
			if (e.bundlesAddtocartSchema == null) throw new Y("bundlesAddtocartSchema", "Required parameter \"bundlesAddtocartSchema\" was null or undefined when calling bundlesAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Yd(e.bundlesAddtocartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async bundlesAddtocart(e, t) {
			return await (await this.bundlesAddtocartRaw(e, t)).value();
		}
		async bundlesClickthroughRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesClickthrough().");
			if (e.bundlesClickthroughSchema == null) throw new Y("bundlesClickthroughSchema", "Required parameter \"bundlesClickthroughSchema\" was null or undefined when calling bundlesClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Ef(e.bundlesClickthroughSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async bundlesClickthrough(e, t) {
			return await (await this.bundlesClickthroughRaw(e, t)).value();
		}
		async bundlesImpressionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesImpression().");
			if (e.bundlesImpressionSchema == null) throw new Y("bundlesImpressionSchema", "Required parameter \"bundlesImpressionSchema\" was null or undefined when calling bundlesImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Ff(e.bundlesImpressionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async bundlesImpression(e, t) {
			return await (await this.bundlesImpressionRaw(e, t)).value();
		}
		async bundlesRenderRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesRender().");
			if (e.bundlesRenderSchema == null) throw new Y("bundlesRenderSchema", "Required parameter \"bundlesRenderSchema\" was null or undefined when calling bundlesRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Vf(e.bundlesRenderSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async bundlesRender(e, t) {
			return await (await this.bundlesRenderRaw(e, t)).value();
		}
	};
})), Nh, Ph = o((() => {
	Oh(), _h(), Nh = class extends Th {
		async cartAddRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling cartAdd().");
			if (e.cartSchema == null) throw new Y("cartSchema", "Required parameter \"cartSchema\" was null or undefined when calling cartAdd().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/cart/add";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: qf(e.cartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async cartAdd(e, t) {
			return await (await this.cartAddRaw(e, t)).value();
		}
		async cartRemoveRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling cartRemove().");
			if (e.cartSchema == null) throw new Y("cartSchema", "Required parameter \"cartSchema\" was null or undefined when calling cartRemove().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/cart/remove";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: qf(e.cartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async cartRemove(e, t) {
			return await (await this.cartRemoveRaw(e, t)).value();
		}
	};
})), Fh, Ih = o((() => {
	Oh(), _h(), Fh = class extends Th {
		async categoryAddtocartRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryAddtocart().");
			if (e.addtocartSchema == null) throw new Y("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling categoryAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Bd(e.addtocartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async categoryAddtocart(e, t) {
			return await (await this.categoryAddtocartRaw(e, t)).value();
		}
		async categoryClickthroughRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryClickthrough().");
			if (e.clickthroughSchema == null) throw new Y("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling categoryClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Ip(e.clickthroughSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async categoryClickthrough(e, t) {
			return await (await this.categoryClickthroughRaw(e, t)).value();
		}
		async categoryImpressionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryImpression().");
			if (e.impressionSchema == null) throw new Y("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling categoryImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Up(e.impressionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async categoryImpression(e, t) {
			return await (await this.categoryImpressionRaw(e, t)).value();
		}
		async categoryRenderRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryRender().");
			if (e.renderSchema == null) throw new Y("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling categoryRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: sh(e.renderSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async categoryRender(e, t) {
			return await (await this.categoryRenderRaw(e, t)).value();
		}
	};
})), Lh, Rh = o((() => {
	Oh(), _h(), Lh = class extends Th {
		async chatAddtocartRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling chatAddtocart().");
			if (e.chatAddtocartSchema == null) throw new Y("chatAddtocartSchema", "Required parameter \"chatAddtocartSchema\" was null or undefined when calling chatAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: $f(e.chatAddtocartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async chatAddtocart(e, t) {
			return await (await this.chatAddtocartRaw(e, t)).value();
		}
		async chatClickthroughRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling chatClickthrough().");
			if (e.chatClickthroughSchema == null) throw new Y("chatClickthroughSchema", "Required parameter \"chatClickthroughSchema\" was null or undefined when calling chatClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: up(e.chatClickthroughSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async chatClickthrough(e, t) {
			return await (await this.chatClickthroughRaw(e, t)).value();
		}
		async chatFeedbackRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling chatFeedback().");
			if (e.chatFeedbackSchema == null) throw new Y("chatFeedbackSchema", "Required parameter \"chatFeedbackSchema\" was null or undefined when calling chatFeedback().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/feedback";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: gp(e.chatFeedbackSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async chatFeedback(e, t) {
			return await (await this.chatFeedbackRaw(e, t)).value();
		}
		async chatImpressionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling chatImpression().");
			if (e.chatImpressionSchema == null) throw new Y("chatImpressionSchema", "Required parameter \"chatImpressionSchema\" was null or undefined when calling chatImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Sp(e.chatImpressionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async chatImpression(e, t) {
			return await (await this.chatImpressionRaw(e, t)).value();
		}
	};
})), zh, Bh = o((() => {
	Oh(), _h(), zh = class extends Th {
		async logPersonalizationRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling logPersonalization().");
			if (e.personalizationLogSchema == null) throw new Y("personalizationLogSchema", "Required parameter \"personalizationLogSchema\" was null or undefined when calling logPersonalization().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/personalization";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: gm(e.personalizationLogSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async logPersonalization(e, t) {
			return await (await this.logPersonalizationRaw(e, t)).value();
		}
		async logShopifypixelRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling logShopifypixel().");
			if (e.logSchema == null) throw new Y("logSchema", "Required parameter \"logSchema\" was null or undefined when calling logShopifypixel().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/shopifypixel";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Qp(e.logSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async logShopifypixel(e, t) {
			return await (await this.logShopifypixelRaw(e, t)).value();
		}
		async logSnapRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling logSnap().");
			if (e.logSchema == null) throw new Y("logSchema", "Required parameter \"logSchema\" was null or undefined when calling logSnap().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/snap";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Qp(e.logSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async logSnap(e, t) {
			return await (await this.logSnapRaw(e, t)).value();
		}
	};
})), Vh = o((() => {
	Oh(), _h();
})), Hh, Uh = o((() => {
	Oh(), _h(), Hh = class extends Th {
		async orderTransactionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling orderTransaction().");
			if (e.orderTransactionSchema == null) throw new Y("orderTransactionSchema", "Required parameter \"orderTransactionSchema\" was null or undefined when calling orderTransaction().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/order/transaction";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: sm(e.orderTransactionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async orderTransaction(e, t) {
			return await (await this.orderTransactionRaw(e, t)).value();
		}
	};
})), Wh, Gh = o((() => {
	Oh(), _h(), Wh = class extends Th {
		async productPageviewRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling productPageview().");
			if (e.productPageviewSchema == null) throw new Y("productPageviewSchema", "Required parameter \"productPageviewSchema\" was null or undefined when calling productPageview().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/product/pageview";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Tm(e.productPageviewSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async productPageview(e, t) {
			return await (await this.productPageviewRaw(e, t)).value();
		}
	};
})), Kh, qh = o((() => {
	Oh(), _h(), Kh = class extends Th {
		async recommendationsAddtocartRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsAddtocart().");
			if (e.recommendationsAddtocartSchema == null) throw new Y("recommendationsAddtocartSchema", "Required parameter \"recommendationsAddtocartSchema\" was null or undefined when calling recommendationsAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: jm(e.recommendationsAddtocartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async recommendationsAddtocart(e, t) {
			return await (await this.recommendationsAddtocartRaw(e, t)).value();
		}
		async recommendationsClickthroughRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsClickthrough().");
			if (e.recommendationsClickthroughSchema == null) throw new Y("recommendationsClickthroughSchema", "Required parameter \"recommendationsClickthroughSchema\" was null or undefined when calling recommendationsClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Lm(e.recommendationsClickthroughSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async recommendationsClickthrough(e, t) {
			return await (await this.recommendationsClickthroughRaw(e, t)).value();
		}
		async recommendationsImpressionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsImpression().");
			if (e.recommendationsImpressionSchema == null) throw new Y("recommendationsImpressionSchema", "Required parameter \"recommendationsImpressionSchema\" was null or undefined when calling recommendationsImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Um(e.recommendationsImpressionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async recommendationsImpression(e, t) {
			return await (await this.recommendationsImpressionRaw(e, t)).value();
		}
		async recommendationsRenderRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsRender().");
			if (e.recommendationsRenderSchema == null) throw new Y("recommendationsRenderSchema", "Required parameter \"recommendationsRenderSchema\" was null or undefined when calling recommendationsRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Ym(e.recommendationsRenderSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async recommendationsRender(e, t) {
			return await (await this.recommendationsRenderRaw(e, t)).value();
		}
	};
})), Jh, Yh = o((() => {
	Oh(), _h(), Jh = class extends Th {
		async searchAddtocartRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling searchAddtocart().");
			if (e.addtocartSchema == null) throw new Y("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling searchAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Bd(e.addtocartSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async searchAddtocart(e, t) {
			return await (await this.searchAddtocartRaw(e, t)).value();
		}
		async searchClickthroughRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling searchClickthrough().");
			if (e.clickthroughSchema == null) throw new Y("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling searchClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Ip(e.clickthroughSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async searchClickthrough(e, t) {
			return await (await this.searchClickthroughRaw(e, t)).value();
		}
		async searchImpressionRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling searchImpression().");
			if (e.impressionSchema == null) throw new Y("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling searchImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Up(e.impressionSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async searchImpression(e, t) {
			return await (await this.searchImpressionRaw(e, t)).value();
		}
		async searchRedirectRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling searchRedirect().");
			if (e.redirectSchema == null) throw new Y("redirectSchema", "Required parameter \"redirectSchema\" was null or undefined when calling searchRedirect().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/redirect";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: th(e.redirectSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async searchRedirect(e, t) {
			return await (await this.searchRedirectRaw(e, t)).value();
		}
		async searchRenderRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling searchRender().");
			if (e.renderSchema == null) throw new Y("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling searchRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: sh(e.renderSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async searchRender(e, t) {
			return await (await this.searchRenderRaw(e, t)).value();
		}
	};
})), Xh, Zh = o((() => {
	Oh(), _h(), Xh = class extends Th {
		async loginRaw(e, t) {
			if (e.siteId == null) throw new Y("siteId", "Required parameter \"siteId\" was null or undefined when calling login().");
			if (e.shopperLoginSchema == null) throw new Y("shopperLoginSchema", "Required parameter \"shopperLoginSchema\" was null or undefined when calling login().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/shopper/login";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: ph(e.shopperLoginSchema)
			}, t);
			return new X(a, (e) => J(e));
		}
		async login(e, t) {
			return await (await this.loginRaw(e, t)).value();
		}
	};
})), Qh = o((() => {
	Ah(), Mh(), Ph(), Ih(), Rh(), Bh(), Vh(), Uh(), Gh(), qh(), Yh(), Zh();
})), $h, eg, tg, ng, rg, ig, ag, og, sg, cg, lg, ug, dg, fg, pg = o((() => {
	$h = "@athoscommerce/beacon", eg = "1.2.0", tg = "athoscommerce", ng = "Javascript library for utilizing Athos Commerce beacon tracking.", rg = "dist/cjs/src/index.js", ig = "dist/esm/src/index.js", ag = {
		type: "git",
		url: "https://github.com/AthosCommerce/beacon.js.git"
	}, og = "@searchspring/prettier", sg = {
		build: "rm -rf ./dist && npm run generate && tsc && tsc -p tsconfig.cjs.json && npm run build:cdn",
		"build:cdn": "webpack --config webpack.prod.js",
		dev: "tsc --watch & webpack serve --config webpack.dev.js",
		commit: "cz",
		test: "jest",
		"test:watch": "jest --watch",
		generate: "rm -fr ./src/client && openapi-generator-cli generate -i ./beacon.v2.snap.types.oas.yaml -g typescript-fetch -o ./src/client && npm run format",
		format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
		lint: "eslint src --ext .ts,.tsx",
		prepare: "husky",
		version: "standard-version -a",
		postpublish: "git push && git push --tags"
	}, cg = { uuid: "9.0.1" }, lg = {
		"@babel/core": "^7.21.4",
		"@babel/preset-env": "^7.21.4",
		"@babel/runtime": "^7.21.0",
		"@openapitools/openapi-generator-cli": "^2.25.2",
		"@searchspring/browserslist-config-snap": "^1.0.7",
		"@searchspring/prettier": "1.0.2",
		"@types/jest": "^29.5.14",
		"@types/uuid": "^10.0.0",
		"babel-loader": "^9.1.2",
		"cz-conventional-changelog": "3.3.0",
		eslint: "9.23.0",
		"eslint-config-prettier": "10.1.1",
		husky: "9.1.7",
		jest: "29.7.0",
		"jest-environment-jsdom": "^29.7.0",
		jsdom: "26.0.0",
		"lint-staged": "15.5.0",
		prettier: "3.5.3",
		"standard-version": "9.5.0",
		"ts-jest": "^29.3.0",
		"ts-loader": "9.4.2",
		typedoc: "0.28.1",
		typescript: "5.8.2",
		"typescript-eslint": "^8.55.0",
		webpack: "^5.77.0",
		"webpack-cli": "^5.0.1",
		"webpack-dev-server": "^4.13.2",
		"webpack-merge": "^5.8.0",
		"whatwg-fetch": "^3.6.20"
	}, ug = { commitizen: { path: "./node_modules/cz-conventional-changelog" } }, dg = { universal: "extends @searchspring/browserslist-config-snap/universal" }, fg = {
		name: $h,
		version: eg,
		author: tg,
		license: "MIT",
		description: ng,
		main: rg,
		module: ig,
		repository: ag,
		prettier: og,
		scripts: sg,
		dependencies: cg,
		devDependencies: lg,
		"lint-staged": { "*.{js,ts,tsx}": ["prettier --write", "eslint"] },
		config: ug,
		browserslist: dg
	};
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/utils/featureFlags.js
function mg() {
	return {
		cookies: function() {
			return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
		},
		storage: function() {
			let e = "ss-test";
			if (typeof window > "u") return !1;
			try {
				return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
			} catch {
				return !1;
			}
		}
	};
}
var hg, gg, _g = o((() => {
	hg = mg(), gg = {
		cookies: hg.cookies(),
		storage: hg.storage()
	};
})), vg, yg = o((() => {
	vg = (e, t, n, r, i) => {
		let a = window.location.protocol == "https:" ? "Secure;" : "", o = "SameSite=" + (n || "Lax") + ";", s = "";
		if (r) {
			let e = /* @__PURE__ */ new Date();
			e.setTime(e.getTime() + r), s = "expires=" + e.toUTCString() + ";";
		}
		let c = encodeURIComponent(t) + ";";
		if (i) return e + "=" + c + s + o + a + "path=/; domain=" + i;
		let l = window?.location?.hostname;
		if (!l || l.split(".").length === 1) return e + "=" + c + s + o + a + "path=/";
		let u = l.split(".");
		return u.shift(), i = "." + u.join("."), e + "=" + c + s + o + a + "path=/; domain=" + i;
	};
})), bg = o((() => {
	_g(), yg();
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/rng.js
function xg() {
	if (!Sg && (Sg = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Sg)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return Sg(Cg);
}
var Sg, Cg, wg = o((() => {
	Cg = /* @__PURE__ */ new Uint8Array(16);
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/stringify.js
function Tg(e, t = 0) {
	return Eg[e[t + 0]] + Eg[e[t + 1]] + Eg[e[t + 2]] + Eg[e[t + 3]] + "-" + Eg[e[t + 4]] + Eg[e[t + 5]] + "-" + Eg[e[t + 6]] + Eg[e[t + 7]] + "-" + Eg[e[t + 8]] + Eg[e[t + 9]] + "-" + Eg[e[t + 10]] + Eg[e[t + 11]] + Eg[e[t + 12]] + Eg[e[t + 13]] + Eg[e[t + 14]] + Eg[e[t + 15]];
}
var Eg, Dg = o((() => {
	Eg = [];
	for (let e = 0; e < 256; ++e) Eg.push((e + 256).toString(16).slice(1));
})), Og, kg, Ag = o((() => {
	Og = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), kg = { randomUUID: Og };
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/v4.js
function jg(e, t, n) {
	if (kg.randomUUID && !t && !e) return kg.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || xg)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return Tg(r);
}
var Mg = o((() => {
	Ag(), wg(), Dg();
})), Ng = o((() => {
	wg(), Dg(), Mg();
})), Pg = o((() => {
	Oh(), Qh(), _h();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/Beacon.js
function Fg(e, t, n, r) {
	if (!e.batches[t]) e.batches[t] = JSON.parse(JSON.stringify(r));
	else {
		let i = e.batches[t].payload, a = r.payload, o = i[n], s = a[n];
		if (s?.data?.results) {
			let e = o.data.results || [], t = s.data.results, n = [...e, ...t];
			o.data.results = n;
		}
		if (s?.data?.banners) {
			let e = o?.data?.banners || [], t = s.data.banners, n = [...e, ...t];
			o.data.banners = n;
		}
	}
}
function Ig(e, t) {
	let n = "";
	return n += `||${t.context.pageLoadId}`, n += `||${t.context.sessionId}`, t.data?.chatSessionId ? n += `||chatSessionId=${t.data.chatSessionId}||responseId=${t.data.responseId}` : t.data?.responseId ? n += `||responseId=${t.data.responseId}` : e === "shopper" && t.context.shopperId && (n += `||shopperId=${t.context.shopperId}`), (e === "recommendation" || e === "bundle") && (n += `||tag=${t.data.tag}`), n;
}
function Lg(e) {
	if (typeof window < "u" && gg.cookies) {
		let t = e + "=", n = window.document.cookie.split(";");
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			for (; r.charAt(0) == " ";) r = r.substring(1);
			if (r.indexOf(t) == 0) return decodeURIComponent(r.substring(t.length, r.length));
		}
		return "";
	}
	return "";
}
function Rg(e, t) {
	let n = t_[e];
	return t.trim().toLowerCase().startsWith("at") ? [n.primary, n.legacy] : [n.legacy, n.primary];
}
function zg(e, t) {
	let n = t_[e];
	return t.trim().toLowerCase().startsWith("at") ? [n.primary] : [n.legacy];
}
function Bg(e) {
	let t = t_[e];
	typeof window < "u" && (window.localStorage?.removeItem(t.primary), window.localStorage?.removeItem(t.legacy));
}
function Vg(e, t, n, r) {
	if (e instanceof Error && e.name === "QuotaExceededError") {
		let e = t_[n];
		t.events.error.snap({ data: {
			message: "QuotaExceededError",
			details: {
				key: e.legacy,
				keyPrimary: e.primary,
				value: r
			}
		} });
	}
}
var Hg, Ug, Wg, Gg, Kg, qg, Jg, Yg, Xg, Zg, Qg, $g, e_, t_, n_, r_ = o((() => {
	pg(), bg(), Ng(), Pg(), Qh(), {version: Hg} = fg, Ug = 47304e6, Wg = 18e5, Gg = 20, Kg = -1, qg = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, Jg = "userId", Yg = "pageLoadId", Xg = "sessionId", Zg = "shopperId", Qg = "cartProducts", $g = "viewedProducts", e_ = "attribution", t_ = {
		[Jg]: {
			primary: "athosUserId",
			legacy: "ssUserId"
		},
		[Yg]: {
			primary: "athosPageLoadId",
			legacy: "ssPageLoadId"
		},
		[Xg]: {
			primary: "athosSessionId",
			legacy: "ssSessionId"
		},
		[Zg]: {
			primary: "athosShopperId",
			legacy: "ssShopperId"
		},
		[Qg]: {
			primary: "athosCartProducts",
			legacy: "ssCartProducts"
		},
		[$g]: {
			primary: "athosViewedProducts",
			legacy: "ssViewedProducts"
		},
		[e_]: {
			primary: "athosAttribution",
			legacy: "ssAttribution"
		}
	}, n_ = class {
		constructor(e, t) {
			if (this.mode = "production", this.pageLoadId = "", this.userId = "", this.sessionId = "", this.shopperId = "", this.currency = { code: "" }, this.initiator = "", this.batchIntervalTimeout = 0, this.preflightTimeout = 0, this.requests = [], this.storage = {
				cart: {
					get: () => {
						let e = this.getLocalStorageItem(Qg);
						if (e) try {
							if (Array.isArray(e)) return e;
						} catch {
							Bg(Qg), this.setCookie(Qg, "", "Lax", 0, qg);
						}
						else return this.getCookie(Qg).split(",").filter((e) => e).map((e) => ({
							parentId: e,
							uid: e,
							sku: e,
							qty: 1,
							price: 0
						}));
						return [];
					},
					set: (e) => {
						let t = this.storage.cart.get(), n = JSON.stringify(e);
						try {
							this.setLocalStorageItem(Qg, e);
						} catch (e) {
							Vg(e, this, Qg, n);
						}
						let r = e.map((e) => this.getProductId(e)).join(",");
						this.setCookie(Qg, r, "Lax", 0, qg), JSON.stringify(t) !== n && this._sendPreflight();
					},
					add: (e) => {
						if (e.length) {
							let t = [...this.storage.cart.get()];
							e.filter((e) => typeof e == "object" && e.uid).reverse().forEach((e) => {
								let n = t.find((t) => t.uid === e.uid);
								n ? (n.qty += e.qty, n.price = e.price || n.price, (e.parentId !== n.parentId || e.sku !== n.sku) && (n.parentId = e.parentId, n.sku = e.sku)) : t.unshift(e);
							}), this.storage.cart.set(t);
						}
					},
					remove: (e) => {
						if (e.length) {
							let t = [...this.storage.cart.get()];
							e.forEach((e) => {
								let n = t.find((t) => t.uid === e.uid);
								n && n.qty > 0 && (n.qty -= e.qty || 1, (e.parentId !== n.parentId || e.sku !== n.sku) && (n.parentId = e.parentId, n.sku = e.sku));
							});
							let n = t.filter((e) => e.qty > 0);
							this.storage.cart.set(n);
						}
					},
					clear: () => {
						this.storage.cart.set([]);
					}
				},
				viewed: {
					get: () => {
						let e = this.getLocalStorageItem($g);
						if (e) try {
							if (Array.isArray(e)) return e;
						} catch {
							Bg($g), this.setCookie($g, "", "Lax", Ug, qg);
						}
						else return this.getCookie($g).split(",").filter((e) => e).map((e) => ({
							parentId: e,
							uid: e,
							sku: e
						}));
						return [];
					},
					set: (e) => {
						let t = this.storage.viewed.get(), n = e.map((e) => ({
							sku: e.sku,
							parentId: e.parentId,
							uid: e.uid
						})).slice(0, Gg), r = JSON.stringify(n);
						try {
							this.setLocalStorageItem($g, n);
						} catch (e) {
							Vg(e, this, $g, r);
						}
						let i = n.map((e) => this.getProductId(e)).join(",");
						this.setCookie($g, i, "Lax", Ug, qg), JSON.stringify(t) !== r && this._sendPreflight();
					},
					add: (e) => {
						if (e.length) {
							let t = this.storage.viewed.get();
							e.forEach((e) => {
								let n = {
									sku: e.sku,
									parentId: e.parentId,
									uid: e.uid
								}, r = t.find((e) => e.uid === n.uid);
								if (r) {
									let e = t.indexOf(r);
									t.splice(e, 1);
								}
								t.unshift(n);
							}), this.storage.viewed.set(t);
						}
					}
				}
			}, this.events = {
				shopper: { login: (e) => {
					let t = this.getContext();
					if (!t.shopperId || t.shopperId !== e.data.id) {
						this.setShopperId(e.data.id);
						return;
					}
					if (t.shopperId = e.data?.id, e.data?.id) {
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							shopperLoginSchema: { context: t }
						}, r = this.createRequest("shopper", "login", n);
						this.queueRequest(r);
					}
				} },
				autocomplete: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteClickthrough", t);
						this.sendRequests([n]);
					},
					redirect: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							redirectSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteRedirect", t);
						this.sendRequests([n]);
					}
				},
				search: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchClickthrough", t);
						this.sendRequests([n]);
					},
					redirect: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							redirectSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchRedirect", t);
						this.sendRequests([n]);
					}
				},
				category: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryClickthrough", t);
						this.sendRequests([n]);
					}
				},
				bundles: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesRenderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesClickthrough", t);
						this.sendRequests([n]);
					}
				},
				chat: {
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatClickthrough", t);
						this.sendRequests([n]);
					},
					feedback: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatFeedbackSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatFeedback", t);
						this.sendRequests([n]);
					}
				},
				recommendations: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsRenderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsClickthrough", t);
						this.sendRequests([n]);
					}
				},
				product: { pageView: (e) => {
					let t = {
						siteId: e?.siteId || this.globals.siteId,
						productPageviewSchema: {
							context: this.getContext(),
							data: e.data
						}
					}, n = this.createRequest("product", "productPageview", t);
					this.sendRequests([n]);
					let r = e.data.result;
					this.storage.viewed.add([r]);
				} },
				cart: {
					add: (e) => {
						let t = { ...e.data };
						t.cart ? this.storage.cart.set(t.cart) : (t.results && this.storage.cart.add(t.results), t.cart = this.storage.cart.get());
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							cartSchema: {
								context: this.getContext(),
								data: t
							}
						}, r = this.createRequest("cart", "cartAdd", n);
						this.sendRequests([r]);
					},
					remove: (e) => {
						let t = { ...e.data };
						t.cart ? this.storage.cart.set(t.cart) : (t.results && this.storage.cart.remove(t.results), t.cart = this.storage.cart.get());
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							cartSchema: {
								context: this.getContext(),
								data: t
							}
						}, r = this.createRequest("cart", "cartRemove", n);
						this.sendRequests([r]);
					}
				},
				order: { transaction: (e) => {
					let t = {
						siteId: e?.siteId || this.globals.siteId,
						orderTransactionSchema: {
							context: this.getContext(),
							data: e.data
						}
					}, n = this.createRequest("order", "orderTransaction", t);
					this.sendRequests([n]), this.storage.cart.clear();
				} },
				error: {
					shopifypixel: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							logSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("error", "logShopifypixel", t);
						this.sendRequests([n]);
					},
					snap: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							logSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("error", "logSnap", t);
						this.sendRequests([n]);
					}
				}
			}, typeof e != "object" || typeof e.siteId != "string") throw Error("Invalid config passed to tracker. The \"siteId\" attribute must be provided.");
			this.config = {
				mode: "production",
				...t || {}
			}, this.config.mode && ["production", "development"].includes(this.config.mode) && (this.mode = this.config.mode);
			let n = this.config.apis?.fetch, r = `${e.siteId}`.trim().toLowerCase().startsWith("at") ? "athos" : "searchspring", i = r === "searchspring" ? "https://analytics.searchspring.net/beacon/v2" : void 0, a = new Ch({
				fetchApi: n,
				basePath: this.config.requesters?.beacon?.origin || i,
				headers: { "Content-Type": "text/plain" }
			});
			if (this.apis = {
				shopper: new Xh(a),
				autocomplete: new kh(a),
				search: new Jh(a),
				category: new Fh(a),
				recommendations: new Kh(a),
				bundles: new jh(a),
				chat: new Lh(a),
				product: new Wh(a),
				cart: new Nh(a),
				order: new Hh(a),
				error: new zh(a)
			}, this.initiator = this.config.initiator || `${r}/beaconjs/${Hg}`, this.globals = e, this.pageLoadId = this.getPageLoadId(), this.globals?.siteId) this.globals.siteId = `${this.globals.siteId}`.trim().toLowerCase();
			else throw Error("Beacon: No siteId found in globals. Beacon will not initialize.");
		}
		setCookie(e, t, n, r, i) {
			gg.cookies && zg(e, this.globals.siteId).forEach((e) => {
				try {
					if (window.document.cookie = vg(e, t, n, r, i), Lg(e) == null || Lg(e) != t) {
						let i = "." + window.location.hostname;
						window.document.cookie = vg(e, t, n, r, i);
					}
				} catch (t) {
					console.error(`Failed to set '${e}' cookie:`, t);
				}
			});
		}
		getLocalStorageItem(e) {
			let t = Rg(e, this.globals.siteId);
			if (typeof window < "u" && gg.storage) {
				let e = "";
				for (let n of t) {
					let t = window.localStorage.getItem(n);
					if (t) {
						e = t;
						break;
					}
				}
				try {
					let n = JSON.parse(e);
					if (n && n.value) return n.value;
					t.forEach((e) => {
						window.localStorage.removeItem(e);
					});
				} catch {}
			}
		}
		setLocalStorageItem(e, t) {
			let n = zg(e, this.globals.siteId);
			if (typeof window < "u" && gg.storage) try {
				let e = JSON.stringify({ value: t });
				n.forEach((t) => {
					window.localStorage.setItem(t, e);
				});
			} catch (t) {
				throw console.warn(`Something went wrong setting local storage item '${e}':`, t), t;
			}
		}
		getCookie(e) {
			let t = Rg(e, this.globals.siteId);
			for (let e of t) {
				let t = Lg(e);
				if (t) return t;
			}
			return "";
		}
		queueRequest(e) {
			this.requests.push(e), clearTimeout(this.batchIntervalTimeout), this.batchIntervalTimeout = setTimeout(() => {
				this.processRequests();
			}, 300);
		}
		updateContext(e, t) {
			if (t !== void 0) switch (e) {
				case Jg:
				case Xg:
				case Zg:
				case Yg:
				case e_:
					this[e] = t;
					break;
				case "pageUrl":
					this.config.href = t;
					break;
				case "userAgent":
					this.config.userAgent = t;
					break;
				case "dev": ["production", "development"].includes(t) && (this.mode = t);
			}
		}
		getContext() {
			let e = {
				userAgent: this.config.userAgent,
				timestamp: this.getTimestamp(),
				pageUrl: this.config.href || typeof window < "u" && window.location.href || "",
				userId: this.userId || this.getUserId(),
				sessionId: this.sessionId || this.getSessionId(),
				pageLoadId: this.pageLoadId,
				shopperId: this.shopperId || this.getShopperId(),
				initiator: this.initiator,
				dev: this.mode === "development" || void 0,
				attribution: this.attribution || this.getAttribution()
			};
			return this.currency.code && (e.currency = { ...this.currency }), e;
		}
		getStoredId(e, t) {
			let n = "", r = "";
			try {
				r = this.getCookie(e);
				let i = this.getLocalStorageItem(e);
				i.timestamp && new Date(i.timestamp).getTime() < Date.now() - t ? (n = this.generateId(), this.attribution = void 0) : n = i.value;
			} catch {}
			let i = {
				value: r || n || this.generateId(),
				timestamp: this.getTimestamp()
			};
			e === "userId" && (this.userId = i.value), e === Xg && (this.sessionId = i.value), this.setCookie(e, i.value, "Lax", Kg, qg), this.setCookie(e, i.value, "Lax", t);
			try {
				this.setLocalStorageItem(e, i);
			} catch (t) {
				Vg(t, this, e, i.value);
			}
			return i.value;
		}
		getPageLoadId() {
			if (this.pageLoadId) return this.pageLoadId;
			let e = this.generateId(), t = this.getLocalStorageItem(Yg), n = this.config.href || typeof window < "u" && window.location.href || "";
			if (t) {
				let { href: r, value: i, timestamp: a } = t;
				r === n && i && a && new Date(a).getTime() > Date.now() - 1e4 && (e = i);
			}
			this.pageLoadId = e;
			try {
				this.setLocalStorageItem(Yg, {
					href: n,
					value: e,
					timestamp: this.getTimestamp()
				});
			} catch (t) {
				Vg(t, this, Yg, e);
			}
			return e;
		}
		getUserId() {
			return this.userId || this.getStoredId("userId", Ug);
		}
		getSessionId() {
			return this.sessionId || this.getStoredId(Xg, Wg);
		}
		getShopperId() {
			try {
				let e = this.getCookie(Zg), t = this.getLocalStorageItem(Zg), n = e || (t ? "" + t : void 0);
				n && (this.shopperId = n);
			} catch {}
			return this.shopperId || "";
		}
		setShopperId(e) {
			if (!e) return;
			let t = this.getShopperId();
			this.shopperId = "" + e, this.setCookie(Zg, this.shopperId, "Lax", Ug, qg);
			try {
				this.setLocalStorageItem(Zg, this.shopperId);
			} catch (e) {
				Vg(e, this, Zg, this.shopperId);
			}
			t !== e && (this.events.shopper.login({ data: { id: this.shopperId } }), this._sendPreflight());
		}
		getAttribution() {
			let e = [], t = null;
			try {
				let e = new URL(this.config.href || typeof window < "u" && window.location.href || "");
				t = e.searchParams.get("athos_attribution") || e.searchParams.get("ss_attribution");
			} catch {}
			let n = this.getCookie(e_) || this.getLocalStorageItem(e_);
			if (n) try {
				typeof n == "string" ? e = JSON.parse(n) : Array.isArray(n) && (e = n);
			} catch {}
			if (t) try {
				let [n, r] = decodeURIComponent(t).split(":");
				n && r && !e.find((e) => e.type === n && e.id === r) && e.unshift({
					type: n,
					id: r
				});
			} catch {}
			if (e.length) {
				let t = JSON.stringify(e);
				this.setCookie(e_, t, "Lax", Wg, qg);
				try {
					this.setLocalStorageItem(e_, e);
				} catch (e) {
					Vg(e, this, e_, t);
				}
				return this.attribution = e, [...e];
			}
		}
		generateId() {
			return jg();
		}
		getTimestamp() {
			return (/* @__PURE__ */ new Date()).toISOString();
		}
		setCurrency(e) {
			e && e.code && this.currency?.code !== e.code && (this.currency = e);
		}
		pageLoad() {
			return this.pageLoadId = this.generateId(), this.pageLoadId;
		}
		createRequest(e, t, n) {
			return {
				apiType: e,
				endpoint: t,
				payload: n
			};
		}
		getApiClient(e) {
			return this.apis[e];
		}
		sendRequests(e) {
			for (let t of e) this.getApiClient(t.apiType)[t.endpoint](t.payload, async ({ init: e }) => {
				let t = {
					...e.headers,
					...this.config.requesters?.beacon?.headers || {}
				}, n = t && "Content-Type" in t && t["Content-Type"] === "application/json";
				return {
					keepalive: this.mode === "production" || void 0,
					body: n ? e.body : JSON.stringify(e.body),
					headers: t
				};
			}).catch((e) => {
				this.mode === "development" && console.debug(e);
			});
		}
		processRequests() {
			let e = this.requests.reduce((e, t) => {
				let n = `${t.payload.siteId}||${t.endpoint}`;
				switch (t.endpoint) {
					case "recommendationsAddtocart": {
						let r = t.payload.recommendationsAddtocartSchema;
						n += Ig("recommendation", r), Fg(e, n, "recommendationsAddtocartSchema", t);
						break;
					}
					case "recommendationsImpression": {
						let r = t.payload.recommendationsImpressionSchema;
						n += Ig("recommendation", r), Fg(e, n, "recommendationsImpressionSchema", t);
						break;
					}
					case "bundlesAddtocart": {
						let r = t.payload.bundlesAddtocartSchema;
						n += Ig("bundle", r), Fg(e, n, "bundlesAddtocartSchema", t);
						break;
					}
					case "bundlesImpression": {
						let r = t.payload.bundlesImpressionSchema;
						n += Ig("bundle", r), Fg(e, n, "bundlesImpressionSchema", t);
						break;
					}
					case "chatAddtocart": {
						let r = t.payload.chatAddtocartSchema;
						n += Ig("chat", r), Fg(e, n, "chatAddtocartSchema", t);
						break;
					}
					case "chatImpression": {
						let r = t.payload.chatImpressionSchema;
						n += Ig("chat", r), Fg(e, n, "chatImpressionSchema", t);
						break;
					}
					case "searchAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Ig("search", r), Fg(e, n, "addtocartSchema", t);
						break;
					}
					case "searchImpression": {
						let r = t.payload.impressionSchema;
						n += Ig("search", r), Fg(e, n, "impressionSchema", t);
						break;
					}
					case "autocompleteAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Ig("autocomplete", r), Fg(e, n, "addtocartSchema", t);
						break;
					}
					case "autocompleteImpression": {
						let r = t.payload.impressionSchema;
						n += Ig("autocomplete", r), Fg(e, n, "impressionSchema", t);
						break;
					}
					case "categoryAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Ig("category", r), Fg(e, n, "addtocartSchema", t);
						break;
					}
					case "categoryImpression": {
						let r = t.payload.impressionSchema;
						n += Ig("category", r), Fg(e, n, "impressionSchema", t);
						break;
					}
					case "login": {
						let r = t.payload.shopperLoginSchema;
						n += Ig("shopper", r), Fg(e, n, "shopperLoginSchema", t);
						break;
					}
					default: e.nonBatched.push(t);
				}
				return e;
			}, {
				nonBatched: [],
				batches: {}
			});
			this.requests = [];
			let t = Object.values(e.batches).reduce((e, t) => (e.push(t), e), e.nonBatched);
			this.sendRequests(t);
		}
		_sendPreflight() {
			clearTimeout(this.preflightTimeout), this.preflightTimeout = setTimeout(() => {
				this.sendPreflight();
			}, 300);
		}
		sendPreflight(e) {
			let t = e?.userId || this.getUserId(), n = e?.siteId || this.globals.siteId, r = e?.shopper || this.getShopperId(), i = e?.cart || this.storage.cart.get(), a = e?.lastViewed || this.storage.viewed.get();
			if (t && typeof t == "string" && n) {
				let e = {
					userId: t,
					siteId: n
				};
				r && (e.shopper = r), i.length && (e.cart = i.map((e) => this.getProductId(e))), a.length && (e.lastViewed = a.map((e) => this.getProductId(e)));
				let o = `${n}`.toLowerCase().startsWith("at") ? "athoscommerce.net" : "searchspring.io", s = `${this.config.requesters?.personalization?.origin || `https://${n}.a.${o}`}/v1/preflight`;
				(this.config.apis?.fetch || typeof fetch < "u") && (this.config.apis?.fetch || fetch)(s, {
					method: "POST",
					headers: {
						"Content-Type": "text/plain",
						...this.config.requesters?.personalization?.headers || {}
					},
					body: JSON.stringify(e),
					keepalive: !0
				});
			}
		}
		getProductId(e) {
			return `${e.sku || e.uid || ""}`.trim();
		}
	};
})), i_ = o((() => {
	_h(), Qh(), Oh(), r_();
})), a_, o_, s_, c_ = o((() => {
	a_ = /* @__PURE__ */ u(R()), wu(), i_(), o_ = {
		id: "track",
		framework: "snap",
		mode: q.production
	}, s_ = class extends n_ {
		constructor(e, t) {
			if (t = (0, a_.default)(o_, t || {}), t.initiator || (t.initiator = `athos/${t.framework}/${fu}`), typeof e != "object" || typeof e.siteId != "string") throw Error("Invalid config passed to tracker. The \"siteId\" attribute must be provided.");
			super(e, t), this.targeters = [], this.track = {
				error: (e, t) => {
					if (this.doNotTrack?.includes("error") || this.mode === q.development || !e?.stack && !e?.message) return;
					let { stack: n, message: r, ...i } = e, { pageUrl: a } = this.getContext();
					r?.includes("Profile is currently paused") || a.includes("//localhost") || a.includes("//snapui.searchspring.io/") || a.includes("//snapui.athoscommerce.io/") || this.events.error.snap({
						data: {
							message: r || "unknown",
							stack: n,
							details: i
						},
						siteId: t
					});
				},
				shopper: { login: (e, t) => {
					this.doNotTrack?.includes("shopper.login") || this.events.shopper.login({
						data: { id: e.id },
						siteId: t
					});
				} },
				product: {
					view: (e, t) => {
						if (this.doNotTrack?.includes("product.view")) return;
						let n = { result: {
							parentId: e.parentId || e.uid || "",
							uid: e.uid || e.parentId || e.sku || "",
							sku: e.sku
						} };
						(e.childSku || e.childUid) && (n = { result: {
							parentId: e.parentId || e.uid || e.childUid || "",
							uid: e.childUid || e.uid || "",
							sku: e.childSku || e.sku
						} }), this.events.product.pageView({
							data: n,
							siteId: t
						});
					},
					click: () => {
						console.warn("tracker.track.product.click() is deprecated and is no longer functional. Use tracker.events['search' | 'category'].clickThrough() instead"), this.events.error.snap({ data: { message: "tracker.track.product.click was called" } });
					}
				},
				cart: { view: () => {
					console.warn("tracker.cart.view is deprecated and no longer functional. Use tracker.events.cart.add() and tracker.events.cart.remove() instead"), this.events.error.snap({ data: { message: "tracker.track.cart.view was called" } });
				} },
				order: { transaction: (e, t) => {
					if (this.doNotTrack?.includes("order.transaction")) return;
					let n = e.order, r = e.items, i = {
						orderId: `${n?.id || ""}`,
						transactionTotal: Number(n?.transactionTotal || 0),
						total: Number(n?.total || 0),
						city: n?.city,
						state: n?.state,
						country: n?.country,
						results: r.map((e) => ({
							parentId: e.parentId || e.uid || "",
							uid: e.uid || e.parentId || e.sku || "",
							sku: e.sku,
							qty: Number(e.qty),
							price: Number(e.price)
						}))
					};
					this.events.order.transaction({
						data: i,
						siteId: t
					});
				} }
			}, this.cookies = {
				cart: {
					get: () => this.storage.cart.get().map((e) => this.getProductId(e)),
					set: (e) => {
						let t = e.map((e) => `${e}`.trim()), n = Array.from(new Set(t)).map((e) => ({
							parentId: e,
							uid: e,
							sku: e,
							price: 0,
							qty: 1
						}));
						this.storage.cart.set(n);
					},
					add: (e) => {
						if (e.length) {
							let t = e.map((e) => `${e}`.trim()).map((e) => ({
								parentId: e,
								uid: e,
								sku: e,
								price: 0,
								qty: 1
							}));
							this.storage.cart.add(t);
						}
					},
					remove: (e) => {
						if (e.length) {
							let t = e.map((e) => `${e}`.trim()).map((e) => ({
								parentId: e,
								uid: e,
								sku: e,
								price: 0,
								qty: 1
							}));
							this.storage.cart.remove(t);
						}
					},
					clear: () => {
						this.storage.cart.clear();
					}
				},
				viewed: { get: () => this.storage.viewed.get().map((e) => this.getProductId(e)) }
			}, this.config = t, this.doNotTrack = this.config.doNotTrack || [], Object.values(q).includes(this.config.mode) && (this.mode = this.config.mode), this.localStorage = new gu({
				type: "local",
				key: `athos-${this.config.id}`
			}), this.localStorage.set("siteId", this.globals.siteId);
			let n = this.globals?.currency;
			n && this.setCurrency(n), window.athos?.tracker || (window.athos = window.athos || {}, window.athos.tracker = this, window.athos.version = fu), setTimeout(() => {
				this.targeters.push(new Ml([{
					selector: "script[type^=\"athos/track/\"], script[type^=\"searchspring/track/\"]",
					emptyTarget: !1
				}], (e, t) => {
					let { item: n, items: r, siteId: i, shopper: a, order: o, type: s, currency: c } = Gl([
						"item",
						"items",
						"siteId",
						"shopper",
						"order",
						"type",
						"currency"
					], t);
					switch (this.setCurrency(c), s) {
						case "searchspring/track/shopper/login":
						case "athos/track/shopper/login":
							this.track.shopper.login(a, i);
							break;
						case "searchspring/track/product/view":
						case "athos/track/product/view":
							this.track.product.view(n, i);
							break;
						case "searchspring/track/cart/view":
						case "athos/track/cart/view":
							this.track.cart.view();
							break;
						case "searchspring/track/order/transaction":
						case "athos/track/order/transaction":
							this.track.order.transaction({
								order: o,
								items: r
							}, i);
							break;
						default: console.error(`event '${s}' is not supported`);
					}
				}));
			});
			let r = this.globals.cart;
			if (Array.isArray(r)) {
				if (r.length === 0) {
					let e = this.storage.cart.get();
					e.length && this.events.cart.remove({ data: {
						results: e,
						cart: []
					} }), this.storage.cart.clear();
				} else if (r.length) {
					let e = r.filter((e) => typeof e == "object" && (e.parentId || e.uid || e.sku) && e.qty !== void 0 && e.price !== void 0).map((e) => ({
						parentId: e.parentId || e.uid,
						uid: e.uid,
						sku: e.sku,
						price: e.price,
						qty: e.qty
					}));
					e.length || this.events.error.snap({ data: {
						message: "cart globals missing properties",
						details: { cart: r }
					} });
					let t = this.storage.cart.get(), n = [], i = [];
					!t?.length && e.length ? n.push(...e) : e.length && (e.forEach((e) => {
						let r = t.find((t) => t.parentId === e.parentId && t.uid === e.uid && t.sku === e.sku);
						if (!r) n.push(e);
						else if (r) {
							e.qty > r.qty ? n.push({
								...e,
								qty: e.qty - r.qty
							}) : e.qty < r.qty && i.push({
								...r,
								qty: r.qty - e.qty
							});
							let a = t.indexOf(r);
							a !== -1 && t.splice(a, 1);
						}
					}), t.length && i.push(...t)), n.length && this.events.cart.add({ data: {
						results: n,
						cart: e
					} }), i.length && this.events.cart.remove({ data: {
						results: i,
						cart: e
					} });
				}
			}
		}
		getGlobals() {
			return JSON.parse(JSON.stringify(this.globals));
		}
		retarget() {
			this.targeters.forEach((e) => {
				e.retarget();
			});
		}
	};
})), l_ = o((() => {})), u_ = o((() => {
	c_(), l_();
})), d_, f_ = o((() => {
	Al(), d_ = class {
		constructor(e) {
			this.custom = {}, this.loading = !1, this.loaded = !1, this.config = e, B(this, {
				custom: U,
				loading: U,
				loaded: U,
				config: U
			});
		}
		setConfig(e) {
			this.config = e;
		}
		toJSON(e = this) {
			return ns(e);
		}
	};
})), p_, m_, h_, g_ = o((() => {
	(function(e) {
		e.HEADER = "header", e.BANNER = "banner", e.FOOTER = "footer", e.LEFT = "left", e.INLINE = "inline";
	})(p_ ||= {}), m_ = class {
		constructor(e) {
			this.redirect = "", this.responseId = "", this.content = {}, this.campaigns = [], this.personalized = !1, this.experiments = [];
			let { merchandising: t } = e?.data?.search || {};
			t && (this.redirect = t.redirect || "", this.responseId = e?.data?.search?.tracking?.responseId || e?.data?.tracking?.responseId || "", t.content && Object.values(p_).forEach((e) => {
				if (t.content && t.content[e]) {
					let n = t.content[e]?.[0] || "", r = typeof n == "string" && n.match(/data-banner-id="(\d+)"/), i = r ? r[1] : "";
					this.content[e] = new h_([{
						value: t.content[e],
						uid: i,
						responseId: this.responseId
					}]);
				}
			}), t.campaigns && (this.campaigns = t.campaigns, t.campaigns.forEach((e) => {
				e.type == "landing-page" && (this.landingPage = e);
			})), t.experiments && (this.experiments = t.experiments), this.personalized = !!t.personalized);
		}
	}, h_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			super(...e);
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Search/Stores/SearchFacetStore.js
function __(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var v_, y_, b_, x_, S_, C_, w_, T_, E_ = o((() => {
	v_ = /* @__PURE__ */ u(R()), Al(), y_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = e?.config || {}, { services: n, stores: r, data: i } = e || {}, { search: a, meta: o } = i || {}, { facets: s, merchandising: c, pagination: l } = a || {}, { storage: u } = r || {}, d = s?.filter((e) => {
				let n = e.field && o.facets && o.facets[e.field];
				if (!n || n.display == "slider" && e.type !== "range" || e.type == "range" && n.display !== "slider") return !1;
				let r = t.settings?.facets?.fields && e.field && t.settings?.facets?.fields[e.field];
				if (typeof r?.trim == "boolean" ? r?.trim : t.settings?.facets?.trim) {
					if (e.type === "range" && e?.range?.low == e?.range?.high || e.values?.length == 0) return !1;
					if (!e.filtered && e.values?.length == 1) return c?.content?.inline ? e.values[0].count + c.content?.inline.length != l.totalResults : e.values[0].count != l.totalResults;
				}
				return !0;
			}).map((e) => {
				let r = e.field && o.facets && o.facets[e.field], i = (0, v_.default)({
					...t.settings?.facets,
					fields: void 0
				}, t.settings?.facets?.fields && e.field && t.settings?.facets?.fields[e.field] || {});
				switch (delete i.fields, e.type) {
					case "range": return new x_(n, u, e, r || {}, i);
					default: return new S_(n, u, e, r || {}, i);
				}
			}) || [];
			super(...d);
		}
	}, b_ = class {
		constructor(e, t, n, r, i) {
			this.filtered = !1, this.custom = {}, this.collapsed = !1, this.display = "", this.label = "", this.services = e, this.storage = t, Object.assign(this, r, n), B(this, {
				type: U,
				field: U,
				filtered: U,
				custom: U,
				collapsed: U,
				display: U,
				label: U,
				clear: W,
				toggleCollapse: Wc
			});
			let a = this.storage.get(`facets.${this.field}.collapsed`);
			this.collapsed = a ?? this.collapsed, this.filtered && this.collapsed && a === void 0 && i.autoOpenActive && this.toggleCollapse();
		}
		get clear() {
			return { url: this.services.urlManager.remove("page").remove(`filter.${this.field}`) };
		}
		toggleCollapse() {
			this.collapsed = !this.collapsed, this.storage.set(`facets.${this.field}.collapsed`, this.collapsed);
		}
	}, x_ = class extends b_ {
		constructor(e, t, n, r, i) {
			super(e, t, n, r, i), this.range = {
				low: 0,
				high: 0
			}, this.active = {
				low: 0,
				high: 0
			}, this.step = n?.step;
			let a = i.storeRange && this.storage.get(`facets.${this.field}.range`);
			a && n.filtered && (n.range?.low > a.low || n.range?.high < a.high) ? this.range = this.storage.get(`facets.${this.field}.range`) : (this.storage.set(`facets.${this.field}.range`, n.range), this.range = n.range), this.active = n.active || n.range, this.formatSeparator = r?.formatSeparator || "-", this.formatValue = r?.formatValue || "%01.2f", B(this, {
				step: U,
				range: U,
				active: U,
				formatSeparator: U,
				formatValue: U
			});
		}
		get filteredCount() {
			return Number(this.filtered);
		}
	}, S_ = class extends b_ {
		constructor(e, t, n, r, i) {
			super(e, t, n, r, i), this.values = [], this.search = { input: "" }, this.overflow = {
				enabled: !1,
				limited: !0,
				limit: 0,
				remaining: void 0,
				setLimit: function(e) {
					e != this.limit && (this.enabled = !0, this.limit = e, this.calculate());
				},
				toggle: (e) => {
					e === void 0 ? this.overflow.limited = !this.overflow.limited : this.overflow.limited = e, this.storage.set(`facets.${this.field}.overflow.limited`, this.overflow.limited), this.overflow.calculate();
				},
				calculate: () => {
					if (this.overflow.limit > 0) {
						let e = this.values.length - this.overflow.limit;
						e > 0 && !this.search.input ? (this.overflow.enabled = !0, this.overflow.limited ? this.overflow.remaining = e : this.overflow.remaining = 0) : this.overflow.enabled = !1;
					}
				}
			}, this.multiple = this.multiple, this.values = n.values && n.values.map((t) => {
				switch (n.type) {
					case "value":
						if (r.display === "hierarchy") {
							let r = n?.values?.filter((e) => e.filtered) || [];
							return new w_(e, this, t, r);
						}
						return t.value = t?.value?.toString(), new C_(e, this, t);
					case "range-buckets": return new T_(e, this, t);
				}
			}) || [], i.pinFiltered && r.display !== "hierarchy" && this.values.sort((e, t) => Number(t.filtered) - Number(e.filtered));
			let a = this.storage.get(`facets.${this.field}.overflow.limited`);
			a !== void 0 && this.overflow.toggle(a), B(this, {
				values: U,
				search: U,
				multiple: U,
				overflow: U,
				refinedValues: W
			}), zo(() => this.search.input, () => {
				this.overflow.calculate();
			});
		}
		get filteredCount() {
			return this.values.filter((e) => e?.filtered).length;
		}
		get refinedValues() {
			let e = this.values || [];
			if (this.search.input) {
				let t = new RegExp(__(this.search.input), "i");
				e = this.values.filter((e) => String(e?.label || "").match(t));
			}
			return this.overflow.enabled && this.overflow.limited && (e = e.slice(0, this.overflow.limit)), e;
		}
	}, C_ = class {
		constructor(e, t, n) {
			if (Object.assign(this, n), this.filtered) this.url = e.urlManager.remove("page").remove(`filter.${t.field}`, n.value);
			else {
				let r = e.urlManager.remove("page");
				t.multiple == "single" && (r = r?.remove(`filter.${t.field}`)), this.url = r?.merge(`filter.${t.field}`, n.value);
			}
		}
	}, w_ = class extends C_ {
		constructor(e, t, n, r) {
			if (super(e, t, n), this.level = 0, this.history = !1, n.value && t.hierarchyDelimiter && (this.level = n.value.split(t.hierarchyDelimiter).length), t.filtered && r?.length) {
				let e = t?.hierarchyDelimiter && r[0].value?.split(t.hierarchyDelimiter).length;
				e && this.level <= e && (this.history = !0);
			}
			this.url = n.value ? e.urlManager.remove("page").set(`filter.${t.field}`, n.value) : e.urlManager.remove("page").remove(`filter.${t.field}`);
		}
	}, T_ = class {
		constructor(e, t, n) {
			if (Object.assign(this, n), this.filtered) this.url = e.urlManager.remove("page").remove(`filter.${t.field}`, [{
				low: this.low,
				high: this.high
			}]);
			else {
				let n = e.urlManager.remove("page");
				t.multiple == "single" && (n = n?.remove(`filter.${t.field}`)), this.url = n?.merge(`filter.${t.field}`, [{
					low: this.low,
					high: this.high
				}]);
			}
		}
	};
})), D_, O_, k_, A_ = o((() => {
	Al(), wu(), D_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { services: t, data: n, config: r } = e || {}, { search: i, meta: a } = n || {}, { filters: o } = i || {}, s = o?.map((e) => {
				let n = e.field, i = a.facets && a.facets[n];
				switch (e.type) {
					case "range":
						let n = e, a = r?.settings?.filters?.fields?.[e.field]?.rangeFormatValue || r?.settings?.filters?.rangeFormatValue;
						return a && (n.label = Su(a, n.value?.low, n.value?.high)), new k_(t, n, i);
					default: return new O_(t, e, i);
				}
			}) || [];
			super(...s);
		}
	}, O_ = class {
		constructor(e, t, n) {
			this.facet = {
				field: t.field,
				label: n?.label || t.field
			}, this.value = {
				value: t.value,
				label: t.label
			}, this.label = `${this.facet.label}: ${this.value.label}`, this.url = e?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, this.value.value), B(this, {
				facet: U,
				value: U,
				label: U
			});
		}
	}, k_ = class {
		constructor(e, t, n) {
			this.facet = {
				field: t.field,
				label: n?.label || t.field
			}, this.value = {
				low: t?.value?.low,
				high: t?.value?.high,
				label: t.label || `${t?.value?.low} - ${t?.value?.high}`
			}, this.label = `${this.facet.label}: ${this.value.label}`, this.url = e?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, {
				low: this.value.low,
				high: this.value.high
			}), B(this, {
				facet: U,
				value: U,
				label: U
			});
		}
	};
})), j_, M_, N_, P_ = o((() => {
	Al(), j_ = class {
		constructor(e) {
			let { services: t, data: n, config: r } = e || {}, { search: i, meta: a } = n || {}, { pagination: o } = i || {}, s = r?.settings?.pagination;
			this.services = t, this.controllerConfig = r, this.page = o?.page, this.pageSize = o?.pageSize, this.totalResults = o?.totalResults, this.defaultPageSize = a?.pagination?.defaultPageSize, this.totalPages = o?.totalPages;
			let c = s?.pageSizeOptions || [
				{
					label: `Show ${this.defaultPageSize}`,
					value: this.defaultPageSize
				},
				{
					label: `Show ${this.defaultPageSize * 2}`,
					value: this.defaultPageSize * 2
				},
				{
					label: `Show ${this.defaultPageSize * 3}`,
					value: this.defaultPageSize * 3
				}
			];
			this.pageSizeOptions = c.filter((e) => e.value <= 100).map((e) => new M_(this.services, this.pageSize, {
				label: e.label,
				value: e.value
			})), this.pageSizeOption = this.pageSizeOptions.find((e) => e.active), B(this, {
				page: U,
				pageSize: U,
				totalResults: U,
				totalPages: U,
				begin: W,
				end: W,
				multiplePages: W,
				current: W,
				first: W,
				last: W,
				next: W,
				previous: W,
				getPages: Wc,
				setPageSize: Wc
			});
		}
		get begin() {
			return this.controllerConfig?.settings?.infinite?.enabled ? 1 : this.pageSize * (this.page - 1) + 1;
		}
		get end() {
			return this.pageSize * this.page > this.totalResults ? this.totalResults : this.pageSize * this.page;
		}
		get multiplePages() {
			return this.pageSize < this.totalResults;
		}
		get current() {
			return new N_(this.services, {
				number: this.page,
				active: !0
			});
		}
		get first() {
			return new N_(this.services, {
				number: 1,
				active: this.page == 1
			});
		}
		get last() {
			return new N_(this.services, {
				number: this.totalPages,
				active: this.totalPages == this.page
			});
		}
		get next() {
			if (this.page < this.totalPages) return new N_(this.services, { number: this.page + 1 });
		}
		get previous() {
			if (this.page > 1) return new N_(this.services, { number: this.page - 1 });
		}
		getPages(e = 5, t) {
			if (!Number.isInteger(e)) return [];
			if (t === void 0 || !Number.isInteger(t)) {
				let n = e - 1, r = this.page, i = this.page, a = i - r;
				do {
					if (a = i - r, i < this.totalPages && i++, i - r >= n) break;
					r > 1 && r--;
				} while (a != i - r && i - r < n);
				e = r - this.page, t = i - this.page;
			} else e = -Math.abs(e), t = Math.abs(t);
			let n = [];
			for (let r = this.page + e; r <= this.page + t; r++) r > 0 && r <= this.totalPages && n.push(new N_(this.services, {
				number: r,
				active: r == this.page
			}));
			return n;
		}
		setPageSize(e) {
			e !== void 0 && this.services.urlManager.remove("page").set("pageSize", e).go();
		}
	}, M_ = class {
		constructor(e, t, n) {
			this.services = e, this.value = n.value, this.label = n.label, this.url = this.services?.urlManager.remove("page").set("pageSize", n.value), this.active = t == n.value;
		}
	}, N_ = class {
		constructor(e, t) {
			this.services = e, this.number = t.number, this.active = t.active || !1, this.url = this.services?.urlManager?.set("page", this.number), this.key = this.url.href;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Search/Stores/SearchResultStore.js
function F_(e, t, n, r) {
	let i = [...t], a = r.pageSize * (r.page - 1) + 1, o = r.pageSize * r.page;
	e?.settings?.infinite?.enabled && (a = 1), r.pageSize * r.page > r.totalResults && (o = r.totalResults);
	let s = n.filter((e) => !i.some((t) => t.id == e.id)), c = s.filter((e) => {
		let t = e.config.position.index;
		return t >= a - 1 && t <= o - 1;
	}), l = s.filter((e) => e.config.position.index >= r.totalResults);
	return c.forEach((e) => {
		let t = e.config.position.index - (a - 1);
		i.splice(t, 0, e);
	}), l.forEach((e, t) => {
		let n = r.totalResults - (l.length - t);
		n >= a - 1 && n <= o - 1 && i.splice(n, 0, e);
	}), e?.settings?.infinite && i.forEach((e, t) => {
		if (e.type === "banner") {
			let n = r.pageSize, a = (Math.floor(t / n) + 1 - 1) * n, o = a + n - 1;
			for (let t = a; t < o; t++) if (i[t].type === "product") {
				e.responseId = i[t].responseId;
				break;
			}
		}
	}), i;
}
function I_(e, t, n) {
	let r = {}, i = e.getAttribute(z_);
	if (i) {
		let [a, o] = i.split(":");
		!a || !o ? console.error("Error!: realtime variant is missing option or value (option:value)!", e, i) : (r[a.toLowerCase()] = [o.toLowerCase()], L_(t, r, n));
	}
}
function L_(e, t, n) {
	let r = n;
	e.realtime?.filters?.forEach((e) => {
		e == "first" && (r = [r[0]]), e == "unaltered" && (r = r.filter((e) => !e.variants?.selections.some((e) => e.previouslySelected)));
	}), r.forEach((e) => {
		e.type == "product" && e.variants?.makeSelections(t);
	});
}
var R_, z_, B_, V_, H_, U_, W_, G_, K_, q_, J_, Y_ = o((() => {
	Al(), R_ = /* @__PURE__ */ u(R()), ki(), z_ = "ss-variant-option", B_ = "ss-variant-option-selected", V_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { config: t, data: n, state: r, stores: i } = e || {}, { search: a, meta: o, previousSearch: s } = n || {}, { results: c, merchandising: l, pagination: u } = a || {}, { previousResults: d } = i || {}, { loaded: f } = r || {}, p = (c || []).map((n, r) => new U_({
				config: t,
				data: {
					result: n,
					meta: o
				},
				position: r + 1,
				responseId: e.data.search?.tracking?.responseId || ""
			})), m = t?.settings?.variants;
			if (m?.realtime?.enabled) {
				if (!f && p?.length) {
					let e = /* @__PURE__ */ new Set();
					document.querySelectorAll(`[${z_}]`).forEach((t) => {
						if (t.tagName == "OPTION") {
							let n = t.closest("select");
							n ? e.has(n) || (e.add(n), n.addEventListener("change", (e) => {
								let t = e.target?.value, r = Array.from(n.querySelectorAll(`[${z_}]`)).filter((e) => e.value == t);
								r.length > 0 && I_(r[0], m, p);
							})) : console.warn("Warning: unable to add realtime variant event listener for element - ", t);
						} else t.addEventListener("click", () => {
							I_(t, m, p);
						});
					});
				}
				if (p.length) {
					let e = {};
					document.querySelectorAll(`[${B_}]`).forEach((t) => {
						let n = t.getAttribute(z_);
						if (n) {
							let [t, r] = n.split(":");
							t && r && (e[t.toLowerCase()] = [r.toLowerCase()]);
						}
					}), L_(m, e, p);
				}
			}
			if (t?.settings?.infinite?.enabled && d && u?.page && s?.pagination?.page && u.page == s.pagination.page + 1 && (p = (d || []).concat(p)), u && l?.content?.inline) {
				let n = l.content.inline.sort(function(e, t) {
					return e.config.position.index - t.config.position.index;
				}).map((t) => new H_({ data: {
					banner: t,
					responseId: e.data.search?.tracking?.responseId || ""
				} }));
				n && u.totalResults && (p = F_(t, p, n, u));
			}
			super(...p);
		}
	}, H_ = class {
		constructor(e) {
			this.type = "banner", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {};
			let { banner: t, responseId: n } = e?.data || {}, r = t.value, i = typeof r == "string" && r.match(/data-banner-id="(\d+)"/), a = i ? i[1] : "ss-ib-" + t.config.position.index;
			this.id = a, this.responseId = n, this.config = t.config, this.value = t.value, B(this, {
				id: U,
				mappings: U,
				attributes: U,
				custom: U,
				state: U
			});
		}
	}, U_ = class {
		constructor(e) {
			this.type = "product", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {}, this.quantity = 1, this.mask = new G_();
			let { config: t } = e || {}, { result: n, meta: r } = e?.data || {};
			this.id = n.id, this.attributes = n.attributes, this.mappings = n.mappings, this.position = e.position, this.badges = new W_({ data: {
				meta: r,
				result: n
			} }), this.responseId = n.responseId || e.responseId, n.bundleSeed && (this.bundleSeed = !!n.bundleSeed), n.variants && n.variants.data && (this.variants = new K_({
				data: {
					mask: this.mask,
					variants: n.variants.data,
					optionConfig: n.variants.optionConfig,
					preferences: n.variants?.preferences,
					meta: r
				},
				config: t?.settings?.variants
			})), B(this, {
				id: U,
				display: W,
				mappings: U,
				attributes: U,
				custom: U,
				state: U,
				quantity: U
			});
		}
		get display() {
			return (0, R_.default)({
				id: this.id,
				mappings: this.mappings,
				attributes: this.attributes,
				badges: this.badges
			}, this.mask.data, { isMergeableObject: Oi });
		}
	}, W_ = class {
		constructor(e) {
			this.all = [];
			let { data: t } = e || {}, { meta: n, result: r } = t || {};
			this.all = (r.badges || []).filter((e) => !!(e?.tag && n.badges?.tags && n.badges?.tags[e.tag] && n.badges?.tags[e.tag].enabled)).map((e) => {
				let t = n.badges?.tags?.[e.tag];
				return {
					...e,
					...t
				};
			}).sort((e, t) => e.priority - t.priority), B(this, {
				all: U,
				tags: W,
				locations: W
			});
		}
		atLocation(e) {
			let t = Array.isArray(e) ? e : [e];
			return this.all.filter((e) => t.some((t) => e.location.startsWith(`${t}/`) || e.location == t));
		}
		get tags() {
			return this.all.reduce((e, t) => (e[t.tag] = t, e), {});
		}
		get locations() {
			return this.all.reduce((e, t) => {
				let [n, r] = t.location.split("/");
				return e[n] = e[n] || {}, e[n][r] = (e[n][r] || []).concat(t), e;
			}, {});
		}
	}, G_ = class {
		constructor() {
			this.data = {}, B(this, { data: U });
		}
		merge(e) {
			JSON.stringify((0, R_.default)(this.data, e)) != JSON.stringify(this.data) && (this.data = (0, R_.default)(this.data, e));
		}
		set(e) {
			JSON.stringify(e) != JSON.stringify(this.data) && (this.data = e);
		}
		reset() {
			this.data = {};
		}
	}, K_ = class {
		constructor(e) {
			this.data = [], this.selections = [];
			let { config: t, data: n } = e || {}, { variants: r, mask: i, meta: a } = n || {}, o = e?.data?.preferences || {};
			this.setActive = (e) => {
				this.active = e;
				let t = new W_({ data: {
					meta: a,
					result: e
				} });
				i.set({
					mappings: this.active.mappings,
					attributes: this.active.attributes,
					badges: t,
					state: this.active.state,
					custom: this.active.custom
				});
			}, t && (this.config = t), n.optionConfig && (this.optionConfig = n.optionConfig), this.update(r, t, o);
		}
		update(e, t = this.config, n) {
			try {
				let r = [];
				this.data = e.filter((e) => this.config?.showDisabledSelectionValues || e.mappings.core?.available !== !1).map((e) => (e.mappings.core?.price && (e.mappings.core.price = Number(e.mappings.core?.price)), e.mappings.core?.msrp && (e.mappings.core.msrp = Number(e.mappings.core?.msrp)), e)).map((e) => (e.options && Object.keys(e.options).forEach((e) => {
					r.includes(e) || r.push(e);
				}), new J_({ data: { variant: e } }))), this.selections = [], r.map((e) => {
					let t = this.config?.options && this.config.options[e];
					this.selections.push(new q_({
						config: t,
						optionConfig: this.optionConfig?.[e],
						data: {
							variants: this,
							selectorField: e
						}
					}));
				});
				let i = {};
				n && Object.keys(n).forEach((e) => {
					i[e] = n[e];
				}), t?.options && Object.keys(t?.options).forEach((e) => {
					t.options[e].preSelected && (i[e] = t.options[e].preSelected);
				}), t?.autoSelect && this.makeSelections(i);
			} catch (e) {
				console.error(e, "Failed to update variants!");
			}
		}
		makeSelections(e) {
			!e || !Object.keys(e).length ? this.selections.forEach((e) => {
				let t = e.values.find((e) => e.available);
				t && e.select(t.value, !0);
			}) : this.selections.forEach((t, n) => {
				let r = t.values.filter((e) => n == 0 || e.available), i = e[t.field.toLowerCase()], a = t.selected || r[0];
				if (i) {
					let e = (e) => {
						let t = r.find((t) => t.value.toString().toLowerCase() == e?.toString().toLowerCase());
						t && (a = t);
					};
					Array.isArray(i) ? i.forEach((t) => {
						e(t);
					}) : e(i);
				}
				a && t.select(a.value, !0);
			});
		}
		refineSelections(e) {
			let t = [...this.selections];
			t.sort((t) => t.field == e.field ? 1 : -1), t.forEach((e) => e.refineValues(this));
			let n = this.selections.filter((e) => e.selected?.value?.length);
			if (n.length) {
				let e = this.data;
				for (let t of n) e = e.filter((e) => t.selected?.value == e.options[t.field]?.value && e.available);
				if (e.length == 1) {
					let t = e[0];
					this.selections.filter((e) => !e.selected).forEach((e) => {
						let n = e.field, r = t.options[n].value;
						e.select(r);
					}), this.setActive(t);
				}
			}
		}
	}, q_ = class {
		constructor(e) {
			this.selected = void 0, this.previouslySelected = void 0, this.values = [];
			let { data: t, config: n, optionConfig: r } = e || {}, { variants: i, selectorField: a } = t || {};
			this.field = a, this.type = r?.type, this.count = r?.count, this.label = n?.label || a, this.config = n || {}, this.variantsUpdate = () => i.refineSelections(this), this.refineValues(i), B(this, {
				selected: U,
				values: U
			});
		}
		refineValues(e) {
			let t = e.selections.filter((e) => e.field != this.field && e.selected), n = e.data.filter((e) => e.available);
			for (let e of t) n = n.filter((t) => e.selected?.value == t.options?.[e.field]?.value && t.available);
			let r = e.data.filter((e) => e.options[this.field]).reduce((t, r) => {
				if (!t.some((e) => r.options[this.field].value == e.value)) {
					let i = r.options[this.field].value, a = r.mappings.core?.thumbnailImageUrl, o = !e.data.filter((e) => e.available).some((e) => e.options[this.field].value === i), s = {
						value: i,
						label: i,
						thumbnailImageUrl: a,
						available: !!n.some((e) => e.options[this.field].value == r.options[this.field].value),
						disabled: o
					};
					if (this.config.thumbnailBackgroundImages ? s.backgroundImageUrl = a : r.options[this.field].backgroundImageUrl && (s.backgroundImageUrl = r.options[this.field].backgroundImageUrl), r.options[this.field].background && (s.background = r.options[this.field].background), this.config.mappings && this.config.mappings && this.config.mappings[i.toString().toLowerCase()]) {
						let e = this.config.mappings[i.toString().toLowerCase()];
						e.label && (s.label = e.label), e.background && (s.background = e.background), e.backgroundImageUrl && (s.backgroundImageUrl = e.backgroundImageUrl);
					}
					t.push(s);
				}
				return t;
			}, []);
			if (this.selected && !r.some((e) => e.value == this.selected?.value && e.available)) {
				if (this.selected !== this.previouslySelected && this.previouslySelected && r.some((e) => e.value == this.previouslySelected?.value && e.available)) this.select(this.previouslySelected.value, !0);
				else {
					let e = r.filter((e) => e.available);
					if (r.length && e.length) {
						let t = e[0].value;
						this.selected.value !== t && this.select(t, !0);
					}
				}
			}
			this.values = r;
		}
		reset() {
			this.selected = void 0, this.values.forEach((e) => e.available = !1);
		}
		select(e, t = !1) {
			let n = this.values.find((t) => t.value == e);
			n && (t || (this.previouslySelected = this.selected), this.selected = n, this.variantsUpdate());
		}
	}, J_ = class {
		constructor(e) {
			this.type = "variant", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {};
			let { data: t } = e || {}, { variant: n } = t || {};
			this.attributes = n.attributes || {}, this.mappings = n.mappings, this.options = n.options, this.badges = n.badges || [], this.available = this.mappings.core?.available ?? !0, B(this, {
				attributes: U,
				mappings: U,
				custom: U,
				state: U,
				available: U
			});
		}
	};
})), X_, Z_, Q_ = o((() => {
	Al(), X_ = class {
		constructor(e) {
			this.options = [];
			let { services: t, data: n } = e || {}, { meta: r } = n || {}, { sorting: i, search: a } = n?.search || {};
			if (t && r.sortOptions) {
				let e = i?.length && i[0], n = (r.sortOptions || []).filter((e) => a?.query ? e : e.type == "field").map((n, r) => (n.active = !1, (e && e.field == n.field && String(e.direction) == String(n.direction) || !e && r === 0) && (n.active = !0), n.default = !1, r === 0 && (n.default = !0), new Z_(t, n, r)));
				this.options = n, B(this, {
					options: U,
					current: W
				});
			}
		}
		get current() {
			return this.options.filter((e) => e.active).pop();
		}
	}, Z_ = class {
		constructor(e, t, n) {
			this.active = t.active, this.default = t.default, this.field = t.field, this.label = t.label, this.direction = t.direction, this.type = t.type, this.value = `${t.label}:${t.field}:${t.direction}:${n}`, this.url = this.default ? e.urlManager.remove("page").remove("sort") : e.urlManager.remove("page").set("sort", [{
				field: this.field,
				direction: this.direction
			}]), B(this, {
				field: U,
				label: U,
				direction: U,
				type: U,
				value: U
			});
		}
	};
})), $_, ev, tv = o((() => {
	Al(), wu(), $_ = class {
		constructor(e) {
			let { services: t, data: n } = e || {}, { search: r } = n.search || {}, i = {};
			r?.query && (this.query = new ev(t, r.query), i.query = U), r?.didYouMean && (this.didYouMean = new ev(t, r.didYouMean), i.didYouMean = U), r?.originalQuery && (this.originalQuery = new ev(t, r.originalQuery), i.originalQuery = U), r?.subject && (this.subject = new ev(t, r.subject), i.subject = U), this.matchType = r?.matchType, i.matchType = U, B(this, i);
		}
	}, ev = class {
		constructor(e, t) {
			this.string = Vl(t), this.url = e?.urlManager?.remove("page").remove("filter").set("query", this.string), B(this, { string: U });
		}
	};
})), nv, rv = o((() => {
	wu(), tv(), nv = class {
		constructor(e) {
			let { services: t, config: n } = e || {};
			this.config = n, this.services = t, this.max = this.config.settings?.history?.max ?? 25, this.config.settings?.history?.url && (this.services.urlManager = this.services.urlManager.withConfig((e) => ({
				...e,
				urlRoot: this.config.settings?.history?.url
			}))), this.storage = new gu({
				type: "local",
				key: `athos-history${this.config.globals?.siteId ? `-${this.config.globals?.siteId}` : ""}`
			}), this.max === 0 && this.reset(), this.queries.length > this.max && this.getStoredData().forEach((e, t) => {
				t > this.max - 1 && this.remove(e);
			});
		}
		get queries() {
			return this.getStoredData().map((e) => new ev(this.services, e));
		}
		save(e) {
			if (this.max) {
				let t = this.getStoredData(), n = t.indexOf(e);
				n != -1 && t.splice(n, 1), t.unshift(e), t.length > this.max && t.pop(), this.storage.set("history", JSON.stringify(t));
			}
		}
		remove(e) {
			let t = this.getStoredData(), n = t.indexOf(e);
			n != -1 && (t.splice(n, 1), this.storage.set("history", JSON.stringify(t)));
		}
		reset() {
			this.storage.clear();
		}
		getStoredData(e) {
			let t = this.storage.get("history");
			if (t) try {
				let n = JSON.parse(t);
				if (Array.isArray(n)) return e && Number.isInteger(e) ? n.slice(0, e) : n;
			} catch {
				this.reset();
			}
			return [];
		}
	};
})), iv = o((() => {
	g_(), E_(), A_(), P_(), Y_(), Q_(), tv(), rv();
})), av, ov = o((() => {
	iv(), av = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { services: t, state: n } = e || {}, r = new y_({
				...e,
				services: {
					...t,
					urlManager: t.urlManager.remove("filter")
				}
			});
			r.forEach((e) => {
				e.values?.forEach((t) => {
					t.preview = () => {
						r.map((e) => {
							e.filtered = !1, e.values?.map((e) => {
								e.filtered = !1;
							});
						}), e.filtered = !0, t.filtered = !0, n?.autocomplete.locks.facets.lock(), t.url.go();
					};
				});
			}), super(...r);
		}
	};
})), sv, cv, lv = o((() => {
	Al(), sv = class {
		constructor(e) {
			let { services: t, data: n } = e || {}, { search: r, autocomplete: i } = n?.autocomplete || {}, a = {};
			r?.query && (this.query = new cv(t.urlManager, r.query), a.query = U), i?.correctedQuery && (this.correctedQuery = new cv(t.urlManager, i.correctedQuery), a.correctedQuery = U), r?.subject && (this.subject = new cv(t.urlManager, r.subject), a.subject = U), this.matchType = r?.matchType, a.matchType = U, B(this, a);
		}
	}, cv = class {
		constructor(e, t) {
			this.string = t, this.url = e.set({ query: this.string }), B(this, { string: U });
		}
	};
})), uv, dv, fv = o((() => {
	Al(), uv = class {
		constructor(e) {
			this.focusedInput = void 0, this.input = void 0, this.source = "input";
			let { services: t } = e || {};
			this.locks = {
				terms: new dv(!1),
				facets: new dv(!1)
			}, this.url = t.urlManager, B(this, {
				focusedInput: U,
				locks: U,
				input: U,
				reset: Wc
			});
		}
		reset() {
			this.input = void 0, this.locks.terms.reset(), this.locks.facets.reset();
		}
	}, dv = class {
		constructor(e = !1) {
			this.state = this.startState = e;
		}
		reset() {
			this.state = this.startState;
		}
		get locked() {
			return this.state;
		}
		lock() {
			this.state = !0;
		}
		unlock() {
			this.state = !1;
		}
	};
})), pv, mv, hv = o((() => {
	Al(), pv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { data: t } = e || {}, { autocomplete: n, search: r } = t?.autocomplete || {}, i = [...(n?.alternatives ? n.alternatives : []).map((e) => e.text)];
			n?.correctedQuery && r?.query && n.correctedQuery.toLowerCase() != r.query.toLowerCase() && i.unshift(n.correctedQuery), r?.query && i.unshift(r.query);
			let a = [];
			i.map((t, n) => a.push(new mv({
				...e,
				data: {
					term: {
						active: n === 0,
						value: t
					},
					terms: a
				},
				functions: e.functions,
				state: e.state,
				type: "suggested"
			}))), super(...a);
		}
	}, mv = class {
		constructor(e) {
			let { services: t, functions: n, state: r, data: i, type: a } = e || {}, { term: o, terms: s } = i || {};
			this.active = o?.active, this.value = o?.value, this.type = a, this.url = t?.urlManager?.set({ query: this.value }), this.preview = () => {
				n.resetTerms(), s.map((e) => {
					e.active = !1;
				}), r.rootState.source = a, this.active = !0, r.rootState.locks.terms.lock(), r.rootState.locks.facets.unlock(), this.url?.set({ query: this.value }).go();
			}, B(this, {
				active: U,
				value: U
			});
		}
	};
})), gv, _v = o((() => {
	hv(), gv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = [], { data: n } = e || {}, { trending: r } = n?.trending || {};
			r?.queries?.map((n) => {
				t.push(new mv({
					...e,
					data: {
						term: {
							active: !1,
							value: n.searchQuery
						},
						terms: t
					},
					functions: e.functions,
					state: e.state,
					type: "popular"
				}));
			}), super(...t);
		}
	};
})), vv, yv = o((() => {
	hv(), vv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { data: t } = e || {}, { queries: n } = t || {}, r = [];
			n?.map((t) => {
				r.push(new mv({
					...e,
					data: {
						term: {
							active: !1,
							value: t
						},
						terms: r
					},
					functions: e.functions,
					state: e.state,
					type: "historical"
				}));
			}), super(...r);
		}
	};
})), bv = o((() => {
	ov(), lv(), fv(), hv(), _v(), yv();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Meta/MetaStore.js
function xv(e, t) {
	return t ? xv(t, e % t) : e;
}
function Sv(e, t) {
	let n = xv(e, t);
	return e * t / n;
}
var Cv, wv, Tv = o((() => {
	Cv = class {
		constructor(e) {
			let { meta: t } = e?.data || {};
			this.data = t ?? {}, this.badges = new wv(this.data);
		}
	}, wv = class {
		constructor(e) {
			this.groups = {};
			let t = { overlay: { sections: ["left", "right"] } };
			Object.keys(t).map((n) => {
				let r = t[n], i = r.sections.map((t) => ({
					areas: e?.badges?.locations?.[t]?.map((e) => e.tag) || [],
					grid: []
				})), a = i.map((e) => e.areas.length).reduce(Sv);
				i.forEach((e) => {
					e.grid = Array.from({ length: a }).map((t, n) => e.areas[Math.floor(n / (a / e.areas.length))]);
				});
				let o = Array.from({ length: a }).map((e, t) => i.map((e) => e.grid[t]));
				this.groups[n] = {
					sections: r.sections,
					grid: o
				};
			});
		}
	};
})), Ev, Dv = o((() => {
	Al(), wu(), f_(), iv(), bv(), Tv(), Ev = class extends d_ {
		constructor(e, t) {
			if (super(e), typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, this.state = new uv({ services: this.services }), this.storage = new gu(), this.trending = [], this.history = [], this.initHistory(), this.reset(), B(this, {
				state: U,
				search: U,
				terms: U,
				facets: U,
				filters: U,
				merchandising: U,
				results: U,
				pagination: U,
				sorting: U,
				history: U,
				trending: U
			});
		}
		get hasQuery() {
			return !!(this.state.input && this.loaded || this.search.query?.string);
		}
		reset() {
			this.state.reset(), this.update(), this.resetTerms();
		}
		initHistory() {
			let e = this.config.settings?.history?.limit;
			if (e && this.config.settings?.history?.enabled !== !1) {
				let t = new nv({
					services: this.services,
					config: {
						id: this.config.id,
						globals: this.config.globals
					}
				});
				this.history = new vv({
					services: this.services,
					functions: { resetTerms: () => {
						this.resetTerms();
					} },
					state: { rootState: this.state },
					data: { queries: t.getStoredData(e) }
				});
			} else this.history = [];
		}
		resetTerms() {
			this.resetSuggestions(), this.resetTrending(), this.resetHistory();
		}
		resetSuggestions() {
			this.terms?.forEach((e) => e.active = !1);
		}
		resetTrending() {
			this.trending?.forEach((e) => e.active = !1);
		}
		resetHistory() {
			this.history?.forEach((e) => e.active = !1);
		}
		setService(e, t) {
			this.services[e] && t && (this.services[e] = t, e === "urlManager" && (this.state.url = t, this.history?.forEach((e) => {
				e.url = t.set({ query: e.value });
			})));
		}
		updateTrendingTerms(e) {
			this.trending = new gv({
				services: this.services,
				functions: { resetTerms: () => {
					this.resetTerms();
				} },
				state: { rootState: this.state },
				data: { trending: e }
			});
		}
		update(e) {
			let { meta: t, search: n } = e || {};
			this.meta = new Cv({ data: { meta: t } }), n?.search && (this.state.url = this.services.urlManager = this.services.urlManager.set("query", n.search.query)), this.state.locks.terms.locked || (this.terms = new pv({
				config: this.config,
				services: this.services,
				functions: { resetTerms: () => {
					this.resetTerms();
				} },
				state: { rootState: this.state },
				data: { autocomplete: n }
			}), n?.autocomplete && this.state.locks.terms.lock()), this.merchandising = new m_({ data: { search: n } }), this.search = new sv({
				config: this.config,
				services: this.services,
				data: { autocomplete: n }
			}), this.state.locks.facets.locked || (this.facets = new av({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				state: { autocomplete: this.state },
				data: {
					search: n,
					meta: this.meta.data
				}
			})), this.filters = new D_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.results = new V_({
				config: this.config,
				state: { loaded: this.loaded },
				data: {
					search: n,
					meta: this.meta.data
				}
			}), (this.results.length === 0 && !this.trending.filter((e) => e.active).length || this.terms?.filter((e) => e.active).length) && this.resetTrending(), this.pagination = new j_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.sorting = new X_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.error = void 0, this.loaded = !!n?.pagination;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Finder/Stores/FinderSelectionStore.js
function Ov(e, t) {
	return `ss-finder-${e}.${t}`;
}
var kv, Av, jv, Mv, Nv = o((() => {
	kv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = e.config, { services: n, data: r, stores: i, state: a } = e || {}, { storage: o } = i || {}, { search: s, meta: c, selections: l } = r || {}, { facets: u } = s || {}, d = [];
			l?.length ? t.fields.forEach((e) => {
				let r = l.find((t) => t.facet.field === e.field);
				if (r) {
					let { facet: s, selected: c } = r || {};
					if (s?.hierarchyDelimiter) l.forEach((r, c) => {
						let l = e?.levels || s?.values[s?.values.length - 1]?.value.split(s.hierarchyDelimiter), u = {
							index: c,
							label: e.levels ? l[c] : "",
							key: `ss-${c}`
						}, f = Ov(t.id, s.field);
						o.set(`${f}.${u.key}.values`, r.data), o.set(`${f}.${u.key}.selected`, r.selected);
						let p = new Mv({
							config: u,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: s
							}
						});
						t.persist?.lockSelections && (p.disabled = !0), r.selected && (n.urlManager = n.urlManager.set(`filter.${r.facet.field}`, r.selected)), d.push(p);
					});
					else {
						let r = new jv({
							config: e,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: s
							}
						});
						r.selected = c, r.storage.set("selected", c), r.data = s.values, c && (n.urlManager = n.urlManager.set(`filter.${s.field}`, c)), t.persist?.lockSelections && (r.disabled = !0), d.push(r);
					}
				}
			}) : u && c && (t?.fields && u.sort((e, n) => {
				let r = t.fields.map((e) => e.field);
				return r.indexOf(e.field) - r.indexOf(n.field);
			}), t?.fields?.forEach((e) => {
				let r = u.filter((t) => t.field == e.field).pop();
				if (r = {
					...c?.facets && c.facets[e.field] || {},
					...r
				}, r?.display === "hierarchy") {
					let o = r.values?.filter((e) => e.filtered).pop();
					if (o) {
						let e = o.value?.split(r?.hierarchyDelimiter).length;
						r.values = r.values?.filter((t, n) => t.value && t.value.split(r?.hierarchyDelimiter).length > e || n == r.values?.length - 1);
					}
					(e?.levels || r?.values && r?.values[r?.values?.length - 1].value?.split(r.hierarchyDelimiter))?.map((o, s) => {
						let c = {
							index: s,
							label: e.levels ? o : "",
							key: `ss-${s}`
						};
						d.push(new Mv({
							config: c,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: r
							}
						}));
					});
				} else d.push(new jv({
					config: e,
					services: n,
					stores: i,
					state: a,
					data: {
						id: t.id,
						facet: r
					}
				}));
			})), super(...d);
		}
	}, Av = class {
		constructor(e) {
			this.filtered = !1, this.collapsed = !1, this.display = "", this.disabled = !1, this.selected = "", this.custom = {};
			let { config: t, services: n, stores: r, state: i, data: a } = e || {}, { storage: o } = r || {}, { id: s, facet: c } = a || {}, { persisted: l } = i;
			this.services = n, this.persisted = l, this.id = s, this.config = t, this.facet = c, this.type = c.type, this.field = c.field, this.filtered = c.filtered, this.collapsed = c.collapsed, this.display = c.display, this.label = c.label, this.multiple = c.multiple, this.storage = {
				key: Ov(this.id, this.field),
				get: function(e) {
					let t = this.key + (e ? `.${e}` : "");
					return o.get(t);
				},
				set: function(e, t) {
					let n = this.key + (e ? `.${e}` : "");
					return o.set(n, t);
				}
			};
		}
		get values() {
			let e = [...this.data || []];
			return e.unshift({
				filtered: !1,
				value: "",
				label: this.config.label || this.label
			}), e;
		}
	}, jv = class extends Av {
		constructor(e) {
			super(e);
			let { data: t } = e || {}, { facet: n } = t || {};
			this.storage.set("values", n.values);
			let r = this.storage.get();
			this.data = r.values || [], this.disabled = !this.values.length, this.selected = this.disabled ? "" : r.selected || "";
		}
		select(e = "") {
			this.selected = e, this.storage.set("selected", e), this.persisted = !1, e ? this.services.urlManager.set(`filter.${this.field}`, e).go() : this.services.urlManager.remove(`filter.${this.field}`).go();
		}
	}, Mv = class extends Av {
		constructor(e) {
			super(e);
			let { data: t } = e || {}, { facet: n } = t || {};
			this.hierarchyDelimiter = n.hierarchyDelimiter;
			let r = this.storage.get();
			if (!r) this.storage.set(`${this.config.key}.values`, n.values), r = this.storage.get();
			else if (r[this.config.key]?.values) this.selected = r[this.config.key]?.selected || "";
			else {
				let e = this.storage.get(), t = Object.keys(e).map((e, t) => `ss-${t}`);
				!t.includes(this.config.key) && t.push(this.config.key);
				let r = Object.keys(e).filter((t) => e[t].selected), i = r[r.length - 1], a = t.indexOf(this.config.key), o = t.indexOf(i);
				o != -1 && a == o + 1 ? this.storage.set(`${this.config.key}.values`, n.values) : this.disabled = !0;
			}
			this.data = r[this.config.key]?.values || [];
		}
		select(e = "") {
			this.selected = e, this.persisted = !1;
			let t = this.config.index, n = this.storage.get(), r = Object.keys(n).slice(t);
			Object.keys(n).reverse().forEach((t) => {
				t == this.config.key ? this.storage.set(`${t}.selected`, e) : r.includes(t) && this.storage.set(`${t}`, {}), e ||= this.storage.get(`${t}.selected`);
			}), e ? this.services.urlManager.set(`filter.${this.field}`, e).go() : this.services.urlManager.remove(`filter.${this.field}`).go();
		}
	};
})), Pv = o((() => {
	Nv();
})), Fv, Iv = o((() => {
	Al(), wu(), f_(), iv(), Pv(), Tv(), Fv = class extends d_ {
		constructor(e, t) {
			if (super(e), this.persisted = !1, this.save = () => {}, this.reset = () => {
				this.config.persist?.enabled && (this.persistedStorage?.clear(), this.persisted = !1), this.services.urlManager.state.filter && (this.storage.clear(), this.selections = [], this.loaded = !1);
			}, typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, this.config.persist?.enabled && (this.persistedStorage = new gu({
				type: "local",
				key: `athos-${this.config.id}-persisted`
			})), this.storage = new gu(), this.update(), B(this, {
				selections: U,
				pagination: U
			});
		}
		setService(e, t) {
			this.services[e] && t && (this.services[e] = t);
		}
		loadPersisted() {
			if (this.config.persist?.enabled && this.persistedStorage) {
				let e = this.persistedStorage.get("date"), t = this.persistedStorage.get("data"), n = this.persistedStorage.get("config"), r = this.persistedStorage.get("selections"), i = this.config.persist.expiration && Date.now() - e > this.config.persist.expiration;
				t && r.filter((e) => e.selected).length && (JSON.stringify({
					...n,
					plugins: [],
					middleware: {}
				}) === JSON.stringify({
					...this.config,
					plugins: [],
					middleware: {}
				}) && !i ? (this.update(t, r), this.persisted = !0, this.services.urlManager.go()) : this.reset());
			}
		}
		update(e, t) {
			let { meta: n, search: r } = e || {};
			this.error = void 0, this.loaded = !!r?.pagination, this.meta = new Cv({ data: { meta: n || {} } }), this.pagination = new j_({
				config: this.config,
				services: this.services,
				data: {
					search: r,
					meta: this.meta.data
				}
			}), this.selections = new kv({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				state: { persisted: this.persisted },
				data: {
					search: r,
					meta: this.meta.data,
					selections: t || []
				}
			}), this.save = () => {
				this.config.persist?.enabled && this.persistedStorage && this?.selections?.filter((e) => e.selected).length && (this.persistedStorage.set("config", this.config), this.persistedStorage.set("data", e), this.persistedStorage.set("date", Date.now()), this.persistedStorage.set("selections", this.selections.map((e) => ({
					selected: e.selected,
					data: e.data,
					facet: e.facet
				}))));
			}, this.error = void 0, this.loaded = !!r?.pagination;
		}
	};
})), Lv, Rv = o((() => {
	Al(), wu(), iv(), f_(), Tv(), Lv = class extends d_ {
		constructor(e, t) {
			if (super(e), typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to SearchStore. Missing \"subscribe\" function.");
			this.services = t, this.storage = new gu(), this.history = new nv({
				services: this.services,
				config: this.config
			}), this.update(), B(this, {
				search: U,
				merchandising: U,
				facets: U,
				filters: U,
				results: U,
				pagination: U,
				sorting: U
			});
		}
		reset() {
			this.update();
		}
		update(e) {
			let { meta: t, search: n } = e || {};
			this.meta = new Cv({ data: { meta: t } }), this.merchandising = new m_({ data: { search: n } }), this.search = new $_({
				services: this.services,
				data: { search: n }
			}), this.facets = new y_({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.filters = new D_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.results = new V_({
				config: this.config,
				state: { loaded: this.loaded },
				stores: {},
				data: {
					previousSearch: this.previousSearch,
					search: n,
					meta: this.meta.data
				}
			}), this.pagination = new j_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.sorting = new X_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.error = void 0, this.loaded = !!n?.pagination, this.previousSearch = n;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-event-manager/dist/esm/MiddlewareManager.js
async function zv(e, t) {
	let n = !1;
	return await Bv(e, t, (e) => {
		e === !1 && (n = !0);
	}), n;
}
async function Bv(e, t, n) {
	if (!t.length) return;
	let r = t[0];
	n(await r(e, async () => {
		await Bv(e, t.slice(1), n);
	}));
}
var Vv, Hv = o((() => {
	Vv = class {
		constructor() {
			this.functions = [];
		}
		use(...e) {
			this.functions.push(...e);
		}
		remove(e) {
			let t = e.toString();
			this.functions = this.functions.filter((n) => e.name !== n.name || n.toString() != t);
		}
		clear() {
			this.functions = [];
		}
		async dispatch(e) {
			if (await zv(e || {}, this.functions) == 1) throw Error("cancelled");
		}
	};
})), Uv, Wv = o((() => {
	Hv(), Uv = class {
		constructor() {
			this.events = {};
		}
		async fire(e, t) {
			return this.events[e] && await this.events[e].dispatch(t), Promise.resolve();
		}
		on(e, ...t) {
			this.events[e] || (this.events[e] = new Vv()), this.events[e].use(...t);
		}
	};
})), Gv = o((() => {})), Kv = o((() => {
	Wv(), Gv();
})), qv, Jv = o((() => {
	Al(), Kv(), qv = class {
		constructor() {
			this.items = [], B(this, {
				items: U,
				price: W,
				count: W,
				msrp: W
			}), this.eventManager = new Uv();
		}
		on(e, ...t) {
			this.eventManager.on(e, ...t);
		}
		get count() {
			let e = 0;
			return this.items.forEach((t) => {
				e += t.quantity;
			}), e;
		}
		get price() {
			let e = 0;
			return this.items.forEach((t) => {
				e = (e * 100 + +(+((t.display.mappings.core?.price || 0) * 100) * t.quantity)) / 100 || 0;
			}), e;
		}
		get msrp() {
			let e = 0;
			return this.items.forEach((t) => {
				e = (e * 100 + +((+((t.display.mappings.core?.msrp || 0) * 100) || +((t.display.mappings.core?.price || 0) * 100) || 0) * t.quantity)) / 100 || 0;
			}), e;
		}
		addItems(e) {
			e.forEach((e) => {
				this.items.findIndex((t) => t.id == e.id) == -1 && this.items.push(e);
			}), this.eventManager.fire("addItems", {
				cart: this,
				items: e
			});
		}
		removeItems(e) {
			let t = [...this.items];
			e.forEach((e) => {
				let n = t.findIndex((t) => t.id == e.id);
				n > -1 && (t.splice(n, 1), t.length == 0 && this.eventManager.fire("emptied", { cart: this }));
			}), this.items = t, this.eventManager.fire("removeItems", {
				cart: this,
				items: e
			});
		}
		reset() {
			this.items = [], this.eventManager.fire("reset", { cart: this });
		}
	};
})), Yv, Xv = o((() => {
	Al(), Yv = class {
		constructor(e) {
			this.display = {}, this.type = "default";
			let { data: t } = e || {}, { profile: n } = t?.profile || {};
			if (n?.tag) {
				if (!n.display.template) throw Error(`Recommendation Profile Store found a profile without a set template: ${n.tag}`);
				this.tag = n.tag, this.placement = n.placement, this.display = n.display, this.type = n.isBundle ? "bundle" : "default", B(this, {
					tag: U,
					placement: U,
					display: U,
					type: U
				});
			}
		}
	};
})), Zv = o((() => {
	Xv();
})), Qv, $v, ey = o((() => {
	Al(), Qv = /* @__PURE__ */ u(R()), f_(), iv(), Jv(), Zv(), Tv(), $v = class extends d_ {
		constructor(e, t) {
			if (super(e), this.loaded = !1, this.profile = {}, this.results = [], typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, B(this, {
				profile: U,
				results: U
			});
		}
		reset() {
			this.error = void 0, this.loaded = !1, this.profile = {}, this.results = [];
		}
		update(e) {
			let { meta: t, profile: n, results: r } = e || {};
			this.error = void 0, this.meta = new Cv({ data: { meta: t } }), this.profile = new Yv({ data: { profile: { profile: n } } }), this.profile.type == "bundle" && (this.config.settings = (0, Qv.default)(this.config.settings || {}, { variants: { autoSelect: !0 } }), this.cart = new qv()), this.results = new V_({
				config: this.config,
				state: { loaded: this.loaded },
				data: {
					search: {
						results: r,
						tracking: { responseId: e.responseId }
					},
					meta: this.meta.data
				}
			}), this.loaded = !!n;
		}
	};
})), ty, ny = o((() => {
	(function(e) {
		e.WARNING = "warning", e.INFO = "info", e.ERROR = "error";
	})(ty ||= {});
})), ry = o((() => {
	f_(), Dv(), Iv(), Rv(), iv(), bv(), ey(), Jv(), wu(), Tv(), ny();
})), iy, ay = o((() => {
	wu(), iy = class {
		get initialized() {
			return this._initialized;
		}
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c = {}) {
			if (this.type = "abstract", this.targeters = {}, this._initialized = !1, this.handleError = (e, t) => {
				let n;
				if (e instanceof ErrorEvent) n = e;
				else if (e instanceof Error) n = new ErrorEvent("error", {
					error: e,
					message: e.message
				});
				else if (typeof e == "string" || typeof e == "number") n = new ErrorEvent("error", { error: Error(e.toString()) });
				else if (typeof e == "object" && Object.keys(e).length) try {
					n = new ErrorEvent("error", { error: Error(JSON.stringify(e)) });
				} catch {}
				if (n) {
					let { filename: r, colno: i, lineno: a, error: { stack: o }, message: s, timeStamp: c } = n, l = {
						filename: r,
						stack: o,
						message: s,
						colno: i,
						lineno: a,
						errortimestamp: c,
						details: t,
						context: { controller: {
							id: this.id,
							type: this.type
						} }
					};
					this.tracker.track.error(l), this.eventManager.fire("error", {
						controller: this,
						error: e
					});
				}
			}, typeof e != "object" || typeof e.id != "string" || !e.id.match(/^[a-zA-Z0-9_-]*$/)) throw Error("Invalid config passed to controller. The \"id\" attribute must be an alphanumeric string.");
			if (typeof t != "object" || typeof t.search != "function") throw Error("Invalid service 'client' passed to controller. Missing \"search\" function.");
			if (typeof n != "object" || typeof n.update != "function") throw Error("Invalid service 'store' passed to controller. Missing \"update\" function.");
			if (typeof r != "object" || typeof r.subscribe != "function") throw Error("Invalid service 'urlManager' passed to controller. Missing \"subscribe\" function.");
			if (typeof i != "object" || typeof i.on != "function") throw Error("Invalid service 'eventManager' passed to controller. Missing \"on\" function.");
			if (typeof i != "object" || typeof i.fire != "function") throw Error("Invalid service 'eventManager' passed to controller. Missing \"fire\" function.");
			if (typeof a != "object" || typeof a.setNamespace != "function") throw Error("Invalid service 'profiler' passed to controller. Missing \"setNamespace\" function.");
			if (typeof a != "object" || typeof a.create != "function") throw Error("Invalid service 'profiler' passed to controller. Missing \"create\" function.");
			if (typeof o != "object" || typeof o.dev != "function") throw Error("Invalid service 'logger' passed to controller. Missing \"dev\" function.");
			if (typeof s != "object" || typeof s.track != "object") throw Error("Invalid service 'tracker' passed to controller. Missing \"track\" object.");
			this.id = e.id, this.config = e, this.client = t, this.store = n, this.urlManager = r, this.eventManager = i, this.profiler = a, this.log = o, this.tracker = s, this.context = c, this.log.setNamespace(this.config.id), this.profiler.setNamespace(this.config.id);
		}
		createTargeter(e, t, n) {
			return this.addTargeter(new Ml([e], t, n));
		}
		addTargeter(e) {
			let t = e.getTargets()[0], n = t?.name ?? t?.selector;
			if (n && !this.targeters[n]) return this.targeters[n] = e, e;
		}
		async init() {
			this._initialized && this.log.warn("'init' middleware recalled");
			let e = this.profiler.create({
				type: "event",
				name: "init",
				context: this.config
			}).start();
			try {
				try {
					await this.eventManager.fire("init", { controller: this });
				} catch (e) {
					if (e?.message == "cancelled") this.log.warn("'init' middleware cancelled");
					else throw this.log.error("error in 'init' middleware"), e;
				}
			} catch (e) {
				e && (console.error(e), this.handleError(e));
			}
			this._initialized ||= (this.urlManager.subscribe((e, t) => {
				try {
					JSON.stringify(e) !== JSON.stringify(t) && this.search();
				} catch (e) {
					this.log.error("URL state is invalid", e);
				}
			}), !0), e.stop(), this.log.profile(e);
		}
		retarget() {
			Object.keys(this.targeters).forEach((e) => {
				this.targeters[e].retarget();
			});
		}
		async plugin(e, ...t) {
			await e(this, ...t);
		}
		on(e, ...t) {
			this.eventManager.on(e, ...t);
		}
		use(e) {
			if (e?.plugins) try {
				if (!Array.isArray(e?.plugins)) throw "invalid format";
				e?.plugins.forEach((e) => {
					if (!Array.isArray(e)) throw "invalid format";
					let [t, ...n] = e;
					this.plugin(t, ...n);
				});
			} catch {
				this.log.warn("plugins not attached - use format [func, ...args?][]");
			}
			e?.middleware && Object.keys(e.middleware).forEach((t) => {
				let n = e.middleware[t], r;
				r = Array.isArray(n) ? n : [n], r.forEach((e) => {
					this.on(t, e);
				});
			});
		}
		setConfig(e) {
			this.config = e, this.store.setConfig(e);
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/utils/getParams.js
function oy(e) {
	let t = {};
	if (e.tag && (t.merchandising = t.merchandising || {}, t.merchandising.landingPage = e.tag), e.query && (t.search = t.search || {}, t.search.query = t.search.query || {}, t.search.query.string = e.query), e.rq && (t.search = t.search || {}, t.search.subQuery = e.rq), e.fallbackQuery && (t.search = t.search || {}, t.search.fallbackQuery = e.fallbackQuery), e.page && (t.pagination = t.pagination || {}, t.pagination.page = e.page), e.pageSize && (t.pagination = t.pagination || {}, t.pagination.pageSize = e.pageSize), e.sort) {
		t.sorts = t.sorts || [];
		let n = (Array.isArray(e.sort) ? e.sort : [e.sort])[0];
		n && n.field && n.direction && t.sorts.push({
			field: n.field,
			direction: n.direction
		});
	}
	return e.filter && (t.filters = t.filters || [], Object.keys(e.filter).forEach((n) => {
		if (typeof n != "string") return;
		let r = e.filter[n];
		(Array.isArray(r) ? r : [r]).forEach((e) => {
			typeof e == "object" ? e.low !== void 0 && e.high !== void 0 && t.filters.push({
				type: "range",
				field: n,
				value: e
			}) : t.filters.push({
				type: "value",
				field: n,
				value: e
			});
		});
	})), t;
}
var sy = o((() => {})), cy, ly = o((() => {
	(function(e) {
		e.search = "search", e.autocomplete = "autocomplete", e.finder = "finder", e.recommendation = "recommendation";
	})(cy ||= {});
})), uy, dy, fy, py = o((() => {
	uy = /* @__PURE__ */ u(R()), ry(), ay(), sy(), ly(), dy = {
		id: "finder",
		beacon: { enabled: !0 },
		globals: { pagination: { pageSize: 0 } },
		fields: [],
		persist: {
			enabled: !1,
			lockSelections: !0,
			expiration: 0
		}
	}, fy = class extends iy {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = cy.finder, this.find = async () => {
				await this.store.save();
				try {
					await this.eventManager.fire("beforeFind", { controller: this }), window.location.href = this.urlManager.href;
				} catch (e) {
					e?.message == "cancelled" ? this.log.warn("'beforeFind' middleware cancelled") : (this.log.error("error in 'beforeFind' middleware"), this.log.error(e));
				}
			}, this.reset = () => {
				this.store.reset(), this.urlManager.remove("filter").go(), this.store.setService("urlManager", this.urlManager);
			}, this.search = async () => {
				try {
					if (this.initialized || await this.init(), this.store.persisted) return;
					let e = this.params;
					this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, search: r } = await this.client.finder(e);
					t.stop(), this.log.profile(t);
					let i = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), i.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					i.stop(), this.log.profile(i), this.store.update({
						meta: n,
						search: r
					});
					let a = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), a.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					a.stop(), this.log.profile(a);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: ty.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: ty.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: ty.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: ty.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.config = (0, uy.default)(dy, this.config), this.store.setConfig(this.config), this.config.url && (this.urlManager = this.urlManager.withConfig((e) => ({
				...e,
				urlRoot: this.config.url
			}))), this.use(this.config), this.store.loadPersisted();
		}
		get params() {
			let e = this.urlManager.state, { userId: t, sessionId: n, pageLoadId: r } = this.tracker.getContext(), i = {};
			t && (i.userId = t), n && (i.sessionId = n), r && (i.pageLoadId = r), i.domain = window.location.href;
			let a = {
				facets: {
					include: this.config.fields.map((e) => e.field),
					autoDrillDown: !1
				},
				tracking: i
			};
			return (0, uy.default)({ ...oy(e) }, (0, uy.default)(a, this.config.globals));
		}
	};
})), my = /* @__PURE__ */ s(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = r(n) : typeof define == "function" && define.amd ? define([], r.bind(n, n)) : r(n);
	})(typeof global < "u" ? global : e, function(e) {
		if (e.CSS && e.CSS.escape) return e.CSS.escape;
		var t = function(e) {
			if (arguments.length == 0) throw TypeError("`CSS.escape` requires an argument.");
			for (var t = String(e), n = t.length, r = -1, i, a = "", o = t.charCodeAt(0); ++r < n;) {
				if (i = t.charCodeAt(r), i == 0) {
					a += "�";
					continue;
				}
				if (i >= 1 && i <= 31 || i == 127 || r == 0 && i >= 48 && i <= 57 || r == 1 && i >= 48 && i <= 57 && o == 45) {
					a += "\\" + i.toString(16) + " ";
					continue;
				}
				if (r == 0 && n == 1 && i == 45) {
					a += "\\" + t.charAt(r);
					continue;
				}
				if (i >= 128 || i == 45 || i == 95 || i >= 48 && i <= 57 || i >= 65 && i <= 90 || i >= 97 && i <= 122) {
					a += t.charAt(r);
					continue;
				}
				a += "\\" + t.charAt(r);
			}
			return a;
		};
		return e.CSS ||= {}, e.CSS.escape = t, t;
	});
})), hy, gy, _y = o((() => {
	hy = 1e3, gy = (e, t) => {
		let n = t?.display?.mappings.core?.url || "", r = t?.mappings.core?.url || "", i = (e.composedPath ? e.composedPath() : [e.target]).slice(0, 12);
		for (let e of i) if (e instanceof Element) {
			let t = e.getAttribute("href");
			if (t && (r && t.includes(r) || n && t.includes(n))) return !0;
		}
		return !1;
	};
})), vy, yy, by = o((() => {
	_y(), vy = "sstracking", yy = (e) => {
		let t = e.target, n = null, r = 0;
		for (; t && (r < 12 || !t.getAttribute(vy));) {
			n = t.getAttribute("href");
			let e = t.tagName.toLowerCase() === "a";
			if (n && e) return !0;
			t = t.parentElement, r++;
		}
		return !1;
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/Search/SearchController.js
function xy(e) {
	return {
		siteId: e.siteId,
		sorts: e.sorts,
		search: {
			query: { string: e?.search?.query?.string || "" },
			subQuery: e?.search?.subQuery || ""
		},
		filters: e.filters,
		pagination: e.pagination,
		facets: e.facets,
		merchandising: { landingPage: e.merchandising?.landingPage || "" }
	};
}
function Sy(e, t, n = 7) {
	let r = 0, i = e;
	for (; i && r <= n;) {
		let e = null;
		try {
			e = i.querySelector(`[href*="${t}"]`);
		} catch {
			try {
				e = i.querySelector((0, wy.default)(`[href*="${t}"]`));
			} catch {}
		}
		if (e) {
			let n = "", r = e;
			for (; r && r != i.parentElement;) {
				let e = r.classList.value.trim().split(" ").reduce((e, t) => t.trim() ? `${e}.${(0, wy.default)(t.trim())}` : e, "");
				n = `${r.tagName}${e}${n ? ` ${n}` : ""}`, r = r.parentElement;
			}
			return `${n}[href*="${t}"]`;
		}
		i = i.parentElement, r++;
	}
}
var Cy, wy, Ty, Ey, Dy, Oy, ky = o((() => {
	Cy = /* @__PURE__ */ u(R()), wy = /* @__PURE__ */ u(my()), ay(), ry(), wu(), sy(), ly(), _y(), by(), Ty = [
		"collection",
		"category",
		"categories",
		"hierarchy",
		"brand",
		"manufacturer"
	], Ey = [
		1,
		0,
		"1",
		"0",
		"true",
		"false",
		!0,
		!1
	], Dy = {
		id: "search",
		globals: {},
		beacon: { enabled: !0 },
		settings: {
			redirects: {
				merchandising: !0,
				singleResult: !0
			},
			facets: {
				trim: !0,
				pinFiltered: !0,
				storeRange: !0,
				autoOpenActive: !0
			}
		}
	}, Oy = class extends iy {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = cy.search, this.previousResults = [], this.page = { type: "search" }, this.events = {}, this.track = {
				banner: {
					impression: ({ uid: e, responseId: t }) => {
						if (!e) {
							this.log.warn("No banner provided to track.banner.impression");
							return;
						}
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events[t]?.banner[e]?.impression) return;
						let n = {
							responseId: t,
							banners: [{ uid: e }],
							results: []
						};
						this.eventManager.fire("track.banner.impression", {
							controller: this,
							product: { uid: e },
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].impression({
							data: n,
							siteId: this.config.globals?.siteId
						}), this.events[t].banner[e] = this.events[t].banner[e] || {}, this.events[t].banner[e].impression = !0;
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.click");
							return;
						}
						let { responseId: n, uid: r } = t;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (yy(e)) {
							if (this.events?.[n]?.banner[r]?.clickThrough) return;
							this.track.banner.clickThrough(e, t), this.events[n].banner[r] = this.events[n].banner[r] || {}, this.events[n].banner[r].clickThrough = !0, setTimeout(() => {
								this.events[n].banner[r].clickThrough = !1;
							}, hy);
						}
					},
					clickThrough: (e, { uid: t, responseId: n }) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.clickThrough");
							return;
						}
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = {
							responseId: n,
							banners: [{ uid: t }]
						};
						this.eventManager.fire("track.banner.clickThrough", {
							controller: this,
							event: e,
							product: { uid: t },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].clickThrough({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[n].banner[t] = this.events[n].banner[t] || {}, this.events[n].banner[t].clickThrough = !0, setTimeout(() => {
							this.events[n].banner[t].clickThrough = !1;
						}, hy);
					}
				},
				product: {
					clickThrough: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.clickThrough");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = e.target, i = t.display?.mappings.core?.url || t.mappings.core?.url || "", a = r?.getAttribute("href"), o = a?.indexOf(i) == -1 && a || i, s = {}, c = Sy(r, o), l = c ? document?.querySelector(c)?.getBoundingClientRect() : void 0;
						if (c || o || l) try {
							let e = this.storage.get("lastStringyParams");
							if (e) {
								let t = xy(JSON.parse(e)), n = JSON.stringify(t);
								s[n] = {
									domRect: l,
									href: o,
									selector: c
								};
							}
						} catch (e) {
							this.log.warn("Failed to save srcollMap!", e);
						}
						this.storage.set("scrollMap", s);
						let u = ["product", "banner"].includes(t.type) ? t.type : "product", d = {
							responseId: n,
							results: [{
								type: u,
								uid: t.id ? "" + t.id : "",
								...u === "product" ? {
									parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
									sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
								} : {}
							}]
						};
						this.eventManager.fire("track.product.clickThrough", {
							controller: this,
							event: e,
							product: t,
							trackEvent: d
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].clickThrough({
							data: d,
							siteId: this.config.globals?.siteId
						});
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.click");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (t.type === "banner" && yy(e)) {
							if (this.events?.[n]?.product[t.id]?.inlineBannerClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].inlineBannerClickThrough = !1;
							}, hy);
						} else if (gy(e, t)) {
							if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].productClickThrough = !1;
							}, hy);
						}
					},
					impression: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.impression");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events[t]?.product[e.id]?.impression) return;
						let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
							responseId: t,
							results: [{
								type: n,
								uid: e.id ? "" + e.id : "",
								...n === "product" ? {
									parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
									sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
								} : {}
							}],
							banners: []
						};
						this.eventManager.fire("track.product.impression", {
							controller: this,
							product: e,
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
					},
					addToCart: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.addToCart");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let n = {
							responseId: t,
							results: [{
								parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
								uid: e.display.mappings.core?.uid || e.display.id,
								sku: e.display.mappings.core?.sku,
								qty: e.quantity || 1,
								price: Number(e.display.mappings.core?.price) || 0
							}]
						};
						this.eventManager.fire("track.product.addToCart", {
							controller: this,
							product: e,
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].addToCart({
							data: n,
							siteId: this.config.globals?.siteId
						});
					}
				},
				redirect: ({ redirectURL: e, responseId: t }) => {
					if (!e) {
						this.log.warn("No redirectURL provided to track.redirect");
						return;
					}
					let n = {
						responseId: t,
						redirect: e
					};
					this.eventManager.fire("track.redirect", {
						controller: this,
						redirectURL: e,
						trackEvent: n
					}), this.config.beacon?.enabled && this.tracker.events.search.redirect({
						data: n,
						siteId: this.config.globals?.siteId
					});
				}
			}, this.search = async () => {
				try {
					this.initialized || await this.init();
					let e = this.params;
					e.search?.query?.string && e.search?.query?.string.length && this.store.history.save(e.search.query.string), this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = JSON.stringify(xy(e)), n = this.storage.get("lastStringyParams");
					if (this.store.loaded && t === n) return;
					let r = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), i = {}, a;
					if (this.config.settings?.infinite?.enabled && e.pagination?.page && e.pagination.page > 1) {
						let t = this.config.settings.infinite?.backfill && !this.store.results.length && e.pagination.page > this.config.settings.infinite.backfill, n = !this.config.settings.infinite?.backfill && !this.store.results.length;
						if (t || n) {
							this.storage.set("scrollMap", {}), this.urlManager.set("page", 1).go();
							return;
						}
						if (this.config.settings?.infinite.backfill && !this.store.loaded) {
							let t = [], n = Array(e.pagination.page).fill("backfill").map((n, r) => {
								let i = (0, Cy.default)({ ...e }, {
									pagination: { page: r + 1 },
									search: { redirectResponse: "full" }
								});
								return r + 1 == 1 && (delete i?.pagination?.page, this.config.settings?.redirects?.merchandising && delete i?.search?.redirectResponse), t.push(i), this.client[this.page.type](i);
							}), r = await Promise.all(n);
							i = r[0].meta, a = r[0].search;
							let o = r.reduce((e, t) => {
								let n = t.search.tracking.responseId;
								return this.events[n] = this.events[n] || {
									product: {},
									banner: {}
								}, e.concat(...t.search.results);
							}, []);
							a.pagination.totalPages = Math.ceil(a.pagination.totalResults / a.pagination.pageSize), a.pagination.page = e.pagination?.page, a.results = o;
						} else {
							let t = await this.client[this.page.type](e);
							i = t.meta, a = t.search;
							let n = a.tracking.responseId;
							this.events[n] = this.events[n] || {
								product: {},
								banner: {}
							}, a.results = [...this.previousResults, ...a.results || []];
						}
					} else {
						this.previousResults = [];
						let t = await this.client[this.page.type](e);
						i = t.meta, a = t.search;
						let n = a.tracking.responseId;
						this.events[n] = {
							product: {},
							banner: {}
						};
					}
					let o = {
						meta: i,
						search: a
					};
					r.stop(), this.log.profile(r);
					let s = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: o
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), s.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					s.stop(), this.log.profile(s), this.previousResults = JSON.parse(JSON.stringify(o.search.results)), this.store.update(o);
					let c = { responseId: o.search.tracking.responseId };
					this.config.beacon?.enabled && this.tracker.events[this.page.type].render({
						data: c,
						siteId: this.config.globals?.siteId
					});
					let l = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: o
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), l.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					l.stop(), this.log.profile(l);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: ty.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: ty.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: ty.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: ty.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to search controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, this.config = (0, Cy.default)(Dy, this.config), this.config.settings?.infinite && typeof this.config.settings?.infinite == "object" && (Object.keys(this.config.settings?.infinite).length == 0 || this.config.settings?.infinite?.backfill !== void 0) && (this.config.settings = {
				...this.config.settings,
				infinite: {
					enabled: !0,
					...this.config.settings.infinite
				}
			}), this.config.settings?.infinite?.enabled && this.config.settings.restorePosition === void 0 && (this.config.settings.restorePosition = { enabled: !0 }), this.store.setConfig(this.config), this.storage = new gu({
				type: "session",
				key: `athos-controller-${this.config.id}`
			}), typeof this.context?.page == "object" && ["search", "category"].includes(this.context.page.type) && (this.page = (0, Cy.default)(this.page, this.context.page)), this.eventManager.on("beforeSearch", async ({ request: e }, t) => {
				await t();
				let n = e;
				n.search?.query || n.filters?.filter((e) => e.background).filter((e) => Ty.find((t) => e.field?.toLowerCase().includes(t))).filter((e) => Ey.every((t) => {
					switch (e.type) {
						case "range": return e.value !== t;
						default: return e.value !== t;
					}
				}))?.length && (this.page = (0, Cy.default)(this.page, { type: "category" }));
			}), this.eventManager.on("afterSearch", async (e, t) => {
				let n = e.controller.config, r = e.response?.search?.merchandising?.redirect, i = e.controller.store;
				if (r && n?.settings?.redirects?.merchandising && !e?.response?.search?.filters?.length && !i.loaded) return i.loaded = !0, this.track.redirect({
					redirectURL: r,
					responseId: e.response.search.tracking.responseId
				}), window.location.replace(r), !1;
				await t();
			}), this.eventManager.on("afterStore", async (e, t) => {
				await t();
				let n = xy(e.request), r = JSON.stringify(n);
				this.storage.set("lastStringyParams", r);
				let i = (this.storage.get("scrollMap") || {})[r];
				i || this.storage.set("scrollMap", {}), this.eventManager.fire("restorePosition", {
					controller: this,
					element: i
				});
			}), this.eventManager.on("afterSearch", async (e, t) => {
				await t();
				let n = e.response.search.facets;
				n && n.forEach((t) => {
					if (e.response.meta?.facets && t.field) {
						let n = t.field || "", r = e.response.meta.facets[n], i = r?.hierarchyDelimiter || " / ", a = this.config?.settings?.filters?.fields ? this.config?.settings?.filters?.fields[n] : this.config?.settings?.filters, o = a?.hierarchy?.displayDelimiter ?? " / ", s = a?.hierarchy?.showFullPath ?? !1;
						if (a?.hierarchy?.enabled && r && r.display === "hierarchy" && t.filtered && t.values?.length > 0) {
							let n = t.values?.filter((e) => e?.filtered === !0);
							if (n && n.length) {
								let r = {
									field: t.field,
									label: s ? (n[0].value ?? n[0].label ?? "").replace(new RegExp(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"), o) : n[0].label,
									type: "value"
								};
								e.response.search.filters ? e.response.search.filters.push(r) : e.response.search.filters = [r];
							}
						}
					}
				});
			}), this.eventManager.on("afterStore", async (e, t) => {
				await t();
				let n = e.controller, r = e.response.search;
				if (n.store.loaded && !n.store.error) {
					let t = e.controller.config, n = e?.request?.filters?.filter((e) => !e.background), i = r?.results?.length && r?.results[0].mappings?.core?.url;
					if (t?.settings?.redirects?.singleResult && r.search?.query && r.pagination?.totalResults === 1 && !n?.length && i) return window.location.replace(i), !1;
				}
			}), this.config.settings?.restorePosition?.enabled && (this.eventManager.on("restorePosition", async ({ controller: e, element: t }, n) => {
				if (!t?.selector) {
					let e = this.storage.get("lastStringyParams");
					if (e) {
						let n = xy(JSON.parse(e)), r = JSON.stringify(n);
						t = (this.storage.get("scrollMap") || {})[r];
					}
				}
				t && await new Promise(async (n) => {
					let r = 0, i = 0, a, o = () => {
						let e = t?.domRect?.top || 0, n = document.querySelector(t?.selector);
						for (; n && !n.getBoundingClientRect().height;) n = n.parentElement, e = 0;
						if (n) {
							let { y: t } = n.getBoundingClientRect();
							r++, t > e + 1 || t < e - 1 ? window.scrollBy(0, t - e) : a = n;
						} else i++;
						return !0;
					};
					for (; o() && r <= 10 && i <= 12;) await new Promise((e) => setTimeout(e, 60));
					a ? e.log.debug("restored position to: ", a) : e.log.debug("attempted to scroll back to element with selector: ", t?.selector), n();
				}), await n();
			}), this.config.settings?.restorePosition?.onPageShow && window.addEventListener("pageshow", (e) => {
				e.persisted && this.store.loaded && this.eventManager.fire("restorePosition", {
					controller: this,
					element: {}
				});
			})), this.use(this.config);
		}
		get params() {
			let e = (0, Cy.default)({ ...oy(this.urlManager.state) }, this.config.globals || {});
			(!this.config.settings?.redirects?.merchandising || this.store.loaded) && (e.search = e.search || {}, e.search.redirectResponse = "full"), e.tracking = e.tracking || {}, e.tracking.domain = window.location.href;
			let { userId: t, sessionId: n, pageLoadId: r, shopperId: i } = this.tracker.getContext();
			if (t && (e.tracking.userId = t), n && (e.tracking.sessionId = n), r && (e.tracking.pageLoadId = r), !this.config.globals?.personalization?.disabled) {
				let t = this.tracker.cookies.cart.get();
				t.length && (e.personalization = e.personalization || {}, e.personalization.cart = t.join(","));
				let n = this.tracker.cookies.viewed.get();
				n.length && (e.personalization = e.personalization || {}, e.personalization.lastViewed = n.join(",")), i && (e.personalization = e.personalization || {}, e.personalization.shopper = i);
			}
			return e;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/Autocomplete/AutocompleteController.js
function Ay(e, t, n) {
	let r = document.createElement("input");
	r.type = "hidden", r.name = t, r.value = n, e.querySelector(`[type="hidden"][name="${t}"]`)?.remove(), e.append(r);
}
async function jy(e) {
	return new Promise((t) => {
		window.setTimeout(t, e);
	});
}
function My(e, t) {
	let n = {};
	if (typeof e == "object" && e.nodeName == "FORM") for (let r = e.elements.length - 1; r >= 0; r--) {
		let i = e.elements[r];
		typeof t == "function" && !t(i) || i.name && !Hy.includes(i.type) && (i.type != "checkbox" && i.type != "radio" || i.checked) && (n[i.name] = i.value);
	}
	return n;
}
function Ny(e, t, n) {
	if (typeof e == "object" && e.nodeName == "FORM") for (let r = e.elements.length - 1; r >= 0; r--) {
		let i = e.elements[r];
		typeof n == "function" && !n(i) || i.name && !Hy.includes(i.type) && i.addEventListener("change", t);
	}
}
function Py(e, t) {
	if (typeof e == "object" && e.nodeName == "FORM") for (let n = e.elements.length - 1; n >= 0; n--) {
		let r = e.elements[n];
		r.name && !Hy.includes(r.type) && r.removeEventListener("change", t);
	}
}
var Fy, Iy, Ly, Ry, zy, By, Vy, Hy, Uy = o((() => {
	Fy = /* @__PURE__ */ u(R()), ry(), wu(), ay(), sy(), ly(), _y(), by(), Iy = "ss-autocomplete-input", Ly = 13, Ry = 27, zy = "fallbackQuery", By = {
		id: "autocomplete",
		selector: "",
		action: "",
		globals: {},
		beacon: { enabled: !0 },
		settings: {
			initializeFromUrl: !0,
			syncInputs: !0,
			serializeForm: !1,
			facets: {
				trim: !0,
				pinFiltered: !0
			},
			redirects: {
				merchandising: !0,
				singleResult: !1
			},
			bind: {
				input: !0,
				submit: !0
			}
		}
	}, Vy = class extends iy {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = cy.autocomplete, this.events = {}, this.track = {
				banner: {
					impression: (e) => {
						if (!e) {
							this.log.warn("No banner provided to track.banner.impression");
							return;
						}
						let { responseId: t, uid: n } = e;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events?.[t]?.banner?.[n]?.impression) return;
						let r = {
							responseId: t,
							banners: [{ uid: n }],
							results: []
						};
						this.eventManager.fire("track.banner.impression", {
							controller: this,
							product: { uid: n },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].banner[n] = this.events[t].banner[n] || {}, this.events[t].banner[n].impression = !0;
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.click");
							return;
						}
						let { responseId: n, uid: r } = t;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (yy(e)) {
							if (this.events?.[n]?.banner[r]?.clickThrough) return;
							this.track.banner.clickThrough(e, t), this.events[n].banner[r] = this.events[n].banner[r] || {}, this.events[n].banner[r].clickThrough = !0, setTimeout(() => {
								this.events[n].banner[r].clickThrough = !1;
							}, hy);
						}
					},
					clickThrough: (e, { uid: t, responseId: n }) => {
						if (!t) {
							this.log.warn("No banner uid provided to track.banner.clickThrough");
							return;
						}
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = {
							responseId: n,
							banners: [{ uid: t }]
						};
						this.eventManager.fire("track.banner.clickThrough", {
							controller: this,
							event: e,
							product: { uid: t },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.clickThrough({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[n].banner[t] = this.events[n].banner[t] || {}, this.events[n].banner[t].clickThrough = !0, setTimeout(() => {
							this.events[n].banner[t].clickThrough = !1;
						}, hy);
					}
				},
				product: {
					clickThrough: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.clickThrough");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = ["product", "banner"].includes(t.type) ? t.type : "product", i = {
							responseId: n,
							results: [{
								type: r,
								uid: t.id ? "" + t.id : "",
								...r === "product" ? {
									parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
									sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
								} : {}
							}]
						};
						this.eventManager.fire("track.product.clickThrough", {
							controller: this,
							event: e,
							product: t,
							trackEvent: i
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.clickThrough({
							data: i,
							siteId: this.config.globals?.siteId
						});
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.click");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (t.type === "banner" && yy(e)) {
							if (this.events?.[n]?.product[t.id]?.inlineBannerClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].inlineBannerClickThrough = !1;
							}, hy);
						} else if (gy(e, t)) {
							if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].productClickThrough = !1;
							}, hy);
						}
					},
					impression: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.impression");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events?.[t]?.product[e.id]?.impression) return;
						let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
							responseId: t,
							results: [{
								type: n,
								uid: e.id ? "" + e.id : "",
								...n === "product" ? {
									parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
									sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
								} : {}
							}],
							banners: []
						};
						this.eventManager.fire("track.product.impression", {
							controller: this,
							product: e,
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
					},
					addToCart: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.addToCart");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let n = {
							responseId: t,
							results: [{
								parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
								uid: e.display.mappings.core?.uid || e.display.id,
								sku: e.display.mappings.core?.sku,
								qty: e.quantity || 1,
								price: Number(e.display.mappings.core?.price) || 0
							}]
						};
						this.eventManager.fire("track.product.addToCart", {
							controller: this,
							product: e,
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.addToCart({
							data: n,
							siteId: this.config.globals?.siteId
						});
					}
				},
				redirect: ({ redirectURL: e, responseId: t }) => {
					if (!e) {
						this.log.warn("No redirectURL provided to track.redirect");
						return;
					}
					let n = {
						responseId: t,
						redirect: e
					};
					this.eventManager.fire("track.redirect", {
						controller: this,
						redirectURL: e,
						trackEvent: n
					}), this.config.beacon?.enabled && this.tracker.events.autocomplete.redirect({
						data: n,
						siteId: this.config.globals?.siteId
					});
				}
			}, this.handlers = {
				input: {
					enterKey: async (e) => {
						if (e.keyCode == Ly) {
							let t = e.target, n = this.store.services.urlManager;
							for (e.preventDefault(); this.store.loading;) await jy(200);
							this.store.search.correctedQuery && (n = n?.set(zy, this.store.search.correctedQuery.string)), n = n?.set("query", t.value), await jy(201);
							try {
								await this.eventManager.fire("beforeSubmit", {
									controller: this,
									input: t
								});
							} catch (e) {
								if (e?.message == "cancelled") {
									this.log.warn("'beforeSubmit' middleware cancelled");
									return;
								}
								this.log.error("error in 'beforeSubmit' middleware"), console.error(e);
							}
							window.location.href = n?.href || "";
						}
					},
					escKey: (e) => {
						e.keyCode == Ry && (e.target.blur(), this.setFocused());
					},
					focus: (e) => {
						e.stopPropagation(), setTimeout(() => {
							this.setFocused(e.target);
						});
					},
					formSubmit: async (e) => {
						let t = e.target, n = t.querySelector(`input[${Iy}]`);
						for (e.preventDefault(); this.store.loading;) await jy(200);
						this.store.search.correctedQuery && Ay(t, zy, this.store.search.correctedQuery.string), await jy(201);
						try {
							await this.eventManager.fire("beforeSubmit", {
								controller: this,
								input: n
							});
						} catch (e) {
							if (e?.message == "cancelled") {
								this.log.warn("'beforeSubmit' middleware cancelled");
								return;
							}
							this.log.error("error in 'beforeSubmit' middleware"), console.error(e);
						}
						t.submit();
					},
					formElementChange: (e) => {
						let t = e.target?.form, n = t?.querySelector(`input[${Iy}]`);
						if (t && n && this.config.settings?.serializeForm) {
							let e = My(t, function(e) {
								return e != n;
							});
							this.store.setService("urlManager", this.store.services.urlManager.reset().withGlobals(e)), this.store.reset(), this.config.settings?.trending?.enabled && this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && this.searchTrending();
						}
					},
					input: (e) => {
						e.isTrusted && this.store.state.focusedInput !== e.target && this.setFocused(e.target);
						let t = e.target.value;
						if ((!this.store.state.input && !t || this.store.state.input == t) && this.store.loaded) return;
						this.store.state.source = "input", this.store.state.input = t, this.store.merchandising.redirect = "", this.config?.settings?.syncInputs && document.querySelectorAll(this.config.selector).forEach((e) => {
							e.value = t;
						}), clearTimeout(this.handlers.input.timeoutDelay);
						let n = this.store.trending?.length && this.config.settings?.trending?.enabled && this.config.settings?.trending?.showResults, r = this.store.history?.length && this.config.settings?.history?.enabled && this.config.settings?.history?.showResults;
						this.handlers.input.timeoutDelay = setTimeout(() => {
							t ? (this.store.state.locks.terms.unlock(), this.store.state.locks.facets.unlock(), this.urlManager.set({ query: this.store.state.input }).go()) : (this.store.reset(), n ? this.store.trending[0].preview() : r ? this.store.history[0].preview() : this.urlManager.reset().go());
						}, 200);
					},
					timeoutDelay: void 0
				},
				document: { click: (e) => {
					let t = document.querySelectorAll(this.config.selector);
					Array.from(t).includes(e.target) || e.target?.nodeName == "FORM" && e.target.querySelectorAll(this.config.selector).length ? e.stopPropagation() : this.setFocused();
				} }
			}, this.searchTrending = async (e) => {
				let t, n = this.storage.get("terms");
				if (n && !e?.limit) t = JSON.parse(n);
				else {
					let n = { limit: e?.limit || this.config.settings?.trending?.limit || 5 }, r = this.profiler.create({
						type: "event",
						name: "trending",
						context: n
					}).start();
					t = await this.client.trending(n), r.stop(), this.log.profile(r), t?.trending.queries?.length && this.storage.set("terms", JSON.stringify(t));
				}
				this.store.updateTrendingTerms(t);
			}, this.search = async () => {
				try {
					if (this.initialized || await this.init(), !this.urlManager.state.query) return;
					let e = this.params;
					if (!e?.search?.query?.string) return;
					this.store.loading = !0, this.store.merchandising.redirect = "";
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, search: r } = await this.client.autocomplete(e);
					t.stop(), this.log.profile(t);
					let i = r.tracking.responseId;
					this.events[i] = this.events[i] || {
						product: {},
						banner: {}
					};
					let a = this.store.results[0]?.responseId, o = a && a === i;
					if (o) {
						let e = Object.keys(this.events[i].product || {}).filter((e) => this.events[i].product?.[e]?.impression);
						this.events[i] = {
							product: e.reduce((e, t) => (e[t] = { impression: !0 }, e), {}),
							banner: this.events[i].banner
						};
					} else this.events[i] = {
						product: {},
						banner: {}
					};
					let s = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), s.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					if (s.stop(), this.log.profile(s), this.store.update({
						meta: n,
						search: r
					}), !o) {
						let e = { responseId: i };
						this.config.beacon?.enabled && this.tracker.events.autocomplete.render({
							data: e,
							siteId: this.config.globals?.siteId
						});
					}
					let c = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), c.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					c.stop(), this.log.profile(c);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: ty.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: ty.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: ty.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: ty.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to autocomplete controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, this.config = (0, Fy.default)(By, this.config), this.config.settings?.trending?.limit && this.config.settings?.trending?.enabled === void 0 && (this.config.settings = {
				...this.config.settings,
				trending: {
					enabled: !0,
					...this.config.settings.trending
				}
			}), this.config.settings?.history?.limit && this.config.settings?.history?.enabled === void 0 && (this.config.settings = {
				...this.config.settings,
				history: {
					enabled: !0,
					...this.config.settings.history
				}
			}), this.store.setConfig(this.config), this.config.settings.initializeFromUrl && (this.store.state.input = this.urlManager.state.query, this.urlManager.reset().go()), this.storage = new gu({
				type: "session",
				key: `athos-controller-${this.config.id}`
			}), this.eventManager.on("afterSearch", async (e, t) => {
				if (await t(), e.response.search.autocomplete?.query != e.controller.urlManager.state.query) return !1;
			}), this.eventManager.on("beforeSubmit", async (e, t) => {
				if (await t(), e.controller.store.loading) return;
				let n = e.controller.store.state.input, r = e.controller.store.merchandising?.redirect;
				if (this.config?.settings?.redirects?.merchandising && n && r) return this.track.redirect({
					redirectURL: r,
					responseId: e.controller.store.merchandising?.responseId
				}), window.location.href = r, !1;
				if (this.config?.settings?.redirects?.singleResult) {
					let { results: t } = e.controller.store, n = t.filter((e) => e.type == "product"), r = n.length === 1 && n[0].mappings.core?.url;
					if (r) return window.location.href = r, !1;
				}
			}), this.use(this.config);
		}
		get params() {
			let e = this.urlManager.state, t = (0, Fy.default)({ ...oy(e) }, this.config.globals || {}), { userId: n, sessionId: r, pageLoadId: i, shopperId: a } = this.tracker.getContext();
			if (t.tracking = t.tracking || {}, t.tracking.domain = window.location.href, n && (t.tracking.userId = n), r && (t.tracking.sessionId = r), i && (t.tracking.pageLoadId = i), this.store.state.input && (t.search = t.search || {}, t.search.input = this.store.state.input), this.store.state.source && (t.search = t.search || {}, t.search.source = this.store.state.source), !this.config.globals?.personalization?.disabled) {
				let e = this.tracker.cookies.cart.get();
				e.length && (t.personalization = t.personalization || {}, t.personalization.cart = e.join(","));
				let n = this.tracker.cookies.viewed.get();
				n.length && (t.personalization = t.personalization || {}, t.personalization.lastViewed = n.join(",")), a && (t.personalization = t.personalization || {}, t.personalization.shopper = a);
			}
			return t;
		}
		async setFocused(e) {
			if (this.store.state.focusedInput !== e) {
				this.store.state.focusedInput = e;
				try {
					try {
						await this.eventManager.fire("focusChange", { controller: this });
					} catch (e) {
						if (e?.message == "cancelled") this.log.warn("'focusChange' middleware cancelled");
						else throw this.log.error("error in 'focusChange' middleware"), e;
					}
				} catch (e) {
					e && console.error(e);
				}
			}
			e?.dispatchEvent(new Event("input"));
		}
		reset() {
			document.querySelectorAll(this.config.selector).forEach((e) => {
				e.value = "";
			}), this.store.reset();
		}
		unbind() {
			document.querySelectorAll(`input[${Iy}]`)?.forEach((e) => {
				e.removeEventListener("input", this.handlers.input.input), e.removeEventListener("keydown", this.handlers.input.enterKey), e.removeEventListener("keydown", this.handlers.input.escKey), e.removeEventListener("focus", this.handlers.input.focus), e.form && (e.form.removeEventListener("submit", this.handlers.input.formSubmit), Py(e.form, this.handlers.input.formElementChange));
			}), document.removeEventListener("click", this.handlers.document.click);
		}
		async bind() {
			this.initialized || await this.init(), this.unbind(), document.querySelectorAll(this.config.selector).forEach((e) => {
				e.setAttribute("spellcheck", "false"), e.setAttribute("autocomplete", "off"), e.setAttribute("autocorrect", "off"), e.setAttribute("autocapitalize", "none"), e.setAttribute(Iy, ""), this.config.settings?.bind?.input && e.addEventListener("input", this.handlers.input.input), this.config?.settings?.initializeFromUrl && !e.value && this.store.state.input && (e.value = this.store.state.input), e.addEventListener("focus", this.handlers.input.focus), e.addEventListener("keydown", this.handlers.input.escKey);
				let t = e.form, n;
				if (this.config.action) this.config.settings?.bind?.submit && e.addEventListener("keydown", this.handlers.input.enterKey), n = this.config.action;
				else if (t) {
					if (this.config.settings?.bind?.submit && t.addEventListener("submit", this.handlers.input.formSubmit), n = t.action || "", this.config.settings?.serializeForm) {
						Ny(t, this.handlers.input.formElementChange, function(t) {
							return t != e;
						});
						let n = My(t, function(t) {
							return t != e;
						});
						this.store.setService("urlManager", this.urlManager.reset().withGlobals(n));
					}
				} else this.config.settings?.bind?.submit && this.log.warn("Missing form action url! Input element is not inside a <form> and no 'action' URL is configured. Enter key will not submit. Set the 'action' url in the config to enable submission.", e);
				n && this.store.setService("urlManager", this.store.services.urlManager.withConfig((e) => ({
					...e,
					urlRoot: n
				}))), document.activeElement === e && !this.store.loading && this.setFocused(e);
			}), this.config.settings?.trending?.enabled && this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && !this.store.trending?.length && this.searchTrending(), this.config.settings?.disableClickOutside || document.addEventListener("click", this.handlers.document.click);
		}
	}, Hy = [
		"file",
		"reset",
		"submit",
		"button",
		"image",
		"password"
	];
})), Wy, Gy, Ky, qy = o((() => {
	Wy = /* @__PURE__ */ u(R()), ry(), ay(), ly(), _y(), Gy = {
		id: "recommend",
		beacon: { enabled: !0 },
		tag: "",
		batched: !0,
		realtime: !1,
		globals: {}
	}, Ky = class extends iy {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			if (super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = cy.recommendation, this.beaconType = "recommendations", this.events = {}, this.track = { product: {
				clickThrough: (e, t) => {
					if (!t) {
						this.log.warn("No result provided to track.product.clickThrough");
						return;
					}
					let n = t.responseId;
					if (!this.events[n]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (this.events[n]?.product[t.id]?.productClickThrough) return;
					let r = ["product", "banner"].includes(t.type) ? t.type : "product", i = {
						type: r,
						uid: t.id ? "" + t.id : "",
						...r === "product" ? {
							parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
							sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
						} : {}
					}, a = {
						tag: this.store.profile.tag,
						responseId: n,
						results: [i]
					};
					this.eventManager.fire("track.product.clickThrough", {
						controller: this,
						event: e,
						product: t,
						trackEvent: a
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].clickThrough({
						data: a,
						siteId: this.config.globals?.siteId
					}), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0;
				},
				click: (e, t) => {
					if (!t) {
						this.log.warn("No result provided to track.product.click");
						return;
					}
					let n = t.responseId;
					if (!this.events[n]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (t.type === "banner") {
						if (this.events[n]?.product[t.id]?.inlineBannerClickThrough) return;
						this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
							this.events[n].product[t.id].inlineBannerClickThrough = !1;
						}, hy);
					} else if (gy(e, t)) {
						if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
						this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
							this.events[n].product[t.id].productClickThrough = !1;
						}, hy);
					}
				},
				impression: (e) => {
					if (!e) {
						this.log.warn("No result provided to track.product.impression");
						return;
					}
					let t = e.responseId;
					if (!this.events[t]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (this.events[t]?.product[e.id]?.impression) return;
					let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
						type: n,
						uid: e.id ? "" + e.id : "",
						...n === "product" ? {
							parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
							sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
						} : {}
					}, i = {
						tag: this.store.profile.tag,
						responseId: t,
						results: [r],
						banners: []
					};
					this.eventManager.fire("track.product.impression", {
						controller: this,
						product: e,
						trackEvent: i
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].impression({
						data: i,
						siteId: this.config.globals?.siteId
					}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
				},
				addToCart: (e) => {
					if (!e) {
						this.log.warn("No result provided to track.product.addToCart");
						return;
					}
					let t = e.responseId;
					if (!this.events[t]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					let n = {
						parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
						uid: e.display.mappings.core?.uid || e.display.id,
						sku: e.display.mappings.core?.sku,
						qty: e.quantity || 1,
						price: Number(e.display.mappings.core?.price) || 0
					}, r = {
						responseId: t,
						tag: this.store.profile.tag,
						results: [n]
					};
					this.eventManager.fire("track.product.addToCart", {
						controller: this,
						product: e,
						trackEvent: r
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].addToCart({
						data: r,
						siteId: this.config.globals?.siteId
					});
				}
			} }, this.search = async () => {
				try {
					this.initialized || await this.init();
					let e = this.params;
					this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, profile: r, results: i, responseId: a } = await this.client.recommend(e);
					t.stop(), this.log.profile(t), this.events[a] = this.events[a] || { product: {} };
					let o = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								profile: r,
								results: i
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), o.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					o.stop(), this.log.profile(o), this.store.update({
						meta: n,
						profile: r,
						results: i,
						responseId: a
					}), this.beaconType = this.store.profile.type === "bundle" ? "bundles" : "recommendations";
					let s = {
						responseId: a,
						tag: this.store.profile.tag
					};
					this.config.beacon?.enabled && this.tracker.events[this.beaconType].render({
						data: s,
						siteId: this.config.globals?.siteId
					});
					let c = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								profile: r,
								results: i,
								responseId: a
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), c.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					c.stop(), this.log.profile(c);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: ty.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: ty.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: ty.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: ty.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to recommendation controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, !e.tag) throw Error("Invalid config passed to RecommendationController. The \"tag\" attribute is required.");
			e.settings?.searchOnPageShow !== !1 && window.addEventListener("pageshow", (e) => {
				e.persisted && !this.store.error && this.store.loaded && !this.store.loading && this.search();
			}), this.config = (0, Wy.default)(Gy, this.config), this.store.setConfig(this.config), this.use(this.config);
		}
		get params() {
			let e = {
				tag: this.config.tag,
				batched: this.config.batched,
				branch: this.config.branch || "production",
				batchId: this.config.batchId,
				...this.config.globals
			}, { shopperId: t } = this.tracker.getContext();
			if (t && (e.shopper = t), !e.siteId || e.siteId == this.tracker.getGlobals().siteId) {
				let t = this.tracker.cookies.cart.get(), n = this.tracker.cookies.viewed.get();
				t?.length && (e.cart = t), n?.length && (e.lastViewed = n);
			}
			return e;
		}
	};
})), Jy = o((() => {
	py(), ky(), Uy(), qy(), ay(), ly();
})), Yy = ["merge", "set"], Xy = [
	"query",
	"tag",
	"fallbackQuery"
], Zy = (e, t) => {
	let { parameters: n } = e, r = e.settings?.useDefaultIgnoreParameters ?? !0, i = e?.settings?.ignoreParameters || [];
	i = r ? i.concat(Xy) : i;
	let a = t, o = t.merge({});
	return Object.keys(n).forEach((e) => {
		let t = n[e].action || "merge", { state: r } = n[e], s = n[e].ignoreParameters || [], c = n[e].useGlobalIgnoreParameters ?? !0 ? i.concat(s) : s, l = Object.keys(a.state).filter((e) => !c.includes(e)).length == 0;
		r && l && Yy.includes(t) && (o = o[t](e, r));
	}), o;
}, Qy = /* @__PURE__ */ s(((e, t) => {
	(function() {
		function n(e) {
			var t = typeof Symbol == "function" && Symbol.for && Symbol.for("react.element"), r = 60103, i = { use_static: !1 };
			a(e) && e.use_static !== void 0 && (i.use_static = !!e.use_static);
			function a(e) {
				return typeof e == "object" && !Array.isArray(e) && e !== null;
			}
			function o(e) {
				var t = Object.getPrototypeOf(e);
				return t ? Object.create(t) : {};
			}
			function s(e, t, n) {
				Object.defineProperty(e, t, {
					enumerable: !1,
					configurable: !1,
					writable: !1,
					value: n
				});
			}
			function c(e, t) {
				s(e, t, function() {
					throw new y("The " + t + " method cannot be invoked on an Immutable data structure.");
				});
			}
			var l = "__immutable_invariants_hold";
			function u(e) {
				s(e, l, !0);
			}
			function d(e) {
				return typeof e != "object" || !e || !!Object.getOwnPropertyDescriptor(e, l);
			}
			function f(e, t) {
				return e === t || e !== e && t !== t;
			}
			function p(e) {
				return typeof e == "object" && !!e && !Array.isArray(e) && !(e instanceof Date);
			}
			var m = ["setPrototypeOf"], h = ["keys"], g = m.concat([
				"push",
				"pop",
				"sort",
				"splice",
				"shift",
				"unshift",
				"reverse"
			]), _ = h.concat([
				"map",
				"filter",
				"slice",
				"concat",
				"reduce",
				"reduceRight"
			]), v = m.concat([
				"setDate",
				"setFullYear",
				"setHours",
				"setMilliseconds",
				"setMinutes",
				"setMonth",
				"setSeconds",
				"setTime",
				"setUTCDate",
				"setUTCFullYear",
				"setUTCHours",
				"setUTCMilliseconds",
				"setUTCMinutes",
				"setUTCMonth",
				"setUTCSeconds",
				"setYear"
			]);
			function y(e) {
				this.name = "MyError", this.message = e, this.stack = (/* @__PURE__ */ Error()).stack;
			}
			y.prototype = /* @__PURE__ */ Error(), y.prototype.constructor = Error;
			function b(e, t) {
				for (var n in u(e), t) t.hasOwnProperty(n) && c(e, t[n]);
				return Object.freeze(e), e;
			}
			function x(e, t) {
				var n = e[t];
				s(e, t, function() {
					return k(n.apply(e, arguments));
				});
			}
			function S(e, t, n) {
				var r = n && n.deep;
				if (e in this && (r && this[e] !== t && p(t) && p(this[e]) && (t = k.merge(this[e], t, {
					deep: !0,
					mode: "replace"
				})), f(this[e], t))) return this;
				var i = ne.call(this);
				return i[e] = k(t), T(i);
			}
			var C = k([]);
			function w(e, t, n) {
				var r = e[0];
				if (e.length === 1) return S.call(this, r, t, n);
				var i = e.slice(1), a = this[r], o;
				if (typeof a == "object" && a) o = k.setIn(a, i, t);
				else {
					var s = i[0];
					o = s !== "" && isFinite(s) ? w.call(C, i, t) : le.call(ce, i, t);
				}
				if (r in this && a === o) return this;
				var c = ne.call(this);
				return c[r] = o, T(c);
			}
			function T(e) {
				for (var t in _) if (_.hasOwnProperty(t)) {
					var n = _[t];
					x(e, n);
				}
				i.use_static || (s(e, "flatMap", ee), s(e, "asObject", re), s(e, "asMutable", ne), s(e, "set", S), s(e, "setIn", w), s(e, "update", de), s(e, "updateIn", pe), s(e, "getIn", me));
				for (var r = 0, a = e.length; r < a; r++) e[r] = k(e[r]);
				return b(e, g);
			}
			function E(e) {
				return i.use_static || s(e, "asMutable", D), b(e, v);
			}
			function D() {
				return new Date(this.getTime());
			}
			function ee(e) {
				if (arguments.length === 0) return this;
				var t = [], n = this.length, r;
				for (r = 0; r < n; r++) {
					var i = e(this[r], r, this);
					Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
				}
				return T(t);
			}
			function te(e) {
				if (e === void 0 && arguments.length === 0) return this;
				if (typeof e != "function") {
					var t = Array.isArray(e) ? e.slice() : Array.prototype.slice.call(arguments);
					t.forEach(function(e, t, n) {
						typeof e == "number" && (n[t] = e.toString());
					}), e = function(e, n) {
						return t.indexOf(n) !== -1;
					};
				}
				var n = o(this);
				for (var r in this) this.hasOwnProperty(r) && e(this[r], r) === !1 && (n[r] = this[r]);
				return O(n);
			}
			function ne(e) {
				var t = [], n, r;
				if (e && e.deep) for (n = 0, r = this.length; n < r; n++) t.push(ie(this[n]));
				else for (n = 0, r = this.length; n < r; n++) t.push(this[n]);
				return t;
			}
			function re(e) {
				typeof e != "function" && (e = function(e) {
					return e;
				});
				var t = {}, n = this.length, r;
				for (r = 0; r < n; r++) {
					var i = e(this[r], r, this), a = i[0];
					t[a] = i[1];
				}
				return O(t);
			}
			function ie(e) {
				return !e || typeof e != "object" || !Object.getOwnPropertyDescriptor(e, l) || e instanceof Date ? e : k.asMutable(e, { deep: !0 });
			}
			function ae(e, t) {
				for (var n in e) Object.getOwnPropertyDescriptor(e, n) && (t[n] = e[n]);
				return t;
			}
			function oe(e, t) {
				if (arguments.length === 0) return this;
				if (typeof e != "object" || !e) throw TypeError("Immutable#merge can only be invoked with objects or arrays, not " + JSON.stringify(e));
				var n = Array.isArray(e), r = t && t.deep, i = t && t.mode || "merge", a = t && t.merger, s;
				function c(e, n, i) {
					var c = k(n[i]), l = a && a(e[i], c, t), u = e[i];
					if (s !== void 0 || l !== void 0 || !e.hasOwnProperty(i) || !f(c, u)) {
						var d = l === void 0 ? r && p(u) && p(c) ? k.merge(u, c, t) : c : l;
						(!f(u, d) || !e.hasOwnProperty(i)) && (s === void 0 && (s = ae(e, o(e))), s[i] = d);
					}
				}
				function l(e, t) {
					for (var n in e) t.hasOwnProperty(n) || (s === void 0 && (s = ae(e, o(e))), delete s[n]);
				}
				var u;
				if (n) for (var d = 0, m = e.length; d < m; d++) {
					var h = e[d];
					for (u in h) h.hasOwnProperty(u) && c(s === void 0 ? this : s, h, u);
				}
				else {
					for (u in e) Object.getOwnPropertyDescriptor(e, u) && c(this, e, u);
					i === "replace" && l(this, e);
				}
				return s === void 0 ? this : O(s);
			}
			function se(e, t) {
				var n = t && t.deep;
				if (arguments.length === 0) return this;
				if (typeof e != "object" || !e) throw TypeError("Immutable#replace can only be invoked with objects or arrays, not " + JSON.stringify(e));
				return k.merge(this, e, {
					deep: n,
					mode: "replace"
				});
			}
			var ce = k({});
			function le(e, t, n) {
				if (!Array.isArray(e) || e.length === 0) throw TypeError("The first argument to Immutable#setIn must be an array containing at least one \"key\" string.");
				var r = e[0];
				if (e.length === 1) return ue.call(this, r, t, n);
				var i = e.slice(1), a, s = this[r];
				if (a = this.hasOwnProperty(r) && typeof s == "object" && s ? k.setIn(s, i, t) : le.call(ce, i, t), this.hasOwnProperty(r) && s === a) return this;
				var c = ae(this, o(this));
				return c[r] = a, O(c);
			}
			function ue(e, t, n) {
				var r = n && n.deep;
				if (this.hasOwnProperty(e) && (r && this[e] !== t && p(t) && p(this[e]) && (t = k.merge(this[e], t, {
					deep: !0,
					mode: "replace"
				})), f(this[e], t))) return this;
				var i = ae(this, o(this));
				return i[e] = k(t), O(i);
			}
			function de(e, t) {
				var n = Array.prototype.slice.call(arguments, 2), r = this[e];
				return k.set(this, e, t.apply(r, [r].concat(n)));
			}
			function fe(e, t) {
				for (var n = 0, r = t.length; e != null && n < r; n++) e = e[t[n]];
				return n && n == r ? e : void 0;
			}
			function pe(e, t) {
				var n = Array.prototype.slice.call(arguments, 2), r = fe(this, e);
				return k.setIn(this, e, t.apply(r, [r].concat(n)));
			}
			function me(e, t) {
				var n = fe(this, e);
				return n === void 0 ? t : n;
			}
			function he(e) {
				var t = o(this), n;
				if (e && e.deep) for (n in this) this.hasOwnProperty(n) && (t[n] = ie(this[n]));
				else for (n in this) this.hasOwnProperty(n) && (t[n] = this[n]);
				return t;
			}
			function ge() {
				return {};
			}
			function O(e) {
				return i.use_static || (s(e, "merge", oe), s(e, "replace", se), s(e, "without", te), s(e, "asMutable", he), s(e, "set", ue), s(e, "setIn", le), s(e, "update", de), s(e, "updateIn", pe), s(e, "getIn", me)), b(e, m);
			}
			function _e(e) {
				return typeof e == "object" && !!e && (e.$$typeof === r || e.$$typeof === t);
			}
			function ve(e) {
				return typeof File < "u" && e instanceof File;
			}
			function ye(e) {
				return typeof Blob < "u" && e instanceof Blob;
			}
			function be(e) {
				return typeof e == "object" && typeof e.then == "function";
			}
			function xe(e) {
				return e instanceof Error;
			}
			function k(e, t, n) {
				if (d(e) || _e(e) || ve(e) || ye(e) || xe(e)) return e;
				if (be(e)) return e.then(k);
				if (Array.isArray(e)) return T(e.slice());
				if (e instanceof Date) return E(new Date(e.getTime()));
				var r = t && t.prototype, i = (!r || r === Object.prototype ? ge : (function() {
					return Object.create(r);
				}))();
				if (n ??= 64, n <= 0) throw new y("Attempt to construct Immutable from a deeply nested object was detected. Have you tried to wrap an object with circular references (e.g. React element)? See https://github.com/rtfeldman/seamless-immutable/wiki/Deeply-nested-object-was-detected for details.");
				for (var a in --n, e) Object.getOwnPropertyDescriptor(e, a) && (i[a] = k(e[a], void 0, n));
				return O(i);
			}
			function Se(e) {
				function t() {
					var t = [].slice.call(arguments), n = t.shift();
					return e.apply(n, t);
				}
				return t;
			}
			function Ce(e, t) {
				function n() {
					var n = [].slice.call(arguments), r = n.shift();
					return Array.isArray(r) ? t.apply(r, n) : e.apply(r, n);
				}
				return n;
			}
			function we(e, t, n) {
				function r() {
					var r = [].slice.call(arguments), i = r.shift();
					return Array.isArray(i) ? t.apply(i, r) : i instanceof Date ? n.apply(i, r) : e.apply(i, r);
				}
				return r;
			}
			return k.from = k, k.isImmutable = d, k.ImmutableError = y, k.merge = Se(oe), k.replace = Se(se), k.without = Se(te), k.asMutable = we(he, ne, D), k.set = Ce(ue, S), k.setIn = Ce(le, w), k.update = Se(de), k.updateIn = Se(pe), k.getIn = Se(me), k.flatMap = Se(ee), k.asObject = Se(re), i.use_static || (k.static = n({ use_static: !0 })), Object.freeze(k), k;
		}
		var r = n();
		/* istanbul ignore if */
		typeof define == "function" && define.amd ? define(function() {
			return r;
		}) : typeof t == "object" ? t.exports = r : typeof e == "object" ? e.Immutable = r : typeof window == "object" ? window.Immutable = r : typeof global == "object" && (global.Immutable = r);
	})();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/UrlManager/UrlManager.js
function $y(e) {
	return Array.isArray(e) && e.length ? e.reduce((e, t) => (e.some((e) => tb(e, t)) || e.push(t), e), [e[0]]) : e;
}
function eb(e, t) {
	if (e instanceof Array && t instanceof Array) return $y([...e, ...t]);
}
function tb(e, t) {
	if (!e && !t) return !0;
	if (!e && t || e && !t) return !1;
	let n = [
		"string",
		"number",
		"boolean",
		"undefined"
	], r = typeof e;
	if (r !== typeof t) return !1;
	if (n.includes(r)) return e === t;
	let i = Array.isArray(e);
	if (i !== Array.isArray(t)) return !1;
	if (i) {
		if (e.length != t.length) return !1;
		for (let n = 0; n < e.length; n++) if (!tb(e[n], t[n])) return !1;
	} else {
		if (!tb(Object.keys(e).sort(), Object.keys(t).sort())) return !1;
		let n = !0;
		return Object.keys(e).forEach((r) => {
			tb(e[r], t[r]) || (n = !1);
		}), n;
	}
	return !0;
}
var nb, rb, ib, ab = o((() => {
	nb = /* @__PURE__ */ u(Qy()), rb = class {
		constructor() {
			this.callbacks = [];
		}
		subscribe(e) {
			return this.callbacks.push(e), () => this.callbacks = this.callbacks.filter((t) => t != e);
		}
		notify() {
			this.callbacks.forEach((e) => e());
		}
	}, ib = class e {
		constructor(e, t, n, r, i, a = [], o) {
			this.linker = t, this.omissions = a, this.detached = o, this.urlState = (0, nb.default)({}), this.globalState = (0, nb.default)({}), this.localState = (0, nb.default)({}), this.mergedState = (0, nb.default)({}), this.localState = (0, nb.default)(r || {}), this.globalState = (0, nb.default)(n || {}), this.translator = e;
			let s = this.getTranslatorConfig();
			s.urlRoot && s.settings?.serializeUrlRoot && (this.globalState = this.globalState.merge((0, nb.default)(this.translator.deserialize(s.urlRoot)), {
				deep: !0,
				merger: eb
			})), i ? this.watcherPool = i : (this.watcherPool = new rb(), this.translator.bindExternalEvents instanceof Function && this.translator.bindExternalEvents(() => this.watcherPool.notify())), this.subscribe(() => {
				this.refresh();
			}), this.refresh();
		}
		without(e, t, n) {
			let r = t.slice(0, -1), i = t[t.length - 1];
			if (!r.length) return n?.length ? a(i, e) : e.without(i);
			if (!e.getIn(r)) return e;
			return e.updateIn(r, (e) => a(i, e));
			function a(e, t) {
				return t[i] === void 0 ? t : t[i] instanceof Array ? !n || !n.length ? t.without(i) : t.set(i, t[i].filter((e) => !n.some((t) => tb(e, t)))) : typeof t == "object" ? t.without(i) : t;
			}
		}
		getTranslatorUrl() {
			return this.detached ? this.detached.url : this.translator.getCurrentUrl();
		}
		refresh() {
			this.prevState = this.mergedState, this.urlState = this.omissions.reduce((e, t) => this.without(e, t.path, t.values), (0, nb.default)(this.translator.deserialize(this.getTranslatorUrl()))), this.mergedState = this.globalState.merge(this.urlState, {
				deep: !0,
				merger: eb
			}), this.mergedState = this.mergedState.merge(this.localState, {
				deep: !0,
				merger: eb
			});
		}
		get state() {
			return this.mergedState;
		}
		unpackPathAndState(e, t) {
			return {
				path: e instanceof Array ? e : typeof e == "string" ? e.split(".") : [],
				state: !(e instanceof Array) && typeof e == "object" ? e : t === void 0 ? {} : t
			};
		}
		set(...t) {
			let { path: n, state: r } = this.unpackPathAndState(t[0], t[1]), i = n.length ? this.localState.setIn(n, $y(r)) : $y(r), a = $y(this.omissions.concat(n.length ? { path: n } : Object.keys(this.urlState).map((e) => ({ path: [e] }))));
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, a, this.detached);
		}
		merge(...t) {
			let { path: n, state: r } = this.unpackPathAndState(t[0], t[1]), i = n.length ? this.localState.updateIn(n, (e) => {
				if (e instanceof Array) {
					let t = Array.isArray(r) ? r : [r];
					return $y(e.concat(t));
				}
				if (typeof e == "object") return Array.isArray(r) ? r.length ? $y([e].concat(r)) : e : e.merge(r, {
					deep: !0,
					merger: eb
				});
				if (e !== void 0) {
					let t = (Array.isArray(r) ? r : [r]).filter((t) => !tb(t, e));
					return t.length ? $y([e].concat(t)) : e;
				}
				return e === void 0 && this.urlState.getIn(n) instanceof Array && !Array.isArray(r) ? [r] : r;
			}) : this.localState.merge(r, {
				deep: !0,
				merger: eb
			});
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, this.omissions, this.detached);
		}
		remove(t, n) {
			let { path: r } = this.unpackPathAndState(t, {});
			n = n === void 0 ? [] : n instanceof Array ? n : [n];
			let i = this.without(this.localState, r, n), a = $y(this.omissions.concat({
				path: r,
				values: n
			}));
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, a, this.detached);
		}
		reset() {
			return this.detached && (this.detached.url = ""), new e(this.translator, this.linker, this.globalState, {}, this.watcherPool, Object.keys(this.urlState).map((e) => ({ path: [e] })), this.detached);
		}
		withConfig(t) {
			return t instanceof Function && (t = t(this.translator.getConfig())), new e(new (Object.getPrototypeOf(this.translator)).constructor(t), this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
		}
		withGlobals(t) {
			return this.globalState = this.globalState.merge((0, nb.default)(t), {
				deep: !0,
				merger: eb
			}), new e(this.translator, this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
		}
		getTranslatorConfig() {
			return this.translator.getConfig();
		}
		get href() {
			return this.translator.serialize(this.state);
		}
		go(e) {
			this.detached ? this.detached.url = this.href : this.translator.go(this.href, e), this.watcherPool.notify();
		}
		detach(t = !1) {
			return new e(this.translator, this.linker, this.globalState, this.localState, new rb(), this.omissions, { url: t ? "" : this.getTranslatorUrl() });
		}
		get link() {
			return this.linker ? this.linker(this) : {};
		}
		subscribe(e) {
			return this.watcherPool.subscribe(() => {
				let t = this.prevState, n = this.mergedState;
				e(t, n);
			});
		}
	};
})), ob, Z, sb = o((() => {
	(function(e) {
		e.LOW = "low", e.HIGH = "high";
	})(ob ||= {}), (function(e) {
		e.hash = "hash", e.query = "query";
	})(Z ||= {});
})), cb = o((() => {
	R(), Qy();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/Translators/Url/UrlTranslator.js
function lb(e) {
	return typeof e == "string" && (e = e.replace(/%2425/g, "$$25"), e = e.replace(/\$25/g, "%"), e = decodeURIComponent(e)), e;
}
function ub(e) {
	return typeof e == "string" && (e = encodeURIComponent(e), e = e.replace(/%/g, "$$25")), e;
}
var db, fb, pb, mb, hb = o((() => {
	db = /* @__PURE__ */ u(R()), sb(), fb = {
		urlRoot: "",
		settings: {
			corePrefix: "",
			customType: Z.query,
			serializeUrlRoot: !0
		},
		parameters: {
			core: {
				query: {
					name: "q",
					type: Z.query
				},
				rq: {
					name: "rq",
					type: Z.query
				},
				tag: {
					name: "tag",
					type: Z.query
				},
				page: {
					name: "page",
					type: Z.query
				},
				pageSize: {
					name: "pageSize",
					type: Z.hash
				},
				sort: {
					name: "sort",
					type: Z.hash
				},
				filter: {
					name: "filter",
					type: Z.hash
				},
				fallbackQuery: {
					name: "fallbackQuery",
					type: Z.query
				}
			},
			custom: {}
		}
	}, pb = [
		"query",
		"fallbackQuery",
		"rq",
		"tag",
		"page",
		"pageSize",
		"sort",
		"filter"
	], mb = class {
		constructor(e) {
			this.reverseMapping = {}, this.coreNames = {}, this.config = (0, db.default)(fb, e || {}), Object.keys(this.config.parameters.core).forEach((t) => {
				let n = this.config.parameters.core[t], r = this.config.settings.corePrefixParams, i = (!r || r.includes(t)) && this.config.settings.corePrefix || "";
				this.coreNames[t] = i + n.name;
				let a = this.config.settings?.coreType;
				a && Object.values(Z).includes(a) && (n.type = e?.parameters?.core && e.parameters?.core[t]?.type ? e.parameters?.core[t]?.type : a), this.reverseMapping[this.coreNames[t]] = t;
			});
			let t = this.config.settings?.customType;
			t && !Object.values(Z).includes(t) && (this.config.settings.customType = Z.hash);
		}
		bindExternalEvents(e) {
			window.addEventListener("popstate", e);
		}
		getCurrentUrl() {
			return window.location.search + window.location.hash;
		}
		getConfig() {
			return (0, db.default)({}, this.config);
		}
		deserialize(e) {
			let t = this.parseUrlParams(e);
			return this.paramsToState(t);
		}
		parseUrlParams(e) {
			let t = e.includes("?") && (e.split("?").pop() || "").split("#").shift() || "", n = e.includes("#") && e.substring(e.indexOf("#") + 1) || "";
			return [...this.parseHashString(n), ...this.parseQueryString(t)];
		}
		parseQueryString(e) {
			return (e.split("?").pop() || "").split("&").filter((e) => e).map((e) => {
				try {
					let [t, n] = e.split("=").map((e) => decodeURIComponent(e.replace(/\+/g, " ")));
					return {
						key: t.split("."),
						value: n,
						type: Z.query
					};
				} catch {
					return console.warn("Snap UrlTranslator: URI malformed - ignoring parameter", e), {
						key: ["ss__delete"],
						value: "ss__delete",
						type: Z.query
					};
				}
			}).filter((e) => {
				let t = this.reverseMapping[e.key[0]];
				return e.value === "ss__delete" ? "" : !t || t && e.value;
			});
		}
		parseHashString(e) {
			let t = [];
			return (e.split("#").pop() || "").split("/").filter((e) => e).map((e) => {
				try {
					return e.split(":").map((e) => lb(e));
				} catch {
					return console.warn("Snap UrlTranslator: URI malformed - ignoring parameter", e), [];
				}
			}).filter((e) => {
				let [t, n] = e, r = this.reverseMapping[t];
				return !r || r && n;
			}).forEach((e) => {
				if (e.length == 1) t.push({
					key: [e[0]],
					value: "",
					type: Z.hash
				});
				else if (e.length && e.length >= 2) {
					let n = this.reverseMapping[e[0]];
					if (n && n == "filter" && e.length == 4) {
						let [n, r, i, a] = e;
						t.push({
							key: [
								n,
								r,
								"low"
							],
							value: i,
							type: Z.hash
						}), t.push({
							key: [
								n,
								r,
								"high"
							],
							value: a,
							type: Z.hash
						});
					} else {
						let [n, ...r] = e.reverse();
						t.push({
							key: r.reverse(),
							value: n,
							type: Z.hash
						});
					}
				}
			}), t;
		}
		paramsToState(e) {
			let t = [], n = [], r = [], i = [];
			return e?.forEach((e) => {
				let a = this.reverseMapping[e.key[0]], o = this.config.parameters.core[a], s = this.config.parameters.custom[e.key[0]];
				if (a) switch (a) {
					case "filter":
						o.type == e.type && n.push(e);
						break;
					case "sort":
						o.type == e.type && r.push(e);
						break;
					default: o.type == e.type && t.push(e);
				}
				else pb.includes(e.key[0]) || (s || (this.config.parameters.custom[e.key[0]] = { type: e.type || this.config.settings.customType }), i.push(e));
			}), {
				...this.parseCoreOther(t),
				...this.parseCoreFilter(n),
				...this.parseCoreSort(r),
				...this.parseOther(i)
			};
		}
		parseCoreOther(e) {
			let t = {}, n = ["page", "pageSize"];
			return e ? (e.forEach((e) => {
				let r = this.reverseMapping[e.key[0]];
				if (n.includes(r)) {
					let n = Number(e.value);
					(r == "page" && n > 1 || r != "page") && (t[r] = n);
				} else t[r] = e.value;
			}), t) : {};
		}
		parseCoreFilter(e) {
			let t = e.filter((e) => e.key.length == 2), n = e.filter((e) => e.key.length == 3), r = t.reduce((e, t) => {
				let n = (e.filter || {})[t.key[1]] || [];
				return { filter: {
					...e.filter,
					[t.key[1]]: [...Array.isArray(n) ? n : [n], t.value]
				} };
			}, {}), i = n.reduce((e, t, r) => {
				let i = e, a = n[r + 1];
				if (r % 2 == 0 && a && a.key[1] == t.key[1] && t.key[2] == ob.LOW && a.key[2] == ob.HIGH) {
					let n = (e.filter || {})[t.key[1]] || [];
					i = { filter: {
						...e.filter,
						[t.key[1]]: [...Array.isArray(n) ? n : [n], {
							[ob.LOW]: isNaN(+t.value) ? null : +t.value,
							[ob.HIGH]: isNaN(+a.value) ? null : +a.value
						}]
					} };
				}
				return i;
			}, {});
			return { ...r.filter || i.filter ? { filter: {
				...r.filter,
				...i.filter
			} } : {} };
		}
		parseCoreSort(e) {
			return e.length ? { sort: e.map((e) => ({
				field: e.key[1],
				direction: e.value
			})) } : {};
		}
		parseOther(e) {
			let t = {};
			return e.forEach((e) => {
				let n = t;
				e.key.forEach((t, r) => {
					r == e.key.length - 1 ? (n[t] = n[t] || [], e.value && n[t].push(e.value)) : (n[t] = n[t] || {}, n = n[t]);
				});
			}), t;
		}
		serialize(e) {
			let t = this.config.urlRoot.includes("?") ? this.config.urlRoot.split("?")[0] : this.config.urlRoot.includes("#") ? this.config.urlRoot.split("#")[0] : this.config.urlRoot || window.location.pathname, n = this.stateToParams(e), r = n.filter((e) => e.type == Z.query), i = n.filter((e) => e.type == Z.hash);
			return `${t}${r.length ? "?" + r.map((e) => encodeURIComponent(e.key.join(".")) + (e.value ? "=" + encodeURIComponent(e.value) : "")).join("&") : ""}${i.length ? "#/" + i.map((e) => e.key.map((e) => ub(e)).join(":") + (e.value ? ":" + ub(e.value) : "")).join("/") : ""}`;
		}
		stateToParams(e) {
			return [
				...this.encodeOther(e),
				...this.encodeCoreOther(e, ["filter", "sort"]),
				...this.encodeCoreFilters(e),
				...this.encodeCoreSorts(e)
			];
		}
		encodeCoreFilters(e) {
			let t = this.config.parameters.core.filter, n = this.coreNames.filter;
			return !e.filter || !t ? [] : Object.keys(e.filter).flatMap((r) => {
				if (!e.filter || !e.filter[r]) return [];
				let i = e.filter[r];
				return (i instanceof Array ? i : [i]).flatMap((e) => {
					if (typeof e == "string" || typeof e == "number" || typeof e == "boolean") return [{
						key: [n, r],
						value: "" + e,
						type: t.type
					}];
					if (typeof e == "object" && e[ob.LOW] !== void 0 && e[ob.HIGH] !== void 0) {
						if (t.type == Z.query) return [{
							key: [
								n,
								r,
								ob.LOW
							],
							value: "" + (e[ob.LOW] ?? "*"),
							type: t.type
						}, {
							key: [
								n,
								r,
								ob.HIGH
							],
							value: "" + (e[ob.HIGH] ?? "*"),
							type: t.type
						}];
						if (t.type == Z.hash) return [{
							key: [
								n,
								r,
								"" + (e[ob.LOW] ?? "*")
							],
							value: "" + (e[ob.HIGH] ?? "*"),
							type: t.type
						}];
					}
					return [];
				});
			});
		}
		encodeCoreSorts(e) {
			let t = this.config.parameters.core.sort;
			return !e.sort || !t ? [] : (e.sort instanceof Array ? e.sort : [e.sort]).map((e) => ({
				key: [this.coreNames.sort, e.field],
				value: e.direction,
				type: t.type
			}));
		}
		encodeCoreOther(e, t) {
			let n = [];
			return Object.keys(e).sort(function(e, t) {
				return pb.indexOf(e) - pb.indexOf(t);
			}).map((r) => {
				if (pb.includes(r) && !t.includes(r)) {
					let t = this.config.parameters.core[r];
					r == "page" && e[r] == 1 || n.push({
						key: [this.coreNames[r]],
						value: "" + e[r],
						type: t.type
					});
				}
			}), n;
		}
		encodeOther(e) {
			let t = [], n = (e, r) => {
				Object.keys(e).forEach((i) => {
					if (r.length == 0 && pb.includes(i)) return;
					let a = e[i];
					if (a instanceof Array) {
						let e = this.config.parameters.custom[r[0] || i]?.type || this.config.settings.customType;
						t = a.length ? t.concat(a.map((t) => ({
							key: [...r, i],
							value: t,
							type: e
						}))) : t.concat({
							key: [...r, i],
							value: "",
							type: e
						});
					} else if (typeof a == "object" && Object.keys(a || {}).length) n(a, [...r, i]);
					else {
						let e = this.config.parameters.custom[r[0] || i]?.type || this.config.settings.customType, n = typeof a == "object" ? void 0 : a;
						t = t.concat([{
							key: [...r, i],
							value: n,
							type: e
						}]);
					}
				});
			};
			return n(e, []), t;
		}
		go(e, t) {
			e != this.getCurrentUrl() && (t?.history == "replace" ? history.replaceState(null, "", e) : history.pushState(null, "", e));
		}
	};
})), gb = o((() => {})), _b = o((() => {
	cb(), hb(), gb();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/linkers/react/react.js
function vb(e) {
	return {
		href: e.href,
		onClick: (t) => {
			e?.detached || t?.preventDefault(), e.go();
		}
	};
}
var yb = o((() => {})), bb = o((() => {
	yb();
})), xb = o((() => {
	ab(), _b(), bb();
})), Sb, Cb, wb = o((() => {
	Sb = class {
		constructor(e) {
			this.namespace = e || "", this.profiles = [];
		}
		setNamespace(e) {
			this.namespace ||= e;
		}
		create({ type: e, name: t, context: n }) {
			if (!t) throw Error("Profile name is required.");
			let r = new Cb(this.namespace, {
				type: e,
				name: t,
				context: n
			});
			return this.profiles.push(r), r;
		}
	}, Cb = class {
		constructor(e, { type: t, name: n, context: r }) {
			this.status = "pending", this.time = {
				date: 0,
				begin: 0,
				end: 0,
				run: 0
			}, this.namespace = e, this.type = t, this.name = n, this.context = r;
		}
		start() {
			return this.time.begin || (this.time.date = Date.now(), this.time.begin = window.performance.now(), this.status = "started"), this;
		}
		stop() {
			return !this.time.end && this.time.begin && (this.time.date = Date.now(), this.time.end = window.performance.now(), this.time.run = +(this.time.end - this.time.begin).toFixed(3), this.status = "finished"), this;
		}
	};
})), Tb = o((() => {
	wb();
})), Eb = /* @__PURE__ */ c({ default: () => Db }), Db, Ob = o((() => {
	Jy(), _d(), ry(), xb(), Kv(), Tb(), wd(), u_(), Db = (e, t) => {
		let n = t?.urlManager || new ib(new mb(e.url), vb);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Oy(e.controller, {
			client: t?.client || new hd(e.client.globals, e.client.config),
			store: t?.store || new Lv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new Uv(),
			profiler: t?.profiler || new Sb(),
			logger: t?.logger || new Sd({ mode: e.mode }),
			tracker: t?.tracker || new s_(e.client.globals)
		}, e.context);
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/src/utils/configureSnapFeatures/configureSnapFeatures.js
function kb(e) {
	Ab(e);
}
function Ab(e) {
	let t;
	try {
		t = window.sessionStorage?.getItem(jb);
	} catch {}
	if (t) try {
		if (JSON.parse(t)?.enabled) {
			let t = [
				"product.view",
				"cart.view",
				"order.transaction"
			];
			e.tracker = e.tracker || {}, e.tracker.config = e.tracker.config || {}, e.tracker.config.doNotTrack = (e.tracker.config.doNotTrack || []).concat(t);
		}
	} catch {}
}
var jb, Mb = o((() => {
	jb = "ssWebPixel";
})), Nb = o((() => {
	Mb();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/src/setupEvents.js
Kv();
var Pb = () => {
	let e = new Uv();
	return e.on("controller/selectVariantOptions", async (e, t) => {
		let { options: n, controllerIds: r } = e;
		Fb(r).map((e) => {
			e.store?.results && e.store?.results.forEach((e) => {
				e.type == "product" && e.variants?.makeSelections(n);
			});
		}), await t();
	}), e.on("controller/recommendation/update", async (e, t) => {
		let { controllerIds: n } = e || {};
		Fb(n).filter((e) => !!(e.type === "recommendation" && e.config?.realtime)).map((e) => {
			e.search();
		}), await t();
	}), e;
}, Fb = (e) => Object.keys(window.athos.controller || {}).reduce((t, n) => {
	let r = window.athos.controller[n];
	return (!e || (Array.isArray(e) && e.forEach((e) => {
		if (e instanceof RegExp) {
			if (n.match(e)?.length) return t.push(r), t;
		} else if (n == e) return t.push(r), t;
	}), typeof e == "string" && e === n)) && t.push(r), t;
}, []), Ib = /* @__PURE__ */ c({ default: () => Lb }), Lb, Rb = o((() => {
	Jy(), _d(), ry(), xb(), Kv(), Tb(), wd(), u_(), Lb = (e, t) => {
		let { globals: n, ...r } = e.url || {}, i = (t?.urlManager || new ib(new mb(r), vb)).detach();
		return n?.length && (i = i.withGlobals(Object.fromEntries(n.map(({ param: e, value: t }) => [e, [t]])))), e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Vy(e.controller, {
			client: t?.client || new hd(e.client.globals, e.client.config),
			store: t?.store || new Ev(e.controller, { urlManager: i }),
			urlManager: i,
			eventManager: t?.eventManager || new Uv(),
			profiler: t?.profiler || new Sb(),
			logger: t?.logger || new Sd({ mode: e.mode }),
			tracker: t?.tracker || new s_(e.client.globals)
		}, e.context);
	};
})), zb = /* @__PURE__ */ c({ default: () => Bb }), Bb, Vb = o((() => {
	Jy(), _d(), ry(), xb(), Kv(), Tb(), wd(), u_(), Bb = (e, t) => {
		let n = (t?.urlManager || new ib(new mb(e.url), vb)).detach(!0);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new fy(e.controller, {
			client: t?.client || new hd(e.client.globals, e.client.config),
			store: t?.store || new Fv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new Uv(),
			profiler: t?.profiler || new Sb(),
			logger: t?.logger || new Sd({ mode: e.mode }),
			tracker: t?.tracker || new s_(e.client.globals)
		}, e.context);
	};
})), Hb = /* @__PURE__ */ c({ default: () => Ub }), Ub, Wb = o((() => {
	Jy(), _d(), ry(), xb(), Kv(), Tb(), wd(), u_(), Ub = (e, t) => {
		let n = (t?.urlManager || new ib(new mb(e.url), vb)).detach(!0);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Ky(e.controller, {
			client: t?.client || new hd(e.client.globals, e.client.config),
			store: t?.store || new $v(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new Uv(),
			profiler: t?.profiler || new Sb(),
			logger: t?.logger || new Sd({ mode: e.mode }),
			tracker: t?.tracker || new s_(e.client.globals)
		}, e.context);
	};
})), Gb = /* @__PURE__ */ c({ getBundleDetails: () => Kb }), Kb, qb = o((() => {
	Kb = async (e) => new Promise((t, n) => {
		let r = new XMLHttpRequest();
		r.open("HEAD", e, !0), r.onreadystatechange = () => {
			if (r.readyState === r.DONE) {
				let i = r.status, a = r.getResponseHeader("Last-Modified");
				a && i === 0 || i >= 200 && i < 400 ? t({
					url: e,
					lastModified: a?.split(",")[1]?.trim() || ""
				}) : n({
					message: "Branch not found!",
					description: "Incorrect branch name or branch no longer exists."
				});
			}
		}, r.onerror = () => n({
			message: "Branch load fail!",
			description: "There was an error with the request."
		}), r.send();
	});
}));
//#endregion
//#region node_modules/@emotion/react/dist/emotion-react.browser.esm.js
function Jb() {
	return Zr([...arguments]);
}
var Yb, Xb = o((() => {
	Ci(), mn(), fi(), ci(), Br(), Yb = function(e, t) {
		var n = arguments;
		if (t == null || !vi.call(t, "css")) return m.apply(void 0, n);
		var r = n.length, i = Array(r);
		i[0] = Si, i[1] = bi(e, t);
		for (var a = 2; a < r; a++) i[a] = n[a];
		return m.apply(null, i);
	};
})), Q = /* @__PURE__ */ s(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})), Zb = o((() => {
	if (Al(), mn(), !Le) throw Error("mobx-react-lite requires React with Hooks support");
	if (!B) throw Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
})), Qb = o((() => {
	mn();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/utils/observerBatching.js
function $b(e) {
	e();
}
function ex(e) {
	e ||= $b, Wo({ reactionScheduler: e });
}
var tx = o((() => {
	Al();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/utils/printDebugValue.js
function nx(e) {
	return Ko(e);
}
var rx = o((() => {
	Al();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/staticRendering.js
function ix() {
	return ax;
}
var ax, ox = o((() => {
	ax = !1;
})), sx, cx, lx, ux, dx = o((() => {
	sx = 1e4, cx = 1e4, lx = function() {
		function e(e) {
			var t = this;
			Object.defineProperty(this, "finalize", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: e
			}), Object.defineProperty(this, "registrations", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: /* @__PURE__ */ new Map()
			}), Object.defineProperty(this, "sweepTimeout", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: void 0
			}), Object.defineProperty(this, "sweep", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: function(e) {
					e === void 0 && (e = sx), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
					var n = Date.now();
					t.registrations.forEach(function(r, i) {
						n - r.registeredAt >= e && (t.finalize(r.value), t.registrations.delete(i));
					}), t.registrations.size > 0 && t.scheduleSweep();
				}
			}), Object.defineProperty(this, "finalizeAllImmediately", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: function() {
					t.sweep(0);
				}
			});
		}
		return Object.defineProperty(e.prototype, "register", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function(e, t, n) {
				this.registrations.set(n, {
					value: t,
					registeredAt: Date.now()
				}), this.scheduleSweep();
			}
		}), Object.defineProperty(e.prototype, "unregister", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function(e) {
				this.registrations.delete(e);
			}
		}), Object.defineProperty(e.prototype, "scheduleSweep", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function() {
				this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, cx));
			}
		}), e;
	}(), ux = typeof FinalizationRegistry < "u" ? FinalizationRegistry : lx;
})), fx, px = o((() => {
	dx(), fx = new ux(function(e) {
		var t;
		(t = e.reaction) == null || t.dispose(), e.reaction = null;
	});
})), mx = /* @__PURE__ */ s(((e) => {
	var t = (mn(), d(pt));
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var f = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? f : t.useSyncExternalStore;
})), hx = /* @__PURE__ */ s(((e, t) => {
	t.exports = mx();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/useObserver.js
function gx(e) {
	e.reaction = new jc(`observer${e.name}`, function() {
		var t;
		e.stateVersion = Symbol(), (t = e.onStoreChange) == null || t.call(e);
	});
}
function _x(e, t) {
	if (t === void 0 && (t = "observed"), ix()) return e();
	var n = P.useRef(null);
	if (!n.current) {
		var r = {
			reaction: null,
			onStoreChange: null,
			stateVersion: Symbol(),
			name: t,
			subscribe: function(e) {
				return fx.unregister(r), r.onStoreChange = e, r.reaction || (gx(r), r.stateVersion = Symbol()), function() {
					var e;
					r.onStoreChange = null, (e = r.reaction) == null || e.dispose(), r.reaction = null;
				};
			},
			getSnapshot: function() {
				return r.stateVersion;
			}
		};
		n.current = r;
	}
	var i = n.current;
	i.reaction || (gx(i), fx.register(n, i, i)), P.useDebugValue(i.reaction, nx), (0, vx.useSyncExternalStore)(i.subscribe, i.getSnapshot, i.getSnapshot);
	var a, o;
	if (i.reaction.track(function() {
		try {
			a = e();
		} catch (e) {
			o = e;
		}
	}), o) throw o;
	return a;
}
var vx, yx = o((() => {
	Al(), mn(), rx(), ox(), px(), vx = hx();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/observer.js
function bx(e, t) {
	if (Tx && e.$$typeof === Tx) throw Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
	if (ix()) return e;
	var n = t?.forwardRef ?? !1, r = e, i = e.displayName || e.name;
	if (wx && e.$$typeof === wx && (n = !0, r = e.render, typeof r != "function")) throw Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
	var a = function(e, t) {
		return _x(function() {
			return r(e, t);
		}, i);
	};
	return a.displayName = e.displayName, Cx && Object.defineProperty(a, "name", {
		value: e.name,
		writable: !0,
		configurable: !0
	}), e.contextTypes && (a.contextTypes = e.contextTypes), n && (a = Ct(a)), a = St(a), xx(e, a), a;
}
function xx(e, t) {
	Object.keys(e).forEach(function(n) {
		Ex[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
	});
}
var Sx, Cx, wx, Tx, Ex, Dx = o((() => {
	mn(), ox(), yx(), Sx = typeof Symbol == "function" && Symbol.for, Cx = Object.getOwnPropertyDescriptor(function() {}, "name")?.configurable ?? !1, wx = Sx ? Symbol.for("react.forward_ref") : typeof Ct == "function" && Ct(function(e) {
		return null;
	}).$$typeof, Tx = Sx ? Symbol.for("react.memo") : typeof St == "function" && St(function(e) {
		return null;
	}).$$typeof, Ex = {
		$$typeof: !0,
		render: !0,
		compare: !0,
		type: !0,
		displayName: !0
	};
})), Ox = o((() => {
	yx();
})), kx = o((() => {
	mn();
})), Ax = o((() => {
	mn();
})), jx = o((() => {
	mn(), Ax();
})), $ = o((() => {
	Zb(), Qb(), tx(), yx(), px(), ox(), Dx(), Ox(), kx(), jx(), Ax(), ex(dn), fx.finalizeAllImmediately;
})), Mx, Nx, Px = o((() => {
	Ei(), Xb(), Lr(), Mx = Ir({
		key: "ss",
		prepend: !0
	}), Nx = (e) => L(mi, {
		value: e.cache || Mx,
		children: e.children
	});
})), Fx = o((() => {
	Ne(), N();
})), Ix = o((() => {
	Ne(), N();
})), Lx = o((() => {
	Ne(), N(), Xb();
})), Rx = o((() => {
	Ne();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/defined.js
function zx(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var Bx = o((() => {})), Vx = o((() => {})), Hx = o((() => {})), Ux = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/mergeProps.js
function Wx(e, t, n, r) {
	let i = r.theme, a = r?.name || n.name, o = r.treePath || n.treePath || "";
	o += `${o ? " " : ""}${e}`;
	let s = { ...n };
	if (t?.type !== "templates") {
		let n = t?.components && t.components[e];
		n && (s = Gx(n, s)), s = {
			...s,
			...r,
			treePath: o
		};
		let a = i?.components && i.components[e];
		a && (s = Gx(a, s));
	} else {
		s = {
			...s,
			...r
		}, o += a?.match(/^[A-Za-z0-9-]+$/) ? `.${a}` : "";
		let e = qx(t?.components || {}, o).sort(Kx), n = e.filter((e) => e.includes("*")), c = e.filter((e) => !e.includes("*")), l = /* @__PURE__ */ new Set();
		n.forEach((e) => {
			let n = t.components?.[e];
			n && (e.replace(/^\*/, "").replace(/\([MDT]\)$/, "").trim().split(" ").length > 1 && Object.keys(n).forEach((e) => l.add(e)), s = Gx(n, s));
		});
		let u = r.theme?.[Jx];
		if (u instanceof Map && u.size > 0) {
			let e = {}, t = Array.from(u.values());
			for (let n of Object.keys(r)) {
				if (n === "treePath" || n === "theme" || n === "name" || l.has(n)) continue;
				let i = r[n];
				i !== void 0 && t.indexOf(i) !== -1 && (e[n] = i);
			}
			Object.keys(e).length > 0 && (s = {
				...s,
				...e
			});
		}
		c.forEach((e) => {
			let n = t.components?.[e];
			n && (s = Gx(n, s, !0));
		}), qx(i?.components || {}, o).sort(Kx).forEach((e) => {
			let t = i?.components?.[e];
			t && (s = Gx(t, s));
		}), s = {
			...s,
			theme: {
				...s.theme,
				name: t.name,
				...t.activeBreakpoint ? { activeBreakpoint: t.activeBreakpoint } : {}
			},
			treePath: o
		}, r.lang && (s.lang = r.lang), t.variables && s.theme && (s.theme.variables = t.variables);
		let d = s[Jx] || /* @__PURE__ */ new Map();
		if (d.size > 0 && s.theme) {
			let e = new Map(d);
			u instanceof Map && u.forEach((t, n) => {
				e.has(n) || e.set(n, t);
			}), s.theme[Jx] = e;
		}
		o && (o.indexOf("customComponent") > -1 || o.startsWith("storybook") && o.split(" ").length == 2) && (s = {
			...s,
			...r,
			treePath: o
		});
	}
	return s;
}
function Gx(e, t, n = !1) {
	if (e) {
		let r = t[Jx] || /* @__PURE__ */ new Map();
		for (let [t, i] of Object.entries(e)) i != null && typeof i != "function" && (!n || !r.has(t)) && r.set(t, i);
		t = {
			...t,
			...e
		}, t[Jx] = r;
	}
	return t;
}
function Kx(e, t) {
	return e.split(" ").map((e, t) => (t * 2) ** (e.includes(".") ? 2 : 1)).reduce((e, t) => e + t, (e.includes("*") ? 0 : 1e3) + (e.match(/\([MDT]\)/) ? 2e3 : 0)) - t.split(" ").map((e, t) => (t * 2) ** (e.includes(".") ? 2 : 1)).reduce((e, t) => e + t, (t.includes("*") ? 0 : 1e3) + (t.match(/\([MDT]\)/) ? 2e3 : 0));
}
function qx(e, t) {
	let n = Object.keys(e), r = t.split(" "), [i, a] = (r.slice(-1).pop() ?? "").split("."), o = r.map((e) => {
		let [t, n] = e.split(".");
		return {
			type: t,
			name: n,
			path: e
		};
	});
	return n = a ? n.filter((e) => {
		let t = e.split(" "), n = t[t.length - 1].replace(/\*?(\([MDT]\))?/g, "");
		if (n == i || n == `${i}.${a}`) return !0;
	}) : n.filter((e) => e.endsWith(i)), n.filter((e) => {
		let t = e.replace(/\*?(\([MDT]\))?/g, "").split(" ").slice(0, -1);
		if (t.length == 0) return !0;
		for (let e = 0; e < t.length; e++) {
			let n = -1, r = t[e];
			for (let t = n == -1 ? 0 : n; t < o.length; t++) {
				let i = o[t];
				if (r === i.path || r === i.type) {
					n = e;
					break;
				}
			}
			if (n == -1) return !1;
		}
		return !0;
	});
}
var Jx, Yx = o((() => {
	Jx = Symbol.for("__themePropsMap__");
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/mergeStyles.js
function Xx(e, t) {
	let { name: n, treePath: r, style: i, styleScript: a, themeStyleScript: o, disableStyles: s } = e, c = {
		"ss-name": n,
		"ss-path": r,
		css: []
	};
	return s || c.css.push(t(e)), o && c.css.push(o(e)), a && c.css.push(a(e)), i && c.css.push(i), c.css?.length == 0 && delete c.css, c;
}
var Zx = o((() => {})), Qx = o((() => {})), $x = o((() => {
	N();
})), eS = o((() => {
	N();
})), tS = o((() => {
	N();
})), nS = o((() => {
	N();
})), rS = o((() => {
	N();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/hooks/useIntersectionAdvanced.js
function iS(e) {
	return e && "checkVisibility" in e ? e.checkVisibility({
		contentVisibilityAuto: !0,
		opacityProperty: !0,
		visibilityProperty: !0
	}) : !0;
}
var aS, oS, sS = o((() => {
	N(), aS = 250, oS = (e, t = {}) => {
		let { rootMargin: n = "0px", fireOnce: r = !1, threshold: i = 0, minVisibleTime: a = 0 } = t, [o, s] = Le(!1), c = Ve(null), l = Ve(null), [u, d] = Le(0), f = We((t) => {
			e.current = t, d((e) => e + 1);
		}, []);
		return ze(() => {
			s(!1);
			let t = null, o = null;
			if (!window.IntersectionObserver || !e.current) return;
			let u = () => {
				o &&= (window.clearInterval(o), null);
			}, d = () => {
				a > 0 ? (l.current = Date.now(), c.current && window.clearTimeout(c.current), c.current = window.setTimeout(() => {
					s(!0), r && e.current && t && t.unobserve(e.current);
				}, a)) : (s(!0), r && e.current && t && t.unobserve(e.current));
			}, f = () => {
				c.current && window.clearTimeout(c.current), c.current = null, l.current = null, s(!1);
			};
			return t = new IntersectionObserver(([t]) => {
				t.isIntersecting ? e.current && iS(e.current) ? (u(), d()) : (f(), o ||= window.setInterval(() => {
					if (!e.current) {
						u();
						return;
					}
					iS(e.current) && (u(), d());
				}, aS)) : (u(), f());
			}, {
				rootMargin: n,
				threshold: i
			}), e.current && t.observe(e.current), () => {
				s(!1), u(), c.current && window.clearTimeout(c.current), t && e.current && t.unobserve(e.current);
			};
		}, [e, u]), {
			inViewport: o,
			updateRef: f
		};
	};
})), cS = o((() => {
	N();
})), lS = o((() => {
	N();
})), uS = o((() => {
	N();
})), dS = o((() => {})), fS = o((() => {
	N();
})), pS, mS = o((() => {
	N(), pS = (e, t) => {
		let [n, r] = Le(void 0), [i, a] = Le(!1);
		return ze(() => {
			let n = !0;
			if (!t) return r(void 0), () => {
				n = !1;
			};
			a(!1);
			let i = e[t];
			if (i && typeof i == "function") {
				let e = i();
				e instanceof Promise ? e.then((e) => {
					n && r(() => e);
				}).catch((e) => {
					n && (a(!0), r(void 0), console.warn(`Failed to load component "${t}".`, e));
				}) : n && r(() => e);
			} else r(void 0), console.warn(`Component "${t}" not found in component map.`);
			return () => {
				n = !1;
			};
		}, [e, t]), {
			ComponentOverride: n,
			shouldWaitForNamedOverride: !!(t && typeof e[t] == "function") && !n && !i
		};
	};
})), hS, gS = o((() => {
	Ei(), HS(), mS(), hS = (e, t) => {
		let n = LS()?.templates?.library.import.component?.[e] || {}, { customComponent: r } = t, { ComponentOverride: i, shouldWaitForNamedOverride: a } = pS(n, r), o = r && i ? L(i, {
			...t,
			customComponent: void 0
		}) : null;
		return {
			overrideElement: o,
			shouldRenderDefault: !a && !o,
			shouldWaitForNamedOverride: a
		};
	};
})), _S = o((() => {
	N();
})), vS = o((() => {
	eS(), tS(), nS(), rS(), sS(), lS(), uS(), dS(), cS(), fS(), mS(), gS(), _S();
})), yS = o((() => {
	Q(), $();
})), bS = o((() => {
	yS();
})), xS = o((() => {
	Q(), $();
})), SS = o((() => {
	xS();
})), CS = o((() => {
	Q(), $();
})), wS = o((() => {
	CS();
})), TS = o((() => {
	Q(), $();
})), ES = o((() => {
	TS();
})), DS = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/createImpressionObserver.js
function OS(e) {
	let t = Ve(null), { inViewport: n, updateRef: r } = oS(t, {
		...e,
		fireOnce: !0,
		threshold: kS,
		minVisibleTime: AS
	});
	return {
		ref: t,
		inViewport: n,
		updateRef: r
	};
}
var kS, AS, jS = o((() => {
	N(), vS(), kS = .7, AS = 1e3;
})), MS = o((() => {
	Rx(), Bx(), Vx(), Hx(), Ux(), Yx(), Zx(), Qx(), $x(), DS(), jS();
})), NS = o((() => {
	N();
})), PS = o((() => {})), FS = o((() => {})), IS, LS, RS = o((() => {
	Ne(), N(), IS = he(void 0), IS.Provider, LS = () => Ge(IS);
})), zS, BS, VS = o((() => {
	Ne(), N(), zS = he(null), zS.Provider, BS = () => Ge(zS) || void 0;
})), HS = o((() => {
	Px(), Fx(), Ix(), Lx(), NS(), PS(), FS(), RS(), VS();
})), US, WS, GS = o((() => {
	US = {
		layoutGrid2: "M25.846 34.461v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM25.846 8.615v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM56 34.461v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM56 8.615v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308z",
		layoutGrid3: "M16 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3z"
	}, WS = {
		"angle-up": "M56 39.671c0 0.449-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.786 0.561-1.291 0.561-0.449 0-0.954-0.224-1.291-0.561l-22.052-22.052-22.052 22.052c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z",
		"angle-down": "M56 16.329c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-26.148-26.148c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.786-0.561 1.291-0.561 0.449 0 0.954 0.224 1.291 0.561l22.052 22.052 22.052-22.052c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l2.806 2.806c0.337 0.337 0.561 0.842 0.561 1.291z",
		"angle-left": "M44.329 4.657c0 0.449-0.224 0.954-0.561 1.291l-22.052 22.052 22.052 22.052c0.337 0.337 0.561 0.842 0.561 1.291s-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-26.148-26.148c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l2.806 2.806c0.337 0.337 0.561 0.786 0.561 1.291z",
		"angle-right": "M44.329 28c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.786-0.561-1.291 0-0.449 0.224-0.954 0.561-1.291l22.052-22.052-22.052-22.052c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z",
		bag: "M46.5435 18.6657C46.142 15.4166 43.9379 13.1711 40.4449 13.1711H37.3295C36.8838 5.75827 35.1521 0 28.4228 0C21.5677 0 19.8993 5.75827 19.4922 13.1711H16.1019C12.6083 13.1711 10.3416 15.5058 10.0027 18.6657L6.01336 49.5651L6 49.7409C6 53.1533 8.79407 56 12.1 56H44.4455C47.7521 56 50.5455 53.1407 50.5455 49.729L46.5435 18.6657ZM28.4228 3.29383C32.3475 3.29383 33.6011 6.58138 33.9913 13.1704H22.8164C23.1574 6.58138 24.3442 3.29383 28.4228 3.29383ZM44.4455 52.7055H12.1C10.6488 52.7055 9.372 51.4045 9.32279 49.8448L13.3226 18.7676C13.5301 17.0614 14.8195 16.4643 16.1019 16.4643H19.3833C19.3608 17.2881 19.3601 19.3249 19.3601 20.7598C19.3601 21.6694 20.1032 22.4311 21.02 22.4311C21.9369 22.4311 22.6807 21.6589 22.6807 20.7486C22.6807 19.2391 22.6871 17.2888 22.7096 16.4643H34.1242C34.1544 17.2881 34.1656 19.2635 34.1656 20.7598C34.1656 21.6694 34.9081 22.4311 35.8256 22.4311C36.7418 22.4311 37.4856 21.6589 37.4856 20.7486C37.4856 19.3465 37.4842 18.1119 37.4575 16.4643H40.4449C41.7266 16.4643 42.995 17.0397 43.2235 18.7787L47.2234 49.8218C47.1742 51.3808 45.8981 52.7055 44.4455 52.7055Z",
		ban: "M47.769 27.982c0-3.961-1.163-7.631-3.162-10.72l-27.4 27.364c3.125 2.035 6.832 3.234 10.793 3.234 10.902 0 19.769-8.903 19.769-19.878zM11.465 38.848l27.437-27.4c-3.125-2.108-6.868-3.307-10.902-3.307-10.902 0-19.769 8.903-19.769 19.842 0 4.034 1.199 7.74 3.234 10.866zM55.909 27.982c0 15.481-12.501 28.018-27.909 28.018s-27.909-12.537-27.909-28.018c0-15.445 12.501-27.982 27.909-27.982s27.909 12.537 27.909 27.982z",
		check: "M56 14.921c0 0.903-0.361 1.806-1.012 2.457l-31.071 31.071c-0.65 0.65-1.554 1.012-2.457 1.012s-1.806-0.361-2.457-1.012l-17.992-17.992c-0.65-0.65-1.012-1.554-1.012-2.457s0.361-1.806 1.012-2.457l4.914-4.914c0.65-0.65 1.554-1.012 2.457-1.012s1.806 0.361 2.457 1.012l10.622 10.658 23.701-23.737c0.65-0.65 1.554-1.012 2.457-1.012s1.806 0.361 2.457 1.012l4.914 4.914c0.65 0.65 1.012 1.554 1.012 2.457z",
		"check-thin": "M17.771 40.395l33.749-33.749 4.48 4.48-38.229 38.229-17.771-17.771 4.48-4.48z",
		"chevron-up": "M55.349 39.589l-5.769 5.734c-0.869 0.869-2.259 0.869-3.128 0l-18.452-18.452-18.452 18.452c-0.869 0.869-2.259 0.869-3.128 0l-5.769-5.734c-0.869-0.869-0.869-2.293 0-3.162l25.785-25.75c0.869-0.869 2.259-0.869 3.128 0l25.785 25.75c0.869 0.869 0.869 2.293 0 3.162z",
		"chevron-down": "M55.348 19.573l-25.785 25.75c-0.869 0.869-2.259 0.869-3.128 0l-25.785-25.75c-0.869-0.869-0.869-2.293 0-3.162l5.768-5.734c0.869-0.869 2.259-0.869 3.128 0l18.452 18.452 18.452-18.452c0.869-0.869 2.259-0.869 3.128 0l5.768 5.734c0.869 0.869 0.869 2.293 0 3.162z",
		"chevron-left": "M45.34 9.548l-18.452 18.452 18.452 18.452c0.869 0.869 0.869 2.259 0 3.128l-5.769 5.769c-0.869 0.869-2.259 0.869-3.128 0l-25.785-25.785c-0.869-0.869-0.869-2.259 0-3.128l25.785-25.785c0.869-0.869 2.259-0.869 3.128 0l5.769 5.769c0.869 0.869 0.869 2.259 0 3.128z",
		"chevron-right": "M45.34 29.564l-25.785 25.785c-0.869 0.869-2.259 0.869-3.128 0l-5.768-5.768c-0.869-0.869-0.869-2.259 0-3.128l18.452-18.452-18.452-18.452c-0.869-0.869-0.869-2.259 0-3.128l5.768-5.768c0.869-0.869 2.259-0.869 3.128 0l25.785 25.785c0.869 0.869 0.869 2.259 0 3.128z",
		circle: "M56 28c0 15.458-12.542 28-28 28s-28-12.542-28-28 12.542-28 28-28 28 12.542 28 28z",
		close: "M56 45.064c0 1.178-0.471 2.357-1.32 3.205l-6.411 6.411c-0.849 0.849-2.027 1.32-3.205 1.32s-2.357-0.471-3.205-1.32l-13.859-13.859-13.859 13.859c-0.849 0.849-2.027 1.32-3.205 1.32s-2.357-0.471-3.205-1.32l-6.411-6.411c-0.849-0.849-1.32-2.027-1.32-3.205s0.471-2.357 1.32-3.205l13.859-13.859-13.859-13.859c-0.849-0.849-1.32-2.027-1.32-3.205s0.471-2.357 1.32-3.205l6.411-6.411c0.849-0.849 2.027-1.32 3.205-1.32s2.357 0.471 3.205 1.32l13.859 13.859 13.859-13.859c0.849-0.849 2.027-1.32 3.205-1.32s2.357 0.471 3.205 1.32l6.411 6.411c0.849 0.849 1.32 2.027 1.32 3.205s-0.471 2.357-1.32 3.205l-13.859 13.859 13.859 13.859c0.849 0.849 1.32 2.027 1.32 3.205z",
		"close-thin": "M56 5.638l-22.362 22.362 22.362 22.362-5.638 5.638-22.362-22.362-22.362 22.362-5.638-5.638 22.362-22.362-22.362-22.362 5.638-5.638 22.362 22.362 22.362-22.362z",
		cog: "M37.333 28c0-5.141-4.193-9.333-9.333-9.333s-9.333 4.193-9.333 9.333 4.193 9.333 9.333 9.333 9.333-4.193 9.333-9.333zM56 24.026v8.094c0 0.547-0.438 1.203-1.021 1.312l-6.745 1.021c-0.401 1.167-0.839 2.26-1.422 3.318 1.24 1.786 2.552 3.391 3.901 5.031 0.219 0.255 0.365 0.583 0.365 0.911s-0.109 0.583-0.328 0.839c-0.875 1.167-5.797 6.526-7.036 6.526-0.328 0-0.656-0.146-0.948-0.328l-5.031-3.938c-1.057 0.547-2.188 1.021-3.318 1.385-0.255 2.224-0.474 4.594-1.057 6.781-0.146 0.583-0.656 1.021-1.312 1.021h-8.094c-0.656 0-1.24-0.474-1.312-1.094l-1.021-6.708c-1.13-0.365-2.224-0.802-3.281-1.349l-5.141 3.901c-0.255 0.219-0.583 0.328-0.911 0.328s-0.656-0.146-0.911-0.401c-1.932-1.75-4.484-4.010-6.016-6.125-0.182-0.255-0.255-0.547-0.255-0.839 0-0.328 0.109-0.583 0.292-0.839 1.24-1.677 2.589-3.281 3.828-4.995-0.62-1.167-1.13-2.37-1.495-3.609l-6.672-0.984c-0.62-0.109-1.057-0.693-1.057-1.312v-8.094c0-0.547 0.438-1.203 0.984-1.312l6.781-1.021c0.365-1.167 0.839-2.26 1.422-3.354-1.24-1.75-2.552-3.391-3.901-5.031-0.219-0.255-0.365-0.547-0.365-0.875s0.146-0.583 0.328-0.839c0.875-1.203 5.797-6.526 7.036-6.526 0.328 0 0.656 0.146 0.948 0.365l5.031 3.901c1.057-0.547 2.188-1.021 3.318-1.385 0.255-2.224 0.474-4.594 1.057-6.781 0.146-0.583 0.656-1.021 1.312-1.021h8.094c0.656 0 1.24 0.474 1.312 1.094l1.021 6.708c1.13 0.365 2.224 0.802 3.281 1.349l5.177-3.901c0.219-0.219 0.547-0.328 0.875-0.328s0.656 0.146 0.911 0.365c1.932 1.786 4.484 4.047 6.016 6.198 0.182 0.219 0.255 0.51 0.255 0.802 0 0.328-0.109 0.583-0.292 0.839-1.24 1.677-2.589 3.281-3.828 4.995 0.62 1.167 1.13 2.37 1.495 3.573l6.672 1.021c0.62 0.109 1.057 0.693 1.057 1.312z",
		cogs: "M26.133 27.985c0-4.113-3.354-7.467-7.467-7.467s-7.467 3.354-7.467 7.467 3.354 7.467 7.467 7.467 7.467-3.354 7.467-7.467zM48.533 42.919c0-2.042-1.692-3.733-3.733-3.733s-3.733 1.692-3.733 3.733c0 2.071 1.692 3.733 3.733 3.733 2.071 0 3.733-1.692 3.733-3.733zM48.533 13.052c0-2.042-1.692-3.733-3.733-3.733s-3.733 1.692-3.733 3.733c0 2.071 1.692 3.733 3.733 3.733 2.071 0 3.733-1.692 3.733-3.733zM37.333 25.331v5.396c0 0.379-0.292 0.817-0.671 0.875l-4.521 0.7c-0.233 0.758-0.554 1.487-0.933 2.217 0.817 1.167 1.692 2.246 2.625 3.354 0.117 0.175 0.204 0.35 0.204 0.583 0 0.204-0.058 0.408-0.204 0.554-0.583 0.787-3.85 4.346-4.696 4.346-0.233 0-0.438-0.088-0.613-0.204l-3.354-2.625c-0.729 0.379-1.458 0.671-2.246 0.904-0.146 1.487-0.292 3.092-0.671 4.521-0.117 0.408-0.467 0.7-0.875 0.7h-5.425c-0.408 0-0.817-0.321-0.875-0.729l-0.671-4.462c-0.758-0.233-1.488-0.554-2.188-0.904l-3.442 2.596c-0.146 0.146-0.379 0.204-0.583 0.204-0.233 0-0.438-0.087-0.612-0.233-0.758-0.7-4.2-3.821-4.2-4.667 0-0.204 0.087-0.379 0.204-0.554 0.846-1.108 1.721-2.188 2.567-3.325-0.408-0.788-0.758-1.575-1.021-2.392l-4.433-0.7c-0.408-0.058-0.7-0.438-0.7-0.846v-5.396c0-0.379 0.292-0.817 0.671-0.875l4.521-0.7c0.233-0.758 0.554-1.488 0.933-2.217-0.817-1.167-1.692-2.246-2.625-3.354-0.117-0.175-0.204-0.379-0.204-0.583s0.058-0.408 0.204-0.583c0.583-0.787 3.85-4.317 4.696-4.317 0.233 0 0.438 0.087 0.612 0.204l3.354 2.625c0.729-0.379 1.458-0.671 2.246-0.933 0.146-1.458 0.292-3.063 0.671-4.492 0.117-0.408 0.467-0.7 0.875-0.7h5.425c0.408 0 0.817 0.321 0.875 0.729l0.671 4.463c0.758 0.233 1.488 0.554 2.188 0.904l3.442-2.596c0.175-0.146 0.379-0.204 0.583-0.204 0.233 0 0.438 0.088 0.613 0.233 0.758 0.7 4.2 3.85 4.2 4.667 0 0.204-0.087 0.379-0.204 0.554-0.846 1.138-1.721 2.188-2.537 3.325 0.379 0.787 0.729 1.575 0.992 2.392l4.433 0.671c0.408 0.087 0.7 0.467 0.7 0.875zM56 40.877v4.083c0 0.438-3.762 0.846-4.346 0.904-0.233 0.554-0.525 1.050-0.875 1.517 0.263 0.583 1.488 3.5 1.488 4.025 0 0.087-0.029 0.146-0.117 0.204-0.35 0.204-3.471 2.071-3.617 2.071-0.379 0-2.567-2.917-2.858-3.354-0.292 0.029-0.583 0.058-0.875 0.058s-0.583-0.029-0.875-0.058c-0.292 0.438-2.479 3.354-2.858 3.354-0.146 0-3.267-1.867-3.617-2.071-0.087-0.058-0.117-0.146-0.117-0.204 0-0.496 1.225-3.442 1.488-4.025-0.35-0.467-0.642-0.963-0.875-1.517-0.583-0.058-4.346-0.467-4.346-0.904v-4.083c0-0.438 3.762-0.846 4.346-0.904 0.233-0.525 0.525-1.050 0.875-1.517-0.262-0.583-1.488-3.529-1.488-4.025 0-0.058 0.029-0.146 0.117-0.204 0.35-0.175 3.471-2.042 3.617-2.042 0.379 0 2.567 2.887 2.858 3.325 0.292-0.029 0.583-0.058 0.875-0.058s0.583 0.029 0.875 0.058c0.817-1.137 1.692-2.275 2.683-3.267l0.175-0.058c0.146 0 3.267 1.837 3.617 2.042 0.087 0.058 0.117 0.146 0.117 0.204 0 0.525-1.225 3.442-1.488 4.025 0.35 0.467 0.642 0.992 0.875 1.517 0.583 0.058 4.346 0.467 4.346 0.904zM56 11.010v4.083c0 0.438-3.762 0.846-4.346 0.904-0.233 0.554-0.525 1.050-0.875 1.517 0.263 0.583 1.488 3.5 1.488 4.025 0 0.088-0.029 0.146-0.117 0.204-0.35 0.204-3.471 2.071-3.617 2.071-0.379 0-2.567-2.917-2.858-3.354-0.292 0.029-0.583 0.058-0.875 0.058s-0.583-0.029-0.875-0.058c-0.292 0.438-2.479 3.354-2.858 3.354-0.146 0-3.267-1.867-3.617-2.071-0.087-0.058-0.117-0.146-0.117-0.204 0-0.496 1.225-3.442 1.488-4.025-0.35-0.467-0.642-0.963-0.875-1.517-0.583-0.058-4.346-0.467-4.346-0.904v-4.083c0-0.438 3.762-0.846 4.346-0.904 0.233-0.525 0.525-1.050 0.875-1.517-0.262-0.583-1.488-3.529-1.488-4.025 0-0.058 0.029-0.146 0.117-0.204 0.35-0.175 3.471-2.042 3.617-2.042 0.379 0 2.567 2.888 2.858 3.325 0.292-0.029 0.583-0.058 0.875-0.058s0.583 0.029 0.875 0.058c0.817-1.138 1.692-2.275 2.683-3.267l0.175-0.058c0.146 0 3.267 1.837 3.617 2.042 0.087 0.058 0.117 0.146 0.117 0.204 0 0.525-1.225 3.442-1.488 4.025 0.35 0.467 0.642 0.992 0.875 1.517 0.583 0.058 4.346 0.467 4.346 0.904z",
		dollar: "M42.565 37.031c0 6.375-4.563 11.406-11.187 12.5v5.469c0 0.563-0.438 1-1 1h-4.219c-0.531 0-1-0.438-1-1v-5.469c-7.312-1.031-11.312-5.406-11.469-5.594-0.312-0.375-0.344-0.906-0.063-1.281l3.219-4.219c0.156-0.219 0.438-0.344 0.719-0.375s0.563 0.063 0.75 0.281c0.063 0.031 4.438 4.219 9.969 4.219 3.063 0 6.375-1.625 6.375-5.156 0-3-3.688-4.469-7.906-6.156-5.625-2.219-12.625-5.031-12.625-12.875 0-5.75 4.5-10.5 11.031-11.75v-5.625c0-0.563 0.469-1 1-1h4.219c0.563 0 1 0.438 1 1v5.5c6.344 0.719 9.719 4.156 9.844 4.281 0.312 0.344 0.375 0.812 0.156 1.187l-2.531 4.563c-0.156 0.281-0.406 0.469-0.719 0.5-0.312 0.063-0.594-0.031-0.844-0.219-0.031-0.031-3.812-3.375-8.5-3.375-3.969 0-6.719 1.969-6.719 4.812 0 3.312 3.812 4.781 8.25 6.5 5.75 2.219 12.25 4.75 12.25 12.281z",
		envelope: "M56 20.188v24.812c0 2.75-2.25 5-5 5h-46c-2.75 0-5-2.25-5-5v-24.812c0.938 1.031 2 1.938 3.156 2.719 5.187 3.531 10.437 7.063 15.531 10.781 2.625 1.938 5.875 4.312 9.281 4.312h0.063c3.406 0 6.656-2.375 9.281-4.312 5.094-3.688 10.344-7.25 15.562-10.781 1.125-0.781 2.188-1.687 3.125-2.719zM56 11c0 3.5-2.594 6.656-5.344 8.562-4.875 3.375-9.781 6.75-14.625 10.156-2.031 1.406-5.469 4.281-8 4.281h-0.063c-2.531 0-5.969-2.875-8-4.281-4.844-3.406-9.75-6.781-14.594-10.156-2.219-1.5-5.375-5.031-5.375-7.875 0-3.063 1.656-5.688 5-5.688h46c2.719 0 5 2.25 5 5z",
		error: "M28 0c15.458 0 28 12.542 28 28s-12.542 28-28 28-28-12.542-28-28 12.542-28 28-28zM32.667 45.464v-6.927c0-0.656-0.51-1.203-1.13-1.203h-7c-0.656 0-1.203 0.547-1.203 1.203v6.927c0 0.656 0.547 1.203 1.203 1.203h7c0.62 0 1.13-0.547 1.13-1.203zM32.594 32.922l0.656-22.641c0-0.255-0.109-0.51-0.365-0.656-0.219-0.182-0.547-0.292-0.875-0.292h-8.021c-0.328 0-0.656 0.109-0.875 0.292-0.255 0.146-0.365 0.401-0.365 0.656l0.62 22.641c0 0.51 0.547 0.911 1.24 0.911h6.745c0.656 0 1.203-0.401 1.24-0.911z",
		eye: "M28 20.374q3.098 0 5.362 2.264t2.264 5.362-2.264 5.362-5.362 2.264-5.362-2.264-2.264-5.362 2.264-5.362 5.362-2.264zM28 40.749q5.243 0 8.996-3.753t3.753-8.996-3.753-8.996-8.996-3.753-8.996 3.753-3.753 8.996 3.753 8.996 8.996 3.753zM28 8.936q9.413 0 17.038 5.243t10.962 13.821q-3.336 8.579-10.962 13.821t-17.038 5.243-17.038-5.243-10.962-13.821q3.336-8.579 10.962-13.821t17.038-5.243z",
		"eye-thin": "M52 28c-2.969-4.594-7.031-8.531-11.906-11.031 1.25 2.125 1.906 4.563 1.906 7.031 0 7.719-6.281 14-14 14s-14-6.281-14-14c0-2.469 0.656-4.906 1.906-7.031-4.875 2.5-8.938 6.437-11.906 11.031 5.344 8.25 13.969 14 24 14s18.656-5.75 24-14zM29.5 16c0-0.812-0.687-1.5-1.5-1.5-5.219 0-9.5 4.281-9.5 9.5 0 0.812 0.687 1.5 1.5 1.5s1.5-0.687 1.5-1.5c0-3.563 2.937-6.5 6.5-6.5 0.812 0 1.5-0.687 1.5-1.5zM56 28c0 0.781-0.25 1.5-0.625 2.156-5.75 9.469-16.281 15.844-27.375 15.844s-21.625-6.406-27.375-15.844c-0.375-0.656-0.625-1.375-0.625-2.156s0.25-1.5 0.625-2.156c5.75-9.437 16.281-15.844 27.375-15.844s21.625 6.406 27.375 15.844c0.375 0.656 0.625 1.375 0.625 2.156z",
		filter: "M25.519 21.889c0 0-0.241-4.089-0.241-4.089s0-13.471 0-13.471c0.002-1.162-0.005-2.636 0.825-3.553 1.104-1.224 3.156-0.929 4.022 0.435 0.498 0.787 0.443 1.744 0.445 2.636 0 0 0 25.258 0 25.258s-5.052 0-5.052 0c0 0 0-7.217 0-7.217zM42.358 3.848c0.019-1.576 0.281-3.476 2.165-3.794 2.798-0.471 3.125 2.24 3.127 4.275 0 0 0 11.546 0 11.546s-2.646-0.233-2.646-0.233c0 0-2.646 0.233-2.646 0.233s0-12.028 0-12.028zM8.44 3.848c0.014-1.181 0.147-2.442 1.229-3.163 1.484-0.986 3.286-0.156 3.825 1.479 0.322 0.984 0.238 2.545 0.238 3.608 0 0 0 6.014 0 6.014s-2.646-0.197-2.646-0.197c0 0-2.646 0.197-2.646 0.197s0-7.938 0-7.938zM13.010 13.556c5.509 1.855 5.477 10.377-1.203 11.551-5.121 0.902-8.455-5.015-5.867-9.23 0.907-1.475 2.314-2.151 3.943-2.535 1.176-0.166 1.985-0.171 3.127 0.214zM46.207 28.993c-5.564 1.051-8.874-4.833-6.348-9.028 1.046-1.737 2.533-2.357 4.424-2.774 7.57-0.883 9.36 10.399 1.924 11.802zM13.732 26.46c0 0 0 24.536 0 24.536-0.002 1.215-0.067 3.079-0.844 4.063-1.066 1.352-3.094 1.222-3.984-0.226-0.496-0.808-0.462-1.958-0.464-2.875 0 0 0-25.499 0-25.499s5.292 0 5.292 0zM33.219 33.436c1.936 3.286-0.019 8.15-3.851 8.821-1.169 0.207-3.019 0.135-4.089-0.402-4.71-2.355-4.39-9.803 1.443-11.193 2.673-0.375 5.056 0.33 6.497 2.774zM45.004 30.77c0 0 2.646-0.221 2.646-0.221s0 21.409 0 21.409c-0.002 1.034 0.034 2.215-0.649 3.074-0.977 1.224-3.017 1.224-3.993 0-0.637-0.799-0.645-1.867-0.649-2.834 0 0 0-21.65 0-21.65s2.646 0.221 2.646 0.221zM27.684 43.998c0 0 2.887-0.219 2.887-0.219s0 8.66 0 8.66c-0.022 1.758-0.654 3.861-2.887 3.517-1.912-0.296-2.384-2.114-2.406-3.757 0 0 0-8.419 0-8.419s2.406 0.219 2.406 0.219z",
		filters: [
			{
				type: "path",
				attributes: {
					x1: "1",
					y1: "17",
					x2: "55",
					y2: "17",
					"stroke-width": "4",
					"stroke-linecap": "round",
					"stroke-linejoin": "round",
					stroke: "currentColor"
				}
			},
			{
				type: "line",
				attributes: {
					x1: "1",
					y1: "39",
					x2: "55",
					y2: "39",
					"stroke-width": "4",
					"stroke-linecap": "round",
					"stroke-linejoin": "round",
					stroke: "currentColor"
				}
			},
			{
				type: "circle",
				attributes: {
					cx: "18",
					cy: "17",
					r: "8",
					fill: "white",
					"stroke-width": "4",
					stroke: "currentColor"
				}
			},
			{
				type: "circle",
				attributes: {
					cx: "38",
					cy: "39",
					r: "8",
					fill: "white",
					stroke: "currentColor",
					"stroke-width": "4"
				}
			}
		],
		bullet: [{
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "20",
				"stroke-width": "3",
				fill: "white",
				stroke: "currentColor"
			}
		}, {
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "13",
				"stroke-width": "0"
			}
		}],
		"bullet-o": [{
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "20",
				"stroke-width": "3",
				fill: "white",
				stroke: "currentColor"
			}
		}],
		heart: "M28 52c-0.5 0-1-0.188-1.375-0.563l-19.5-18.813c-0.25-0.219-7.125-6.5-7.125-14 0-9.156 5.594-14.625 14.938-14.625 5.469 0 10.594 4.312 13.062 6.75 2.469-2.437 7.594-6.75 13.062-6.75 9.344 0 14.938 5.469 14.938 14.625 0 7.5-6.875 13.781-7.156 14.063l-19.469 18.75c-0.375 0.375-0.875 0.563-1.375 0.563z",
		"heart-o": "M52 18.625c0-8.781-5.937-10.625-10.938-10.625-4.656 0-9.906 5.031-11.531 6.969-0.75 0.906-2.313 0.906-3.063 0-1.625-1.938-6.875-6.969-11.531-6.969-5 0-10.938 1.844-10.938 10.625 0 5.719 5.781 11.031 5.844 11.094l18.156 17.5 18.125-17.469c0.094-0.094 5.875-5.406 5.875-11.125zM56 18.625c0 7.5-6.875 13.781-7.156 14.063l-19.469 18.75c-0.375 0.375-0.875 0.563-1.375 0.563s-1-0.188-1.375-0.563l-19.5-18.813c-0.25-0.219-7.125-6.5-7.125-14 0-9.156 5.594-14.625 14.938-14.625 5.469 0 10.594 4.312 13.062 6.75 2.469-2.437 7.594-6.75 13.062-6.75 9.344 0 14.938 5.469 14.938 14.625z",
		info: "M56.1425 28.2143C56.1425 43.6783 43.6065 56.2143 28.1425 56.2143C12.6786 56.2143 0.142578 43.6783 0.142578 28.2143C0.142578 12.7504 12.6786 0.214325 28.1425 0.214325C43.6065 0.214325 56.1425 12.7504 56.1425 28.2143ZM32.2543 16.7406C33.1441 15.8361 33.587 14.7358 33.587 13.4469C33.587 12.1603 33.1441 11.0578 32.2543 10.1417C31.3665 9.22792 30.2961 8.76988 29.0452 8.76988C27.7901 8.76988 26.7156 9.22562 25.8194 10.1417C24.9232 11.0578 24.4741 12.1603 24.4741 13.4469C24.4741 14.7358 24.9232 15.8361 25.8194 16.7406C26.7177 17.6498 27.7901 18.1032 29.0452 18.1032C30.2961 18.1032 31.3665 17.6498 32.2543 16.7406ZM29.9419 45.5994C30.7373 45.2628 31.8057 44.7746 33.1417 44.1326C33.1417 44.1326 32.9859 42.1999 32.4746 42.3716C31.9633 42.5432 31.5033 42.6302 31.0983 42.6302C30.237 42.6302 29.6304 42.4585 29.2785 42.113C28.9285 41.7675 28.7544 41.1188 28.7544 40.1669C28.7544 39.7902 28.8076 39.2285 28.9175 38.4928C29.0238 37.7527 29.1466 37.0951 29.2822 36.52L30.9462 29.3555C31.1093 28.6979 31.2211 27.9756 31.2816 27.1865C31.342 26.3996 31.3714 25.849 31.3714 25.5369C31.3714 24.0255 30.9352 22.7995 30.0647 21.8543C29.1942 20.9091 27.9536 20.4365 26.3464 20.4365C25.4521 20.4365 24.5065 20.6305 23.5059 21.0161C22.5053 21.4018 21.4588 21.8654 20.3648 22.4071C20.3648 22.4071 20.6323 24.3198 21.0868 24.157C21.5395 23.9943 21.983 23.9096 22.4155 23.9096C23.2969 23.9096 23.8907 24.0924 24.2022 24.4535C24.5138 24.8146 24.6695 25.4566 24.6695 26.3751C24.6695 26.8833 24.6201 27.4473 24.5174 28.0603C24.4167 28.6778 24.2902 29.3309 24.1418 30.0198L22.4704 37.2111C22.322 37.9667 22.2139 38.6444 22.1461 39.2441C22.0783 39.8437 22.0453 40.4322 22.0453 41.0051C22.0453 42.483 22.4943 43.7024 23.3922 44.6632C24.2902 45.6217 25.5492 46.1032 27.1674 46.1032C28.2211 46.1032 29.1466 45.936 29.9419 45.5994Z",
		"layout-grid-4": "M11 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM11 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM11 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3z",
		"layout-grid-3": US.layoutGrid3,
		"layout-grid-2": US.layoutGrid2,
		"layout-grid": US.layoutGrid3,
		"layout-grid-1": "M56 9v38c0 1.656-1.344 3-3 3h-50c-1.656 0-3-1.344-3-3v-38c0-1.656 1.344-3 3-3h50c1.656 0 3 1.344 3 3z",
		"layout-large": US.layoutGrid2,
		"layout-list": "M16 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3zM16 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3z",
		minus: "M56 24.182v7.636c0 2.108-1.71 3.818-3.818 3.818h-48.364c-2.108 0-3.818-1.71-3.818-3.818v-7.636c0-2.108 1.71-3.818 3.818-3.818h48.364c2.108 0 3.818 1.71 3.818 3.818z",
		"minus-thin": "M0 23.297h56v9.406h-56v-9.406z",
		plus: "M56 24.182v7.636c0 2.108-1.71 3.818-3.818 3.818h-16.545v16.545c0 2.108-1.71 3.818-3.818 3.818h-7.636c-2.108 0-3.818-1.71-3.818-3.818v-16.545h-16.545c-2.108 0-3.818-1.71-3.818-3.818v-7.636c0-2.108 1.71-3.818 3.818-3.818h16.545v-16.545c0-2.108 1.71-3.818 3.818-3.818h7.636c2.108 0 3.818 1.71 3.818 3.818v16.545h16.545c2.108 0 3.818 1.71 3.818 3.818z",
		"plus-thin": "M56 31.946h-24.054v24.054h-7.893v-24.054h-24.054v-7.893h24.054v-24.054h7.893v24.054h24.054v7.893z",
		"rotate-left": "M56 28c0 15.422-12.578 28-28 28-8.349 0-16.224-3.682-21.547-10.099-0.365-0.474-0.328-1.167 0.073-1.568l4.995-5.031c0.255-0.219 0.583-0.328 0.911-0.328 0.328 0.036 0.656 0.182 0.839 0.438 3.573 4.63 8.932 7.255 14.729 7.255 10.281 0 18.667-8.385 18.667-18.667s-8.385-18.667-18.667-18.667c-4.776 0-9.297 1.823-12.687 4.995l4.995 5.031c0.693 0.656 0.875 1.677 0.51 2.516-0.365 0.875-1.203 1.458-2.151 1.458h-16.333c-1.276 0-2.333-1.057-2.333-2.333v-16.333c0-0.948 0.583-1.786 1.458-2.151 0.839-0.365 1.859-0.182 2.516 0.51l4.74 4.703c5.141-4.849 12.104-7.729 19.286-7.729 15.422 0 28 12.578 28 28z",
		"rotate-right": "M56 4.667v16.333c0 1.276-1.057 2.333-2.333 2.333h-16.333c-0.948 0-1.786-0.583-2.151-1.458-0.365-0.839-0.182-1.859 0.51-2.516l5.031-5.031c-3.427-3.172-7.948-4.995-12.724-4.995-10.281 0-18.667 8.385-18.667 18.667s8.385 18.667 18.667 18.667c5.797 0 11.156-2.625 14.729-7.255 0.182-0.255 0.51-0.401 0.839-0.438 0.328 0 0.656 0.109 0.911 0.328l4.995 5.031c0.438 0.401 0.438 1.094 0.073 1.568-5.323 6.417-13.198 10.099-21.547 10.099-15.422 0-28-12.578-28-28s12.578-28 28-28c7.182 0 14.146 2.88 19.286 7.729l4.74-4.703c0.656-0.693 1.677-0.875 2.552-0.51 0.839 0.365 1.422 1.203 1.422 2.151z",
		search: "M35.385 23.692c0-6.457-5.235-11.692-11.693-11.692s-11.693 5.235-11.693 11.692 5.235 11.692 11.693 11.692 11.693-5.235 11.693-11.692zM54.243 45.757A6 6 0 0 1 45.757 54.243L35.656 44.141A23.692 23.692 0 1 1 44.141 35.656L54.243 45.757z",
		"search-thin": "M38.769 23.692c0-8.313-6.764-15.077-15.077-15.077s-15.077 6.764-15.077 15.077 6.764 15.077 15.077 15.077 15.077-6.764 15.077-15.077zM56 51.692c0 2.356-1.952 4.308-4.308 4.308-1.144 0-2.255-0.471-3.029-1.279l-11.543-11.51c-3.937 2.726-8.649 4.173-13.428 4.173-13.091 0-23.692-10.601-23.692-23.692s10.601-23.692 23.692-23.692 23.692 10.601 23.692 23.692c0 4.779-1.447 9.49-4.173 13.428l11.543 11.543c0.774 0.774 1.245 1.885 1.245 3.029z",
		sort: "M48.364 35.636c0 0.676-0.278 1.312-0.756 1.79l-17.818 17.818c-0.477 0.477-1.114 0.756-1.79 0.756s-1.312-0.278-1.79-0.756l-17.818-17.818c-0.477-0.477-0.756-1.114-0.756-1.79 0-1.392 1.153-2.545 2.545-2.545h35.636c1.392 0 2.545 1.153 2.545 2.545zM48.364 20.364c0 1.392-1.153 2.545-2.545 2.545h-35.636c-1.392 0-2.545-1.153-2.545-2.545 0-0.676 0.278-1.312 0.756-1.79l17.818-17.818c0.477-0.477 1.114-0.756 1.79-0.756s1.312 0.278 1.79 0.756l17.818 17.818c0.477 0.477 0.756 1.114 0.756 1.79z",
		spinner: "M16.009 45.176c0 2.268-1.847 4.148-4.148 4.148-2.268 0-4.148-1.88-4.148-4.148 0-2.301 1.88-4.148 4.148-4.148 2.301 0 4.148 1.847 4.148 4.148zM32.148 51.852c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM9.333 29.037c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM48.287 45.176c0 2.268-1.88 4.148-4.148 4.148-2.301 0-4.148-1.88-4.148-4.148 0-2.301 1.847-4.148 4.148-4.148 2.268 0 4.148 1.847 4.148 4.148zM17.046 12.898c0 2.852-2.333 5.185-5.185 5.185s-5.185-2.333-5.185-5.185 2.333-5.185 5.185-5.185 5.185 2.333 5.185 5.185zM54.963 29.037c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM34.222 6.222c0 3.435-2.787 6.222-6.222 6.222s-6.222-2.787-6.222-6.222 2.787-6.222 6.222-6.222 6.222 2.787 6.222 6.222zM51.398 12.898c0 4.018-3.273 7.259-7.259 7.259-4.018 0-7.259-3.241-7.259-7.259 0-3.986 3.241-7.259 7.259-7.259 3.986 0 7.259 3.273 7.259 7.259z",
		square: "M0 0h56v56h-56z",
		star: "M56 21.993c0 0.606-0.438 1.178-0.875 1.615l-12.216 11.913 2.894 16.827c0.034 0.236 0.034 0.438 0.034 0.673 0 0.875-0.404 1.683-1.38 1.683-0.471 0-0.942-0.168-1.346-0.404l-15.111-7.942-15.111 7.942c-0.438 0.236-0.875 0.404-1.346 0.404-0.976 0-1.413-0.808-1.413-1.683 0-0.236 0.034-0.438 0.067-0.673l2.894-16.827-12.25-11.913c-0.404-0.438-0.841-1.010-0.841-1.615 0-1.010 1.043-1.413 1.885-1.548l16.894-2.457 7.572-15.312c0.303-0.639 0.875-1.38 1.649-1.38s1.346 0.74 1.649 1.38l7.572 15.312 16.894 2.457c0.808 0.135 1.885 0.538 1.885 1.548z",
		"star-half": "M39.919 32.426l8.651-8.415-14.205-2.087-1.010-2.020-5.352-10.839v32.415l1.986 1.043 10.704 5.655-2.020-11.949-0.404-2.222zM55.134 23.607l-12.219 11.916 2.895 16.83c0.236 1.481-0.303 2.356-1.346 2.356-0.37 0-0.842-0.135-1.346-0.404l-15.113-7.944-15.113 7.944c-0.505 0.269-0.976 0.404-1.346 0.404-1.043 0-1.582-0.875-1.346-2.356l2.895-16.83-12.252-11.916c-1.447-1.447-0.976-2.861 1.043-3.164l16.897-2.457 7.574-15.315c0.438-0.909 1.043-1.38 1.649-1.38v0c0.606 0 1.178 0.471 1.649 1.38l7.574 15.315 16.897 2.457c2.020 0.303 2.491 1.717 1.010 3.164z",
		"star-o": "M38.264 34.007l10.298-9.995-14.202-2.087-6.361-12.856-6.361 12.856-14.202 2.087 10.298 9.995-2.457 14.168 12.721-6.697 12.688 6.697zM56 21.993c0 0.606-0.438 1.178-0.875 1.615l-12.216 11.913 2.894 16.827c0.034 0.236 0.034 0.438 0.034 0.673 0 0.909-0.404 1.683-1.38 1.683-0.471 0-0.942-0.168-1.346-0.404l-15.111-7.942-15.111 7.942c-0.438 0.236-0.875 0.404-1.346 0.404-0.976 0-1.413-0.808-1.413-1.683 0-0.236 0.034-0.438 0.067-0.673l2.894-16.827-12.25-11.913c-0.404-0.438-0.841-1.010-0.841-1.615 0-1.010 1.043-1.413 1.885-1.548l16.894-2.457 7.572-15.312c0.303-0.639 0.875-1.38 1.649-1.38s1.346 0.74 1.649 1.38l7.572 15.312 16.894 2.457c0.808 0.135 1.885 0.538 1.885 1.548z",
		"video-camera": "M56 11v34c0 0.812-0.5 1.531-1.219 1.844-0.25 0.094-0.531 0.156-0.781 0.156-0.531 0-1.031-0.188-1.406-0.594l-12.594-12.594v5.187c0 4.969-4.031 9-9 9h-22c-4.969 0-9-4.031-9-9v-22c0-4.969 4.031-9 9-9h22c4.969 0 9 4.031 9 9v5.156l12.594-12.562c0.375-0.406 0.875-0.594 1.406-0.594 0.25 0 0.531 0.063 0.781 0.156 0.719 0.312 1.219 1.031 1.219 1.844z",
		warn: "M31.2981 5.28228C29.8323 2.74341 26.1677 2.74341 24.7019 5.28228L0.515899 47.1737C-0.94992 49.7126 0.88235 52.8861 3.81399 52.8861H52.186C55.1176 52.8861 56.9499 49.7126 55.4841 47.1737L31.2981 5.28228ZM25.2229 35.0037L24.8264 18.837C24.8264 18.655 24.8923 18.4729 25.047 18.3686C25.1794 18.2387 25.3776 18.1601 25.5759 18.1601H30.4241C30.6223 18.1601 30.8206 18.238 30.953 18.3686C31.1071 18.4729 31.1736 18.655 31.1736 18.837L30.7988 35.0037C30.7988 35.3679 30.4682 35.6542 30.0493 35.6542H25.9724C25.5759 35.6542 25.2453 35.3679 25.2229 35.0037ZM25.1788 43.9593V39.0131C25.1788 38.5447 25.487 38.1541 25.8618 38.1541H30.0929C30.4894 38.1541 30.82 38.5447 30.82 39.0131V43.9593C30.82 44.4277 30.4894 44.8183 30.0929 44.8183H25.8618C25.487 44.8183 25.1788 44.4277 25.1788 43.9593Z",
		wrench: "M12.407 45.809c0-1.193-0.988-2.181-2.181-2.181s-2.181 0.988-2.181 2.181 0.988 2.181 2.181 2.181 2.181-0.988 2.181-2.181zM34.357 31.494l-23.245 23.245c-0.784 0.784-1.909 1.261-3.068 1.261s-2.284-0.477-3.102-1.261l-3.613-3.681c-0.818-0.784-1.295-1.909-1.295-3.068s0.477-2.284 1.295-3.102l23.211-23.211c1.772 4.465 5.351 8.044 9.816 9.816zM55.966 16.667c0 1.125-0.409 2.522-0.784 3.613-2.147 6.067-7.976 10.259-14.418 10.259-8.419 0-15.27-6.851-15.27-15.27s6.851-15.27 15.27-15.27c2.488 0 5.726 0.75 7.805 2.147 0.341 0.239 0.545 0.545 0.545 0.954 0 0.375-0.239 0.75-0.545 0.954l-9.987 5.76v7.635l6.578 3.647c1.125-0.648 9.032-5.624 9.714-5.624s1.091 0.511 1.091 1.193z"
	};
})), KS, qS, JS, YS = o((() => {
	Ei(), Xb(), KS = /* @__PURE__ */ u(Q()), $(), HS(), GS(), MS(), vS(), qS = ({ color: e, fill: t, stroke: n, theme: r, width: i, height: a, size: o }) => Jb({
		color: e || t || r?.variables?.colors?.primary,
		fill: t || e || r?.variables?.colors?.primary,
		stroke: n,
		width: isNaN(Number(i || o)) ? i || o : `${i || o}px`,
		height: isNaN(Number(a || o)) ? a || o : `${a || o}px`,
		position: "relative"
	}), JS = bx((e) => {
		let t = Wx("icon", _i(), {
			size: "16px",
			viewBox: "0 0 56 56",
			treePath: BS()
		}, e), { color: n, icon: r, fill: i, path: a, children: o, size: s, width: c, title: l, height: u, viewBox: d, svg: f, disableStyles: p, className: m, internalClassName: h, style: g, styleScript: _, themeStyleScript: v, name: y, treePath: b, ...x } = t, { overrideElement: S, shouldRenderDefault: C } = hS("icon", t);
		if (!C) return S;
		let w = Xx(t, qS), T = (0, KS.default)("ss__icon", r && !f ? `ss__icon--${r}` : null, m, h);
		if (f) {
			let e = f?.props?.className || f?.props?.class, t = {
				...w,
				className: (0, KS.default)(T, e),
				...x
			};
			return p && (t.width = c || s, t.height = u || s), L(Nx, { children: Yb(f.type, {
				...f.props,
				...t,
				children: f.props.children
			}) });
		}
		let E = WS[r] || a, D = typeof E;
		return o || E && (D === "string" || D === "object" && Array.isArray(E)) ? L(Nx, { children: wi("svg", {
			...w,
			className: T,
			viewBox: d,
			xmlns: "http://www.w3.org/2000/svg",
			width: p ? c || s : void 0,
			height: p ? u || s : void 0,
			...x,
			children: [l ? L("title", { children: l }) : null, (() => {
				if (o) return o;
				if (D === "string") return L("path", {
					fill: p && (i || n) || void 0,
					d: E
				});
				if (E && D === "object" && Array.isArray(E)) return E.map((e, t) => L(e.type, { ...e.attributes }, t));
			})()]
		}) }) : null;
	});
})), XS, ZS, QS, $S, eC = o((() => {
	Ei(), Xb(), XS = /* @__PURE__ */ u(Q()), N(), YS(), MS(), HS(), vS(), ZS = ({ componentTheme: e }) => Jb({
		width: "360px",
		height: "120px",
		overflow: "hidden",
		fontSize: "14px",
		position: "fixed",
		zIndex: "9999",
		cursor: "auto",
		bottom: "50px",
		right: 0,
		padding: "0 5px",
		background: e.main.background,
		color: e.main.color,
		border: e.main.border,
		borderTopLeftRadius: "10px",
		borderBottomLeftRadius: "10px",
		boxShadow: e.main.boxShadow,
		transition: "height ease 0.2s, right ease 0.5s 0.2s",
		"&.ss__branch-override--collapsed": {
			transition: "height ease 0.5s 0.5s, right ease 0.5s",
			right: "-323px",
			height: "50px",
			cursor: "pointer"
		},
		".ss__branch-override__top": {
			padding: "10px 5px",
			background: e.top.background,
			borderBottom: e.top.border,
			".ss__branch-override__top__logo": {
				display: "inline-block",
				height: "30px",
				maxHeight: "30px",
				verticalAlign: "middle"
			},
			".ss__branch-override__top__collapse": {
				display: "inline-block",
				float: "right",
				paddingTop: "7px",
				cursor: "pointer"
			},
			".ss__branch-override__top__button": {
				borderRadius: "5px",
				padding: "6px",
				height: "100%",
				lineHeight: "14px",
				textAlign: "center",
				cursor: "pointer",
				fontSize: "10px",
				border: e.top.button.border,
				color: e.top.button.color,
				float: "right",
				marginRight: "14px"
			}
		},
		".ss__branch-override__bottom": {
			padding: "10px 15px",
			fontSize: "12px",
			".ss__branch-override__bottom__left": {
				fontWeight: "bold",
				fontStyle: e.bottom.branch.style,
				color: e.bottom.branch.color,
				fontSize: "14px",
				lineHeight: "20px",
				display: "inline-flex",
				alignItems: "center",
				maxWidth: "180px",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				svg: { marginRight: "10px" }
			},
			".ss__branch-override__bottom__right": {
				float: "right",
				fontStyle: "italic",
				color: e.bottom.additional.color,
				fontSize: "12px",
				lineHeight: "20px"
			},
			".ss__branch-override__bottom__content": { marginTop: "10px" }
		}
	}), QS = {
		darkTheme: {
			class: "ss__branch-override--dark",
			main: {
				border: "0",
				background: "rgba(26, 29, 36, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #454c5f",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "STOP PREVIEW"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Preview functionality may differ from production.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		},
		lightTheme: {
			class: "ss__branch-override--light",
			main: {
				border: "0",
				background: "rgba(29, 73, 144, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #3c78d7",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "STOP PREVIEW"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Preview functionality may differ from production.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		},
		failureTheme: {
			class: "ss__branch-override--error",
			main: {
				border: "0",
				background: "rgba(130, 6, 6, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #e50b0b",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "REMOVE"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Incorrect branch name or branch no longer exists.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		}
	}, $S = (e) => {
		let t = Wx("branchOverride", _i(), { treePath: BS() }, e), { branch: n, details: r, error: i, className: a, internalClassName: o, darkMode: s, disableStyles: c, onRemoveClick: l, treePath: u } = t, { overrideElement: d, shouldRenderDefault: f } = hS("branchOverride", t);
		if (!f) return d;
		let p = { icon: {
			internalClassName: "ss__branch-override__bottom__left__icon",
			size: "12px",
			...zx({ disableStyles: c }),
			theme: t?.theme,
			treePath: u
		} }, [m, h] = Le((typeof s == "boolean" ? s : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) ? "darkTheme" : "lightTheme"), [g, _] = Le(0);
		i && h("failureTheme");
		let v = Xx({
			...t,
			componentTheme: QS[m]
		}, ZS);
		return (r || i) && n ? wi("div", {
			className: (0, XS.default)("ss__branch-override", QS[m].class, { "ss__branch-override--collapsed": g }, a, o),
			...v,
			onClick: (e) => {
				e.preventDefault(), e.stopPropagation(), _(0);
			},
			children: [wi("div", {
				className: "ss__branch-override__top",
				children: [
					L("img", {
						className: "ss__branch-override__top__logo",
						src: QS[m].top.logo.src
					}),
					L("div", {
						className: "ss__branch-override__top__collapse",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), _(1);
						},
						children: L(JS, {
							size: "18px",
							color: QS[m].top.close.fill,
							...p.icon,
							icon: "close-thin"
						})
					}),
					L("div", {
						className: "ss__branch-override__top__button",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), l && l(e, n);
						},
						children: QS[m].top.button.content
					})
				]
			}), wi("div", {
				className: "ss__branch-override__bottom",
				children: [
					L("span", {
						className: "ss__branch-override__bottom__left",
						children: i ? wi(Ti, { children: [L(JS, {
							size: "12px",
							color: QS[m].bottom.branch.color,
							...p.icon,
							icon: "warn"
						}), L("span", { children: i.message })] }) : n
					}),
					L("span", {
						className: "ss__branch-override__bottom__right",
						children: i ? n : r?.lastModified
					}),
					L("div", {
						className: "ss__branch-override__bottom__content",
						children: i?.description || QS[m].bottom.content
					})
				]
			})]
		}) : null;
	};
})), tC = /* @__PURE__ */ c({ BranchOverride: () => $S }), nC = o((() => {
	eC();
})), rC = o((() => {
	Rb(), Vb(), Wb(), Ob();
})), iC = /* @__PURE__ */ c({
	RecommendationInstantiator: () => dC,
	defined: () => cC
});
async function aC(e, t, n, r, i, a, o, s, c) {
	let { profile: l, batchId: u, cart: d, tag: f } = o, p = l?.batched ?? o.batched ?? !0;
	if (!f) {
		e.logger.warn("'tag' is missing from <script> tag, skipping this profile", a);
		return;
	}
	Array.isArray(d) && e.tracker.cookies.cart.set(d);
	let m = lC.default.all([
		e.config.client?.globals || {},
		e.config.config?.globals || {},
		o
	]), h = {
		tag: f,
		batched: p ?? e.config.config?.batched ?? !0,
		realtime: !!(r.options?.realtime ?? r.profile?.options?.realtime ?? e.config.config?.realtime),
		batchId: u,
		middleware: e.config.config.middleware,
		plugins: e.config.config.plugins,
		branch: e.config.config?.branch || "production",
		limit: e.config.config?.limit,
		beacon: e.config.config?.beacon || { enabled: !0 },
		settings: { variants: e.config.config?.variants },
		globals: m
	};
	l?.branch && (h.branch = l?.branch), i[f] = i[f] + 1 || 1;
	let g = {
		id: `recommend_${f}_${i[f] - 1}`,
		...h
	}, _ = Ub({
		url: e.config.url,
		controller: g,
		context: r,
		mode: e.config.mode
	}, {
		client: e.client,
		tracker: e.tracker
	});
	n && n.setAttribute("ss-controller-id", _.id), e.uses.forEach((e) => _.use(e)), e.plugins.forEach((e) => _.plugin(e.func, ...e.args)), e.middleware.forEach((e) => _.on(e.event, ...e.func)), e.controller[_.config.id] = _, window.athos.controller = window.athos.controller || {}, window.athos.controller[_.config.id] = _, _.addTargeter(c), _.store.loading || await _.search();
	let v = _.store.profile.display?.templateParameters;
	if (!_.store.error) {
		if (!_.store.profile.display.template) {
			e.logger.error(`profile '${f}' found on the following element is missing a template!\n${a?.outerHTML}`);
			return;
		}
		if (!v) {
			e.logger.error(`profile '${f}' found on the following element is missing templateParameters!\n${a?.outerHTML}`);
			return;
		}
		return n && await oC(e, t, _, n, a, s), _;
	}
}
async function oC(e, t, n, r, i, a) {
	r && r.setAttribute("ss-controller-id", n.id);
	let o = n.config.tag, s = n.store.profile.display?.template?.component;
	if (!s) {
		e.logger.error(`profile '${o}' found on the following element is missing a component!\n${i?.outerHTML}`);
		return;
	}
	let c = {}, l;
	if (c.className = `ss__recommendation-${s.toLowerCase()}`, e.config.components[s]?.onTarget?.(a, i, r, n), e.config.components[s] && typeof e.config.components[s] == "function") l = await e.config.components[s]();
	else if (e.config.components[s] && typeof e.config.components[s] == "object") {
		c = e.config.components[s].props || {};
		let t = [];
		t.push(e.config.components[s].component()), l = (await Promise.all(t))[0];
	}
	if (!l) {
		e.logger.error(`profile '${o}' found on the following element is expecting component mapping for '${s}' - verify instantiator config.\n${i?.outerHTML}`);
		return;
	}
	setTimeout(() => {
		fe(L(l, {
			controller: n,
			snap: t?.snap,
			...c
		}), r);
	});
}
function sC(e) {
	if (typeof e == "function") try {
		let t = e();
		if (Array.isArray(t)) return t;
	} catch {}
	else if (Array.isArray(e)) return e;
	return [];
}
function cC(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var lC, uC, dC, fC = o((() => {
	Ei(), Ne(), lC = /* @__PURE__ */ u(R()), wu(), _d(), wd(), u_(), rC(), uC = "production", dC = class {
		constructor(e, t, n) {
			if (this.mode = q.production, this.controller = {}, this.uses = [], this.plugins = [], this.middleware = [], this.config = e, !this.config) throw Error("Recommendation Instantiator config is required");
			if (this.config.config?.branch || (this.config.config = this.config.config || {}, this.config.config.branch = uC), !this.config.components || typeof this.config.components != "object" || !Object.keys(this.config.components).length) throw Error("Recommendation Instantiator config must contain 'components' mapping property");
			if ((!t?.client || !t?.tracker) && !this.config?.client?.globals?.siteId) throw Error("Recommendation Instantiator config must contain a valid config.client.globals.siteId value");
			this.config.mode && Object.values(q).includes(this.config.mode) && (this.mode = this.config.mode, this.config?.client?.globals?.siteId && (this.config.client.config = this.config.client.config || {}, this.config.client.config.mode = this.config.client.config.mode || this.mode)), window.athos = window.athos || {}, this.context = (0, lC.default)(n || {}, e.context || {}), this.client = t?.client || new hd(this.config.client.globals, this.config.client.config), this.tracker = t?.tracker || new s_(this.config.client.globals), this.logger = t?.logger || new Sd({
				prefix: "RecommendationInstantiator ",
				mode: this.mode
			});
			let r = {};
			this.targeter = new Ml([{
				selector: `${this.config.selector || "script[type=\"searchspring/recommend\"], script[type=\"searchspring/personalized-recommendations\"], script[type=\"athos/recommend\"], script[type=\"athos/personalized-recommendations\"]"}, script[type="searchspring/recommend"][profile="email"], script[type="athos/recommend"][profile="email"]`,
				autoRetarget: !0,
				clickRetarget: !0,
				navigationRetarget: !0,
				emptyTarget: !1
			}, {
				selector: "script[type=\"searchspring/recommendations\"], script[type=\"athos/recommendations\"]",
				autoRetarget: !0,
				clickRetarget: !0,
				navigationRetarget: !0,
				emptyTarget: !1
			}], async (e, n) => {
				this.cleanupStaleControllers();
				let i = n, a = Gl([
					"shopperId",
					"shopper",
					"product",
					"products",
					"seed",
					"cart",
					"filters",
					"blockedItems",
					"options",
					"profile",
					"custom",
					"profiles",
					"globals"
				], i);
				if (a.profiles && a.profiles.length) {
					let e = a.profiles, n = a.globals, o = { ...cC({
						blockedItems: n?.blockedItems,
						filters: n?.filters,
						cart: n?.cart && sC(n.cart),
						products: n?.products,
						shopper: n?.shopper?.id,
						batchId: Math.floor(Math.random() * (2 ** 53 - 1))
					}) };
					e.forEach((e, s) => {
						if (e.selector) {
							let c = {
								selector: e.selector,
								autoRetarget: !0,
								profile: e,
								order: s
							}, l;
							new Ml([c], async (e, s, c, u) => {
								if (i.isConnected === !1) {
									s && u?.releaseTargets([s]);
									return;
								}
								if (e.profile?.profile || e.profile?.tag) {
									let c = {
										...o,
										profile: {
											...e.profile?.options,
											order: e.order
										},
										tag: e.profile.tag || e.profile.profile
									}, d = (0, lC.default)(this.context, cC({
										globals: n,
										profile: e.profile
									}));
									if (a.custom && (d.custom = (0, lC.default)(d.custom, a.custom)), !l) l = aC(this, t || {}, s, d, r, i, c, e, u);
									else {
										let n = await l;
										n && s && oC(this, t || {}, n, s, i, e);
									}
								}
							});
						}
					});
				} else {
					let { profile: n, products: o, product: s, seed: c, filters: l, blockedItems: u, options: d, shopper: f, shopperId: p } = a, m = [].concat(o || s || c || []), h = [
						f,
						f?.id,
						p,
						p?.id
					].filter((e) => e && typeof e == "string").pop(), g = {
						tag: n,
						...cC({
							products: m.length ? m : void 0,
							cart: a.cart && sC(a.cart),
							shopper: h,
							filters: l,
							blockedItems: u,
							profile: d
						})
					}, _ = i.getAttribute("profile") || "", v = i.ownerDocument.createElement("div");
					v.setAttribute("searchspring-recommend", _), i.before(v);
					let y = (0, lC.default)(this.context, a);
					new Ml([{
						selector: `[searchspring-recommend="${_}"]`,
						name: `legacy_${n}_${r[n || ""] || 0}`
					}], async (n, a, o, s) => {
						if (i.isConnected === !1) {
							a && s?.releaseTargets([a]);
							return;
						}
						aC(this, t || {}, a, y, r, i, g, e, s);
					});
				}
			});
		}
		plugin(e, ...t) {
			this.plugins.push({
				func: e,
				args: t
			});
		}
		on(e, ...t) {
			this.middleware.push({
				event: e,
				func: t
			});
		}
		use(e) {
			this.uses.push(e);
		}
		cleanupStaleControllers() {
			Object.keys(this.controller).forEach((e) => {
				let t = this.controller[e];
				Object.values(t.targeters).some((t) => t.getTargetedElems().some((t) => (t.isConnected !== !1 && t.getAttribute("ss-controller-id")) === e)) || (Object.keys(t.targeters).forEach((e) => t.targeters[e].destroy()), t.targeters = {}, delete this.controller[e], window.athos?.controller && delete window.athos.controller[e]);
			});
		}
	};
}));
Ei(), Ne();
var pC = /* @__PURE__ */ u(R());
ki(), Al(), _d(), wd(), u_(), wu(), Jy(), Ob(), Nb(), Wo({
	useProxies: "never",
	isolateGlobalState: !0,
	enforceActions: "never"
});
var mC = "athosBranch", hC = "athos-preview", gC = "athos-Dev", _C = "athos-snap-bundle-styles", vC = 3, yC = "Uncaught Error - Invalid value passed as the component.\nThis usually happens when you pass a JSX Element, and not a function that returns the component, in the snap config. \n		\n		instead of - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: <Content/>,\n		},\n	]\n\n		or - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: Content,\n		},\n	]\n\n		please try - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: () => Content\n		},\n	]\n\nThe error above happened in the following targeter in the Snap Config", bC = class {
	constructor(e, t) {
		this.mode = q.production, this._instantiatorPromises = {}, this._controllerPromises = {}, this.controllers = {}, this.getInstantiator = (e) => this._instantiatorPromises[e] || Promise.reject(`getInstantiator could not find instantiator with id: ${e}`), this.getController = (e) => this._controllerPromises[e] || Promise.reject(`getController could not find controller with id: ${e}`), this.getControllers = (...e) => {
			let t = [];
			return e.forEach((e) => t.push(this.getController(e))), Promise.all(t);
		}, this.createController = async (e, t, n, r, i, a) => {
			if (this._controllerPromises[t.id] !== void 0) throw Error(`Controller with id '${t.id}' is already defined`);
			return this._controllerPromises[t.id] = new Promise((o) => this._createController(e, t, n, r, i, async (e) => {
				typeof a == "function" && await a(e), o(e);
			})), this._controllerPromises[t.id];
		}, this._createController = async (e, t, n, r, i, a) => {
			let o;
			switch (e) {
				case cy.autocomplete:
					o = Promise.resolve().then(() => (Rb(), Ib));
					break;
				case cy.finder:
					o = Promise.resolve().then(() => (Vb(), zb));
					break;
				case cy.recommendation:
					o = Promise.resolve().then(() => (Wb(), Hb));
					break;
				case cy.search:
				default: o = Promise.resolve().then(() => (Ob(), Eb));
			}
			let s = (await o).default;
			return this.controllers[t.id] || (window.athos.controller = window.athos.controller || {}, window.athos.controller[t.id] = this.controllers[t.id] = s({
				mode: this.mode,
				url: (0, pC.default)(this.config.url || {}, r || {}),
				controller: t,
				context: (0, pC.default)(this.context || {}, i || {})
			}, {
				client: n?.client || this.client,
				store: n?.store,
				urlManager: n?.urlManager,
				eventManager: n?.eventManager,
				profiler: n?.profiler,
				logger: n?.logger,
				tracker: n?.tracker || this.tracker
			})), a && await a(this.controllers[t.id]), this.controllers[t.id];
		}, this.handlers = {
			attributes: (e) => {
				let t = this.tracker.config.id, n = [
					`ss-${t}-cart-add`,
					`ss-${t}-cart-remove`,
					`ss-${t}-cart-clear`,
					`ss-${t}-cart-view`,
					`ss-${t}-intellisuggest`,
					`ss-${t}-intellisuggest-signature`,
					"href"
				], r = {}, i = 0, a = null;
				for (a = e && e.target; Object.keys(r).length == 0 && a !== null && i <= vC;) a.attributes && Object.values(a.attributes).forEach((e) => {
					let t = e.nodeName;
					n.indexOf(t) != -1 && (r[t] = a && a.getAttribute(t));
				}), a = a.parentElement, i++;
				if (r[`ss-${t}-cart-add`]) {
					let e = r[`ss-${t}-cart-add`].split(",");
					this.tracker.cookies.cart.add(e), this.eventManager.fire("controller/recommendation/update");
				} else if (r[`ss-${t}-cart-remove`]) {
					let e = r[`ss-${t}-cart-remove`].split(",");
					this.tracker.cookies.cart.remove(e), this.eventManager.fire("controller/recommendation/update");
				} else `ss-${t}-cart-clear` in r ? (this.tracker.cookies.cart.clear(), this.eventManager.fire("controller/recommendation/update")) : `ss-${t}-cart-view` in r ? this.eventManager.fire("controller/recommendation/update") : r[`ss-${t}-intellisuggest`] && r[`ss-${t}-intellisuggest-signature`] && this.tracker.track.product.click();
			},
			error: (e) => {
				try {
					let { filename: t } = e;
					if ((t.includes("snapui.searchspring.io") || t.includes("snapui.athoscommerce.io")) && t.endsWith(".js") && this.tracker.track.error) {
						let { colno: n, lineno: r, error: { stack: i }, message: a, timeStamp: o } = e, s = {
							href: window.location.href,
							filename: t,
							stack: i,
							message: a,
							colno: n,
							lineno: r,
							errortimestamp: o
						};
						this.tracker.track.error(s);
					}
				} catch {}
			}
		}, window.removeEventListener("error", this.handlers.error), window.addEventListener("error", this.handlers.error), document.removeEventListener("click", this.handlers.attributes), document.addEventListener("click", this.handlers.attributes), this.config = e;
		let n = {};
		try {
			n = Gl([
				"shopper",
				"config",
				"custom",
				"merchandising",
				"siteId",
				"currency",
				"page",
				"backgroundFilters",
				"collection",
				"tags",
				"category",
				"brand"
			]);
		} catch {
			console.error("Snap failed to find global context");
		}
		if (this.config = (0, pC.default)(this.config || {}, n.config || {}, { isMergeableObject: Oi }), this.context = (0, pC.default)(this.config.context || {}, n || {}, { isMergeableObject: Oi }), !this.config?.client?.globals?.siteId && this.context.siteId) {
			let e = { globals: { siteId: this.context.siteId } };
			this.config.client = (0, pC.default)(e, this.config.client || {});
		}
		if ((!t?.client || !t?.tracker) && !this.config?.client?.globals?.siteId) throw t?.templatesStore ? Error("SnapTemplates: config provided must contain a valid config.siteId value") : Error("Snap: config provided must contain a valid config.client.globals.siteId value");
		this.config.client?.globals && this.context.merchandising?.segments && (this.config.client.globals?.merchandising ? this.config.client.globals.merchandising.segments = (0, pC.default)(this.config.client.globals.merchandising.segments, this.context.merchandising.segments) : this.config.client.globals.merchandising = { segments: this.context.merchandising.segments }), t?.templatesStore && (this.templates = t.templatesStore);
		try {
			let e = Xl(window.location.href), n = e?.params?.query["athos-preview"] || zl.get("athosBranch"), r = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0;
			Object.values(q).includes("production") && (this.mode = "production"), this.config.mode && Object.values(q).includes(this.config.mode) && (this.mode = this.config.mode), (e?.params?.query && "dev" in e.params.query || zl.get("athos-Dev")) && (e?.params.query?.dev == "false" || e?.params.query?.dev == "0" ? (zl.unset(gC, r), this.mode = q.production) : (zl.set(gC, "1", "Lax", 0, r), this.mode = q.development));
			let i = window?.athos?.managed ? "managed/" : "";
			this.config.client && (this.config.client.config = this.config.client.config || {}, this.config.client.config.initiator || (this.config.client.config.initiator = `athos/${i}snap/preact/${fu}`), this.config.client.config.mode = this.config.client.config.mode || this.mode), kb(this.config), this.client = t?.client || new hd(this.config.client.globals, this.config.client.config), this.logger = t?.logger || new Sd({
				prefix: `${this.config.tracker?.config?.framework == "snap/templates" ? "Snap Preact Templates " : this.config.tracker?.config?.framework == "snap/hybrid" ? "Snap Preact Hybrid " : "Snap Preact "}`,
				mode: this.mode
			});
			let a = this.config.tracker?.globals || this.config.client.globals;
			this.context.currency?.code && (a = (0, pC.default)(a || {}, { currency: this.context.currency })), this.context.shopper?.cart && (a = (0, pC.default)(a || {}, { cart: this.context.shopper.cart }));
			let o = (0, pC.default)(this.config.tracker?.config || {}, {
				framework: `${i}${this.config.tracker?.config?.framework || "snap"}/preact`,
				mode: this.mode
			});
			if (this.tracker = t?.tracker || new s_(a, o), this.logger.imageText({
				url: "https://snapui.athoscommerce.io/favicon.svg",
				text: `[${fu}]`,
				style: `color: ${this.logger.colors.indigo}; font-weight: bold;`
			}), n && !document.querySelector("script[athosBranch]")) {
				this.logger.warn(`:: loading branch override ~ '${n}' ...`), Ll.cookies ? zl.set(mC, n, "Lax", 36e5, r) : this.logger.warn("Cookies are not supported/enabled by this browser, branch overrides will not persist!");
				let e = `https://snapui.athoscommerce.io/${this.config.client?.globals?.siteId}/`, t = document.querySelector("script[src*=\"//snapui.searchspring.io\"], script[src*=\"//snapui.athoscommerce.io\"]");
				if (t) {
					let n = t.getAttribute("src").match(/\/\/snapui.searchspring.io\/[a-zA-Z0-9]{6}\//);
					n ? e = n.toString() : (n = t.getAttribute("src").match(/\/\/snapui.athoscommerce.io\/[a-zA-Z0-9]{6}\//), n && (e = n.toString()));
				}
				let i = document.createElement("script"), a = `${e}${n}/bundle.js`;
				throw i.src = a, i.setAttribute(mC, n), new Ml([{
					selector: "body",
					inject: {
						action: "append",
						element: () => {
							let e = document.createElement("div");
							return e.id = "athos-branch-override", e;
						}
					}
				}], async (e, t) => {
					let o = {};
					try {
						let e = (await Promise.resolve().then(() => (qb(), Gb))).getBundleDetails;
						o.details = await e(a);
					} catch (e) {
						o.error = e;
					}
					let s = (await Promise.resolve().then(() => (nC(), tC))).BranchOverride;
					fe(L(s, {
						...o,
						branch: n,
						onRemoveClick: () => {
							zl.unset(mC, r);
							let e = Xl(window.location.href);
							delete e?.params.query[hC];
							let t = e?.url();
							t && t != window.location.href ? window.location.href = t : window.location.reload();
						}
					}), t);
					try {
						delete window.athos;
					} catch {
						window.athos = void 0;
					}
					document.head.appendChild(i);
				}), document.querySelectorAll(`.${_C}`).forEach((e) => e.remove()), "branch override";
			}
		} catch (e) {
			if (e == "branch override") throw `${this.logger.emoji.bang} Snap instantiation halted - using branch override.`;
			this.logger.error(e);
		}
		if (window.athos = window.athos || {}, window.athos.build = window.athos.build || "modern", window.athos.context = this.context, this.client && (window.athos.client = this.client), t?.templatesStore && (window.athos.templates = this.templates), this.eventManager = Pb(), this.eventManager && (window.athos.on = (e, ...t) => {
			this.eventManager.on(e, ...t);
		}, window.athos.fire = (e, ...t) => {
			this.eventManager.fire(e, ...t);
		}), this.context?.shopper?.id && this.tracker.track.shopper.login({ id: this.context.shopper.id }), Object.keys(this.config?.controllers || {}).forEach((e) => {
			switch (e) {
				case "search":
					this.config.controllers[e].forEach((t, n) => {
						try {
							if (this._controllerPromises[t.config.id] !== void 0) {
								this.logger.error(`Controller with id '${t.config.id}' is already defined`);
								return;
							}
							let e = Db({
								mode: this.mode,
								url: (0, pC.default)(this.config.url || {}, t.url || {}),
								controller: t.config,
								context: (0, pC.default)(this.context || {}, t.context || {})
							}, {
								client: t.services?.client || this.client,
								store: t.services?.store,
								urlManager: t.services?.urlManager,
								eventManager: t.services?.eventManager,
								profiler: t.services?.profiler,
								logger: t.services?.logger,
								tracker: t.services?.tracker || this.tracker
							});
							window.athos.controller = window.athos.controller || {}, window.athos.controller[e.config.id] = this.controllers[e.config.id] = e, this._controllerPromises[e.config.id] = new Promise((t) => t(e));
							let n = null, r = async () => (n ||= (t.url?.initial && Zy(t.url.initial, e.urlManager).go({ history: "replace" }), this.controllers[t.config.id].search()), n), i = async (e, n, i) => {
								let a = [];
								e.renderAfterSearch ? a.push(r()) : (a.push(Promise.resolve()), r());
								let o = e.onTarget;
								o && await o(e, n, i);
								try {
									a.push(e.component());
									let [r, i] = await Promise.all(a);
									setTimeout(() => {
										fe(L(i, {
											controller: this.controllers[t.config.id],
											snap: this,
											...e.props
										}), n);
									});
								} catch (t) {
									this.logger.error(t), this.logger.error(yC, e);
								}
							};
							t?.targeters?.forEach((t, n) => {
								if (!t.selector) throw Error(`Targets at index ${n} missing selector value (string).`);
								if (!t.component) throw Error(`Targets at index ${n} missing component value (Component).`);
								let a = this.context.pageType && `${this.context.pageType}`.toLowerCase().trim();
								(t.prefetch || ["search", "category"].includes(a)) && (r(), t.component()), e.createTargeter({
									controller: e,
									...t
								}, async (e, t, n) => {
									if (e && e.skeleton && t) {
										let n = await e.skeleton();
										setTimeout(() => {
											fe(L(n, {}), t);
										});
									}
									await i(e, t, n);
								});
							});
						} catch (t) {
							this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
						}
					});
					break;
				case "autocomplete":
					this.config.controllers[e].forEach((t, n) => {
						if (this._controllerPromises[t.config.id] !== void 0) {
							this.logger.error(`Controller with id '${t.config.id}' is already defined`);
							return;
						}
						this._controllerPromises[t.config.id] = new Promise(async (r) => {
							try {
								let e = !1, n = () => {
									e || (e = !0, setTimeout(() => {
										this.controllers[t.config.id].bind();
									}));
								}, i = async (e, n, r) => {
									let i = e.onTarget;
									i && await i(e, n, r);
									try {
										let i = [];
										i.push(e.component());
										let a = (await Promise.all(i))[0];
										setTimeout(() => {
											fe(L(a, {
												controller: this.controllers[t.config.id],
												input: r,
												snap: this,
												...e.props
											}), n);
										});
									} catch (t) {
										this.logger.error(t), this.logger.error(yC, e);
									}
								};
								(!t?.targeters || t?.targeters.length === 0) && (await this._createController(cy.autocomplete, t.config, t.services, t.url, t.context, (e) => {
									e && r(e);
								}), n()), t?.targeters?.forEach((e, a) => {
									if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
									if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
									let o = new Ml([{
										inject: {
											action: "after",
											element: () => {
												let e = document.createElement("div");
												return e.className = "ss__autocomplete--target", e.addEventListener("click", (e) => {
													e.stopPropagation();
												}), e;
											}
										},
										...e
									}], async (e, a, s) => {
										let c = await this._createController(cy.autocomplete, t.config, t.services, t.url, t.context, (e) => {
											e && r(e);
										});
										n(), i({
											controller: c,
											...e
										}, a, s), c.addTargeter(o);
									});
								});
							} catch (t) {
								this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
							}
						});
					});
					break;
				case "finder":
					this.config.controllers[e].forEach((t, n) => {
						if (this._controllerPromises[t.config.id] !== void 0) {
							this.logger.error(`Controller with id '${t.config.id}' is already defined`);
							return;
						}
						this._controllerPromises[t.config.id] = new Promise((r) => {
							try {
								let e = !1, n = () => {
									e ||= (this.controllers[t.config.id].search(), !0);
								}, i = async (e, n, r) => {
									let i = e.onTarget;
									i && await i(e, n, r);
									try {
										let r = await e.component();
										setTimeout(() => {
											fe(L(r, {
												controller: this.controllers[t.config.id],
												snap: this,
												...e.props
											}), n);
										});
									} catch (t) {
										this.logger.error(t), this.logger.error(yC, e);
									}
								};
								(!t?.targeters || t?.targeters.length === 0) && this._createController(cy.finder, t.config, t.services, t.url, t.context, (e) => {
									e && r(e);
								}), t?.targeters?.forEach((e, a) => {
									if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
									if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
									let o = new Ml([{ ...e }], async (e, a, s) => {
										let c = await this._createController(cy.finder, t.config, t.services, t.url, t.context, (e) => {
											e && r(e);
										});
										n(), i({
											controller: c,
											...e
										}, a, s), c.addTargeter(o);
									});
								});
							} catch (t) {
								this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
							}
						});
					});
					break;
				case "recommendation": this.config.controllers[e].forEach((t, n) => {
					if (this._controllerPromises[t.config.id] !== void 0) {
						this.logger.error(`Controller with id '${t.config.id}' is already defined`);
						return;
					}
					this._controllerPromises[t.config.id] = new Promise((r) => {
						try {
							let e = !1, n = () => {
								e ||= (this.controllers[t.config.id].search(), !0);
							}, i = async (e, n, r) => {
								let i = e.onTarget;
								i && await i(e, n, r);
								try {
									let r = await e.component();
									setTimeout(() => {
										fe(L(r, {
											controller: this.controllers[t.config.id],
											snap: this,
											...e.props
										}), n);
									});
								} catch (t) {
									this.logger.error(t), this.logger.error(yC, e);
								}
							};
							(!t?.targeters || t?.targeters.length === 0) && this._createController(cy.recommendation, t.config, t.services, t.url, t.context, (e) => {
								e && r(e);
							}), t?.targeters?.forEach((e, a) => {
								if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
								if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
								let o = new Ml([{ ...e }], async (e, a, s) => {
									let c = await this._createController(cy.recommendation, t.config, t.services, t.url, t.context, (e) => {
										e && r(e);
									});
									n(), i({
										controller: c,
										...e
									}, a, s), c.addTargeter(o);
								});
							});
						} catch (t) {
							this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
						}
					});
				});
			}
		}), this.config?.instantiators?.recommendation) try {
			this._instantiatorPromises.recommendation = Promise.resolve().then(() => (fC(), iC)).then(({ RecommendationInstantiator: e }) => (this.config.instantiators.recommendation.mode = this.config.instantiators.recommendation.mode || this.mode, new e(this.config.instantiators.recommendation, {
				client: this.client,
				tracker: this.tracker,
				logger: this.logger,
				snap: this
			}, this.context)));
		} catch (e) {
			this.logger.error("Failed to create Recommendations Instantiator.", e);
		}
	}
}, xC = o((() => {})), SC = o((() => {})), CC = o((() => {})), wC = o((() => {
	Q(), $();
})), TC = o((() => {
	wC();
})), EC = o((() => {
	N(), Q(), $();
})), DC = o((() => {
	EC();
})), OC = o((() => {
	$(), Q();
})), kC = o((() => {
	OC();
})), AC = o((() => {
	Q(), $();
})), jC = o((() => {
	AC();
})), MC = o((() => {
	Q(), $();
})), NC = o((() => {
	MC();
})), PC = o((() => {
	YS(), GS();
})), FC = o((() => {
	$(), Q();
})), IC = o((() => {
	FC();
})), LC = o((() => {
	Q(), $(), R();
})), RC = o((() => {
	LC();
})), zC = o((() => {
	N(), Q(), $(), R();
})), BC = o((() => {
	zC();
})), VC = o((() => {
	N(), Q(), R(), $();
})), HC = o((() => {
	VC();
})), UC = o((() => {
	N(), Q(), R(), $();
})), WC = o((() => {
	UC();
})), GC = o((() => {
	N(), Q(), $(), R();
})), KC = o((() => {
	GC();
})), qC = o((() => {
	Q(), $(), R(), N();
})), JC = o((() => {
	qC();
})), YC = o((() => {
	mn(), N(), Q(), $();
})), XC = o((() => {
	YC();
})), ZC = o((() => {
	$(), Q();
})), QC = o((() => {
	ZC();
})), $C = o((() => {
	N(), $(), Q(), R();
})), ew = o((() => {
	$C();
})), tw, nw, rw, iw = o((() => {
	Ei(), Xb(), $(), tw = /* @__PURE__ */ u(Q()), HS(), MS(), nw = { ResultTracker: () => Jb({}) }, rw = bx((e) => {
		let t = Wx("resultTracker", _i(), {}, e), n = {
			impression: !0,
			click: !0
		}, { children: r, result: i, track: a, controller: o, className: s, internalClassName: c, disableStyles: l, style: u } = t, d = {
			...n,
			...a
		}, { ref: f, inViewport: p } = OS();
		p && d.impression && o?.track.product.impression(i);
		let m = {};
		return l ? u && (m.css = [u]) : m.css = [nw.ResultTracker(), u], L("div", {
			className: (0, tw.default)("ss__result-tracker", `ss__${o?.type}-result-tracker`, s, c),
			onClick: (e) => {
				d.click && o?.track.product.click(e, i);
			},
			ref: f,
			...m,
			children: r
		});
	});
})), aw = o((() => {
	iw();
})), ow = o((() => {
	$(), Q(), R();
})), sw = o((() => {
	ow();
})), cw = o((() => {
	$(), Q(), N();
})), lw = o((() => {
	cw();
})), uw = o((() => {})), dw = o((() => {
	uw();
})), fw = o((() => {
	N(), Q(), $(), R();
})), pw = o((() => {
	fw();
})), mw = o((() => {
	Q(), $(), R();
})), hw = o((() => {
	mw();
})), gw = o((() => {
	Q(), $(), R();
})), _w = o((() => {
	gw();
})), vw = o((() => {
	Q(), $(), R();
})), yw = o((() => {
	vw();
})), bw = o((() => {
	Q(), $(), R();
})), xw = o((() => {
	bw();
})), Sw = o((() => {
	N(), $(), Q(), R();
})), Cw = o((() => {
	Sw();
})), ww = o((() => {
	Q(), $(), N(), R();
})), Tw = o((() => {
	ww();
})), Ew = o((() => {
	N(), Q(), $(), R();
})), Dw = o((() => {
	Ew();
})), Ow = o((() => {
	Q(), R(), $();
})), kw = o((() => {
	Ow();
})), Aw = o((() => {
	$(), Q(), R();
})), jw = o((() => {
	$(), Q();
})), Mw = o((() => {
	jw();
})), Nw = o((() => {
	Aw();
})), Pw = o((() => {
	Q(), $();
})), Fw = o((() => {
	Pw();
})), Iw = o((() => {
	N(), $(), Q();
})), Lw = o((() => {
	Iw();
})), Rw = o((() => {
	$(), Q(), R();
})), zw = o((() => {
	Rw();
})), Bw = o((() => {
	Q(), $(), R();
})), Vw = o((() => {
	Bw();
})), Hw = o((() => {
	$(), Q(), R();
})), Uw = o((() => {
	Hw();
})), Ww = o((() => {
	N(), Q(), $(), R();
})), Gw = o((() => {
	Ww();
})), Kw = o((() => {
	N(), $(), Q(), R();
})), qw = o((() => {
	Kw();
})), Jw = o((() => {
	Q(), $(), mn(), R();
})), Yw = o((() => {
	Jw();
})), Xw = o((() => {
	$(), Q(), R();
})), Zw = o((() => {
	Xw();
})), Qw = o((() => {
	$(), Q(), R();
})), $w = o((() => {
	Qw();
})), eT = o((() => {
	$(), Q(), R();
})), tT = o((() => {
	eT();
})), nT = o((() => {
	$(), Q(), R();
})), rT = o((() => {
	$(), Q(), R();
})), iT = o((() => {
	Q(), $();
})), aT = o((() => {
	iT();
})), oT = o((() => {
	Q(), $(), R();
})), sT = o((() => {
	oT();
})), cT = o((() => {
	Q(), $(), R();
})), lT = o((() => {
	cT();
})), uT = o((() => {
	N(), Q(), $(), R();
})), dT = o((() => {
	uT();
})), fT = o((() => {
	N(), Q(), $();
})), pT = o((() => {
	fT();
})), mT = o((() => {
	Q(), $();
})), hT = o((() => {
	mT();
})), gT = o((() => {
	$(), Q(), R();
})), _T = o((() => {
	gT();
})), vT = o((() => {
	N(), $(), Q(), R();
})), yT = o((() => {
	$();
})), bT = o((() => {
	yT();
})), xT = o((() => {
	vT();
})), ST = o((() => {
	$();
})), CT = o((() => {
	ST();
}));
//#endregion
//#region node_modules/swiper/shared/ssr-window.esm.mjs
function wT(e) {
	return typeof e == "object" && !!e && "constructor" in e && e.constructor === Object;
}
function TT(e, t) {
	e === void 0 && (e = {}), t === void 0 && (t = {}), Object.keys(t).forEach((n) => {
		e[n] === void 0 ? e[n] = t[n] : wT(t[n]) && wT(e[n]) && Object.keys(t[n]).length > 0 && TT(e[n], t[n]);
	});
}
function ET() {
	let e = typeof document < "u" ? document : {};
	return TT(e, OT), e;
}
function DT() {
	let e = typeof window < "u" ? window : {};
	return TT(e, kT), e;
}
var OT, kT, AT = o((() => {
	OT = {
		body: {},
		addEventListener() {},
		removeEventListener() {},
		activeElement: {
			blur() {},
			nodeName: ""
		},
		querySelector() {
			return null;
		},
		querySelectorAll() {
			return [];
		},
		getElementById() {
			return null;
		},
		createEvent() {
			return { initEvent() {} };
		},
		createElement() {
			return {
				children: [],
				childNodes: [],
				style: {},
				setAttribute() {},
				getElementsByTagName() {
					return [];
				}
			};
		},
		createElementNS() {
			return {};
		},
		importNode() {
			return null;
		},
		location: {
			hash: "",
			host: "",
			hostname: "",
			href: "",
			origin: "",
			pathname: "",
			protocol: "",
			search: ""
		}
	}, kT = {
		document: OT,
		navigator: { userAgent: "" },
		location: {
			hash: "",
			host: "",
			hostname: "",
			href: "",
			origin: "",
			pathname: "",
			protocol: "",
			search: ""
		},
		history: {
			replaceState() {},
			pushState() {},
			go() {},
			back() {}
		},
		CustomEvent: function() {
			return this;
		},
		addEventListener() {},
		removeEventListener() {},
		getComputedStyle() {
			return { getPropertyValue() {
				return "";
			} };
		},
		Image() {},
		Date() {},
		screen: {},
		setTimeout() {},
		clearTimeout() {},
		matchMedia() {
			return {};
		},
		requestAnimationFrame(e) {
			return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
		},
		cancelAnimationFrame(e) {
			typeof setTimeout > "u" || clearTimeout(e);
		}
	};
}));
//#endregion
//#region node_modules/swiper/shared/utils.mjs
function jT(e) {
	return e === void 0 && (e = ""), e.trim().split(" ").filter((e) => !!e.trim());
}
function MT(e) {
	let t = e;
	Object.keys(t).forEach((e) => {
		try {
			t[e] = null;
		} catch {}
		try {
			delete t[e];
		} catch {}
	});
}
function NT(e, t) {
	return t === void 0 && (t = 0), setTimeout(e, t);
}
function PT() {
	return Date.now();
}
function FT(e) {
	let t = DT(), n;
	return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n ||= e.style, n;
}
function IT(e, t) {
	t === void 0 && (t = "x");
	let n = DT(), r, i, a, o = FT(e);
	return n.WebKitCSSMatrix ? (i = o.transform || o.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((e) => e.replace(",", ".")).join(", ")), a = new n.WebKitCSSMatrix(i === "none" ? "" : i)) : (a = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = a.toString().split(",")), t === "x" && (i = n.WebKitCSSMatrix ? a.m41 : r.length === 16 ? parseFloat(r[12]) : parseFloat(r[4])), t === "y" && (i = n.WebKitCSSMatrix ? a.m42 : r.length === 16 ? parseFloat(r[13]) : parseFloat(r[5])), i || 0;
}
function LT(e) {
	return typeof e == "object" && !!e && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function RT(e) {
	return typeof window < "u" && window.HTMLElement !== void 0 ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function zT() {
	let e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = [
		"__proto__",
		"constructor",
		"prototype"
	];
	for (let n = 1; n < arguments.length; n += 1) {
		let r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
		if (r != null && !RT(r)) {
			let n = Object.keys(Object(r)).filter((e) => t.indexOf(e) < 0);
			for (let t = 0, i = n.length; t < i; t += 1) {
				let i = n[t], a = Object.getOwnPropertyDescriptor(r, i);
				a !== void 0 && a.enumerable && (LT(e[i]) && LT(r[i]) ? r[i].__swiper__ ? e[i] = r[i] : zT(e[i], r[i]) : !LT(e[i]) && LT(r[i]) ? (e[i] = {}, r[i].__swiper__ ? e[i] = r[i] : zT(e[i], r[i])) : e[i] = r[i]);
			}
		}
	}
	return e;
}
function BT(e, t, n) {
	e.style.setProperty(t, n);
}
function VT(e) {
	let { swiper: t, targetPosition: n, side: r } = e, i = DT(), a = -t.translate, o = null, s, c = t.params.speed;
	t.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(t.cssModeFrameID);
	let l = n > a ? "next" : "prev", u = (e, t) => l === "next" && e >= t || l === "prev" && e <= t, d = () => {
		s = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = s);
		let e = Math.max(Math.min((s - o) / c, 1), 0), l = .5 - Math.cos(e * Math.PI) / 2, f = a + l * (n - a);
		if (u(f, n) && (f = n), t.wrapperEl.scrollTo({ [r]: f }), u(f, n)) {
			t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
				t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({ [r]: f });
			}), i.cancelAnimationFrame(t.cssModeFrameID);
			return;
		}
		t.cssModeFrameID = i.requestAnimationFrame(d);
	};
	d();
}
function HT(e, t) {
	return t === void 0 && (t = ""), [...e.children].filter((e) => e.matches(t));
}
function UT(e) {
	try {
		console.warn(e);
		return;
	} catch {}
}
function WT(e, t) {
	t === void 0 && (t = []);
	let n = document.createElement(e);
	return n.classList.add(...Array.isArray(t) ? t : jT(t)), n;
}
function GT(e, t) {
	let n = [];
	for (; e.previousElementSibling;) {
		let r = e.previousElementSibling;
		t ? r.matches(t) && n.push(r) : n.push(r), e = r;
	}
	return n;
}
function KT(e, t) {
	let n = [];
	for (; e.nextElementSibling;) {
		let r = e.nextElementSibling;
		t ? r.matches(t) && n.push(r) : n.push(r), e = r;
	}
	return n;
}
function qT(e, t) {
	return DT().getComputedStyle(e, null).getPropertyValue(t);
}
function JT(e) {
	let t = e, n;
	if (t) {
		for (n = 0; (t = t.previousSibling) !== null;) t.nodeType === 1 && (n += 1);
		return n;
	}
}
function YT(e, t) {
	let n = [], r = e.parentElement;
	for (; r;) t ? r.matches(t) && n.push(r) : n.push(r), r = r.parentElement;
	return n;
}
function XT(e, t, n) {
	let r = DT();
	return n ? e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
var ZT = o((() => {
	AT();
}));
//#endregion
//#region node_modules/swiper/shared/swiper-core.mjs
function QT() {
	let e = DT(), t = ET();
	return {
		smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
		touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
	};
}
function $T() {
	return nD ||= QT(), nD;
}
function eE(e) {
	let { userAgent: t } = e === void 0 ? {} : e, n = $T(), r = DT(), i = r.navigator.platform, a = t || r.navigator.userAgent, o = {
		ios: !1,
		android: !1
	}, s = r.screen.width, c = r.screen.height, l = a.match(/(Android);?[\s\/]+([\d.]+)?/), u = a.match(/(iPad).*OS\s([\d_]+)/), d = a.match(/(iPod)(.*OS\s([\d_]+))?/), f = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), p = i === "Win32", m = i === "MacIntel";
	return !u && m && n.touch && [
		"1024x1366",
		"1366x1024",
		"834x1194",
		"1194x834",
		"834x1112",
		"1112x834",
		"768x1024",
		"1024x768",
		"820x1180",
		"1180x820",
		"810x1080",
		"1080x810"
	].indexOf(`${s}x${c}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u ||= [
		0,
		1,
		"13_0_0"
	], m = !1), l && !p && (o.os = "android", o.android = !0), (u || f || d) && (o.os = "ios", o.ios = !0), o;
}
function tE(e) {
	return e === void 0 && (e = {}), rD ||= eE(e), rD;
}
function nE() {
	let e = DT(), t = tE(), n = !1;
	function r() {
		let t = e.navigator.userAgent.toLowerCase();
		return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
	}
	if (r()) {
		let t = String(e.navigator.userAgent);
		if (t.includes("Version/")) {
			let [e, r] = t.split("Version/")[1].split(" ")[0].split(".").map((e) => Number(e));
			n = e < 16 || e === 16 && r < 2;
		}
	}
	let i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), a = r(), o = a || i && t.ios;
	return {
		isSafari: n || a,
		needPerspectiveFix: n,
		need3dFix: o,
		isWebView: i
	};
}
function rE() {
	return iD ||= nE(), iD;
}
function iE(e) {
	let { swiper: t, on: n, emit: r } = e, i = DT(), a = null, o = null, s = () => {
		!t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
	}, c = () => {
		!t || t.destroyed || !t.initialized || (a = new ResizeObserver((e) => {
			o = i.requestAnimationFrame(() => {
				let { width: n, height: r } = t, i = n, a = r;
				e.forEach((e) => {
					let { contentBoxSize: n, contentRect: r, target: o } = e;
					o && o !== t.el || (i = r ? r.width : (n[0] || n).inlineSize, a = r ? r.height : (n[0] || n).blockSize);
				}), (i !== n || a !== r) && s();
			});
		}), a.observe(t.el));
	}, l = () => {
		o && i.cancelAnimationFrame(o), a && a.unobserve && t.el && (a.unobserve(t.el), a = null);
	}, u = () => {
		!t || t.destroyed || !t.initialized || r("orientationchange");
	};
	n("init", () => {
		if (t.params.resizeObserver && i.ResizeObserver !== void 0) {
			c();
			return;
		}
		i.addEventListener("resize", s), i.addEventListener("orientationchange", u);
	}), n("destroy", () => {
		l(), i.removeEventListener("resize", s), i.removeEventListener("orientationchange", u);
	});
}
function aE(e) {
	let { swiper: t, extendParams: n, on: r, emit: i } = e, a = [], o = DT(), s = function(e, n) {
		n === void 0 && (n = {});
		let r = new (o.MutationObserver || o.WebkitMutationObserver)((e) => {
			if (t.__preventObserver__) return;
			if (e.length === 1) {
				i("observerUpdate", e[0]);
				return;
			}
			let n = function() {
				i("observerUpdate", e[0]);
			};
			o.requestAnimationFrame ? o.requestAnimationFrame(n) : o.setTimeout(n, 0);
		});
		r.observe(e, {
			attributes: n.attributes === void 0 || n.attributes,
			childList: n.childList === void 0 || n.childList,
			characterData: n.characterData === void 0 || n.characterData
		}), a.push(r);
	};
	n({
		observer: !1,
		observeParents: !1,
		observeSlideChildren: !1
	}), r("init", () => {
		if (t.params.observer) {
			if (t.params.observeParents) {
				let e = YT(t.hostEl);
				for (let t = 0; t < e.length; t += 1) s(e[t]);
			}
			s(t.hostEl, { childList: t.params.observeSlideChildren }), s(t.wrapperEl, { attributes: !1 });
		}
	}), r("destroy", () => {
		a.forEach((e) => {
			e.disconnect();
		}), a.splice(0, a.length);
	});
}
function oE() {
	let e = this, t, n, r = e.el;
	t = e.params.width !== void 0 && e.params.width !== null ? e.params.width : r.clientWidth, n = e.params.height !== void 0 && e.params.height !== null ? e.params.height : r.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(qT(r, "padding-left") || 0, 10) - parseInt(qT(r, "padding-right") || 0, 10), n = n - parseInt(qT(r, "padding-top") || 0, 10) - parseInt(qT(r, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
		width: t,
		height: n,
		size: e.isHorizontal() ? t : n
	}));
}
function sE() {
	let e = this;
	function t(t, n) {
		return parseFloat(t.getPropertyValue(e.getDirectionLabel(n)) || 0);
	}
	let n = e.params, { wrapperEl: r, slidesEl: i, size: a, rtlTranslate: o, wrongRTL: s } = e, c = e.virtual && n.virtual.enabled, l = c ? e.virtual.slides.length : e.slides.length, u = HT(i, `.${e.params.slideClass}, swiper-slide`), d = c ? e.virtual.slides.length : u.length, f = [], p = [], m = [], h = n.slidesOffsetBefore;
	typeof h == "function" && (h = n.slidesOffsetBefore.call(e));
	let g = n.slidesOffsetAfter;
	typeof g == "function" && (g = n.slidesOffsetAfter.call(e));
	let _ = e.snapGrid.length, v = e.slidesGrid.length, y = n.spaceBetween, b = -h, x = 0, S = 0;
	if (a === void 0) return;
	typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * a : typeof y == "string" && (y = parseFloat(y)), e.virtualSize = -y, u.forEach((e) => {
		o ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
	}), n.centeredSlides && n.cssMode && (BT(r, "--swiper-centered-offset-before", ""), BT(r, "--swiper-centered-offset-after", ""));
	let C = n.grid && n.grid.rows > 1 && e.grid;
	C ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
	let w, T = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((e) => n.breakpoints[e].slidesPerView !== void 0).length > 0;
	for (let r = 0; r < d; r += 1) {
		w = 0;
		let i;
		if (u[r] && (i = u[r]), C && e.grid.updateSlide(r, i, u), !(u[r] && qT(i, "display") === "none")) {
			if (n.slidesPerView === "auto") {
				T && (u[r].style[e.getDirectionLabel("width")] = "");
				let a = getComputedStyle(i), o = i.style.transform, s = i.style.webkitTransform;
				if (o && (i.style.transform = "none"), s && (i.style.webkitTransform = "none"), n.roundLengths) w = e.isHorizontal() ? XT(i, "width", !0) : XT(i, "height", !0);
				else {
					let e = t(a, "width"), n = t(a, "padding-left"), r = t(a, "padding-right"), o = t(a, "margin-left"), s = t(a, "margin-right"), c = a.getPropertyValue("box-sizing");
					if (c && c === "border-box") w = e + o + s;
					else {
						let { clientWidth: t, offsetWidth: a } = i;
						w = e + n + r + o + s + (a - t);
					}
				}
				o && (i.style.transform = o), s && (i.style.webkitTransform = s), n.roundLengths && (w = Math.floor(w));
			} else w = (a - (n.slidesPerView - 1) * y) / n.slidesPerView, n.roundLengths && (w = Math.floor(w)), u[r] && (u[r].style[e.getDirectionLabel("width")] = `${w}px`);
			u[r] && (u[r].swiperSlideSize = w), m.push(w), n.centeredSlides ? (b = b + w / 2 + x / 2 + y, x === 0 && r !== 0 && (b = b - a / 2 - y), r === 0 && (b = b - a / 2 - y), Math.abs(b) < 1 / 1e3 && (b = 0), n.roundLengths && (b = Math.floor(b)), S % n.slidesPerGroup === 0 && f.push(b), p.push(b)) : (n.roundLengths && (b = Math.floor(b)), (S - Math.min(e.params.slidesPerGroupSkip, S)) % e.params.slidesPerGroup === 0 && f.push(b), p.push(b), b = b + w + y), e.virtualSize += w + y, x = w, S += 1;
		}
	}
	if (e.virtualSize = Math.max(e.virtualSize, a) + g, o && s && (n.effect === "slide" || n.effect === "coverflow") && (r.style.width = `${e.virtualSize + y}px`), n.setWrapperSize && (r.style[e.getDirectionLabel("width")] = `${e.virtualSize + y}px`), C && e.grid.updateWrapperSize(w, f), !n.centeredSlides) {
		let t = [];
		for (let r = 0; r < f.length; r += 1) {
			let i = f[r];
			n.roundLengths && (i = Math.floor(i)), f[r] <= e.virtualSize - a && t.push(i);
		}
		f = t, Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - a);
	}
	if (c && n.loop) {
		let t = m[0] + y;
		if (n.slidesPerGroup > 1) {
			let r = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup), i = t * n.slidesPerGroup;
			for (let e = 0; e < r; e += 1) f.push(f[f.length - 1] + i);
		}
		for (let r = 0; r < e.virtual.slidesBefore + e.virtual.slidesAfter; r += 1) n.slidesPerGroup === 1 && f.push(f[f.length - 1] + t), p.push(p[p.length - 1] + t), e.virtualSize += t;
	}
	if (f.length === 0 && (f = [0]), y !== 0) {
		let t = e.isHorizontal() && o ? "marginLeft" : e.getDirectionLabel("marginRight");
		u.filter((e, t) => !n.cssMode || n.loop ? !0 : t !== u.length - 1).forEach((e) => {
			e.style[t] = `${y}px`;
		});
	}
	if (n.centeredSlides && n.centeredSlidesBounds) {
		let e = 0;
		m.forEach((t) => {
			e += t + (y || 0);
		}), e -= y;
		let t = e - a;
		f = f.map((e) => e <= 0 ? -h : e > t ? t + g : e);
	}
	if (n.centerInsufficientSlides) {
		let e = 0;
		if (m.forEach((t) => {
			e += t + (y || 0);
		}), e -= y, e < a) {
			let t = (a - e) / 2;
			f.forEach((e, n) => {
				f[n] = e - t;
			}), p.forEach((e, n) => {
				p[n] = e + t;
			});
		}
	}
	if (Object.assign(e, {
		slides: u,
		snapGrid: f,
		slidesGrid: p,
		slidesSizesGrid: m
	}), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
		BT(r, "--swiper-centered-offset-before", `${-f[0]}px`), BT(r, "--swiper-centered-offset-after", `${e.size / 2 - m[m.length - 1] / 2}px`);
		let t = -e.snapGrid[0], n = -e.slidesGrid[0];
		e.snapGrid = e.snapGrid.map((e) => e + t), e.slidesGrid = e.slidesGrid.map((e) => e + n);
	}
	if (d !== l && e.emit("slidesLengthChange"), f.length !== _ && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), p.length !== v && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !c && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
		let t = `${n.containerModifierClass}backface-hidden`, r = e.el.classList.contains(t);
		d <= n.maxBackfaceHiddenSlides ? r || e.el.classList.add(t) : r && e.el.classList.remove(t);
	}
}
function cE(e) {
	let t = this, n = [], r = t.virtual && t.params.virtual.enabled, i = 0, a;
	typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
	let o = (e) => r ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
	if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1) {
		if (t.params.centeredSlides) (t.visibleSlides || []).forEach((e) => {
			n.push(e);
		});
		else for (a = 0; a < Math.ceil(t.params.slidesPerView); a += 1) {
			let e = t.activeIndex + a;
			if (e > t.slides.length && !r) break;
			n.push(o(e));
		}
	} else n.push(o(t.activeIndex));
	for (a = 0; a < n.length; a += 1) if (n[a] !== void 0) {
		let e = n[a].offsetHeight;
		i = e > i ? e : i;
	}
	(i || i === 0) && (t.wrapperEl.style.height = `${i}px`);
}
function lE() {
	let e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
	for (let r = 0; r < t.length; r += 1) t[r].swiperSlideOffset = (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) - n - e.cssOverflowAdjustment();
}
function uE(e) {
	e === void 0 && (e = this && this.translate || 0);
	let t = this, n = t.params, { slides: r, rtlTranslate: i, snapGrid: a } = t;
	if (r.length === 0) return;
	r[0].swiperSlideOffset === void 0 && t.updateSlidesOffset();
	let o = -e;
	i && (o = e), r.forEach((e) => {
		e.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass);
	}), t.visibleSlidesIndexes = [], t.visibleSlides = [];
	let s = n.spaceBetween;
	typeof s == "string" && s.indexOf("%") >= 0 ? s = parseFloat(s.replace("%", "")) / 100 * t.size : typeof s == "string" && (s = parseFloat(s));
	for (let e = 0; e < r.length; e += 1) {
		let c = r[e], l = c.swiperSlideOffset;
		n.cssMode && n.centeredSlides && (l -= r[0].swiperSlideOffset);
		let u = (o + (n.centeredSlides ? t.minTranslate() : 0) - l) / (c.swiperSlideSize + s), d = (o - a[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) / (c.swiperSlideSize + s), f = -(o - l), p = f + t.slidesSizesGrid[e], m = f >= 0 && f <= t.size - t.slidesSizesGrid[e];
		(f >= 0 && f < t.size - 1 || p > 1 && p <= t.size || f <= 0 && p >= t.size) && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(e), r[e].classList.add(n.slideVisibleClass)), m && r[e].classList.add(n.slideFullyVisibleClass), c.progress = i ? -u : u, c.originalProgress = i ? -d : d;
	}
}
function dE(e) {
	let t = this;
	if (e === void 0) {
		let n = t.rtlTranslate ? -1 : 1;
		e = t && t.translate && t.translate * n || 0;
	}
	let n = t.params, r = t.maxTranslate() - t.minTranslate(), { progress: i, isBeginning: a, isEnd: o, progressLoop: s } = t, c = a, l = o;
	if (r === 0) i = 0, a = !0, o = !0;
	else {
		i = (e - t.minTranslate()) / r;
		let n = Math.abs(e - t.minTranslate()) < 1, s = Math.abs(e - t.maxTranslate()) < 1;
		a = n || i <= 0, o = s || i >= 1, n && (i = 0), s && (i = 1);
	}
	if (n.loop) {
		let n = t.getSlideIndexByData(0), r = t.getSlideIndexByData(t.slides.length - 1), i = t.slidesGrid[n], a = t.slidesGrid[r], o = t.slidesGrid[t.slidesGrid.length - 1], c = Math.abs(e);
		s = c >= i ? (c - i) / o : (c + o - a) / o, s > 1 && --s;
	}
	Object.assign(t, {
		progress: i,
		progressLoop: s,
		isBeginning: a,
		isEnd: o
	}), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), a && !c && t.emit("reachBeginning toEdge"), o && !l && t.emit("reachEnd toEdge"), (c && !a || l && !o) && t.emit("fromEdge"), t.emit("progress", i);
}
function fE() {
	let e = this, { slides: t, params: n, slidesEl: r, activeIndex: i } = e, a = e.virtual && n.virtual.enabled, o = e.grid && n.grid && n.grid.rows > 1, s = (e) => HT(r, `.${n.slideClass}${e}, swiper-slide${e}`)[0];
	t.forEach((e) => {
		e.classList.remove(n.slideActiveClass, n.slideNextClass, n.slidePrevClass);
	});
	let c, l, u;
	if (a) {
		if (n.loop) {
			let t = i - e.virtual.slidesBefore;
			t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), c = s(`[data-swiper-slide-index="${t}"]`);
		} else c = s(`[data-swiper-slide-index="${i}"]`);
	} else o ? (c = t.filter((e) => e.column === i)[0], u = t.filter((e) => e.column === i + 1)[0], l = t.filter((e) => e.column === i - 1)[0]) : c = t[i];
	c && (c.classList.add(n.slideActiveClass), o ? (u && u.classList.add(n.slideNextClass), l && l.classList.add(n.slidePrevClass)) : (u = KT(c, `.${n.slideClass}, swiper-slide`)[0], n.loop && !u && (u = t[0]), u && u.classList.add(n.slideNextClass), l = GT(c, `.${n.slideClass}, swiper-slide`)[0], n.loop, l && l.classList.add(n.slidePrevClass))), e.emitSlidesClasses();
}
function pE(e) {
	let { slidesGrid: t, params: n } = e, r = e.rtlTranslate ? e.translate : -e.translate, i;
	for (let e = 0; e < t.length; e += 1) t[e + 1] === void 0 ? r >= t[e] && (i = e) : r >= t[e] && r < t[e + 1] - (t[e + 1] - t[e]) / 2 ? i = e : r >= t[e] && r < t[e + 1] && (i = e + 1);
	return n.normalizeSlideIndex && (i < 0 || i === void 0) && (i = 0), i;
}
function mE(e) {
	let t = this, n = t.rtlTranslate ? t.translate : -t.translate, { snapGrid: r, params: i, activeIndex: a, realIndex: o, snapIndex: s } = t, c = e, l, u = (e) => {
		let n = e - t.virtual.slidesBefore;
		return n < 0 && (n = t.virtual.slides.length + n), n >= t.virtual.slides.length && (n -= t.virtual.slides.length), n;
	};
	if (c === void 0 && (c = pE(t)), r.indexOf(n) >= 0) l = r.indexOf(n);
	else {
		let e = Math.min(i.slidesPerGroupSkip, c);
		l = e + Math.floor((c - e) / i.slidesPerGroup);
	}
	if (l >= r.length && (l = r.length - 1), c === a && !t.params.loop) {
		l !== s && (t.snapIndex = l, t.emit("snapIndexChange"));
		return;
	}
	if (c === a && t.params.loop && t.virtual && t.params.virtual.enabled) {
		t.realIndex = u(c);
		return;
	}
	let d = t.grid && i.grid && i.grid.rows > 1, f;
	if (t.virtual && i.virtual.enabled && i.loop) f = u(c);
	else if (d) {
		let e = t.slides.filter((e) => e.column === c)[0], n = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
		Number.isNaN(n) && (n = Math.max(t.slides.indexOf(e), 0)), f = Math.floor(n / i.grid.rows);
	} else if (t.slides[c]) {
		let e = t.slides[c].getAttribute("data-swiper-slide-index");
		f = e ? parseInt(e, 10) : c;
	} else f = c;
	Object.assign(t, {
		previousSnapIndex: s,
		snapIndex: l,
		previousRealIndex: o,
		realIndex: f,
		previousIndex: a,
		activeIndex: c
	}), t.initialized && cD(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (o !== f && t.emit("realIndexChange"), t.emit("slideChange"));
}
function hE(e, t) {
	let n = this, r = n.params, i = e.closest(`.${r.slideClass}, swiper-slide`);
	!i && n.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
		!i && e.matches && e.matches(`.${r.slideClass}, swiper-slide`) && (i = e);
	});
	let a = !1, o;
	if (i) {
		for (let e = 0; e < n.slides.length; e += 1) if (n.slides[e] === i) {
			a = !0, o = e;
			break;
		}
	}
	if (i && a) n.clickedSlide = i, n.clickedIndex = n.virtual && n.params.virtual.enabled ? parseInt(i.getAttribute("data-swiper-slide-index"), 10) : o;
	else {
		n.clickedSlide = void 0, n.clickedIndex = void 0;
		return;
	}
	r.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
function gE(e) {
	e === void 0 && (e = this.isHorizontal() ? "x" : "y");
	let t = this, { params: n, rtlTranslate: r, translate: i, wrapperEl: a } = t;
	if (n.virtualTranslate) return r ? -i : i;
	if (n.cssMode) return i;
	let o = IT(a, e);
	return o += t.cssOverflowAdjustment(), r && (o = -o), o || 0;
}
function _E(e, t) {
	let n = this, { rtlTranslate: r, params: i, wrapperEl: a, progress: o } = n, s = 0, c = 0;
	n.isHorizontal() ? s = r ? -e : e : c = e, i.roundLengths && (s = Math.floor(s), c = Math.floor(c)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? s : c, i.cssMode ? a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -s : -c : i.virtualTranslate || (n.isHorizontal() ? s -= n.cssOverflowAdjustment() : c -= n.cssOverflowAdjustment(), a.style.transform = `translate3d(${s}px, ${c}px, 0px)`);
	let l, u = n.maxTranslate() - n.minTranslate();
	l = u === 0 ? 0 : (e - n.minTranslate()) / u, l !== o && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function vE() {
	return -this.snapGrid[0];
}
function yE() {
	return -this.snapGrid[this.snapGrid.length - 1];
}
function bE(e, t, n, r, i) {
	e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), r === void 0 && (r = !0);
	let a = this, { params: o, wrapperEl: s } = a;
	if (a.animating && o.preventInteractionOnTransition) return !1;
	let c = a.minTranslate(), l = a.maxTranslate(), u;
	if (u = r && e > c ? c : r && e < l ? l : e, a.updateProgress(u), o.cssMode) {
		let e = a.isHorizontal();
		if (t === 0) s[e ? "scrollLeft" : "scrollTop"] = -u;
		else {
			if (!a.support.smoothScroll) return VT({
				swiper: a,
				targetPosition: -u,
				side: e ? "left" : "top"
			}), !0;
			s.scrollTo({
				[e ? "left" : "top"]: -u,
				behavior: "smooth"
			});
		}
		return !0;
	}
	return t === 0 ? (a.setTransition(0), a.setTranslate(u), n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionEnd"))) : (a.setTransition(t), a.setTranslate(u), n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd ||= function(e) {
		!a || a.destroyed || e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, n && a.emit("transitionEnd"));
	}, a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
function xE(e, t) {
	let n = this;
	n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), n.emit("setTransition", e, t);
}
function SE(e) {
	let { swiper: t, runCallbacks: n, direction: r, step: i } = e, { activeIndex: a, previousIndex: o } = t, s = r;
	if (s ||= a > o ? "next" : a < o ? "prev" : "reset", t.emit(`transition${i}`), n && a !== o) {
		if (s === "reset") {
			t.emit(`slideResetTransition${i}`);
			return;
		}
		t.emit(`slideChangeTransition${i}`), s === "next" ? t.emit(`slideNextTransition${i}`) : t.emit(`slidePrevTransition${i}`);
	}
}
function CE(e, t) {
	e === void 0 && (e = !0);
	let n = this, { params: r } = n;
	r.cssMode || (r.autoHeight && n.updateAutoHeight(), SE({
		swiper: n,
		runCallbacks: e,
		direction: t,
		step: "Start"
	}));
}
function wE(e, t) {
	e === void 0 && (e = !0);
	let n = this, { params: r } = n;
	n.animating = !1, !r.cssMode && (n.setTransition(0), SE({
		swiper: n,
		runCallbacks: e,
		direction: t,
		step: "End"
	}));
}
function TE(e, t, n, r, i) {
	e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
	let a = this, o = e;
	o < 0 && (o = 0);
	let { params: s, snapGrid: c, slidesGrid: l, previousIndex: u, activeIndex: d, rtlTranslate: f, wrapperEl: p, enabled: m } = a;
	if (a.animating && s.preventInteractionOnTransition || !m && !r && !i || a.destroyed) return !1;
	let h = Math.min(a.params.slidesPerGroupSkip, o), g = h + Math.floor((o - h) / a.params.slidesPerGroup);
	g >= c.length && (g = c.length - 1);
	let _ = -c[g];
	if (s.normalizeSlideIndex) for (let e = 0; e < l.length; e += 1) {
		let t = -Math.floor(_ * 100), n = Math.floor(l[e] * 100), r = Math.floor(l[e + 1] * 100);
		l[e + 1] === void 0 ? t >= n && (o = e) : t >= n && t < r - (r - n) / 2 ? o = e : t >= n && t < r && (o = e + 1);
	}
	if (a.initialized && o !== d && (!a.allowSlideNext && (f ? _ > a.translate && _ > a.minTranslate() : _ < a.translate && _ < a.minTranslate()) || !a.allowSlidePrev && _ > a.translate && _ > a.maxTranslate() && (d || 0) !== o)) return !1;
	o !== (u || 0) && n && a.emit("beforeSlideChangeStart"), a.updateProgress(_);
	let v;
	if (v = o > d ? "next" : o < d ? "prev" : "reset", f && -_ === a.translate || !f && _ === a.translate) return a.updateActiveIndex(o), s.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), s.effect !== "slide" && a.setTranslate(_), v !== "reset" && (a.transitionStart(n, v), a.transitionEnd(n, v)), !1;
	if (s.cssMode) {
		let e = a.isHorizontal(), n = f ? _ : -_;
		if (t === 0) {
			let t = a.virtual && a.params.virtual.enabled;
			t && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), t && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
				p[e ? "scrollLeft" : "scrollTop"] = n;
			})) : p[e ? "scrollLeft" : "scrollTop"] = n, t && requestAnimationFrame(() => {
				a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
			});
		} else {
			if (!a.support.smoothScroll) return VT({
				swiper: a,
				targetPosition: n,
				side: e ? "left" : "top"
			}), !0;
			p.scrollTo({
				[e ? "left" : "top"]: n,
				behavior: "smooth"
			});
		}
		return !0;
	}
	return a.setTransition(t), a.setTranslate(_), a.updateActiveIndex(o), a.updateSlidesClasses(), a.emit("beforeTransitionStart", t, r), a.transitionStart(n, v), t === 0 ? a.transitionEnd(n, v) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd ||= function(e) {
		!a || a.destroyed || e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(n, v));
	}, a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function EE(e, t, n, r) {
	e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
	let i = this;
	if (i.destroyed) return;
	let a = i.grid && i.params.grid && i.params.grid.rows > 1, o = e;
	if (i.params.loop) {
		if (i.virtual && i.params.virtual.enabled) o += i.virtual.slidesBefore;
		else {
			let e;
			if (a) {
				let t = o * i.params.grid.rows;
				e = i.slides.filter((e) => e.getAttribute("data-swiper-slide-index") * 1 === t)[0].column;
			} else e = i.getSlideIndexByData(o);
			let t = a ? Math.ceil(i.slides.length / i.params.grid.rows) : i.slides.length, { centeredSlides: n } = i.params, r = i.params.slidesPerView;
			r === "auto" ? r = i.slidesPerViewDynamic() : (r = Math.ceil(parseFloat(i.params.slidesPerView, 10)), n && r % 2 == 0 && (r += 1));
			let s = t - e < r;
			if (n && (s ||= e < Math.ceil(r / 2)), s) {
				let r = n ? e < i.activeIndex ? "prev" : "next" : e - i.activeIndex - 1 < i.params.slidesPerView ? "next" : "prev";
				i.loopFix({
					direction: r,
					slideTo: !0,
					activeSlideIndex: r === "next" ? e + 1 : e - t + 1,
					slideRealIndex: r === "next" ? i.realIndex : void 0
				});
			}
			if (a) {
				let e = o * i.params.grid.rows;
				o = i.slides.filter((t) => t.getAttribute("data-swiper-slide-index") * 1 === e)[0].column;
			} else o = i.getSlideIndexByData(o);
		}
	}
	return requestAnimationFrame(() => {
		i.slideTo(o, t, n, r);
	}), i;
}
function DE(e, t, n) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
	let r = this, { enabled: i, params: a, animating: o } = r;
	if (!i || r.destroyed) return r;
	let s = a.slidesPerGroup;
	a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (s = Math.max(r.slidesPerViewDynamic("current", !0), 1));
	let c = r.activeIndex < a.slidesPerGroupSkip ? 1 : s, l = r.virtual && a.virtual.enabled;
	if (a.loop) {
		if (o && !l && a.loopPreventsSliding) return !1;
		if (r.loopFix({ direction: "next" }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && a.cssMode) return requestAnimationFrame(() => {
			r.slideTo(r.activeIndex + c, e, t, n);
		}), !0;
	}
	return a.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + c, e, t, n);
}
function OE(e, t, n) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
	let r = this, { params: i, snapGrid: a, slidesGrid: o, rtlTranslate: s, enabled: c, animating: l } = r;
	if (!c || r.destroyed) return r;
	let u = r.virtual && i.virtual.enabled;
	if (i.loop) {
		if (l && !u && i.loopPreventsSliding) return !1;
		r.loopFix({ direction: "prev" }), r._clientLeft = r.wrapperEl.clientLeft;
	}
	let d = s ? r.translate : -r.translate;
	function f(e) {
		return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
	}
	let p = f(d), m = a[a.map((e) => f(e)).indexOf(p) - 1];
	if (m === void 0 && i.cssMode) {
		let e;
		a.forEach((t, n) => {
			p >= t && (e = n);
		}), e !== void 0 && (m = a[e > 0 ? e - 1 : e]);
	}
	let h = 0;
	if (m !== void 0 && (h = o.indexOf(m), h < 0 && (h = r.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (h = h - r.slidesPerViewDynamic("previous", !0) + 1, h = Math.max(h, 0))), i.rewind && r.isBeginning) {
		let i = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
		return r.slideTo(i, e, t, n);
	}
	return i.loop && r.activeIndex === 0 && i.cssMode ? (requestAnimationFrame(() => {
		r.slideTo(h, e, t, n);
	}), !0) : r.slideTo(h, e, t, n);
}
function kE(e, t, n) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
	let r = this;
	if (!r.destroyed) return r.slideTo(r.activeIndex, e, t, n);
}
function AE(e, t, n, r) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), r === void 0 && (r = .5);
	let i = this;
	if (i.destroyed) return;
	let a = i.activeIndex, o = Math.min(i.params.slidesPerGroupSkip, a), s = o + Math.floor((a - o) / i.params.slidesPerGroup), c = i.rtlTranslate ? i.translate : -i.translate;
	if (c >= i.snapGrid[s]) {
		let e = i.snapGrid[s], t = i.snapGrid[s + 1];
		c - e > (t - e) * r && (a += i.params.slidesPerGroup);
	} else {
		let e = i.snapGrid[s - 1], t = i.snapGrid[s];
		c - e <= (t - e) * r && (a -= i.params.slidesPerGroup);
	}
	return a = Math.max(a, 0), a = Math.min(a, i.slidesGrid.length - 1), i.slideTo(a, e, t, n);
}
function jE() {
	let e = this;
	if (e.destroyed) return;
	let { params: t, slidesEl: n } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView, i = e.clickedIndex, a, o = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
	if (t.loop) {
		if (e.animating) return;
		a = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? i < e.loopedSlides - r / 2 || i > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), i = e.getSlideIndex(HT(n, `${o}[data-swiper-slide-index="${a}"]`)[0]), NT(() => {
			e.slideTo(i);
		})) : e.slideTo(i) : i > e.slides.length - r ? (e.loopFix(), i = e.getSlideIndex(HT(n, `${o}[data-swiper-slide-index="${a}"]`)[0]), NT(() => {
			e.slideTo(i);
		})) : e.slideTo(i);
	} else e.slideTo(i);
}
function ME(e) {
	let t = this, { params: n, slidesEl: r } = t;
	if (!n.loop || t.virtual && t.params.virtual.enabled) return;
	let i = () => {
		HT(r, `.${n.slideClass}, swiper-slide`).forEach((e, t) => {
			e.setAttribute("data-swiper-slide-index", t);
		});
	}, a = t.grid && n.grid && n.grid.rows > 1, o = n.slidesPerGroup * (a ? n.grid.rows : 1), s = t.slides.length % o !== 0, c = a && t.slides.length % n.grid.rows !== 0, l = (e) => {
		for (let r = 0; r < e; r += 1) {
			let e = t.isElement ? WT("swiper-slide", [n.slideBlankClass]) : WT("div", [n.slideClass, n.slideBlankClass]);
			t.slidesEl.append(e);
		}
	};
	s ? (n.loopAddBlankSlides ? (l(o - t.slides.length % o), t.recalcSlides(), t.updateSlides()) : UT("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"), i()) : (c && (n.loopAddBlankSlides ? (l(n.grid.rows - t.slides.length % n.grid.rows), t.recalcSlides(), t.updateSlides()) : UT("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)")), i()), t.loopFix({
		slideRealIndex: e,
		direction: n.centeredSlides ? void 0 : "next"
	});
}
function NE(e) {
	let { slideRealIndex: t, slideTo: n = !0, direction: r, setTranslate: i, activeSlideIndex: a, byController: o, byMousewheel: s } = e === void 0 ? {} : e, c = this;
	if (!c.params.loop) return;
	c.emit("beforeLoopFix");
	let { slides: l, allowSlidePrev: u, allowSlideNext: d, slidesEl: f, params: p } = c, { centeredSlides: m } = p;
	if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && p.virtual.enabled) {
		n && (!p.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : p.centeredSlides && c.snapIndex < p.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = u, c.allowSlideNext = d, c.emit("loopFix");
		return;
	}
	let h = p.slidesPerView;
	h === "auto" ? h = c.slidesPerViewDynamic() : (h = Math.ceil(parseFloat(p.slidesPerView, 10)), m && h % 2 == 0 && (h += 1));
	let g = p.slidesPerGroupAuto ? h : p.slidesPerGroup, _ = g;
	_ % g !== 0 && (_ += g - _ % g), _ += p.loopAdditionalSlides, c.loopedSlides = _;
	let v = c.grid && p.grid && p.grid.rows > 1;
	l.length < h + _ ? UT("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : v && p.grid.fill === "row" && UT("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
	let y = [], b = [], x = c.activeIndex;
	a === void 0 ? a = c.getSlideIndex(l.filter((e) => e.classList.contains(p.slideActiveClass))[0]) : x = a;
	let S = r === "next" || !r, C = r === "prev" || !r, w = 0, T = 0, E = v ? Math.ceil(l.length / p.grid.rows) : l.length, D = (v ? l[a].column : a) + (m && i === void 0 ? -h / 2 + .5 : 0);
	if (D < _) {
		w = Math.max(_ - D, g);
		for (let e = 0; e < _ - D; e += 1) {
			let t = e - Math.floor(e / E) * E;
			if (v) {
				let e = E - t - 1;
				for (let t = l.length - 1; t >= 0; --t) l[t].column === e && y.push(t);
			} else y.push(E - t - 1);
		}
	} else if (D + h > E - _) {
		T = Math.max(D - (E - _ * 2), g);
		for (let e = 0; e < T; e += 1) {
			let t = e - Math.floor(e / E) * E;
			v ? l.forEach((e, n) => {
				e.column === t && b.push(n);
			}) : b.push(t);
		}
	}
	if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
		c.__preventObserver__ = !1;
	}), C && y.forEach((e) => {
		l[e].swiperLoopMoveDOM = !0, f.prepend(l[e]), l[e].swiperLoopMoveDOM = !1;
	}), S && b.forEach((e) => {
		l[e].swiperLoopMoveDOM = !0, f.append(l[e]), l[e].swiperLoopMoveDOM = !1;
	}), c.recalcSlides(), p.slidesPerView === "auto" ? c.updateSlides() : v && (y.length > 0 && C || b.length > 0 && S) && c.slides.forEach((e, t) => {
		c.grid.updateSlide(t, e, c.slides);
	}), p.watchSlidesProgress && c.updateSlidesOffset(), n) {
		if (y.length > 0 && C) {
			if (t === void 0) {
				let e = c.slidesGrid[x], t = c.slidesGrid[x + w] - e;
				s ? c.setTranslate(c.translate - t) : (c.slideTo(x + Math.ceil(w), 0, !1, !0), i && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t));
			} else if (i) {
				let e = v ? y.length / p.grid.rows : y.length;
				c.slideTo(c.activeIndex + e, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
			}
		} else if (b.length > 0 && S) {
			if (t === void 0) {
				let e = c.slidesGrid[x], t = c.slidesGrid[x - T] - e;
				s ? c.setTranslate(c.translate - t) : (c.slideTo(x - T, 0, !1, !0), i && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t));
			} else {
				let e = v ? b.length / p.grid.rows : b.length;
				c.slideTo(c.activeIndex - e, 0, !1, !0);
			}
		}
	}
	if (c.allowSlidePrev = u, c.allowSlideNext = d, c.controller && c.controller.control && !o) {
		let e = {
			slideRealIndex: t,
			direction: r,
			setTranslate: i,
			activeSlideIndex: a,
			byController: !0
		};
		Array.isArray(c.controller.control) ? c.controller.control.forEach((t) => {
			!t.destroyed && t.params.loop && t.loopFix({
				...e,
				slideTo: t.params.slidesPerView === p.slidesPerView && n
			});
		}) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
			...e,
			slideTo: c.controller.control.params.slidesPerView === p.slidesPerView && n
		});
	}
	c.emit("loopFix");
}
function PE() {
	let e = this, { params: t, slidesEl: n } = e;
	if (!t.loop || e.virtual && e.params.virtual.enabled) return;
	e.recalcSlides();
	let r = [];
	e.slides.forEach((e) => {
		let t = e.swiperSlideIndex === void 0 ? e.getAttribute("data-swiper-slide-index") * 1 : e.swiperSlideIndex;
		r[t] = e;
	}), e.slides.forEach((e) => {
		e.removeAttribute("data-swiper-slide-index");
	}), r.forEach((e) => {
		n.append(e);
	}), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
function FE(e) {
	let t = this;
	if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
	let n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
	t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
		t.__preventObserver__ = !1;
	});
}
function IE() {
	let e = this;
	e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
		e.__preventObserver__ = !1;
	}));
}
function LE(e, t) {
	t === void 0 && (t = this);
	function n(t) {
		if (!t || t === ET() || t === DT()) return null;
		t.assignedSlot && (t = t.assignedSlot);
		let r = t.closest(e);
		return !r && !t.getRootNode ? null : r || n(t.getRootNode().host);
	}
	return n(t);
}
function RE(e, t, n) {
	let r = DT(), { params: i } = e, a = i.edgeSwipeDetection, o = i.edgeSwipeThreshold;
	return a && (n <= o || n >= r.innerWidth - o) ? a === "prevent" && (t.preventDefault(), !0) : !0;
}
function zE(e) {
	let t = this, n = ET(), r = e;
	r.originalEvent && (r = r.originalEvent);
	let i = t.touchEventsData;
	if (r.type === "pointerdown") {
		if (i.pointerId !== null && i.pointerId !== r.pointerId) return;
		i.pointerId = r.pointerId;
	} else r.type === "touchstart" && r.targetTouches.length === 1 && (i.touchId = r.targetTouches[0].identifier);
	if (r.type === "touchstart") {
		RE(t, r, r.targetTouches[0].pageX);
		return;
	}
	let { params: a, touches: o, enabled: s } = t;
	if (!s || !a.simulateTouch && r.pointerType === "mouse" || t.animating && a.preventInteractionOnTransition) return;
	!t.animating && a.cssMode && a.loop && t.loopFix();
	let c = r.target;
	if (a.touchEventsTarget === "wrapper" && !t.wrapperEl.contains(c) || "which" in r && r.which === 3 || "button" in r && r.button > 0 || i.isTouched && i.isMoved) return;
	let l = !!a.noSwipingClass && a.noSwipingClass !== "", u = r.composedPath ? r.composedPath() : r.path;
	l && r.target && r.target.shadowRoot && u && (c = u[0]);
	let d = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, f = !!(r.target && r.target.shadowRoot);
	if (a.noSwiping && (f ? LE(d, c) : c.closest(d))) {
		t.allowClick = !0;
		return;
	}
	if (a.swipeHandler && !c.closest(a.swipeHandler)) return;
	o.currentX = r.pageX, o.currentY = r.pageY;
	let p = o.currentX, m = o.currentY;
	if (!RE(t, r, p)) return;
	Object.assign(i, {
		isTouched: !0,
		isMoved: !1,
		allowTouchCallbacks: !0,
		isScrolling: void 0,
		startMoving: void 0
	}), o.startX = p, o.startY = m, i.touchStartTime = PT(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, a.threshold > 0 && (i.allowThresholdMove = !1);
	let h = !0;
	c.matches(i.focusableElements) && (h = !1, c.nodeName === "SELECT" && (i.isTouched = !1)), n.activeElement && n.activeElement.matches(i.focusableElements) && n.activeElement !== c && n.activeElement.blur();
	let g = h && t.allowTouchMove && a.touchStartPreventDefault;
	(a.touchStartForcePreventDefault || g) && !c.isContentEditable && r.preventDefault(), a.freeMode && a.freeMode.enabled && t.freeMode && t.animating && !a.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", r);
}
function BE(e) {
	let t = ET(), n = this, r = n.touchEventsData, { params: i, touches: a, rtlTranslate: o, enabled: s } = n;
	if (!s || !i.simulateTouch && e.pointerType === "mouse") return;
	let c = e;
	if (c.originalEvent && (c = c.originalEvent), c.type === "pointermove" && (r.touchId !== null || c.pointerId !== r.pointerId)) return;
	let l;
	if (c.type === "touchmove") {
		if (l = [...c.changedTouches].filter((e) => e.identifier === r.touchId)[0], !l || l.identifier !== r.touchId) return;
	} else l = c;
	if (!r.isTouched) {
		r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", c);
		return;
	}
	let u = l.pageX, d = l.pageY;
	if (c.preventedByNestedSwiper) {
		a.startX = u, a.startY = d;
		return;
	}
	if (!n.allowTouchMove) {
		c.target.matches(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(a, {
			startX: u,
			startY: d,
			currentX: u,
			currentY: d
		}), r.touchStartTime = PT());
		return;
	}
	if (i.touchReleaseOnEdges && !i.loop) {
		if (n.isVertical()) {
			if (d < a.startY && n.translate <= n.maxTranslate() || d > a.startY && n.translate >= n.minTranslate()) {
				r.isTouched = !1, r.isMoved = !1;
				return;
			}
		} else if (u < a.startX && n.translate <= n.maxTranslate() || u > a.startX && n.translate >= n.minTranslate()) return;
	}
	if (t.activeElement && c.target === t.activeElement && c.target.matches(r.focusableElements)) {
		r.isMoved = !0, n.allowClick = !1;
		return;
	}
	r.allowTouchCallbacks && n.emit("touchMove", c), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = u, a.currentY = d;
	let f = a.currentX - a.startX, p = a.currentY - a.startY;
	if (n.params.threshold && Math.sqrt(f ** 2 + p ** 2) < n.params.threshold) return;
	if (r.isScrolling === void 0) {
		let e;
		n.isHorizontal() && a.currentY === a.startY || n.isVertical() && a.currentX === a.startX ? r.isScrolling = !1 : f * f + p * p >= 25 && (e = Math.atan2(Math.abs(p), Math.abs(f)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? e > i.touchAngle : 90 - e > i.touchAngle);
	}
	if (r.isScrolling && n.emit("touchMoveOpposite", c), r.startMoving === void 0 && (a.currentX !== a.startX || a.currentY !== a.startY) && (r.startMoving = !0), r.isScrolling) {
		r.isTouched = !1;
		return;
	}
	if (!r.startMoving) return;
	n.allowClick = !1, !i.cssMode && c.cancelable && c.preventDefault(), i.touchMoveStopPropagation && !i.nested && c.stopPropagation();
	let m = n.isHorizontal() ? f : p, h = n.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
	i.oneWayMovement && (m = Math.abs(m) * (o ? 1 : -1), h = Math.abs(h) * (o ? 1 : -1)), a.diff = m, m *= i.touchRatio, o && (m = -m, h = -h);
	let g = n.touchesDirection;
	n.swipeDirection = m > 0 ? "prev" : "next", n.touchesDirection = h > 0 ? "prev" : "next";
	let _ = n.params.loop && !i.cssMode, v = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
	if (!r.isMoved) {
		if (_ && v && n.loopFix({ direction: n.swipeDirection }), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
			let e = new window.CustomEvent("transitionend", {
				bubbles: !0,
				cancelable: !0
			});
			n.wrapperEl.dispatchEvent(e);
		}
		r.allowMomentumBounce = !1, i.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", c);
	}
	if ((/* @__PURE__ */ new Date()).getTime(), r.isMoved && r.allowThresholdMove && g !== n.touchesDirection && _ && v && Math.abs(m) >= 1) {
		Object.assign(a, {
			startX: u,
			startY: d,
			currentX: u,
			currentY: d,
			startTranslate: r.currentTranslate
		}), r.loopSwapReset = !0, r.startTranslate = r.currentTranslate;
		return;
	}
	n.emit("sliderMove", c), r.isMoved = !0, r.currentTranslate = m + r.startTranslate;
	let y = !0, b = i.resistanceRatio;
	if (i.touchReleaseOnEdges && (b = 0), m > 0 ? (_ && v && r.allowThresholdMove && r.currentTranslate > (i.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] : n.minTranslate()) && n.loopFix({
		direction: "prev",
		setTranslate: !0,
		activeSlideIndex: 0
	}), r.currentTranslate > n.minTranslate() && (y = !1, i.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + m) ** b))) : m < 0 && (_ && v && r.allowThresholdMove && r.currentTranslate < (i.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] : n.maxTranslate()) && n.loopFix({
		direction: "next",
		setTranslate: !0,
		activeSlideIndex: n.slides.length - (i.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
	}), r.currentTranslate < n.maxTranslate() && (y = !1, i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - m) ** b))), y && (c.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), i.threshold > 0) {
		if (Math.abs(m) > i.threshold || r.allowThresholdMove) {
			if (!r.allowThresholdMove) {
				r.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, r.currentTranslate = r.startTranslate, a.diff = n.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
				return;
			}
		} else {
			r.currentTranslate = r.startTranslate;
			return;
		}
	}
	!i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && n.freeMode || i.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), i.freeMode && i.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
function VE(e) {
	let t = this, n = t.touchEventsData, r = e;
	r.originalEvent && (r = r.originalEvent);
	let i;
	if (r.type !== "touchend" && r.type !== "touchcancel") {
		if (n.touchId !== null || r.pointerId !== n.pointerId) return;
		i = r;
	} else if (i = [...r.changedTouches].filter((e) => e.identifier === n.touchId)[0], !i || i.identifier !== n.touchId) return;
	if ([
		"pointercancel",
		"pointerout",
		"pointerleave",
		"contextmenu"
	].includes(r.type) && !(["pointercancel", "contextmenu"].includes(r.type) && (t.browser.isSafari || t.browser.isWebView))) return;
	n.pointerId = null, n.touchId = null;
	let { params: a, touches: o, rtlTranslate: s, slidesGrid: c, enabled: l } = t;
	if (!l || !a.simulateTouch && r.pointerType === "mouse") return;
	if (n.allowTouchCallbacks && t.emit("touchEnd", r), n.allowTouchCallbacks = !1, !n.isTouched) {
		n.isMoved && a.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
		return;
	}
	a.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
	let u = PT(), d = u - n.touchStartTime;
	if (t.allowClick) {
		let e = r.path || r.composedPath && r.composedPath();
		t.updateClickedSlide(e && e[0] || r.target, e), t.emit("tap click", r), d < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
	}
	if (n.lastClickTime = PT(), NT(() => {
		t.destroyed || (t.allowClick = !0);
	}), !n.isTouched || !n.isMoved || !t.swipeDirection || o.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
		n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
		return;
	}
	n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
	let f;
	if (f = a.followFinger ? s ? t.translate : -t.translate : -n.currentTranslate, a.cssMode) return;
	if (a.freeMode && a.freeMode.enabled) {
		t.freeMode.onTouchEnd({ currentPos: f });
		return;
	}
	let p = f >= -t.maxTranslate() && !t.params.loop, m = 0, h = t.slidesSizesGrid[0];
	for (let e = 0; e < c.length; e += e < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
		let t = e < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
		c[e + t] === void 0 ? (p || f >= c[e]) && (m = e, h = c[c.length - 1] - c[c.length - 2]) : (p || f >= c[e] && f < c[e + t]) && (m = e, h = c[e + t] - c[e]);
	}
	let g = null, _ = null;
	a.rewind && (t.isBeginning ? _ = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (g = 0));
	let v = (f - c[m]) / h, y = m < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
	if (d > a.longSwipesMs) {
		if (!a.longSwipes) {
			t.slideTo(t.activeIndex);
			return;
		}
		t.swipeDirection === "next" && (v >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? g : m + y) : t.slideTo(m)), t.swipeDirection === "prev" && (v > 1 - a.longSwipesRatio ? t.slideTo(m + y) : _ !== null && v < 0 && Math.abs(v) > a.longSwipesRatio ? t.slideTo(_) : t.slideTo(m));
	} else {
		if (!a.shortSwipes) {
			t.slideTo(t.activeIndex);
			return;
		}
		t.navigation && (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl) ? r.target === t.navigation.nextEl ? t.slideTo(m + y) : t.slideTo(m) : (t.swipeDirection === "next" && t.slideTo(g === null ? m + y : g), t.swipeDirection === "prev" && t.slideTo(_ === null ? m : _));
	}
}
function HE() {
	let e = this, { params: t, el: n } = e;
	if (n && n.offsetWidth === 0) return;
	t.breakpoints && e.setBreakpoint();
	let { allowSlideNext: r, allowSlidePrev: i, snapGrid: a } = e, o = e.virtual && e.params.virtual.enabled;
	e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
	let s = o && t.loop;
	(t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !s ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !o ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
		e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
	}, 500)), e.allowSlidePrev = i, e.allowSlideNext = r, e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
}
function UE(e) {
	let t = this;
	t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function WE() {
	let e = this, { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
	if (!r) return;
	e.previousTranslate = e.translate, e.translate = e.isHorizontal() ? -t.scrollLeft : -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
	let i, a = e.maxTranslate() - e.minTranslate();
	i = a === 0 ? 0 : (e.translate - e.minTranslate()) / a, i !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function GE(e) {
	let t = this;
	oD(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function KE() {
	let e = this;
	e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
function qE() {
	let e = this, { params: t } = e;
	e.onTouchStart = zE.bind(e), e.onTouchMove = BE.bind(e), e.onTouchEnd = VE.bind(e), e.onDocumentTouchStart = KE.bind(e), t.cssMode && (e.onScroll = WE.bind(e)), e.onClick = UE.bind(e), e.onLoad = GE.bind(e), hD(e, "on");
}
function JE() {
	let e = this;
	hD(e, "off");
}
function YE() {
	let e = this, { realIndex: t, initialized: n, params: r, el: i } = e, a = r.breakpoints;
	if (!a || a && Object.keys(a).length === 0) return;
	let o = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
	if (!o || e.currentBreakpoint === o) return;
	let s = (o in a ? a[o] : void 0) || e.originalParams, c = _D(e, r), l = _D(e, s), u = r.enabled;
	c && !l ? (i.classList.remove(`${r.containerModifierClass}grid`, `${r.containerModifierClass}grid-column`), e.emitContainerClasses()) : !c && l && (i.classList.add(`${r.containerModifierClass}grid`), (s.grid.fill && s.grid.fill === "column" || !s.grid.fill && r.grid.fill === "column") && i.classList.add(`${r.containerModifierClass}grid-column`), e.emitContainerClasses()), [
		"navigation",
		"pagination",
		"scrollbar"
	].forEach((t) => {
		if (s[t] === void 0) return;
		let n = r[t] && r[t].enabled, i = s[t] && s[t].enabled;
		n && !i && e[t].disable(), !n && i && e[t].enable();
	});
	let d = s.direction && s.direction !== r.direction, f = r.loop && (s.slidesPerView !== r.slidesPerView || d), p = r.loop;
	d && n && e.changeDirection(), zT(e.params, s);
	let m = e.params.enabled, h = e.params.loop;
	Object.assign(e, {
		allowTouchMove: e.params.allowTouchMove,
		allowSlideNext: e.params.allowSlideNext,
		allowSlidePrev: e.params.allowSlidePrev
	}), u && !m ? e.disable() : !u && m && e.enable(), e.currentBreakpoint = o, e.emit("_beforeBreakpoint", s), n && (f ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !p && h ? (e.loopCreate(t), e.updateSlides()) : p && !h && e.loopDestroy()), e.emit("breakpoint", s);
}
function XE(e, t, n) {
	if (t === void 0 && (t = "window"), !e || t === "container" && !n) return;
	let r = !1, i = DT(), a = t === "window" ? i.innerHeight : n.clientHeight, o = Object.keys(e).map((e) => {
		if (typeof e == "string" && e.indexOf("@") === 0) {
			let t = parseFloat(e.substr(1));
			return {
				value: a * t,
				point: e
			};
		}
		return {
			value: e,
			point: e
		};
	});
	o.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
	for (let e = 0; e < o.length; e += 1) {
		let { point: a, value: s } = o[e];
		t === "window" ? i.matchMedia(`(min-width: ${s}px)`).matches && (r = a) : s <= n.clientWidth && (r = a);
	}
	return r || "max";
}
function ZE(e, t) {
	let n = [];
	return e.forEach((e) => {
		typeof e == "object" ? Object.keys(e).forEach((r) => {
			e[r] && n.push(t + r);
		}) : typeof e == "string" && n.push(t + e);
	}), n;
}
function QE() {
	let e = this, { classNames: t, params: n, rtl: r, el: i, device: a } = e, o = ZE([
		"initialized",
		n.direction,
		{ "free-mode": e.params.freeMode && n.freeMode.enabled },
		{ autoheight: n.autoHeight },
		{ rtl: r },
		{ grid: n.grid && n.grid.rows > 1 },
		{ "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column" },
		{ android: a.android },
		{ ios: a.ios },
		{ "css-mode": n.cssMode },
		{ centered: n.cssMode && n.centeredSlides },
		{ "watch-progress": n.watchSlidesProgress }
	], n.containerModifierClass);
	t.push(...o), i.classList.add(...t), e.emitContainerClasses();
}
function $E() {
	let e = this, { el: t, classNames: n } = e;
	t.classList.remove(...n), e.emitContainerClasses();
}
function eD() {
	let e = this, { isLocked: t, params: n } = e, { slidesOffsetBefore: r } = n;
	if (r) {
		let t = e.slides.length - 1, n = e.slidesGrid[t] + e.slidesSizesGrid[t] + r * 2;
		e.isLocked = e.size > n;
	} else e.isLocked = e.snapGrid.length === 1;
	n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
function tD(e, t) {
	return function(n) {
		n === void 0 && (n = {});
		let r = Object.keys(n)[0], i = n[r];
		if (typeof i != "object" || !i) {
			zT(t, n);
			return;
		}
		if (e[r] === !0 && (e[r] = { enabled: !0 }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = !0), !(r in e && "enabled" in i)) {
			zT(t, n);
			return;
		}
		typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0), e[r] || (e[r] = { enabled: !1 }), zT(t, n);
	};
}
var nD, rD, iD, aD, oD, sD, cD, lD, uD, dD, fD, pD, mD, hD, gD, _D, vD, yD, bD, xD, SD, CD, wD, TD = o((() => {
	AT(), ZT(), aD = {
		on(e, t, n) {
			let r = this;
			if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
			let i = n ? "unshift" : "push";
			return e.split(" ").forEach((e) => {
				r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t);
			}), r;
		},
		once(e, t, n) {
			let r = this;
			if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
			function i() {
				r.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
				var n = [...arguments];
				t.apply(r, n);
			}
			return i.__emitterProxy = t, r.on(e, i, n);
		},
		onAny(e, t) {
			let n = this;
			if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
			let r = t ? "unshift" : "push";
			return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
		},
		offAny(e) {
			let t = this;
			if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
			let n = t.eventsAnyListeners.indexOf(e);
			return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
		},
		off(e, t) {
			let n = this;
			return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((e) => {
				t === void 0 ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((r, i) => {
					(r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1);
				});
			}), n;
		},
		emit() {
			let e = this;
			if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
			let t, n, r;
			var i = [...arguments];
			return typeof i[0] == "string" || Array.isArray(i[0]) ? (t = i[0], n = i.slice(1, i.length), r = e) : (t = i[0].events, n = i[0].data, r = i[0].context || e), n.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
				e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((e) => {
					e.apply(r, [t, ...n]);
				}), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach((e) => {
					e.apply(r, n);
				});
			}), e;
		}
	}, oD = (e, t) => {
		if (!e || e.destroyed || !e.params) return;
		let n = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
		if (n) {
			let t = n.querySelector(`.${e.params.lazyPreloaderClass}`);
			!t && e.isElement && (n.shadowRoot ? t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
				n.shadowRoot && (t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), t && t.remove());
			})), t && t.remove();
		}
	}, sD = (e, t) => {
		if (!e.slides[t]) return;
		let n = e.slides[t].querySelector("[loading=\"lazy\"]");
		n && n.removeAttribute("loading");
	}, cD = (e) => {
		if (!e || e.destroyed || !e.params) return;
		let t = e.params.lazyPreloadPrevNext, n = e.slides.length;
		if (!n || !t || t < 0) return;
		t = Math.min(t, n);
		let r = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), i = e.activeIndex;
		if (e.params.grid && e.params.grid.rows > 1) {
			let n = i, a = [n - t];
			a.push(...Array.from({ length: t }).map((e, t) => n + r + t)), e.slides.forEach((t, n) => {
				a.includes(t.column) && sD(e, n);
			});
			return;
		}
		let a = i + r - 1;
		if (e.params.rewind || e.params.loop) for (let r = i - t; r <= a + t; r += 1) {
			let t = (r % n + n) % n;
			(t < i || t > a) && sD(e, t);
		}
		else for (let r = Math.max(i - t, 0); r <= Math.min(a + t, n - 1); r += 1) r !== i && (r > a || r < i) && sD(e, r);
	}, lD = {
		updateSize: oE,
		updateSlides: sE,
		updateAutoHeight: cE,
		updateSlidesOffset: lE,
		updateSlidesProgress: uE,
		updateProgress: dE,
		updateSlidesClasses: fE,
		updateActiveIndex: mE,
		updateClickedSlide: hE
	}, uD = {
		getTranslate: gE,
		setTranslate: _E,
		minTranslate: vE,
		maxTranslate: yE,
		translateTo: bE
	}, dD = {
		setTransition: xE,
		transitionStart: CE,
		transitionEnd: wE
	}, fD = {
		slideTo: TE,
		slideToLoop: EE,
		slideNext: DE,
		slidePrev: OE,
		slideReset: kE,
		slideToClosest: AE,
		slideToClickedSlide: jE
	}, pD = {
		loopCreate: ME,
		loopFix: NE,
		loopDestroy: PE
	}, mD = {
		setGrabCursor: FE,
		unsetGrabCursor: IE
	}, hD = (e, t) => {
		let n = ET(), { params: r, el: i, wrapperEl: a, device: o } = e, s = !!r.nested, c = t === "on" ? "addEventListener" : "removeEventListener", l = t;
		n[c]("touchstart", e.onDocumentTouchStart, {
			passive: !1,
			capture: s
		}), i[c]("touchstart", e.onTouchStart, { passive: !1 }), i[c]("pointerdown", e.onTouchStart, { passive: !1 }), n[c]("touchmove", e.onTouchMove, {
			passive: !1,
			capture: s
		}), n[c]("pointermove", e.onTouchMove, {
			passive: !1,
			capture: s
		}), n[c]("touchend", e.onTouchEnd, { passive: !0 }), n[c]("pointerup", e.onTouchEnd, { passive: !0 }), n[c]("pointercancel", e.onTouchEnd, { passive: !0 }), n[c]("touchcancel", e.onTouchEnd, { passive: !0 }), n[c]("pointerout", e.onTouchEnd, { passive: !0 }), n[c]("pointerleave", e.onTouchEnd, { passive: !0 }), n[c]("contextmenu", e.onTouchEnd, { passive: !0 }), (r.preventClicks || r.preventClicksPropagation) && i[c]("click", e.onClick, !0), r.cssMode && a[c]("scroll", e.onScroll), r.updateOnWindowResize ? e[l](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", HE, !0) : e[l]("observerUpdate", HE, !0), i[c]("load", e.onLoad, { capture: !0 });
	}, gD = {
		attachEvents: qE,
		detachEvents: JE
	}, _D = (e, t) => e.grid && t.grid && t.grid.rows > 1, vD = {
		setBreakpoint: YE,
		getBreakpoint: XE
	}, yD = {
		addClasses: QE,
		removeClasses: $E
	}, bD = { checkOverflow: eD }, xD = {
		init: !0,
		direction: "horizontal",
		oneWayMovement: !1,
		swiperElementNodeName: "SWIPER-CONTAINER",
		touchEventsTarget: "wrapper",
		initialSlide: 0,
		speed: 300,
		cssMode: !1,
		updateOnWindowResize: !0,
		resizeObserver: !0,
		nested: !1,
		createElements: !1,
		eventsPrefix: "swiper",
		enabled: !0,
		focusableElements: "input, select, option, textarea, button, video, label",
		width: null,
		height: null,
		preventInteractionOnTransition: !1,
		userAgent: null,
		url: null,
		edgeSwipeDetection: !1,
		edgeSwipeThreshold: 20,
		autoHeight: !1,
		setWrapperSize: !1,
		virtualTranslate: !1,
		effect: "slide",
		breakpoints: void 0,
		breakpointsBase: "window",
		spaceBetween: 0,
		slidesPerView: 1,
		slidesPerGroup: 1,
		slidesPerGroupSkip: 0,
		slidesPerGroupAuto: !1,
		centeredSlides: !1,
		centeredSlidesBounds: !1,
		slidesOffsetBefore: 0,
		slidesOffsetAfter: 0,
		normalizeSlideIndex: !0,
		centerInsufficientSlides: !1,
		watchOverflow: !0,
		roundLengths: !1,
		touchRatio: 1,
		touchAngle: 45,
		simulateTouch: !0,
		shortSwipes: !0,
		longSwipes: !0,
		longSwipesRatio: .5,
		longSwipesMs: 300,
		followFinger: !0,
		allowTouchMove: !0,
		threshold: 5,
		touchMoveStopPropagation: !1,
		touchStartPreventDefault: !0,
		touchStartForcePreventDefault: !1,
		touchReleaseOnEdges: !1,
		uniqueNavElements: !0,
		resistance: !0,
		resistanceRatio: .85,
		watchSlidesProgress: !1,
		grabCursor: !1,
		preventClicks: !0,
		preventClicksPropagation: !0,
		slideToClickedSlide: !1,
		loop: !1,
		loopAddBlankSlides: !0,
		loopAdditionalSlides: 0,
		loopPreventsSliding: !0,
		rewind: !1,
		allowSlidePrev: !0,
		allowSlideNext: !0,
		swipeHandler: null,
		noSwiping: !0,
		noSwipingClass: "swiper-no-swiping",
		noSwipingSelector: null,
		passiveListeners: !0,
		maxBackfaceHiddenSlides: 10,
		containerModifierClass: "swiper-",
		slideClass: "swiper-slide",
		slideBlankClass: "swiper-slide-blank",
		slideActiveClass: "swiper-slide-active",
		slideVisibleClass: "swiper-slide-visible",
		slideFullyVisibleClass: "swiper-slide-fully-visible",
		slideNextClass: "swiper-slide-next",
		slidePrevClass: "swiper-slide-prev",
		wrapperClass: "swiper-wrapper",
		lazyPreloaderClass: "swiper-lazy-preloader",
		lazyPreloadPrevNext: 0,
		runCallbacksOnInit: !0,
		_emitClasses: !1
	}, SD = {
		eventsEmitter: aD,
		update: lD,
		translate: uD,
		transition: dD,
		slide: fD,
		loop: pD,
		grabCursor: mD,
		events: gD,
		breakpoints: vD,
		checkOverflow: bD,
		classes: yD
	}, CD = {}, wD = class e {
		constructor() {
			let t, n;
			var r = [...arguments];
			r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? n = r[0] : [t, n] = r, n ||= {}, n = zT({}, n), t && !n.el && (n.el = t);
			let i = ET();
			if (n.el && typeof n.el == "string" && i.querySelectorAll(n.el).length > 1) {
				let t = [];
				return i.querySelectorAll(n.el).forEach((r) => {
					let i = zT({}, n, { el: r });
					t.push(new e(i));
				}), t;
			}
			let a = this;
			a.__swiper__ = !0, a.support = $T(), a.device = tE({ userAgent: n.userAgent }), a.browser = rE(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], n.modules && Array.isArray(n.modules) && a.modules.push(...n.modules);
			let o = {};
			return a.modules.forEach((e) => {
				e({
					params: n,
					swiper: a,
					extendParams: tD(n, o),
					on: a.on.bind(a),
					once: a.once.bind(a),
					off: a.off.bind(a),
					emit: a.emit.bind(a)
				});
			}), a.params = zT({}, zT({}, xD, o), CD, n), a.originalParams = zT({}, a.params), a.passedParams = zT({}, n), a.params && a.params.on && Object.keys(a.params.on).forEach((e) => {
				a.on(e, a.params.on[e]);
			}), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
				enabled: a.params.enabled,
				el: t,
				classNames: [],
				slides: [],
				slidesGrid: [],
				snapGrid: [],
				slidesSizesGrid: [],
				isHorizontal() {
					return a.params.direction === "horizontal";
				},
				isVertical() {
					return a.params.direction === "vertical";
				},
				activeIndex: 0,
				realIndex: 0,
				isBeginning: !0,
				isEnd: !1,
				translate: 0,
				previousTranslate: 0,
				progress: 0,
				velocity: 0,
				animating: !1,
				cssOverflowAdjustment() {
					return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
				},
				allowSlideNext: a.params.allowSlideNext,
				allowSlidePrev: a.params.allowSlidePrev,
				touchEventsData: {
					isTouched: void 0,
					isMoved: void 0,
					allowTouchCallbacks: void 0,
					touchStartTime: void 0,
					isScrolling: void 0,
					currentTranslate: void 0,
					startTranslate: void 0,
					allowThresholdMove: void 0,
					focusableElements: a.params.focusableElements,
					lastClickTime: 0,
					clickTimeout: void 0,
					velocities: [],
					allowMomentumBounce: void 0,
					startMoving: void 0,
					pointerId: null,
					touchId: null
				},
				allowClick: !0,
				allowTouchMove: a.params.allowTouchMove,
				touches: {
					startX: 0,
					startY: 0,
					currentX: 0,
					currentY: 0,
					diff: 0
				},
				imagesToLoad: [],
				imagesLoaded: 0
			}), a.emit("_swiper"), a.params.init && a.init(), a;
		}
		getDirectionLabel(e) {
			return this.isHorizontal() ? e : {
				width: "height",
				"margin-top": "margin-left",
				"margin-bottom ": "margin-right",
				"margin-left": "margin-top",
				"margin-right": "margin-bottom",
				"padding-left": "padding-top",
				"padding-right": "padding-bottom",
				marginRight: "marginBottom"
			}[e];
		}
		getSlideIndex(e) {
			let { slidesEl: t, params: n } = this, r = JT(HT(t, `.${n.slideClass}, swiper-slide`)[0]);
			return JT(e) - r;
		}
		getSlideIndexByData(e) {
			return this.getSlideIndex(this.slides.filter((t) => t.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
		}
		recalcSlides() {
			let e = this, { slidesEl: t, params: n } = e;
			e.slides = HT(t, `.${n.slideClass}, swiper-slide`);
		}
		enable() {
			let e = this;
			e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
		}
		disable() {
			let e = this;
			e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
		}
		setProgress(e, t) {
			let n = this;
			e = Math.min(Math.max(e, 0), 1);
			let r = n.minTranslate(), i = (n.maxTranslate() - r) * e + r;
			n.translateTo(i, t === void 0 ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
		}
		emitContainerClasses() {
			let e = this;
			if (!e.params._emitClasses || !e.el) return;
			let t = e.el.className.split(" ").filter((t) => t.indexOf("swiper") === 0 || t.indexOf(e.params.containerModifierClass) === 0);
			e.emit("_containerClasses", t.join(" "));
		}
		getSlideClasses(e) {
			let t = this;
			return t.destroyed ? "" : e.className.split(" ").filter((e) => e.indexOf("swiper-slide") === 0 || e.indexOf(t.params.slideClass) === 0).join(" ");
		}
		emitSlidesClasses() {
			let e = this;
			if (!e.params._emitClasses || !e.el) return;
			let t = [];
			e.slides.forEach((n) => {
				let r = e.getSlideClasses(n);
				t.push({
					slideEl: n,
					classNames: r
				}), e.emit("_slideClass", n, r);
			}), e.emit("_slideClasses", t);
		}
		slidesPerViewDynamic(e, t) {
			e === void 0 && (e = "current"), t === void 0 && (t = !1);
			let { params: n, slides: r, slidesGrid: i, slidesSizesGrid: a, size: o, activeIndex: s } = this, c = 1;
			if (typeof n.slidesPerView == "number") return n.slidesPerView;
			if (n.centeredSlides) {
				let e = r[s] ? Math.ceil(r[s].swiperSlideSize) : 0, t;
				for (let n = s + 1; n < r.length; n += 1) r[n] && !t && (e += Math.ceil(r[n].swiperSlideSize), c += 1, e > o && (t = !0));
				for (let n = s - 1; n >= 0; --n) r[n] && !t && (e += r[n].swiperSlideSize, c += 1, e > o && (t = !0));
			} else if (e === "current") for (let e = s + 1; e < r.length; e += 1) (t ? i[e] + a[e] - i[s] < o : i[e] - i[s] < o) && (c += 1);
			else for (let e = s - 1; e >= 0; --e) i[s] - i[e] < o && (c += 1);
			return c;
		}
		update() {
			let e = this;
			if (!e || e.destroyed) return;
			let { snapGrid: t, params: n } = e;
			n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll("[loading=\"lazy\"]")].forEach((t) => {
				t.complete && oD(e, t);
			}), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
			function r() {
				let t = e.rtlTranslate ? e.translate * -1 : e.translate, n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
				e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
			}
			let i;
			if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && e.updateAutoHeight();
			else {
				if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
					let t = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
					i = e.slideTo(t.length - 1, 0, !1, !0);
				} else i = e.slideTo(e.activeIndex, 0, !1, !0);
				i || r();
			}
			n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
		}
		changeDirection(e, t) {
			t === void 0 && (t = !0);
			let n = this, r = n.params.direction;
			return e ||= r === "horizontal" ? "vertical" : "horizontal", e === r || e !== "horizontal" && e !== "vertical" ? n : (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((t) => {
				e === "vertical" ? t.style.width = "" : t.style.height = "";
			}), n.emit("changeDirection"), t && n.update(), n);
		}
		changeLanguageDirection(e) {
			let t = this;
			t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
		}
		mount(e) {
			let t = this;
			if (t.mounted) return !0;
			let n = e || t.params.el;
			if (typeof n == "string" && (n = document.querySelector(n)), !n) return !1;
			n.swiper = t, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
			let r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`, i = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : HT(n, r())[0];
			return !i && t.params.createElements && (i = WT("div", t.params.wrapperClass), n.append(i), HT(n, `.${t.params.slideClass}`).forEach((e) => {
				i.append(e);
			})), Object.assign(t, {
				el: n,
				wrapperEl: i,
				slidesEl: t.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : i,
				hostEl: t.isElement ? n.parentNode.host : n,
				mounted: !0,
				rtl: n.dir.toLowerCase() === "rtl" || qT(n, "direction") === "rtl",
				rtlTranslate: t.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || qT(n, "direction") === "rtl"),
				wrongRTL: qT(i, "display") === "-webkit-box"
			}), !0;
		}
		init(e) {
			let t = this;
			if (t.initialized || t.mount(e) === !1) return t;
			t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
			let n = [...t.el.querySelectorAll("[loading=\"lazy\"]")];
			return t.isElement && n.push(...t.hostEl.querySelectorAll("[loading=\"lazy\"]")), n.forEach((e) => {
				e.complete ? oD(t, e) : e.addEventListener("load", (e) => {
					oD(t, e.target);
				});
			}), cD(t), t.initialized = !0, cD(t), t.emit("init"), t.emit("afterInit"), t;
		}
		destroy(e, t) {
			e === void 0 && (e = !0), t === void 0 && (t = !0);
			let n = this, { params: r, el: i, wrapperEl: a, slides: o } = n;
			return n.params === void 0 || n.destroyed ? null : (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), r.loop && n.loopDestroy(), t && (n.removeClasses(), i.removeAttribute("style"), a.removeAttribute("style"), o && o.length && o.forEach((e) => {
				e.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
			})), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((e) => {
				n.off(e);
			}), e !== !1 && (n.el.swiper = null, MT(n)), n.destroyed = !0, null);
		}
		static extendDefaults(e) {
			zT(CD, e);
		}
		static get extendedDefaults() {
			return CD;
		}
		static get defaults() {
			return xD;
		}
		static installModule(t) {
			e.prototype.__modules__ || (e.prototype.__modules__ = []);
			let n = e.prototype.__modules__;
			typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
		}
		static use(t) {
			return Array.isArray(t) ? (t.forEach((t) => e.installModule(t)), e) : (e.installModule(t), e);
		}
	}, Object.keys(SD).forEach((e) => {
		Object.keys(SD[e]).forEach((t) => {
			wD.prototype[t] = SD[e][t];
		});
	}), wD.use([iE, aE]);
}));
//#endregion
//#region node_modules/swiper/shared/update-swiper.mjs
function ED(e) {
	return typeof e == "object" && !!e && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object" && !e.__swiper__;
}
function DD(e, t) {
	let n = [
		"__proto__",
		"constructor",
		"prototype"
	];
	Object.keys(t).filter((e) => n.indexOf(e) < 0).forEach((n) => {
		e[n] === void 0 ? e[n] = t[n] : ED(t[n]) && ED(e[n]) && Object.keys(t[n]).length > 0 ? t[n].__swiper__ ? e[n] = t[n] : DD(e[n], t[n]) : e[n] = t[n];
	});
}
function OD(e) {
	return e === void 0 && (e = {}), e.navigation && e.navigation.nextEl === void 0 && e.navigation.prevEl === void 0;
}
function kD(e) {
	return e === void 0 && (e = {}), e.pagination && e.pagination.el === void 0;
}
function AD(e) {
	return e === void 0 && (e = {}), e.scrollbar && e.scrollbar.el === void 0;
}
function jD(e) {
	e === void 0 && (e = "");
	let t = e.split(" ").map((e) => e.trim()).filter((e) => !!e), n = [];
	return t.forEach((e) => {
		n.indexOf(e) < 0 && n.push(e);
	}), n.join(" ");
}
function MD(e) {
	return e === void 0 && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function ND(e) {
	let { swiper: t, slides: n, passedParams: r, changedParams: i, nextEl: a, prevEl: o, scrollbarEl: s, paginationEl: c } = e, l = i.filter((e) => e !== "children" && e !== "direction" && e !== "wrapperClass"), { params: u, pagination: d, navigation: f, scrollbar: p, virtual: m, thumbs: h } = t, g, _, v, y, b, x, S, C;
	i.includes("thumbs") && r.thumbs && r.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (g = !0), i.includes("controller") && r.controller && r.controller.control && u.controller && !u.controller.control && (_ = !0), i.includes("pagination") && r.pagination && (r.pagination.el || c) && (u.pagination || u.pagination === !1) && d && !d.el && (v = !0), i.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || s) && (u.scrollbar || u.scrollbar === !1) && p && !p.el && (y = !0), i.includes("navigation") && r.navigation && (r.navigation.prevEl || o) && (r.navigation.nextEl || a) && (u.navigation || u.navigation === !1) && f && !f.prevEl && !f.nextEl && (b = !0);
	let w = (e) => {
		t[e] && (t[e].destroy(), e === "navigation" ? (t.isElement && (t[e].prevEl.remove(), t[e].nextEl.remove()), u[e].prevEl = void 0, u[e].nextEl = void 0, t[e].prevEl = void 0, t[e].nextEl = void 0) : (t.isElement && t[e].el.remove(), u[e].el = void 0, t[e].el = void 0));
	};
	i.includes("loop") && t.isElement && (u.loop && !r.loop ? x = !0 : !u.loop && r.loop ? S = !0 : C = !0), l.forEach((e) => {
		if (ED(u[e]) && ED(r[e])) Object.assign(u[e], r[e]), (e === "navigation" || e === "pagination" || e === "scrollbar") && "enabled" in r[e] && !r[e].enabled && w(e);
		else {
			let t = r[e];
			(t === !0 || t === !1) && (e === "navigation" || e === "pagination" || e === "scrollbar") ? t === !1 && w(e) : u[e] = r[e];
		}
	}), l.includes("controller") && !_ && t.controller && t.controller.control && u.controller && u.controller.control && (t.controller.control = u.controller.control), i.includes("children") && n && m && u.virtual.enabled ? (m.slides = n, m.update(!0)) : i.includes("virtual") && m && u.virtual.enabled && (n && (m.slides = n), m.update(!0)), i.includes("children") && n && u.loop && (C = !0), g && h.init() && h.update(!0), _ && (t.controller.control = u.controller.control), v && (t.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-pagination"), c.part.add("pagination"), t.el.appendChild(c)), c && (u.pagination.el = c), d.init(), d.render(), d.update()), y && (t.isElement && (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-scrollbar"), s.part.add("scrollbar"), t.el.appendChild(s)), s && (u.scrollbar.el = s), p.init(), p.updateSize(), p.setTranslate()), b && (t.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = t.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), t.el.appendChild(a)), (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-prev"), o.innerHTML = t.hostEl.constructor.prevButtonSvg, o.part.add("button-prev"), t.el.appendChild(o))), a && (u.navigation.nextEl = a), o && (u.navigation.prevEl = o), f.init(), f.update()), i.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), i.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), i.includes("direction") && t.changeDirection(r.direction, !1), (x || C) && t.loopDestroy(), (S || C) && t.loopCreate(), t.update();
}
var PD, FD = o((() => {
	PD = /* @__PURE__ */ "eventsPrefix.injectStyles.injectStylesUrls.modules.init._direction.oneWayMovement.swiperElementNodeName.touchEventsTarget.initialSlide._speed.cssMode.updateOnWindowResize.resizeObserver.nested.focusableElements._enabled._width._height.preventInteractionOnTransition.userAgent.url._edgeSwipeDetection._edgeSwipeThreshold._freeMode._autoHeight.setWrapperSize.virtualTranslate._effect.breakpoints.breakpointsBase._spaceBetween._slidesPerView.maxBackfaceHiddenSlides._grid._slidesPerGroup._slidesPerGroupSkip._slidesPerGroupAuto._centeredSlides._centeredSlidesBounds._slidesOffsetBefore._slidesOffsetAfter.normalizeSlideIndex._centerInsufficientSlides._watchOverflow.roundLengths.touchRatio.touchAngle.simulateTouch._shortSwipes._longSwipes.longSwipesRatio.longSwipesMs._followFinger.allowTouchMove._threshold.touchMoveStopPropagation.touchStartPreventDefault.touchStartForcePreventDefault.touchReleaseOnEdges.uniqueNavElements._resistance._resistanceRatio._watchSlidesProgress._grabCursor.preventClicks.preventClicksPropagation._slideToClickedSlide._loop.loopAdditionalSlides.loopAddBlankSlides.loopPreventsSliding._rewind._allowSlidePrev._allowSlideNext._swipeHandler._noSwiping.noSwipingClass.noSwipingSelector.passiveListeners.containerModifierClass.slideClass.slideActiveClass.slideVisibleClass.slideFullyVisibleClass.slideNextClass.slidePrevClass.slideBlankClass.wrapperClass.lazyPreloaderClass.lazyPreloadPrevNext.runCallbacksOnInit.observer.observeParents.observeSlideChildren.a11y._autoplay._controller.coverflowEffect.cubeEffect.fadeEffect.flipEffect.creativeEffect.cardsEffect.hashNavigation.history.keyboard.mousewheel._navigation._pagination.parallax._scrollbar._thumbs.virtual.zoom.control".split(".");
}));
//#endregion
//#region node_modules/swiper/shared/update-on-virtual-data.mjs
function ID(e, t) {
	e === void 0 && (e = {}), t === void 0 && (t = !0);
	let n = { on: {} }, r = {}, i = {};
	DD(n, xD), n._emitClasses = !0, n.init = !1;
	let a = {}, o = PD.map((e) => e.replace(/_/, "")), s = Object.assign({}, e);
	return Object.keys(s).forEach((s) => {
		e[s] !== void 0 && (o.indexOf(s) >= 0 ? ED(e[s]) ? (n[s] = {}, i[s] = {}, DD(n[s], e[s]), DD(i[s], e[s])) : (n[s] = e[s], i[s] = e[s]) : s.search(/on[A-Z]/) === 0 && typeof e[s] == "function" ? t ? r[`${s[2].toLowerCase()}${s.substr(3)}`] = e[s] : n.on[`${s[2].toLowerCase()}${s.substr(3)}`] = e[s] : a[s] = e[s]);
	}), [
		"navigation",
		"pagination",
		"scrollbar"
	].forEach((e) => {
		n[e] === !0 && (n[e] = {}), n[e] === !1 && delete n[e];
	}), {
		params: n,
		passedParams: i,
		rest: a,
		events: r
	};
}
function LD(e, t) {
	let { el: n, nextEl: r, prevEl: i, paginationEl: a, scrollbarEl: o, swiper: s } = e;
	OD(t) && r && i && (s.params.navigation.nextEl = r, s.originalParams.navigation.nextEl = r, s.params.navigation.prevEl = i, s.originalParams.navigation.prevEl = i), kD(t) && a && (s.params.pagination.el = a, s.originalParams.pagination.el = a), AD(t) && o && (s.params.scrollbar.el = o, s.originalParams.scrollbar.el = o), s.init(n);
}
function RD(e, t, n, r, i) {
	let a = [];
	if (!t) return a;
	let o = (e) => {
		a.indexOf(e) < 0 && a.push(e);
	};
	if (n && r) {
		let e = r.map(i), t = n.map(i);
		e.join("") !== t.join("") && o("children"), r.length !== n.length && o("children");
	}
	return PD.filter((e) => e[0] === "_").map((e) => e.replace(/_/, "")).forEach((n) => {
		if (n in e && n in t) {
			if (ED(e[n]) && ED(t[n])) {
				let r = Object.keys(e[n]), i = Object.keys(t[n]);
				r.length === i.length ? (r.forEach((r) => {
					e[n][r] !== t[n][r] && o(n);
				}), i.forEach((r) => {
					e[n][r] !== t[n][r] && o(n);
				})) : o(n);
			} else e[n] !== t[n] && o(n);
		}
	}), a;
}
var zD, BD = o((() => {
	FD(), TD(), zD = (e) => {
		!e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
	};
}));
//#endregion
//#region node_modules/swiper/swiper-react.mjs
function VD() {
	return VD = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, VD.apply(this, arguments);
}
function HD(e) {
	return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function UD(e) {
	let t = [];
	return P.Children.toArray(e).forEach((e) => {
		HD(e) ? t.push(e) : e.props && e.props.children && UD(e.props.children).forEach((e) => t.push(e));
	}), t;
}
function WD(e) {
	let t = [], n = {
		"container-start": [],
		"container-end": [],
		"wrapper-start": [],
		"wrapper-end": []
	};
	return P.Children.toArray(e).forEach((e) => {
		if (HD(e)) t.push(e);
		else if (e.props && e.props.slot && n[e.props.slot]) n[e.props.slot].push(e);
		else if (e.props && e.props.children) {
			let r = UD(e.props.children);
			r.length > 0 ? r.forEach((e) => t.push(e)) : n["container-end"].push(e);
		} else n["container-end"].push(e);
	}), {
		slides: t,
		slots: n
	};
}
function GD(e, t, n) {
	if (!n) return null;
	let r = (e) => {
		let n = e;
		return e < 0 ? n = t.length + e : n >= t.length && (n -= t.length), n;
	}, i = e.isHorizontal() ? { [e.rtlTranslate ? "right" : "left"]: `${n.offset}px` } : { top: `${n.offset}px` }, { from: a, to: o } = n, s = e.params.loop ? -t.length : 0, c = e.params.loop ? t.length * 2 : t.length, l = [];
	for (let e = s; e < c; e += 1) e >= a && e <= o && l.push(t[r(e)]);
	return l.map((t, n) => /*#__PURE__*/ P.cloneElement(t, {
		swiper: e,
		style: i,
		key: t.props.virtualIndex || t.key || `slide-${n}`
	}));
}
function KD(e, t) {
	return typeof window > "u" ? ze(e, t) : Be(e, t);
}
var qD, JD, YD, XD, ZD = o((() => {
	mn(), TD(), BD(), FD(), qD = /*#__PURE__*/ he(null), JD = /*#__PURE__*/ he(null), YD = /*#__PURE__*/ Ct(function(e, t) {
		let { className: n, tag: r = "div", wrapperTag: i = "div", children: a, onSwiper: o, ...s } = e === void 0 ? {} : e, c = !1, [l, u] = Le("swiper"), [d, f] = Le(null), [p, m] = Le(!1), h = Ve(!1), g = Ve(null), _ = Ve(null), v = Ve(null), y = Ve(null), b = Ve(null), x = Ve(null), S = Ve(null), C = Ve(null), { params: w, passedParams: T, rest: E, events: D } = ID(s), { slides: ee, slots: te } = WD(a), ne = () => {
			m(!p);
		};
		Object.assign(w.on, { _containerClasses(e, t) {
			u(t);
		} });
		let re = () => {
			Object.assign(w.on, D), c = !0;
			let e = { ...w };
			if (delete e.wrapperClass, _.current = new wD(e), _.current.virtual && _.current.params.virtual.enabled) {
				_.current.virtual.slides = ee;
				let e = {
					cache: !1,
					slides: ee,
					renderExternal: f,
					renderExternalUpdate: !1
				};
				DD(_.current.params.virtual, e), DD(_.current.originalParams.virtual, e);
			}
		};
		g.current || re(), _.current && _.current.on("_beforeBreakpoint", ne);
		let ie = () => {
			c || !D || !_.current || Object.keys(D).forEach((e) => {
				_.current.on(e, D[e]);
			});
		}, ae = () => {
			!D || !_.current || Object.keys(D).forEach((e) => {
				_.current.off(e, D[e]);
			});
		};
		ze(() => () => {
			_.current && _.current.off("_beforeBreakpoint", ne);
		}), ze(() => {
			!h.current && _.current && (_.current.emitSlidesClasses(), h.current = !0);
		}), KD(() => {
			if (t && (t.current = g.current), g.current) return _.current.destroyed && re(), LD({
				el: g.current,
				nextEl: b.current,
				prevEl: x.current,
				paginationEl: S.current,
				scrollbarEl: C.current,
				swiper: _.current
			}, w), o && !_.current.destroyed && o(_.current), () => {
				_.current && !_.current.destroyed && _.current.destroy(!0, !1);
			};
		}, []), KD(() => {
			ie();
			let e = RD(T, v.current, ee, y.current, (e) => e.key);
			return v.current = T, y.current = ee, e.length && _.current && !_.current.destroyed && ND({
				swiper: _.current,
				slides: ee,
				passedParams: T,
				changedParams: e,
				nextEl: b.current,
				prevEl: x.current,
				scrollbarEl: C.current,
				paginationEl: S.current
			}), () => {
				ae();
			};
		}), KD(() => {
			zD(_.current);
		}, [d]);
		function oe() {
			return w.virtual ? GD(_.current, ee, d) : ee.map((e, t) => /*#__PURE__*/ P.cloneElement(e, {
				swiper: _.current,
				swiperSlideIndex: t
			}));
		}
		return /*#__PURE__*/ P.createElement(r, VD({
			ref: g,
			className: jD(`${l}${n ? ` ${n}` : ""}`)
		}, E), /*#__PURE__*/ P.createElement(JD.Provider, { value: _.current }, te["container-start"], /*#__PURE__*/ P.createElement(i, { className: MD(w.wrapperClass) }, te["wrapper-start"], oe(), te["wrapper-end"]), OD(w) && /*#__PURE__*/ P.createElement(P.Fragment, null, /*#__PURE__*/ P.createElement("div", {
			ref: x,
			className: "swiper-button-prev"
		}), /*#__PURE__*/ P.createElement("div", {
			ref: b,
			className: "swiper-button-next"
		})), AD(w) && /*#__PURE__*/ P.createElement("div", {
			ref: C,
			className: "swiper-scrollbar"
		}), kD(w) && /*#__PURE__*/ P.createElement("div", {
			ref: S,
			className: "swiper-pagination"
		}), te["container-end"]));
	}), YD.displayName = "Swiper", XD = /*#__PURE__*/ Ct(function(e, t) {
		let { tag: n = "div", children: r, className: i = "", swiper: a, zoom: o, lazy: s, virtualIndex: c, swiperSlideIndex: l, ...u } = e === void 0 ? {} : e, d = Ve(null), [f, p] = Le("swiper-slide"), [m, h] = Le(!1);
		function g(e, t, n) {
			t === d.current && p(n);
		}
		KD(() => {
			if (l !== void 0 && (d.current.swiperSlideIndex = l), t && (t.current = d.current), !(!d.current || !a)) {
				if (a.destroyed) {
					f !== "swiper-slide" && p("swiper-slide");
					return;
				}
				return a.on("_slideClass", g), () => {
					a && a.off("_slideClass", g);
				};
			}
		}), KD(() => {
			a && d.current && !a.destroyed && p(a.getSlideClasses(d.current));
		}, [a]);
		let _ = {
			isActive: f.indexOf("swiper-slide-active") >= 0,
			isVisible: f.indexOf("swiper-slide-visible") >= 0,
			isPrev: f.indexOf("swiper-slide-prev") >= 0,
			isNext: f.indexOf("swiper-slide-next") >= 0
		}, v = () => typeof r == "function" ? r(_) : r;
		return /*#__PURE__*/ P.createElement(n, VD({
			ref: d,
			className: jD(`${f}${i ? ` ${i}` : ""}`),
			"data-swiper-slide-index": c,
			onLoad: () => {
				h(!0);
			}
		}, u), o && /*#__PURE__*/ P.createElement(qD.Provider, { value: _ }, /*#__PURE__*/ P.createElement("div", {
			className: "swiper-zoom-container",
			"data-swiper-zoom": typeof o == "number" ? o : void 0
		}, v(), s && !m && /*#__PURE__*/ P.createElement("div", { className: "swiper-lazy-preloader" }))), !o && /*#__PURE__*/ P.createElement(qD.Provider, { value: _ }, v(), s && !m && /*#__PURE__*/ P.createElement("div", { className: "swiper-lazy-preloader" })));
	}), XD.displayName = "SwiperSlide";
})), QD = o((() => {
	N(), Q(), $(), R(), ZD();
})), $D = o((() => {
	QD();
})), eO = o((() => {
	Ne(), $(), Q();
})), tO = o((() => {
	eO();
})), nO = o((() => {
	Q(), N(), $(), R();
})), rO = o((() => {
	nO();
})), iO = o((() => {
	$();
})), aO = o((() => {
	iO();
})), oO = o((() => {
	$(), Q(), N(), R();
})), sO = o((() => {
	oO();
})), cO = o((() => {
	$();
})), lO = o((() => {
	cO();
})), uO = o((() => {
	N(), Q(), $(), R();
})), dO = o((() => {
	uO();
})), fO = o((() => {
	$(), Q(), R(), mn(), N();
})), pO = o((() => {
	fO();
})), mO = o((() => {
	$(), R(), Q();
})), hO = o((() => {
	mO();
})), gO = o((() => {
	$(), Q();
})), _O = o((() => {
	gO();
})), vO = o((() => {
	$(), Q();
})), yO = o((() => {
	vO();
})), bO = o((() => {
	nT();
})), xO = o((() => {
	rT();
})), SO = o((() => {
	Q(), $();
})), CO = o((() => {
	SO();
})), wO = o((() => {
	Q(), $(), R();
})), TO = o((() => {
	wO();
})), EO = o((() => {
	Q(), $();
})), DO = o((() => {
	EO();
})), OO = o((() => {
	N(), $(), Q(), R();
})), kO = o((() => {
	OO();
})), AO = o((() => {})), jO = o((() => {})), MO = o((() => {})), NO = o((() => {
	xC(), AO(), SC(), jO(), MO();
})), PO = o((() => {
	ES(), SS(), wS(), bS(), lw(), aT(), RC(), XC(), _O(), PC(), DC(), TC(), yO(), Fw(), bO(), kC(), xO(), CO(), jC(), $D(), BC(), TO(), _w(), xw(), hw(), yw(), Cw(), zw(), tT(), HC(), Gw(), WC(), HC(), pT(), NC(), Uw(), $w(), pw(), Yw(), IC(), ew(), Tw(), qw(), Lw(), Zw(), sT(), DO(), JC(), KC(), QC(), Nw(), nC(), Dw(), kw(), dT(), Vw(), _T(), sw(), lT(), hT(), kO(), Mw(), dO(), rO(), aO(), sO(), lO(), pO(), hO(), xT(), CT(), bT(), CC(), tO(), aw(), aw(), eS(), tS(), nS(), rS(), sS(), lS(), uS(), dS(), cS(), fS(), _S(), HS(), dw(), NO();
}));
//#endregion
//#region src/athos/utils/cardImage.js
PO();
var FO = [
	180,
	390,
	540,
	768,
	1080,
	1500
], IO = "cdn.shopify.com", LO = (e, t = "https://www.stemma.fi") => {
	if (typeof e != "string") return null;
	let n = e.trim();
	if (!n) return null;
	try {
		let e = new URL(n, t);
		return e.protocol !== "http:" && e.protocol !== "https:" ? null : e;
	} catch {
		return null;
	}
}, RO = (e) => {
	let t = LO(e);
	return t ? t.href : "";
}, zO = (e) => {
	let t = LO(e);
	return t ? t.hostname === IO || t.pathname.startsWith("/cdn/shop/") : !1;
}, BO = (e, t) => {
	let n = LO(e);
	return n ? (n.searchParams.set("width", String(t)), n.href) : "";
}, VO = (e, { sizes: t = "", widths: n = FO } = {}) => {
	let r = RO(e);
	if (!r) return {
		src: "",
		srcSet: void 0,
		sizes: t || void 0
	};
	if (!zO(r)) return {
		src: r,
		srcSet: void 0,
		sizes: t || void 0
	};
	let i = n.map((e) => `${BO(r, e)} ${e}w`).join(", ");
	return {
		src: BO(r, 1500),
		srcSet: i,
		sizes: t || void 0
	};
}, HO = (e) => /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(e), UO = (e) => {
	if (!e) return e || "";
	try {
		let t = new URL(e, "https://example.invalid");
		if (!t.searchParams.has("variant")) return e;
		t.searchParams.delete("variant");
		let n = t.searchParams.toString(), r = `${t.pathname}${n ? `?${n}` : ""}${t.hash}`;
		return HO(e) ? `${t.origin}${r}` : r;
	} catch {
		return e;
	}
}, WO = 12, GO = (e) => {
	let t = e?.display?.mappings?.core || e?.mappings?.core || {}, n = e?.display?.mappings?.core?.url || "";
	return {
		coreUrl: t.url || "",
		displayUrl: n
	};
}, KO = (e, t) => !e || !t ? !1 : e.includes(t), qO = (e, t) => {
	if (!e || !t) return !1;
	let n = UO(t);
	if (!n) return !1;
	if (e === n || e.startsWith(`${n}?`)) return !0;
	try {
		return new URL(e, "https://example.invalid").pathname === new URL(n, "https://example.invalid").pathname;
	} catch {
		return !1;
	}
}, JO = (e, t) => {
	let { coreUrl: n, displayUrl: r } = GO(t), i = (e.composedPath ? e.composedPath() : [e.target]).slice(0, WO);
	for (let e of i) {
		if (!(e instanceof Element)) continue;
		let t = e.getAttribute("href");
		if (t && (KO(t, n) || KO(t, r))) return !0;
	}
	return !1;
}, YO = (e, t, n) => {
	if (!t?.track?.product || !n || JO(e, n)) return;
	let { coreUrl: r, displayUrl: i } = GO(n), a = e.composedPath ? e.composedPath() : [e.target];
	for (let o of a.slice(0, WO)) {
		if (!(o instanceof Element)) continue;
		let a = o.getAttribute("href");
		if (a && (qO(a, r) || qO(a, i))) {
			t.track.product.clickThrough(e, n);
			return;
		}
	}
};
//#endregion
//#region src/athos/components/AthosCartResult.jsx
Fe();
var XO = (e) => e?.display?.mappings?.core || e?.mappings?.core || {}, ZO = ({ result: e, mediaClassName: t = "media", controller: n }) => {
	let r = XO(e), i = r.name || "", a = UO(r.url), o = (t) => {
		YO(t, n, e);
	}, { src: s, srcSet: c, sizes: l } = VO(r.imageUrl, {
		widths: [300],
		sizes: "300px"
	});
	return /* @__PURE__ */ A("div", {
		className: "card card--product",
		children: [/* @__PURE__ */ A("a", {
			href: a,
			className: "card-media",
			title: i,
			onClick: o,
			children: /* @__PURE__ */ A("figure", {
				className: t,
				children: s ? /* @__PURE__ */ A("img", {
					width: "300",
					height: "300",
					src: s,
					srcSet: c,
					sizes: l,
					alt: i,
					loading: "lazy"
				}) : null
			})
		}), /* @__PURE__ */ A("div", {
			className: "card-body text-align-center",
			children: /* @__PURE__ */ A("h3", {
				className: "card-title h6 size--tiny",
				children: /* @__PURE__ */ A("a", {
					href: a,
					onClick: o,
					children: i
				})
			})
		})]
	});
}, QO = ["athos_recommendations", "athos_cart_recommendations"], $O = (e, t = document) => {
	if (!e) return null;
	for (let n of QO) for (let r of t.querySelectorAll(`[data-context="${n}"]`)) if (r.querySelector(`[ss-controller-id="${e}"]`)) return r;
	return t.querySelector(`[ss-controller-id="${e}"]`)?.closest("[data-context=\"athos_recommendations\"], [data-context=\"athos_cart_recommendations\"]");
}, ek = (e, t = document) => {
	let n = $O(e?.id, t), r = n?.querySelector("gridy-slider");
	!r || typeof r.refreshSlides != "function" || (r.refreshSlides(), n.querySelectorAll("[data-gridy-arrow].md-hide, [data-gridy-arrow].sm-to-md-hide, [data-gridy-arrow].sm-down-hide").forEach((e) => {
		e.classList.remove("md-hide", "sm-to-md-hide", "sm-down-hide");
	}));
}, tk = (e) => Array.isArray(e) || e != null && typeof e.length == "number" ? e.length : 0, nk = (e) => e ? e.querySelectorAll(".card--product:not(.athos-rec-skeleton)").length : 0, rk = (e = document) => {
	let t = e.getElementById("athos-product-card-config");
	if (!t?.textContent) return !1;
	try {
		return JSON.parse(t.textContent).labels?.stampedEnabled === !0;
	} catch {
		return !1;
	}
}, ik = (e, t = window.innerWidth) => {
	let n = e?.dataset?.athosProfile;
	return n ? `athos-rec-h:${n}:${Math.round(t / 50) * 50}` : "";
}, ak = (e, t) => {
	let n = ik(e);
	if (!n || !t) return;
	let r = Math.ceil(t.getBoundingClientRect().height);
	if (!(r <= 0)) try {
		window.localStorage.setItem(n, String(r));
	} catch {}
}, ok = (e, { stampedEnabled: t = !1, contextRoot: n = null } = {}) => {
	if (!e) return;
	let r = () => {
		e.style.minHeight = "", requestAnimationFrame(() => ak(n, e));
	};
	if (t) {
		window.setTimeout(r, 320);
		return;
	}
	requestAnimationFrame(() => {
		requestAnimationFrame(r);
	});
}, sk = (e, t, n, r) => {
	if (!n && !r) return;
	let i = $O(e?.id);
	if (!i) return;
	let a = tk(t) > 0, o = nk(i), s = !!n && a && o > 0, c = !!n || !!r, l = i.querySelector("gridy-slider"), u = s && !i.classList.contains("athos-recommendations--has-results");
	if (u && l) {
		let e = Math.ceil(l.getBoundingClientRect().height);
		e > 0 && (l.style.minHeight = `${e}px`);
	}
	i.classList.toggle("athos-recommendations--resolved", c), i.classList.toggle("athos-recommendations--has-results", s), c && i.setAttribute("aria-busy", "false"), s && (ek(e), u && ok(l, {
		stampedEnabled: rk(),
		contextRoot: i
	}));
	let d = !!n && !a;
	if (i.id === "athos-search-no-results-recs" || i.closest("#athos-search-no-results-recs")) {
		let e = i.id === "athos-search-no-results-recs" ? i : i.closest("#athos-search-no-results-recs");
		e && (e.hidden = d, s && e.removeAttribute("hidden"));
		return;
	}
	if (i.dataset.context === "athos_cart_recommendations") {
		let e = i.id === "cart-recommendations" || i.id === "cart-page-recommendations" ? i : i.closest("#cart-recommendations, #cart-page-recommendations");
		e && (e.hidden = d, s && e.removeAttribute("hidden"));
		return;
	}
	let f = i.closest(".shopify-section");
	f ? (f.hidden = d, s && f.style.removeProperty("display")) : i.hidden = d;
}, ck = (e) => Array.isArray(e) ? e : e != null && typeof e.length == "number" ? Array.from(e) : [];
N(), $(), Fe();
var lk = bx(({ controller: e }) => {
	let t = e?.store || {}, n = ck(t.results), r = $O(e?.id)?.querySelector("[data-card-media-class]")?.dataset?.cardMediaClass || "media";
	return Be(() => {
		sk(e, n, t.loaded, t.error);
	}, [
		e,
		n.length,
		t.loaded,
		t.error
	]), n.length ? /* @__PURE__ */ A(_, { children: n.map((t) => /* @__PURE__ */ A(rw, {
		controller: e,
		result: t,
		disableStyles: !0,
		children: /* @__PURE__ */ A(ZO, {
			result: t,
			mediaClassName: r,
			controller: e
		})
	}, t.id)) }) : null;
}), uk = (e = document) => {
	let t = e.getElementById("athos-product-card-config");
	if (!t?.textContent) return {};
	try {
		return JSON.parse(t.textContent);
	} catch {
		return {};
	}
}, dk = (e = document, t = {}) => {
	let n = uk(e);
	return {
		...n.labels || {},
		customBadges: n.customBadges,
		badgeCustomAria: n.badgeCustomAria,
		badgePosition: n.badgePosition,
		fromPriceHtml: n.fromPriceHtml,
		regularPrice: n.regularPrice,
		salePrice: n.salePrice,
		customPriceTag: String(n.customPriceTag || "").trim() || void 0,
		customPriceColor: String(n.customPriceColor || "").trim() || void 0,
		enableSwatches: n.enableSwatches !== !1,
		colorSwatchIdentifiers: n.colorSwatchIdentifiers || "",
		cardType: n.cardType || "default",
		imagePadding: n.imagePadding || "default",
		textAlign: n.textAlign || "text-align-left",
		titleFontClass: n.titleFontClass || "",
		titleSizeClass: n.titleSizeClass || "",
		titleSmSizeClass: n.titleSmSizeClass || "",
		priceClass: n.priceClass || "card-price-grid",
		cardLayoutClass: t.cardLayoutClass || "",
		showSecondaryImage: n.showSecondaryImage !== !1,
		showVendor: n.showVendor === !0,
		imageSizes: t.imageSizes || n.imageSizes || "",
		imageLoading: t.imageLoading || n.imageLoading || "lazy"
	};
}, fk = (e, t = document) => {
	let n = $O(e?.id, t);
	return dk(t, {
		cardLayoutClass: n?.dataset?.athosCardLayoutClass || "",
		imageSizes: n?.dataset?.athosCardSizes || "",
		imageLoading: "eager"
	});
}, pk = () => {
	if (typeof window > "u") return;
	let e = requestAnimationFrame(() => {
		window.StampedFn?.loadBadges?.();
	});
	return () => cancelAnimationFrame(e);
}, mk = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", hk = (e) => {
	if (e == null || e === "") return [];
	if (mk(e)) return Array.from(e).flatMap(hk);
	if (typeof e == "string") {
		let t = e.trim();
		if (!t) return [];
		if (t.startsWith("[")) try {
			return hk(JSON.parse(t));
		} catch {}
		return t.split(",").map((e) => e.trim()).filter(Boolean);
	}
	return [e];
}, gk = [
	"tags",
	"ss_tags",
	"_tags"
], _k = (e) => {
	let t = e?.display?.attributes || e?.attributes || {}, n = [];
	for (let e of gk) n.push(...hk(t[e]));
	n.push(...hk(e?.tags));
	let r = [], i = /* @__PURE__ */ new Set();
	return n.forEach((e) => {
		let t = String(e).trim();
		!t || i.has(t) || (i.add(t), r.push(t));
	}), r;
}, vk = (e) => _k(e).join(""), yk = (e, t) => {
	let n = String(t || "").trim();
	return n ? e.some((e) => String(e).trim() === n) : !1;
}, bk = (e) => {
	if (e == null || e === "") return null;
	let t = Number(String(e).trim().replace(/,/g, ""));
	return Number.isFinite(t) && t > 0 ? t : null;
}, xk = (e) => e.reduce((e, t) => {
	let n = bk(t?.price);
	if (n == null) return e;
	let r = bk(e?.price);
	return r == null || n < r ? t : e;
}, null), Sk = ({ core: e = {}, variants: t = [] } = {}) => {
	let n = t.map((e) => bk(e?.price)).filter((e) => e != null), r = xk(t), i = bk(r?.price), a = bk(e.price), o = bk(e.msrp) ?? bk(e.compare_at_price), s = i ?? a ?? 0, c = r ? bk(r.compare_at_price) ?? o ?? 0 : o ?? 0;
	return {
		price: s,
		msrp: c,
		onSale: s > 0 && c > s,
		priceVaries: new Set(n).size > 1
	};
}, Ck = (e) => {
	if (typeof document > "u") return e;
	let t = document.createElement("textarea");
	return t.innerHTML = e, t.value;
}, wk = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", Tk = (e) => {
	if (!e) return null;
	if (typeof e == "string") return {
		image: e,
		alt: ""
	};
	if (typeof e == "object") {
		let t = e.image || e.url || e.src;
		return t ? {
			image: t,
			alt: e.alt || ""
		} : null;
	}
	return null;
}, Ek = (e) => {
	if (wk(e)) return Array.from(e).map(Tk).filter(Boolean);
	if (!e || typeof e != "string") return [];
	try {
		let t = JSON.parse(Ck(e));
		if (wk(t)) return Array.from(t).map(Tk).filter(Boolean);
		let n = Tk(t);
		return n ? [n] : [];
	} catch {
		return e.split("|").map((e) => e.trim()).filter(Boolean).map((e) => ({
			image: e,
			alt: ""
		}));
	}
}, Dk = (e = {}) => {
	let t = Ek(e.ss_alt_images);
	if (t.length > 0) return t;
	let n = Ek(e.images);
	return n.length > 0 ? n : [];
}, Ok = (e, t, n) => {
	if (n?.showSecondaryImage === !1) return null;
	let r = e?.imageUrl || e?.thumbnailImageUrl || "";
	return Dk(t).find((e) => e?.image && e.image !== r) || null;
}, kk = [
	"sileäksi kudottu matto",
	"viskoosimatto",
	"nukkamatto"
], Ak = (e) => {
	let t = String(e || "").trim();
	if (!t) return "";
	let n = t.toLowerCase(), r = [...kk].sort((e, t) => t.length - e.length);
	for (let e of r) {
		let r = e.toLowerCase();
		if (!n.endsWith(r) || t.length <= e.length + 1) continue;
		let i = t[t.length - e.length - 1];
		if (!(i && !/\s/.test(i))) return t.slice(-e.length);
	}
	let i = t.search(/\s+/);
	return i === -1 ? "" : t.slice(i).trim() || "";
}, jk = (e, t) => {
	let n = String(e || "").trim(), r = String(t || "").trim();
	if (!r || !n) return "";
	let i = n.toLowerCase(), a = r.toLowerCase();
	if (!i.includes(a)) return "";
	let o = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	return n.replace(new RegExp(o, "gi"), "").trim();
}, Mk = (e, t, n = "", r = !1) => {
	let i = String(e || "").trim(), a = String(t || "").trim(), o = a ? jk(i, a) : "", s = a && i.toLowerCase().includes(a.toLowerCase()), c = s ? o : "";
	return !c && r && (c = String(n || "").trim()), {
		displayVendor: c,
		displayTitle: s ? a : i
	};
}, Nk = (e = {}, t = {}) => {
	let n = (e) => e == null || e === "" ? "" : Array.isArray(e) ? String(e[0] || "").trim() : String(e).trim();
	return n(e.product_type) || n(e.ss_product_type) || n(e.type) || n(t.productType) || n(t.product_type) || n(t.type) || Ak(t.name || n(e.title));
}, Pk = "€{{amount}}", Fk = (e) => Number.isFinite(e) && Math.abs(e - Math.round(e)) < 1e-9, Ik = (e = {}) => e.moneyFormat ? e.moneyFormat : typeof window < "u" && window.theme?.settings?.moneyFormat ? window.theme.settings.moneyFormat : Pk, Lk = (e, t) => t ? e.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, "{{amount_no_decimals_with_comma_separator}}").replace(/\{\{\s*amount\s*\}\}/g, "{{amount_no_decimals}}") : e.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, "{{amount_with_comma_separator}}").replace(/\{\{\s*amount_no_decimals\s*\}\}/g, "{{amount}}"), Rk = (e, t, n = ",", r = ".") => {
	if (Number.isNaN(e) || e == null) return "0";
	let i = (Number(e) / 100).toFixed(t).split(".");
	return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${n}`) + (i[1] ? r + i[1] : "");
}, zk = (e, t = Pk) => {
	let n = /\{\{\s*(\w+)\s*\}\}/, r = t.match(n);
	if (!r) return String(e);
	let i;
	switch (r[1]) {
		case "amount_no_decimals":
			i = Rk(e, 0);
			break;
		case "amount_with_comma_separator":
			i = Rk(e, 2, ".", ",");
			break;
		case "amount_no_decimals_with_comma_separator":
			i = Rk(e, 0, ".", ",");
			break;
		default: i = Rk(e, 2);
	}
	return t.replace(n, i);
}, Bk = (e, t = {}) => {
	let n = Math.round(Number(e) * 100);
	return t.applyCurrencyRate !== !1 && typeof window < "u" && window.Shopify?.currency?.rate && (n = Math.round(n * parseFloat(window.Shopify.currency.rate || 1))), n;
}, Vk = (e, t = {}) => {
	let n = Number(e);
	if (!Number.isFinite(n)) return "";
	let r = Lk(Ik(t), Fk(n)), i = Bk(n, t);
	return typeof window < "u" && window.Woolman?.Utils?.formatMoney ? window.Woolman.Utils.formatMoney(i, r) : zk(i, r);
};
$(), Fe();
var Hk = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", Uk = (e) => e == null || e === "" ? [] : Hk(e) ? Array.from(e) : [e], Wk = (e) => {
	let t = document.createElement("textarea");
	return t.innerHTML = e, t.value;
}, Gk = (e) => {
	if (Hk(e)) return Array.from(e);
	if (!e || typeof e != "string") return [];
	try {
		let t = JSON.parse(Wk(e));
		return Array.isArray(t) ? t : [];
	} catch {
		return [];
	}
}, Kk = [
	"color",
	"colour",
	"väri"
], qk = (e) => {
	let t = String(e?.colorSwatchIdentifiers || "").split(",").map((e) => e.trim().toLowerCase()).filter(Boolean);
	return t.length > 0 ? t : Kk;
}, Jk = (e, t) => {
	let n = String(e || "").toLowerCase();
	return n ? t.some((e) => n === e || e.includes(n) || n.includes(e)) : !1;
}, Yk = (e, t) => {
	let n = (Array.isArray(e?.selected_options) ? e.selected_options : []).find((e) => Jk(e?.name, t));
	return n?.value ? {
		name: n.name,
		value: n.value
	} : null;
}, Xk = (e, t) => {
	let n = e?.options || {}, r = Object.entries(n).find(([e]) => Jk(e, t));
	if (!r) return null;
	let [i, a] = r, o = a?.value || a;
	return o ? {
		name: i,
		value: o
	} : null;
}, Zk = (e, t, n, r) => ({
	cssColor: $k(e),
	fallbackImageUrl: r,
	imageUrl: `/cdn/shop/files/${$k(e)}.png?crop=center&height=32&width=32`,
	label: e,
	optionName: t,
	url: n
}), Qk = (e, t, n) => {
	let r = Vk(e);
	return t ? (n.fromPriceHtml || "Alkaen {{ price }}").replace("{{ price }}", r).replace("__PRICE__", r) : r;
}, $k = (e) => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""), eA = (e) => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9_]+/g, "-").replace(/^-|-$/g, ""), tA = (e) => e ? e.split(";").map((e) => e.trim()).filter(Boolean).map((e) => {
	let [t, , , n] = e.split(":"), r = n || t;
	return {
		className: `custom-${eA(t)}`,
		label: r,
		tag: t
	};
}) : [], nA = (e, t, n) => tA(t).filter((t) => e.includes(t.tag)).map((e) => ({
	...e,
	ariaLabel: n?.replace("__LABEL__", e.label) || e.label
})), rA = (e, t, n) => {
	let r = qk(n), i = /* @__PURE__ */ new Map();
	return e.length > 0 ? (e.forEach((e) => {
		let t = Yk(e, r);
		!t || i.has(t.value) || i.set(t.value, Zk(t.value, t.name, e.url || e.shop_url));
	}), [...i.values()]) : (t.forEach((e) => {
		let t = Xk(e, r);
		if (!t || i.has(t.value)) return;
		let n = e?.mappings?.core || {};
		i.set(t.value, Zk(t.value, t.name, n.url, n.thumbnailImageUrl || n.imageUrl));
	}), [...i.values()]);
}, iA = ({ imageUrl: e, alt: t, labels: n }) => {
	let { src: r, srcSet: i, sizes: a } = VO(e, { sizes: n.imageSizes });
	return /* @__PURE__ */ A("figure", {
		className: "media contain square",
		children: r ? /* @__PURE__ */ A("img", {
			src: r,
			srcSet: i,
			sizes: a,
			alt: t,
			width: "600",
			height: "600",
			loading: n.imageLoading || "lazy",
			decoding: "async"
		}) : null
	});
}, aA = ({ onSale: e, salePercentage: t, isPreorder: n, isNew: r, showSoldOut: i, customBadges: a, labels: o }) => !e && !n && !r && !i && a.length === 0 ? null : /* @__PURE__ */ A("div", {
	className: "badges",
	children: [
		e && /* @__PURE__ */ A("div", {
			className: "badge sale",
			"aria-label": o.badgeSale,
			children: [
				"-",
				t,
				"%"
			]
		}),
		n && /* @__PURE__ */ A("div", {
			className: "badge preorder",
			"aria-label": o.badgePreorder,
			children: o.preorder
		}),
		r && /* @__PURE__ */ A("div", {
			className: "badge new",
			"aria-label": o.badgeNew,
			children: o.newProduct
		}),
		i && /* @__PURE__ */ A("div", {
			className: "badge soldout",
			"aria-label": o.badgeSoldOut,
			children: o.soldOut
		}),
		a.map((e) => /* @__PURE__ */ A("div", {
			className: `badge ${e.className}`,
			"aria-label": e.ariaLabel,
			children: e.label
		}, e.tag))
	]
}), oA = bx(({ result: e, labels: t, controller: n }) => {
	let r = e?.display?.mappings?.core || e?.mappings?.core || {}, i = e?.display?.attributes || e?.attributes || {}, a = _k(e), o = Nk(i, r), s = Uk(i.vendor)[0] || r.brand || "", c = r.name || "", { displayVendor: l, displayTitle: u } = Mk(c, o, s, t.showVendor === !0), d = Gk(i.all_variants), { price: f, msrp: p, onSale: m, priceVaries: h } = Sk({
		core: r,
		variants: d
	}), g = Qk(f, h, t), _ = !!(t.customPriceTag && t.customPriceColor && yk(a, t.customPriceTag)), v = m ? Math.round((p - f) / p * 100) : 0, y = r.available === !0 || r.available === "true" || i.ss_available === "1", b = Ok(r, i, t), x = Uk(i.handle)[0], S = UO(r.url), C = r.parentId || Uk(i.groupId)[0], w = Number(r.rating || 0), T = Number(r.ratingCount || 0), E = e?.variants?.data || [], D = t.enableSwatches === !1 ? [] : rA(d, E, t), ee = yk(a, "New") || yk(a, "new"), te = yk(a, "Preorder") || yk(a, "preorder"), ne = nA(a, t.customBadges, t.badgeCustomAria), re = yk(a, "Myymälätuote"), ie = !y && !re, ae = t.cardType || "default", oe = t.imagePadding || "default", se = t.textAlign || "text-align-left", ce = t.cardLayoutClass || "", le = [
		"card-title",
		t.titleFontClass,
		t.titleSizeClass,
		t.titleSmSizeClass
	].filter(Boolean).join(" "), ue = !!ce, de = {
		onSale: m,
		salePercentage: v,
		isPreorder: te,
		isNew: ee,
		showSoldOut: ie,
		customBadges: ne,
		labels: t
	}, fe = (t) => {
		YO(t, n, e);
	};
	return /* @__PURE__ */ A("div", {
		className: [
			"card",
			"card--product",
			`card--${ae}`,
			ce,
			b ? "on-hover" : ""
		].filter(Boolean).join(" "),
		children: [
			/* @__PURE__ */ A("a", {
				href: S,
				className: `card-media p-${oe}`,
				"aria-hidden": "true",
				tabIndex: -1,
				onClick: fe,
				children: [b ? /* @__PURE__ */ A("div", {
					className: "card-hover-images",
					children: [/* @__PURE__ */ A(iA, {
						imageUrl: r.imageUrl,
						alt: c,
						labels: t
					}), /* @__PURE__ */ A(iA, {
						imageUrl: b.image,
						alt: b.alt || "",
						labels: t
					})]
				}) : /* @__PURE__ */ A(iA, {
					imageUrl: r.imageUrl,
					alt: c,
					labels: t
				}), /* @__PURE__ */ A("div", {
					className: `card-media-overlay flex ${t.badgePosition || ""}`,
					children: !ue && /* @__PURE__ */ A(aA, { ...de })
				})]
			}),
			t.quickBuyEnabled && y && x && C && /* @__PURE__ */ A("quick-buy", {
				"data-product": C,
				"data-url": S,
				class: "js quick-buy quick-buy-or-add",
				children: /* @__PURE__ */ A("a", {
					className: "btn size--tiny btn--primary btn--full quick-buy_link",
					"data-product-handle": x,
					"data-url": S,
					href: `#modal-${C}-product`,
					"aria-haspopup": "dialog",
					"aria-label": t.quickBuyLabel.replace("__PRODUCT__", c),
					children: [/* @__PURE__ */ A("span", {
						className: "quick-buy_text",
						children: t.quickBuy
					}), /* @__PURE__ */ A("span", {
						className: "quick-buy_icon",
						"aria-hidden": "true",
						children: "+"
					})]
				})
			}),
			/* @__PURE__ */ A("div", {
				className: `card-body ${se}`,
				children: [
					ue && /* @__PURE__ */ A(aA, { ...de }),
					t.stampedEnabled && C && /* @__PURE__ */ A("span", {
						className: "stamped-product-reviews-badge",
						"data-id": C,
						"data-product-sku": x,
						"data-product-title": c,
						"data-product-type": o
					}),
					!t.stampedEnabled && T > 0 && /* @__PURE__ */ A("div", {
						className: "athos-rating",
						"aria-label": `${w} / 5, ${T} ${t.reviews}`,
						children: [/* @__PURE__ */ A("span", {
							"aria-hidden": "true",
							children: ["★".repeat(Math.round(w)), "☆".repeat(5 - Math.round(w))]
						}), /* @__PURE__ */ A("span", {
							"aria-hidden": "true",
							children: [
								" (",
								T,
								")"
							]
						})]
					}),
					/* @__PURE__ */ A("div", {
						className: "card-info-grid",
						children: [
							l ? /* @__PURE__ */ A("span", {
								className: "card-vendor",
								children: l
							}) : null,
							/* @__PURE__ */ A("h3", {
								className: le,
								children: /* @__PURE__ */ A("a", {
									href: S,
									onClick: fe,
									children: u
								})
							}),
							f > 0 && /* @__PURE__ */ A("div", {
								className: [
									"price",
									"card-price-grid",
									m ? "price--on-sale" : "",
									_ ? "price--custom-color" : ""
								].filter(Boolean).join(" "),
								style: _ ? { "--price-custom-color": t.customPriceColor } : void 0,
								children: /* @__PURE__ */ A("div", {
									className: "flex",
									children: [/* @__PURE__ */ A("div", {
										className: "price__regular",
										children: [/* @__PURE__ */ A("span", {
											className: "visually-hidden",
											children: t.regularPrice
										}), /* @__PURE__ */ A("span", {
											className: "price-item price-item--regular",
											children: g
										})]
									}), /* @__PURE__ */ A("div", {
										className: "price__sale",
										children: [
											/* @__PURE__ */ A("span", {
												className: "visually-hidden",
												children: t.salePrice
											}),
											/* @__PURE__ */ A("span", {
												className: "price-item price-item--sale",
												children: g
											}),
											/* @__PURE__ */ A("span", {
												className: "visually-hidden",
												children: t.regularPrice
											}),
											/* @__PURE__ */ A("span", { children: /* @__PURE__ */ A("s", {
												className: "price-item price-item--regular price-item--last",
												children: Vk(p)
											}) })
										]
									})]
								})
							})
						]
					}),
					D.length > 0 && /* @__PURE__ */ A("div", {
						className: "mt-12 swatches flex athos-swatches",
						children: [/* @__PURE__ */ A("span", {
							className: "visually-hidden",
							children: t.availableIn
						}), D.map((e) => {
							let t = RO(e.imageUrl), n = RO(e.fallbackImageUrl);
							return /* @__PURE__ */ A("a", {
								className: "swatch",
								href: e.url || S,
								children: [
									/* @__PURE__ */ A("span", {
										className: "color",
										style: { "--color": e.cssColor },
										"aria-hidden": "true"
									}),
									t ? /* @__PURE__ */ A("img", {
										className: "color",
										src: t,
										alt: e.label,
										width: "16",
										height: "16",
										loading: "lazy",
										style: { "--color": e.cssColor },
										onError: (e) => {
											if (n && !e.currentTarget.dataset.fallbackAttempted) {
												e.currentTarget.dataset.fallbackAttempted = "true", e.currentTarget.src = n;
												return;
											}
											e.currentTarget.hidden = !0;
										}
									}) : null,
									/* @__PURE__ */ A("span", {
										className: "visually-hidden",
										children: e.label
									})
								]
							}, `${e.optionName}-${e.label}`);
						})]
					})
				]
			})
		]
	});
});
N(), $(), PO(), Fe();
var sA = bx(({ controller: e }) => {
	let t = e?.store || {}, n = ck(t.results), r = fk(e);
	return Be(() => {
		sk(e, n, t.loaded, t.error);
	}, [
		e,
		n.length,
		t.loaded,
		t.error
	]), ze(() => {
		if (!n.length) return;
		let t = requestAnimationFrame(() => {
			ek(e);
		});
		return () => cancelAnimationFrame(t);
	}, [e, n.length]), ze(() => {
		if (!(!t.loaded || !n.length || r.stampedEnabled !== !0)) return pk();
	}, [
		r.stampedEnabled,
		t.loaded,
		n.length
	]), n.length ? /* @__PURE__ */ A(_, { children: n.map((t) => /* @__PURE__ */ A(rw, {
		controller: e,
		result: t,
		disableStyles: !0,
		children: /* @__PURE__ */ A(oA, {
			result: t,
			labels: r,
			controller: e
		})
	}, `${t.id}:${vk(t)}`)) }) : null;
}), cA = "atg0mj";
wu(), Fe();
var lA = "script[type=\"athos/recommend\"], script[type=\"athos/personalized-recommendations\"]", uA = () => {
	try {
		return Gl(["siteId"])?.siteId || "atg0mj";
	} catch {
		return cA;
	}
}, dA = () => ({ controller: e }) => $O(e?.id)?.dataset?.context === "athos_cart_recommendations" ? /* @__PURE__ */ A(lk, { controller: e }) : /* @__PURE__ */ A(sA, { controller: e }), fA = "Taiga", pA = ({ controller: e }) => {
	let t = e?.store?.profile?.display;
	t && (t.template &&= {
		...t.template,
		component: fA
	}, t.templateParameters ||= {});
}, mA = async ({ controller: e }) => {
	pA({ controller: e });
	let t = e?.store || {};
	sk(e, ck(t.results), t.loaded, t.error);
}, hA = new Proxy({
	[fA]: dA,
	Default: dA,
	DefaultTemplate: dA,
	Carousel: dA,
	Grid: dA
}, {
	get(e, t) {
		return typeof t == "string" && t !== "then" ? e[t] ?? dA : Reflect.get(e, t);
	},
	has(e, t) {
		return typeof t == "string" || Reflect.has(e, t);
	}
}), gA, _A = () => {
	gA = null;
}, vA = (e = document) => e.querySelector(lA) ? gA ? !0 : (gA = new bC({
	mode: "production",
	client: { globals: { siteId: uA() } },
	instantiators: { recommendation: {
		components: hA,
		middleware: [{
			event: "afterStore",
			func: [mA]
		}]
	} },
	controllers: { recommendation: [] }
}), typeof window < "u" && (window.athosSnapRecommendations = gA, window.mountAthosRecommendations = vA), !0) : !1;
typeof document < "u" && (vA(document), document.addEventListener("athos:cart-recommendations:rendered", () => {
	vA(document);
}), document.addEventListener("athos:recommendations:mount", () => {
	vA(document);
}));
//#endregion
export { vA as mountAthosRecommendations, pA as normalizeRecommendationDisplay, _A as resetAthosRecommendationsForTests };
